var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/constants/terminology.ts
var HANGUL_BASE = 44032;
var HANGUL_LAST = 55203;
var JONG_RIEUL = 8;
function josa(word, pair) {
  const [withBatchim, withoutBatchim] = pair.split("/");
  if (withoutBatchim === void 0) {
    return pair;
  }
  const last = word.charCodeAt(word.length - 1);
  if (!word || Number.isNaN(last) || last < HANGUL_BASE || last > HANGUL_LAST) {
    return withoutBatchim;
  }
  const jong = (last - HANGUL_BASE) % 28;
  if (jong === 0) {
    return withoutBatchim;
  }
  if (jong === JONG_RIEUL && withBatchim === "\uC73C\uB85C") {
    return withoutBatchim;
  }
  return withBatchim;
}
__name(josa, "josa");

// src/locales/en/common.json
var common_default = {
  "term.role": "Role",
  "common.action_items": "Action Items",
  "common.active": "Active",
  "common.add": "Add",
  "common.all": "All",
  "common.apply": "Apply",
  "common.assign": "Assign",
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.open": "Open",
  "common.change": "Change",
  "common.close": "Close",
  "common.expand": "Expand",
  "common.collapse": "Collapse",
  "common.code": "Code",
  "common.confirm": "Confirm",
  "common.confirm_delete": "Are you sure you want to delete this?",
  "common.count_suffix": "",
  "common.create": "Create",
  "common.dashboard": "Dashboard",
  "common.delete": "Delete",
  "common.description": "Description",
  "common.exclude": "Exclude",
  "common.remove": "Remove",
  "common.detail": "Detail",
  "common.download": "Download",
  "common.edit": "Edit",
  "common.export": "Export",
  "common.failed": "Operation failed.",
  "common.filter": "Filter",
  "common.import": "Import",
  "common.inactive": "Inactive",
  "common.items": "",
  "common.list": "List",
  "common.loading": "Loading...",
  "common.login": "Login",
  "common.logout": "Logout",
  "common.name": "Name",
  "common.network_error": "Network error. Please try again later.",
  "common.next": "Next",
  "common.no": "No",
  "common.no_data": "No data available.",
  "common.no_results": "No results found.",
  "common.none": "None",
  "common.not_selected": "Not selected",
  "common.notification": "Notifications",
  "common.off": "OFF",
  "common.on": "ON",
  "common.optional": "Optional",
  "common.people_suffix": "",
  "common.prev": "Previous",
  "common.refresh": "Refresh",
  "common.request": "Request",
  "common.required": "Required",
  "common.reset": "Reset",
  "common.save": "Save",
  "common.saving": "Saving...",
  "common.search": "Search",
  "common.select": "Select",
  "common.settings": "Settings",
  "common.status": "Status",
  "common.submit": "Submit",
  "common.success": "Completed successfully.",
  "common.table": "Table",
  "common.total": "Total",
  "common.tree": "Tree",
  "common.type": "Type",
  "common.unassigned": "Unassigned",
  "common.upload": "Upload",
  "common.won_suffix": "KRW",
  "common.year_suffix": "yr",
  "common.month_suffix": "mo",
  "common.day_suffix": "d",
  "common.hour_suffix": "hr",
  "common.minute_suffix": "min",
  "common.yes": "Yes",
  "common.from": "From",
  "common.to": "To",
  "auth.login_subtitle": "Please log in",
  "auth.admin_login_subtitle": "Log in with admin credentials",
  "auth.employee_login_subtitle": "Log in to the employee app",
  "auth.change_password_title": "Change Password",
  "auth.change_password_subtitle": "Please set a new password for security.",
  "auth.new_password": "New Password",
  "auth.confirm_password": "Confirm Password",
  "auth.password_mismatch": "Passwords do not match.",
  "auth.password_mismatch_current": "Please check your password and try again.",
  "auth.permission_denied_title": "Access Denied",
  "auth.permission_denied_message": "You do not have permission to access this page.",
  "auth.logout_confirm_title": "Ready to sign out?",
  "auth.logout_confirm_desc": "Logging out will end your current session. You'll need to log in to regain access.",
  "auth.request_permission": "Request Permission",
  "auth.identifier_label": "ID",
  "auth.identifier_placeholder": "ID",
  "auth.password_label": "Password",
  "auth.password_placeholder": "Password",
  "auth.password_toggle_show": "Show password",
  "auth.password_toggle_hide": "Hide password",
  "auth.logging_in": "Logging in...",
  "auth.no_account": "Don't have an account?",
  "auth.signup": "Sign up",
  "auth.create_account": "Create a new account",
  "auth.step_account": "Account Info",
  "auth.step_org": "Organization Info",
  "auth.family_name": "Last Name",
  "auth.given_name": "First Name",
  "auth.family_name_placeholder": "Doe",
  "auth.given_name_placeholder": "John",
  "auth.email_label": "Email",
  "auth.phone_label": "Phone",
  "auth.new_password_label": "New Password",
  "auth.password_rule_change_later": "You can change the password rules later in Settings.",
  "auth.new_password_confirm_label": "Confirm New Password",
  "auth.password_confirm_placeholder": "Re-enter password",
  "auth.new_password_confirm_placeholder": "Re-enter new password",
  "auth.org_name_label": "Organization Name",
  "auth.org_name_placeholder": "e.g. Seoul Rehab Hospital",
  "auth.org_code_label": "Organization Code",
  "auth.org_code_placeholder": "e.g. SeoulRehab (starts with letter, 3-50 chars)",
  "auth.accept_terms": "I agree to the Terms of Service and Privacy Policy",
  "auth.processing": "Processing...",
  "auth.already_have_account": "Already have an account?",
  "auth.login_failed": "Login failed.",
  "auth.device_login_title": "Sign in with device lock",
  "auth.device_login_greeting": "{name}, sign in with device lock",
  "auth.device_login_desc": "Sign in with the key registered on this device. Confirm with fingerprint, face, or your device PIN.",
  "auth.device_login_button": "Sign in with biometrics / device lock",
  "auth.device_login_cancelled": "Verification was cancelled. Please try again.",
  "auth.device_login_rejected": "This device's sign-in key is no longer valid. Sign in with your password to register it again.",
  "auth.device_login_use_password": "Sign in with ID and password",
  "auth.device_login_use_key": "Sign in with biometrics / device lock",
  "auth.passkey_login_button": "Sign in with a passkey",
  "auth.passkey_register": "Add passkey",
  "auth.passkey_offer": "Add a passkey to this browser?\nNext time you can sign in with fingerprint, Face ID or Windows Hello instead of a password.",
  "auth.captcha_title": "Security check",
  "auth.captcha_desc": "This sign-in looks different from usual. Complete the check below to continue.",
  "auth.captcha_failed": "Could not load the security check. Please try again shortly.",
  "auth.passkey_offer_unusual": "This sign-in came from an unusual place.\nAdding a passkey to this browser keeps others out even if your password leaks. Add one now?",
  "auth.passkey_offer_later": "Later",
  "auth.passkey_default_name": "This browser",
  "auth.device_key_register": "Register this device",
  "auth.device_login_section": "Device sign-in",
  "auth.device_login_section_desc": "Devices that sign in with a passkey, fingerprint, or device lock instead of a password. Revoking sends that device back to password sign-in.",
  "auth.device_credential_passkey": "Passkey",
  "auth.device_credential_device_key": "Device key",
  "auth.device_credential_last_used": "Last used",
  "auth.device_credential_never_used": "Not used yet",
  "auth.device_login_unsupported_build": "This app version doesn't support fingerprint/device-lock sign-in. Please update the app from the store.",
  "auth.device_login_no_webcrypto": "This device's app environment can't create a device key. Please update the app.",
  "security.title": "Sign-in & security",
  "security.account_section": "Sign-in account",
  "security.id_employee_number": "Employee no.",
  "security.id_email": "Email",
  "security.id_phone": "Phone",
  "security.last_login": "Last sign-in",
  "security.password_change": "Change password",
  "security.current_password": "Current password",
  "security.new_password": "New password",
  "security.new_password_confirm": "Confirm new password",
  "security.new_password_mismatch": "Passwords do not match.",
  "security.two_factor": "Two-factor authentication",
  "security.two_factor_desc": "Ask for a 6-digit code from an authenticator app on password sign-in. Passkey and device-key sign-ins skip it.",
  "security.two_factor_enable": "Set up",
  "security.two_factor_disable": "Turn off",
  "security.two_factor_on": "On",
  "security.two_factor_required_by_org": "Required by organization",
  "security.backup_codes_left": "{n} backup codes left",
  "security.two_factor_scan": "Scan the QR code with your authenticator app, then enter the 6-digit code it shows.",
  "security.two_factor_manual": "Can't scan? Enter this key:",
  "security.two_factor_code_placeholder": "6-digit code",
  "security.two_factor_code_or_backup": "6-digit code or backup code",
  "security.two_factor_code_format": "Enter the 6-digit code from your authenticator app.",
  "security.two_factor_failed": "Two-factor authentication failed. Please try again.",
  "security.two_factor_required_notice": "Your organization requires two-factor authentication. Set it up under \u201CTwo-factor authentication\u201D below.",
  "security.two_factor_login_title": "Two-factor authentication",
  "security.two_factor_login_desc": "Enter the 6-digit code from your authenticator app. A backup code also works.",
  "security.two_factor_verify": "Verify",
  "security.backup_codes_title": "Keep these backup codes somewhere safe",
  "security.backup_codes_desc": "Each code signs you in once when the authenticator app is unavailable. They are shown only now.",
  "security.backup_codes_copy": "Copy",
  "security.backup_codes_copied": "Backup codes copied.",
  "security.sessions": "Signed-in devices",
  "security.sessions_desc": "Devices currently signed in. Sign out any you don't recognize.",
  "security.sessions_empty": "No signed-in devices.",
  "security.session_current": "This device",
  "security.session_last_used": "Last used",
  "security.session_logout": "Sign out",
  "security.session_logout_confirm": "Sign out {device}?\nIt will need to sign in again.",
  "security.session_logout_current_confirm": "Sign out of this device?",
  "security.session_logout_failed": "Could not sign out. Please try again.",
  "security.sessions_logout_others": "Sign out all other devices",
  "security.sessions_logout_others_confirm": "Sign out every device except this one?\nThey will need to sign in again.",
  "security.sessions_logout_others_done": "Signed out all other devices.",
  "security.chat_lock_desc": "Messenger encryption key \xB7 recovery code \xB7 device approval",
  "security.passkey_only": "Sign in with passkey or device key only",
  "security.passkey_only_desc": "When on, password and SMS-code sign-ins are refused, so a leaked password lets nobody in. If you lose your device, an admin can turn it off.",
  "security.passkey_only_need_credential": "Register a passkey or device key first.",
  "security.passkey_only_confirm": "From now on, password and SMS-code sign-ins will be refused.\nOnly devices with a registered passkey or device key can sign in. Turn it on?",
  "employee.passkey_only_login": "Passkey-only sign-in",
  "employee.passkey_only_login_on": "This employee cannot sign in with a password or SMS code. Turn it off if they lost their device.",
  "employee.passkey_only_login_will_disable": "Saving re-enables password and SMS-code sign-in.",
  "employee.passkey_only_login_disable": "Turn off",
  "settings.two_factor_required": "Require two-factor authentication",
  "settings.two_factor_required_desc": "Employees who haven't set it up are sent to Sign-in & security right after signing in, and enrolled employees cannot turn it off. Passkey and device-key sign-ins skip it.",
  "auth.device_credential_revoke": "Revoke",
  "auth.device_credential_revoke_confirm": "Revoke this device's sign-in key?\nThat device will sign in with a password from now on.",
  "auth.device_credentials_empty": "No devices registered.",
  "auth.device_credential_failed": "Could not update device sign-in.",
  "auth.device_key_registered_toast": "You can now sign in with biometrics or device lock.",
  "auth.api_unreachable": "Cannot connect to API server. Check if API is running (default http://localhost:3000) and firewall settings.",
  "auth.identifier_required": "Please enter your employee number (or email) and password.",
  "auth.change_password_failed": "Failed to change password.",
  "auth.password_changed": "Password changed successfully. Redirecting...",
  "auth.changing_password": "Changing...",
  "auth.forgot_password": "Forgot Password",
  "auth.forgot_password_subtitle": "If you did not receive the SMS, please contact your administrator.",
  "auth.forgot_password_submit": "Send Temporary Password",
  "auth.forgot_password_submitting": "Sending...",
  "auth.forgot_password_success": "A temporary password has been sent via SMS. Please change your password after logging in.",
  "auth.forgot_password_info": "If you forgot your employee number or email, please contact your administrator.",
  "auth.forgot_password_back": "Back to Login",
  "auth.forgot_password_failed": "An error occurred while processing your request.",
  "auth.login_method_password": "Password",
  "auth.login_method_otp": "Phone OTP",
  "auth.code_request_button": "Send Code",
  "auth.code_requesting": "Sending...",
  "auth.code_label": "Verification code",
  "auth.code_placeholder": "6-digit code",
  "auth.code_sent_message": "A verification code has been sent to your registered phone.",
  "auth.code_verify_button": "Verify",
  "auth.code_resend": "Resend",
  "auth.code_change_identifier": "Change",
  "auth.code_required": "Please enter the verification code.",
  "auth.code_format_invalid": "The verification code must be 6 digits.",
  "settings.self_password_reset": "Allow Password Reset",
  "settings.self_password_reset_desc": "Employees can use the forgot password feature on the login page.",
  "auth.signup_failed": "Sign up failed.",
  "auth.first_name_required": "First name is required.",
  "auth.last_name_required": "Last name is required.",
  "auth.email_invalid": "Please enter a valid email address.",
  "auth.phone_invalid": "Please enter a valid phone number. (e.g. 010-1234-5678)",
  "auth.org_name_required": "Organization name is required.",
  "auth.org_code_invalid": "Organization code must start with a letter and be 3-50 characters (letters, numbers, hyphens, underscores).",
  "auth.hospital_code_title": "Enter your company code",
  "auth.hospital_code_label": "Company code",
  "auth.hospital_code_placeholder": "Letters and numbers",
  "auth.hospital_code_help": "The letters-and-numbers code in your invitation text or email.",
  "auth.hospital_code_contact": "If you don't know the code, contact your company administrator.",
  "auth.hospital_code_search": "Find",
  "auth.hospital_code_searching": "Finding...",
  "auth.hospital_code_invalid": "Please check the company code.",
  "auth.hospital_code_not_found": "No company matches this code. Check the code in your invitation message.",
  "auth.hospital_code_unreachable": "We can't connect right now. Please try again in a moment.",
  "auth.hospital_code_missing_discovery": "We can't look up companies right now. Please contact your company administrator.",
  "auth.hospital_confirm_title": "Is this your company?",
  "auth.hospital_confirm_subtitle": "If so, you'll go to the sign-in screen.",
  "auth.hospital_confirm_name": "Company name",
  "auth.hospital_confirm_connect": "Yes, connect",
  "auth.hospital_confirm_search_again": "Enter again",
  "auth.hospital_change": "Change organization",
  "auth.hospital_change_confirm": "Connect to a different organization?",
  "auth.accept_terms_required": "Please agree to the terms.",
  "auth.permission_required_title": "Permission Required",
  "auth.permission_required_message": "Please request permission from an administrator to use this feature.",
  "auth.required_permission": "Required permission:",
  "auth.permission_request_reason": "Reason for request",
  "auth.permission_request_placeholder": "Please describe why you need this permission...",
  "auth.permission_request_sent": "Permission request sent.",
  "auth.permission_request_sent_detail": "You will be notified when the administrator approves.",
  "auth.requesting": "Requesting...",
  "nav.employees": "Employees",
  "nav.teams": "Teams",
  "nav.roles": "Roles",
  "nav.leaves": "Leave",
  "nav.settings": "Settings",
  "nav.payroll": "Payroll",
  "nav.admin": "Admin",
  "nav.employee_app": "Employee App",
  "nav.module_manager": "Module Manager",
  "nav.team_management": "Internal Approval",
  "nav.nurse_scheduler": "Nurse Schedule",
  "nav.general_affairs": "General Affairs",
  "nav.inventory": "Inventory",
  "nav.management_dashboard": "Management Dashboard",
  "nav.drive": "Drive",
  "team_drive.title": "Drive",
  "team_drive.search_placeholder": "Folder / file name",
  "team_drive.upload": "Upload files",
  "team_drive.create_folder": "New Folder",
  "team_drive.parent_folder": "Parent Folder",
  "team_drive.folder_name": "Folder Name",
  "team_drive.name_placeholder": "Folder name",
  "team_drive.desc_placeholder": "Description",
  "team_drive.folder_hint": "Folder",
  "team_drive.file_hint": "Uploaded file",
  "team_drive.col_name": "Name",
  "team_drive.col_size": "Size",
  "team_drive.col_uploader": "Uploaded By",
  "team_drive.col_date": "Modified",
  "team_drive.col_comments": "Comments",
  "team_drive.new_comment_badge": "New comment",
  "team_drive.empty_root": "No folders yet. Create a folder to get started.",
  "team_drive.empty_folder": "This folder is empty.",
  "team_drive.toast_folder_created": "Folder created.",
  "team_drive.toast_uploaded": "File uploaded.",
  "team_drive.toast_uploaded_n": "{n} files uploaded.",
  "team_drive.toast_upload_rejected": "Some files were excluded due to type or size (max 10MB).",
  "team_drive.toast_upload_failed": "Upload failed. Please try again shortly.",
  "team_drive.error_name_required": "Please enter a folder name.",
  "team_drive.error_name_duplicate": "A folder with this name already exists. Please use a different name.",
  "team_drive.menu_new_folder": "New Folder",
  "team_drive.menu_rename": "Rename",
  "team_drive.menu_delete": "Delete",
  "team_drive.menu_move": "Move",
  "team_drive.trash": "Trash",
  "team_drive.trash_notice": "Items in the trash are permanently deleted after 30 days.",
  "team_drive.trash_empty": "The trash is empty.",
  "team_drive.trash_restore": "Restore",
  "team_drive.trash_purge": "Delete forever",
  "team_drive.trash_empty_all": "Empty trash",
  "team_drive.col_original_location": "Original location",
  "team_drive.col_deleted_by": "Deleted by",
  "team_drive.col_deleted_at": "Deleted on",
  "team_drive.original_missing": "Original location missing",
  "team_drive.confirm_purge": 'Delete "{name}" forever?',
  "team_drive.purge_irreversible": "This can't be undone. A folder is deleted with its subfolders and files.",
  "team_drive.confirm_empty_trash": "Delete all {n} items in the trash forever?",
  "team_drive.toast_restored": "Restored.",
  "team_drive.toast_restored_relocated": "The original location is gone, so it was restored to the root.",
  "team_drive.toast_purged": "Deleted forever.",
  "team_drive.toast_trash_failed": "Couldn't complete. Please try again.",
  "team_drive.selection_count": "{n} selected",
  "team_drive.selection_clear": "Clear selection",
  "team_drive.selection_no_permission": "Some selected items can't be edited.",
  "team_drive.select_all": "Select all",
  "team_drive.select_row": "Select",
  "team_drive.confirm_delete_many": "Delete the {n} selected items?",
  "team_drive.move_title": "Move",
  "team_drive.move_target": "Destination",
  "team_drive.move_confirm": "Move",
  "team_drive.move_current_location": "Current location",
  "team_drive.move_items_summary": "{folders} folders, {files} files",
  "team_drive.toast_moved": "Moved.",
  "team_drive.toast_move_failed": "Couldn't move. Please try again.",
  "team_drive.confirm_delete_folder": 'Delete the folder "{name}"?',
  "team_drive.confirm_delete_file": 'Delete the file "{name}"?',
  "team_drive.delete_subtree_note": "{folders} subfolders and {files} files will be deleted with it.",
  "team_drive.delete_confirm": "Delete",
  "team_drive.toast_deleted": "Deleted.",
  "team_drive.toast_delete_failed": "Couldn't delete. Please try again.",
  "team_drive.edit_folder": "Edit Folder",
  "team_drive.rename_file_message": "Enter a new file name.",
  "team_drive.rename_confirm": "Rename",
  "team_drive.toast_renamed": "Renamed.",
  "team_drive.toast_folder_updated": "Folder updated.",
  "team_drive.error_file_name_invalid": "That file name can't be used.",
  "team_drive.menu_permissions": "Manage Access",
  "team_drive.menu_share": "Share Link",
  "team_drive.menu_preview": "Preview",
  "team_drive.menu_download": "Download",
  "team_drive.drop_hint": "Drop here to upload",
  "team_drive.restricted_badge": "Restricted",
  "team_drive.access_title": "Manage Access",
  "team_drive.access_mode": "Who can see this",
  "team_drive.access_open": "Everyone in the organization",
  "team_drive.access_restricted": "Selected people only",
  "team_drive.grant_add": "Add people",
  "team_drive.grant_team": "Team",
  "team_drive.grant_employee": "Member",
  "team_drive.role_viewer": "Viewer",
  "team_drive.role_editor": "Editor",
  "team_drive.grant_inherited": "From parent",
  "team_drive.no_grants": "With no one listed, only the creator and admins can see it.",
  "team_drive.toast_access_saved": "Access settings saved.",
  "team_drive.access_open_desc": "Every member of the organization can see it",
  "team_drive.access_restricted_desc": "Only listed teams, members and admins can see it",
  "team_drive.access_open_locked": "Unavailable because a parent folder is restricted",
  "team_drive.access_from_parent": "Follows the restriction on parent folder \u201C{name}\u201D",
  "team_drive.access_from_ancestor": "from parent folder",
  "team_drive.grant_list": "Who can see",
  "team_drive.grant_new": "New",
  "team_drive.grant_sub_teams": "Include {n} sub-teams",
  "team_drive.access_pending": "{n} unsaved changes",
  "team_drive.access_save_without_targets": "Save with no one",
  "team_drive.toast_access_failed": "{n} changes could not be saved. Please save again.",
  "team_drive.share_title": "Share Link",
  "team_drive.share_create": "Create Link",
  "team_drive.share_copy": "Copy",
  "team_drive.share_copied": "Link copied.",
  "team_drive.share_revoke": "Revoke",
  "team_drive.share_none": "No share links yet.",
  "team_drive.share_no_expiry": "No expiry",
  "team_drive.share_login_note": "Only signed-in members of your organization can open this link.",
  "team_drive.share_invalid": "This link is invalid or has expired.",
  "team_drive.preview_unsupported": "Preview is not available for this format. Please download the file.",
  "team_drive.preview_open_tab": "Open in New Tab",
  "employee.employee": "Employee",
  "employee.employee_list": "Employee List",
  "employee.add_employee": "Add Employee",
  "employee.input_btn": "Enter",
  "employee.edit_employee": "Edit Employee",
  "employee.search_placeholder": "Name / Email / Employee no.",
  "employee.all_status": "All Status",
  "employee.download_list": "Download Employee List",
  "employee.selected_count": "{n} selected",
  "employee.bulk_status_change": "Bulk Status Change",
  "employee.bulk_role_change": "Bulk Role Change",
  "employee.family_name": "Last Name",
  "employee.given_name": "First Name",
  "employee.email": "Email",
  "employee.organization": "Organization",
  "employee.phone": "Phone",
  "employee.employee_number": "Employee No.",
  "employee.hire_date": "Hire Date",
  "employee.birth_date": "Date of Birth",
  "employee.auto_generated": "Auto-generated",
  "employee.basic_info": "Basic Info",
  "employee.hr_info": "HR Info",
  "employee.contract": "Contract",
  "employee.my_info": "My Info",
  "employee.address": "Address",
  "employee.street_address": "Street Address",
  "employee.city": "City",
  "employee.postal_code": "Postal Code",
  "employee.emergency_contact": "Emergency Contact",
  "employee.emergency_contact_help": "Name and phone are required when filling in",
  "employee.relationship": "Relationship (spouse, parent, etc.)",
  "employee.bank_account": "Bank Account",
  "employee.bank_account_help": "All fields are required when filling in",
  "employee.bank_name": "Bank Name",
  "employee.account_number": "Account Number",
  "employee.account_holder": "Account Holder",
  "employee.my_info_load_error": "Failed to load profile information",
  "employee.phone_invalid": "Please enter a valid phone number (10-11 digits)",
  "employee.postal_code_invalid": "Postal code must be 5 digits (or leave it empty)",
  "employee.emergency_name_required": "Emergency contact name is required",
  "employee.emergency_phone_required": "Emergency contact phone is required",
  "employee.bank_name_required": "Bank name is required",
  "employee.account_number_required": "Account number is required",
  "employee.account_holder_required": "Account holder is required",
  "employee.info_saved": "Information saved successfully",
  "employee.save_error": "Failed to save information",
  "employee.work_type_required": "Please enter both work type and reason",
  "employee.work_type_requested": "Work type change has been requested",
  "employee.request_error": "Failed to submit request",
  "employee.work_type_cancel_confirm": "Cancel work type change request?",
  "employee.request_cancelled": "Request has been cancelled",
  "employee.cancel_error": "Failed to cancel request",
  "employee.image_size_limit": "Image must be 10MB or smaller",
  "employee.profile_picture_changed": "Profile picture has been updated",
  "employee.profile_picture_error": "Failed to upload profile picture",
  "team.team": "Team",
  "team.add_team": "Add Team",
  "team.edit_team": "Edit Team",
  "team.team_code": "Team Code",
  "team.team_name": "Team Name",
  "team.leader": "Leader",
  "team.member_count": "Members",
  "team.members": "Team Members",
  "team.add_member": "Add Team Member",
  "team.select_employee": "Select an employee",
  "team.search_placeholder": "Search team name, code...",
  "team.code_immutable": "Team code cannot be changed after creation.",
  "team.name_placeholder": "Enter team name",
  "team.desc_placeholder": "Team description (optional)",
  "team.no_members": "No team members. Please add members first.",
  "role.role": "Role",
  "role.add_role": "Add Role",
  "role.edit_role": "Edit Role",
  "role.role_code": "Role Code",
  "role.role_name": "Role Name",
  "role.code_placeholder": "e.g. ROLE_MANAGER",
  "role.name_placeholder": "Enter role name",
  "role.desc_placeholder": "Description",
  "role.form_name_placeholder": "Enter a name for the new role",
  "role.form_desc_placeholder": "Short description of the role",
  "role.no_search_results": "No results found",
  "role.delete_blocked": "This role is assigned to employees and can't be deleted.",
  "role.admin_delete_blocked": "The super admin role can't be deleted.",
  "role.inactive_status": "This role is inactive.",
  "role.code_immutable": "Role code cannot be changed after creation.",
  "role.assigned_permissions": "Assigned Permissions",
  "role.no_permissions": "No permissions assigned",
  "role.select_all": "Turn on all permissions",
  "role.deselect_all": "Deselect All",
  "role.no_data": "No role data",
  "role.permissions_selected": "{n} permissions selected",
  "role.permission_management": "Roles & Permissions",
  "leave.leave": "Leave",
  "leave.leave_status": "Leave Status",
  "leave.entitlement_rules": "Entitlement Rules",
  "leave.search_placeholder": "Search name, employee no...",
  "leave.target_count": "Target Employees",
  "leave.avg_used": "Avg. Used",
  "leave.avg_remaining": "Avg. Remaining",
  "leave.total_granted": "Total Granted",
  "leave.used": "Used",
  "leave.remaining": "Remaining",
  "leave.days_remaining": "{n} days remaining",
  "leave.leave_of_absence_confirm": "Leave of Absence Confirmation",
  "leave.leave_reason": "Reason for Leave",
  "leave.select_reason": "Select a reason",
  "leave.childcare": "Childcare Leave",
  "leave.medical": "Medical (Illness/Injury)",
  "leave.family": "Family Leave",
  "leave.family_care": "Family Care Leave",
  "leave.education": "Education Leave",
  "leave.military": "Military Service Leave",
  "leave.personal": "Personal Reason",
  "leave.other": "Other",
  "leave.other_reason": "Other Reason",
  "leave.termination_confirm": "Termination Confirmation",
  "leave.termination_reason": "Reason for Termination",
  "payroll.payroll": "Payroll",
  "payroll.allowance_config": "Allowance/Incentive Config",
  "payroll.base_allowance": "Base Allowance",
  "payroll.base_allowance_desc": "Base allowances from employment contracts",
  "payroll.manual_entry": "Manual Entry",
  "payroll.manual_entry_desc": "Allowances entered directly by HR (special, etc.)",
  "payroll.overtime_allowance": "Overtime Allowance",
  "payroll.overtime_allowance_desc": "Auto-calculated: hourly rate \xD7 multiplier",
  "payroll.fixed_incentive": "Fixed Incentive",
  "payroll.fixed_incentive_desc": "Fixed unit price, employee self-registration + approval",
  "payroll.linked_module": "Module",
  "payroll.calc_value": "Calculation",
  "payroll.item_code": "Item Code",
  "payroll.item_code_edit": "Edit Item Code",
  "payroll.item_code_add": "Add Item Code",
  "payroll.allowance": "Allowance",
  "payroll.deduction": "Deduction",
  "payroll.effective_period": "Effective Period",
  "payroll.no_base_allowance": "No base allowances registered.",
  "payroll.no_manual_entry": "No manual entry allowances registered.",
  "payroll.no_overtime_allowance": "No overtime allowances registered.",
  "payroll.add_category": "Add Category",
  "payroll.add_preset": "Add Preset",
  "payroll.uncategorized": "Uncategorized",
  "payroll.request_amount": "Request Amount",
  "payroll.all_departments": "All Departments",
  "payroll.load_error": "Failed to load payslips",
  "payroll.status_draft": "Draft",
  "payroll.status_calculated": "Calculated",
  "payroll.status_approved": "Approved",
  "payroll.status_paid": "Paid",
  "payroll.status_cancelled": "Cancelled",
  "payroll.status_corrected": "Corrected",
  "overtime.overtime_request": "Overtime Request",
  "overtime.work_date": "Work Date",
  "overtime.start_time": "Start Time",
  "overtime.end_time": "End Time",
  "overtime.duration": "Duration",
  "overtime.category": "Category",
  "overtime.weekday": "Weekday Overtime",
  "overtime.saturday": "Saturday Work",
  "overtime.holiday": "Holiday Work",
  "overtime.night": "Night Work",
  "overtime.reason": "Reason",
  "overtime.reason_placeholder": "Enter overtime reason",
  "incentive.no_records": "No incentives registered this month",
  "incentive.weekend": "Weekend",
  "incentive.incentive_register": "Register Incentive",
  "incentive.work_date": "Work Date",
  "incentive.today_only": "Only today's incentives can be registered",
  "incentive.count": "Count",
  "incentive.memo": "Memo",
  "incentive.memo_placeholder": "Enter memo",
  "incentive.registering": "Registering...",
  "incentive.register": "Register",
  "incentive.monthly_title": "{month} Incentives",
  "incentive.registered_count": "{n} registered",
  "incentive.monthly_history": "This month's registrations",
  "settings.basic_info": "Basic Info",
  "settings.work_hours": "Work Hours",
  "grades.grade_suffix": "grade",
  "settings.salary_grade": "Salary Grades",
  "settings.allowance_deduction": "Allowance/Deduction",
  "settings.calculation_rules": "Calculation Rules",
  "settings.certifications": "Certifications",
  "settings.doc_templates": "Document Templates",
  "settings.doc_history": "Issuance History",
  "settings.org_loading": "Loading organization info...",
  "settings.org_settings": "Organization",
  "settings.org_basic_info": "Organization Info",
  "settings.hospital_name": "Hospital Name",
  "settings.corp_name": "Corporation Name",
  "settings.org_code": "Organization Code",
  "settings.business_number": "Business Reg. No.",
  "settings.main_phone": "Main Phone",
  "settings.fax": "Fax",
  "settings.website": "Website",
  "cert.cert_edit": "Edit Certification",
  "cert.cert_register": "Register Certification",
  "cert.cert_type": "Certification Type",
  "cert.doc_template_edit": "Edit Document Template",
  "cert.doc_template_add": "Add Document Template",
  "cert.select_template": "Select Base Template",
  "cert.template_code": "Template Code",
  "cert.template_name": "Template Name",
  "cert.preview": "Document Preview",
  "cert.pending_approval": "Pending Approval",
  "cert.approved": "Approved",
  "cert.rejected": "Rejected",
  "cert.request_error": "Failed to request employment certificate",
  "nurse.work_type_three_shift": "3-Shift Rotation",
  "nurse.work_type_night_dedicated": "Night Dedicated",
  "nurse.work_type_day_dedicated": "Day Dedicated",
  "nurse.work_type_evening_dedicated": "Evening Dedicated",
  "grade.grade_edit": "Edit Salary Grade",
  "grade.grade_add": "Add Salary Grade",
  "grade.job_category": "Job Category",
  "grade.rehabilitation": "Rehabilitation",
  "grade.functional": "Functional",
  "shift.shift_edit": "Edit Work Hours",
  "shift.shift_add": "Add Work Hours",
  "shift.regular": "Regular",
  "attendance.attendance_management": "Attendance Management",
  "attendance.this_week": "This Week",
  "attendance.last_week": "Last Week",
  "attendance.this_month": "This Month",
  "messenger.invite_do": "Invite",
  "messenger.loading_more": "Loading...",
  "approval.request_history": "Request History",
  "approval.no_leave_requests": "No leave requests",
  "approval.no_overtime_requests": "No overtime requests",
  "approval.no_documents": "No documents submitted",
  "approval.approver": "Approver:",
  "approval.cancel": "Cancel",
  "messenger.connecting": "Connecting...",
  "messenger.disconnected": "Disconnected \u2014 Retrying",
  "messenger.conversations": "Conversations",
  "messenger.contacts": "Contacts",
  "messenger.conv_search_placeholder": "Search conversations...",
  "messenger.notice": "Notices",
  "messenger.new_notices": "New notices",
  "messenger.channels": "Channels",
  "messenger.messages": "Messages",
  "messenger.no_conversations": "No conversations yet",
  "messenger.start_conversation": "Start a conversation from contacts",
  "messenger.msg_search_placeholder": "Search this chat",
  "messenger.no_search_results": "No results found",
  "messenger.load_older": "Load older messages",
  "messenger.new_messages_below": "{count} new messages",
  "messenger.new_messages_jump": "{count} new messages, jump to latest",
  "messenger.msg_input_placeholder": "Type a message...",
  "messenger.sending": "Sending...",
  "messenger.resend": "Resend",
  "messenger.read": "Read",
  "messenger.read_status": "Read status",
  "messenger.read_by": "Read by",
  "messenger.unread_by": "Not read yet",
  "messenger.group_chat": "Group Chat",
  "messenger.group_create": "Create Group",
  "messenger.creating": "Creating...",
  "messenger.group_title_placeholder": "Enter group name",
  "messenger.contact_search_placeholder": "Search by name or position...",
  "messenger.contact_search_mode": "Search by",
  "messenger.contact_search_by_name": "Name",
  "messenger.contact_search_by_team": "Team",
  "messenger.contact_team_filter_clear": "Clear team filter",
  "messenger.expand_all": "Expand All",
  "messenger.collapse_all": "Collapse All",
  "messenger.notices_more": "See more",
  "messenger.notices_less": "See less",
  "messenger.notices_more_unacknowledged": "{n} unacknowledged notices",
  "messenger.team_message": "Group chat",
  "messenger.chat_settings": "Chat Settings",
  "messenger.room_name_label": "Room name (only visible to you)",
  "messenger.room_name_placeholder": "Room name",
  "messenger.member_invite": "Invite Members",
  "messenger.invite_btn": "+ Invite",
  "messenger.owner": "Owner",
  "messenger.kick_member": "Remove",
  "messenger.leave_room": "Leave Room",
  "messenger.invite_search_placeholder": "Search by name...",
  "messenger.inviting": "Inviting...",
  "messenger.later": "Later",
  "messenger.fold": "Collapse",
  "messenger.view_all": "View All",
  "messenger.search_results_count": " results",
  "messenger.search_jump_not_found": "Message not found",
  "messenger.members_count": "Members",
  "messenger.acknowledged": "Acknowledged",
  "messenger.notice_no_ack_required": "Informational post \u2014 no acknowledgment needed",
  "messenger.acknowledged_done": "Acknowledged",
  "messenger.notice_detail": "Notice",
  "messenger.team_group_message": "Team group message",
  "messenger.selected_count": " selected",
  "messenger.select_all": "Select all",
  "notification.settings": "Notification Settings",
  "notification.push_title": "Push Notifications",
  "notification.push_desc": "Receive push notifications for schedule changes, approval results, etc.",
  "notification.mark_all_read": "Mark all read",
  "notification.no_notifications": "No notifications",
  "notification.no_action_items": "No action items",
  "notification.mute_actor": "Mute notifications from this person",
  "notification.push_notifications": "Push notifications",
  "notification.all_types": "Receive all notifications",
  "notification.all_types_desc": "Turn off to pause notifications of every type.",
  "notification.muted_people": "Muted people",
  "notification.unmute": "Unmute",
  "notification.mute_confirm": "'s notifications will be muted. Continue?",
  "notification.org_not_found": "Could not load organization info. Please log in again.",
  "notification.muted_success": "'s notifications have been blocked",
  "notification.mute_error": "Error while muting notifications",
  "notification.settings_error": "Error while changing notification settings",
  "notification.time_just_now": "just now",
  "notification.time_minutes_ago": "m ago",
  "notification.time_hours_ago": "h ago",
  "notification.time_days_ago": "d ago",
  "notification.event_leave_request": "Leave Request",
  "notification.event_overtime": "Overtime",
  "notification.event_offsite_work": "Offsite work",
  "notification.event_incentive": "Incentive",
  "notification.event_allowance": "Allowance",
  "notification.event_deduction": "Deduction",
  "notification.event_document": "Document",
  "notification.event_education": "Education",
  "notification.event_general": "General",
  "notification.event_system": "System",
  "update.new_version_ready": "New version available",
  "update.version": "Version",
  "update.restart_prompt": "Restart the app to apply",
  "update.later": "Later",
  "update.restart": "Restart",
  "update.applying": "Applying update",
  "update.apply_failed": "Could not apply the update. Please try again.",
  "update.retry": "Try again",
  "update.required_title": "App update required",
  "update.required_description": "This version is no longer supported. Install the latest version, then check again.",
  "update.update_now": "Update now",
  "update.check_again": "Check again",
  "update.checking": "Checking version",
  "update.check_failed": "We could not confirm the supported version. Check your connection and try again.",
  "update.optional_title": "A new version is available",
  "update.optional_description": "You can keep using the app and update later.",
  "admin.hospital_settings": "Workspace Settings",
  "admin.admin_only_message": "This admin page is only accessible to system administrators.",
  "status.active_employee": "Active",
  "status.on_leave": "On Leave",
  "status.terminated": "Terminated",
  "employee.total_employees": "Total Employees",
  "employee.no_team": "Assign Team",
  "employee.no_team_hint": "No teams",
  "employee.no_role_hint": "No roles",
  "employee.team_required": "Team required",
  "employee.no_data": "No employee data",
  "employee.registration_complete": "Employee registration complete",
  "employee.temp_password_issued": "Temporary password issued",
  "employee.password_label": "Password",
  "employee.copy": "Copy",
  "employee.copied": "Copied!",
  "employee.temp_password_notice": "Please share this password with the employee. It will be changed on first login.",
  "employee.send_password_sms": "Send password via SMS",
  "employee.no_team_warning": "Without a team assignment, roles cannot be assigned. Employees registered without a role have no permissions \u2014 assign a role in Team Management afterwards.",
  "employee.select_role_after_team": "Select after team assignment",
  "employee.select_role": "Select role",
  "employee.system_admin": "System Administrator",
  "employee.system_admin_desc": "Superuser privilege that bypasses all permissions",
  "employee.phone_otp_login": "Allow Phone OTP Login",
  "employee.phone_otp_login_desc": "Lets the employee sign in with an SMS verification code",
  "employee.password_change": "Change Password",
  "employee.temp_password_sms": "Temp Password (SMS)",
  "employee.manual_password": "Set Manually",
  "employee.temp_password_sms_desc": "Generate a temporary password and send via SMS.",
  "employee.temp_password_sms_btn": "Generate & Send SMS",
  "employee.new_password_placeholder": "New password (min {min} chars)",
  "employee.confirm_password_placeholder": "Confirm password",
  "employee.change_password_btn": "Change Password",
  "employee.team_role_assignment": "Team Role Assignment",
  "employee.add_team": "Add Team",
  "employee.no_role": "No role",
  "employee.no_team_membership": "Not assigned to any team.",
  "employee.select_team": "Select team",
  "employee.search_team_placeholder": "Search teams",
  "employee.leave_history": "Leave/Termination History",
  "employee.on_leave_label": "On Leave",
  "employee.returned_label": "Returned",
  "employee.leave_cancelled_label": "Leave Cancelled",
  "employee.terminated_label": "Terminated",
  "employee.termination_leave_balance": "Remaining leave (hire-date basis)",
  "employee.termination_leave_balance_hint": "Reference value for resignation settlement.",
  "employee.termination_leave_balance_reference": "Converted to the hire-date basis for reference; the organization uses the fiscal-year basis.",
  "resignation.status_pending": "Pending",
  "resignation.status_processing": "Processing",
  "resignation.status_settled": "Settled",
  "resignation.status_completed": "Completed",
  "employee.attendance_method": "Attendance Method",
  "employee.attendance_method_desc": "Follow org default or set a custom method for this employee.",
  "employee.attendance_org_default": "Use org default",
  "employee.work_group": "Work Group",
  "employee.work_group_unassigned": "No group",
  "employee.default_shift_empty": "No work assignment. Attendance uses the job duty default \u201C{name}\u201D.",
  "employee.default_shift_differs": "Job duty default \u201C{name}\u201D \u2260 individual \u201C{current}\u201D",
  "employee.apply_default_shift": "Use job duty default",
  "employee.work_group_from_job_duty": "The default work assignment for the job duty \u201C{name}\u201D is selected. Change it if it differs.",
  "employee.job_duty_select_placeholder": "Select a job duty",
  "employee.work_pattern": "Work pattern",
  "employee.work_pattern_select_placeholder": "Select a work pattern (optional)",
  "employee.work_pattern_none_registered": "No work patterns registered. Register them under Settings \u203A Work patterns to auto-fill monthly hours and hourly rate.",
  "employee.work_pattern_from_job_duty": 'The default work pattern of job duty "{name}" was selected. Change it if needed.',
  "employee.work_pattern_derived_hint": "With a work pattern, monthly hours, fixed overtime/night hours, wage hours and hourly rate are filled from the pattern. Manually edited values stay manual.",
  "employee.job_duty_none_registered": "No job duties are registered. Register them first under Settings \xE2\x80\xBA Work Settings \xE2\x80\xBA Job Duties.",
  "employee.work_group_from_team": "The team's representative work assignment is selected. Change it if it differs.",
  "employee.work_group_needs_team": "Add a team first \u2014 its work group is filled in automatically.",
  "employee.primary_shift": "Primary team",
  "employee.set_primary_shift": "Make primary",
  "employee.primary_shift_notice": "Attendance reference times and leave follow the primary team's work assignment. The payroll sheet also shows the primary team.",
  "employee.effective_shift_label": "Shift used for attendance now",
  "employee.effective_shift_source": "Source: {source}",
  "employee.effective_shift_group_auto": "{group} group \xB7 weekday shift picked automatically ({count})",
  "employee.effective_shift_none": "Organization default hours",
  "employee.remove_row_shift_group": "Remove this membership's shift group",
  "employee.remove_row_shift_group_confirm": "Remove the shift group of the \u201C{team}\u201D membership?\nToday's attendance will be re-judged on save; scheduler assignments stay as they are.",
  "employee.remove_row_shift_group_primary_hint": "The primary membership's shift cannot be removed. Make another membership primary first.",
  "employee.remove_row_shift_group_pending": "This membership's shift group will be cleared on save.",
  "employee.team_permission_required": "Saving a team requires team edit permission. Ask an administrator who has it.",
  "employee.membership_save_failed": "Couldn't save the team membership: {teams}. Open Edit from the employee list and set the team and work assignment again.",
  "employee.shift_assignment": "Work Shift",
  "employee.resident_number": "Resident Number",
  "employee.rrn_invalid": "Invalid resident registration number format.",
  "employee.rrn_invalid_date": "Invalid date in resident registration number.",
  "employee.rrn_invalid_checksum": "Resident registration number checksum failed. Please verify.",
  "employee.required_missing": "Required field missing",
  "employee.section_required_basic_html": '<span class="text-primary">Required</span> Basic Info',
  "employee.section_required_hr_html": '<span class="text-primary">Required</span> HR Info',
  "employee.section_other_personal": "Other Personal Info",
  "employee.section_other_hr": "Other HR Info",
  "employee.auto_generate": "Auto-generate",
  "employee.email_invalid_format": "Please enter a valid email.",
  "employee.lunar": "Lunar",
  "employee.rrn_front_placeholder": "Enter birth date first",
  "employee.phone_as_id_tip": "The phone number can be used as a login ID.",
  "employee.phone_sms_notice": "A phone number is required to send the temporary password via SMS.",
  "employee.address_search_placeholder": "Search for an address (road name, lot number)",
  "employee.clear_address": "Clear address",
  "employee.address_detail_placeholder": "Detailed address",
  "employee.select_date": "Select date",
  "employee.today": "Today",
  "employee.org_default_or_custom": "Org default or custom setting",
  "employee.affiliation_team_role": "Affiliation (Team \xB7 Role)",
  "employee.job_duty": "Job duty",
  "employee.job_duty_placeholder": "e.g. Nurse",
  "employee.change_team": "Change team",
  "employee.change_role": "Change role",
  "employee.no_role_assigned": "No role",
  "employee.add_affiliation": "Add affiliation",
  "employee.add_without_role": "Add without role",
  "employee.change_without_role": "Change without role",
  "employee.status_inactive_notice": "Registered as inactive. Change to active to enable use.",
  "employee.status_active_notice": "Registered as active. The user can log in and start using it right away.",
  "employee.shift_notice_html": 'Work shift can be added or edited under <strong class="font-semibold">Attendance</strong> > <strong class="font-semibold">Shift Settings</strong>.',
  "employee.allowed_shifts": "Allowed work shifts",
  "employee.allowed_shifts_help": "Shifts this employee may pick in the app even outside the assigned shift group. Merged with the team's allowed shifts; payroll work pattern is unaffected.",
  "employee.view_all_shift_types": "View All Work Shifts",
  "employee.registered_shift_types": "Registered Work Shifts",
  "employee.no_registered_shift_types": "No work shifts registered yet.",
  "employee.select_cert_type": "Select Certification Type",
  "employee.cert_submit_notice_html": `Select the certifications/licenses the employee must submit.<br />Selected items are registered on the certification screen as <strong class="font-semibold">'File Not Submitted'</strong>.<br />After onboarding, certification info can be registered under the <strong class="font-semibold">'Document Approval'</strong> > <strong class="font-semibold">'Certifications'</strong> tab.`,
  "employee.cert_request_count": "Requesting submission of {n} certification(s).",
  "employee.cert_no_request": "Do not request certification submission.",
  "employee.contract_info": "Contract Info",
  "employee.salary_basis": "Salary Basis",
  "employee.salary_grade": "Salary Grade",
  "employee.grade_locked_hint": "Values come from the salary grade table while a grade is selected. Clear the grade to enter them manually.",
  "employee.work_hours_section": "Work Hours",
  "employee.preview": "Preview",
  "employee.reg_success_title": "Employee registered successfully!",
  "employee.temp_password_created": "A temporary password has been generated. Please share it with the employee.",
  "employee.password_copied": "Temporary password copied.",
  "employee.password_once_warning_html": "Once you close this window, the issued password cannot be viewed again! Password reset and reissuance are available in <strong>Edit Employee</strong>.",
  "employee.address_search": "Address Search",
  "employee.address_search_loading": "Loading address search...",
  "employee.full_name": "Full Name",
  "employee.not_entered": "Not entered",
  "employee.certification": "Certification/License",
  "employee.not_submitted": "Not Submitted",
  "employee.weekly_hours_summary": "{std}h/wk (max {max}h)",
  "employee.hobong_label": "Step Pay",
  "employee.longevity_label": "Longevity Pay",
  "employee.meal_label": "Meal Allowance",
  "employee.transport_label": "Transport",
  "employee.position_label": "Position Allowance",
  "employee.close_confirm_title": "Closing the window will discard all entered information.",
  "employee.close_confirm_desc": "Unsaved information cannot be recovered.",
  "employee.continue_editing": "Keep editing",
  "employee.leave_page": "Leave",
  "employee.employee_number_change_notice": "Changing the employee number also changes the login ID.",
  "employee.employee_number_uppercase_hint": "Employee numbers are saved as typed. Login, search and duplicate checks ignore case.",
  "employee.return_notice": "Processing the return ends the leave record and changes the status to active.",
  "employee.cert_edit_notice_html": 'Certification info can be registered/edited under the <strong class="font-semibold">Document Approval</strong> > <strong class="font-semibold">Certifications</strong> tab.',
  "employee.no_certifications": "No certifications/licenses registered.",
  "employee.license_number": "License/Certification No.",
  "employee.registered_date": "Registered Date",
  "employee.next_reporting_deadline": "Next Reporting Deadline",
  "employee.attachment_preview": "Attachment Preview",
  "employee.manual_password_desc": "The administrator enters a new password directly.",
  "employee.manual_password_rule": "Use at least {min} characters, or match the organization's temporary password format.",
  "employee.manual_password_rule_with_format": "Use at least {min} characters, or the temporary password format ({format}).",
  "employee.manual_password_temp_hint": "This matches the temporary password format. The employee must change it at first login.",
  "employee.confirm_temp_format_password": "Set it in the temporary password format? The employee must change it at first login.",
  "employee.sms_login_allow": "Allow SMS Login",
  "employee.saved": "Saved",
  "employee.save_partial": "Save Progress",
  "employee.saving_reflect": "Applying",
  "employee.shift_unassigned": "Unassigned",
  "employee.system_admin_change": "Change System Administrator",
  "employee.system_admin_confirm_html": 'Change this user to a <span style="font-weight: 700;">System Administrator</span>? Administrators can access all features.',
  "employee.close_confirm_edit": "Leave without saving your changes?",
  "employee.loading": "Loading...",
  "employee.preview_unsupported_html": "This format cannot be previewed on screen.<br />Please open it in a new window.",
  "employee.open_new_window": "Open in New Window",
  "employee.expected_return_prefix": "(Expected ",
  "employee.enter_birth_first": "Please enter the birth date first.",
  "employee.phone_required_disabled": "Unavailable \u2014 no phone number entered.",
  "employee.change_preview": "Preview changes",
  "employee.certification_register": "Register Certification/License",
  "employee.account_security": "Account & Security",
  "employee.recurring_allowances": "Fixed allowances",
  "recurring.hint": "Define recurring fixed allowances (licence, position, \u2026) by period. Sheets read the definitions valid in their month, so an ended allowance drops out from the next month and past months keep their values.",
  "recurring.list_title": "Defined allowances",
  "recurring.empty": "No fixed allowances defined.",
  "recurring.add_title": "Add allowance",
  "recurring.label": "Allowance name",
  "recurring.code": "Code",
  "recurring.code_hint": "Sheet columns bound to the recurring allowance source can filter by this code (lowercase letters, digits, underscores).",
  "recurring.amount": "Monthly amount",
  "recurring.note": "Note (optional)",
  "recurring.valid_from": "Start date",
  "recurring.valid_until": "End date",
  "recurring.valid_until_optional": "End date (optional \xB7 empty = open-ended)",
  "recurring.open_ended": "open-ended",
  "recurring.add": "Add",
  "recurring.end": "Save end date",
  "recurring.correct": "Correct amount",
  "recurring.correct_confirm": "Correct the amount? It applies to every unconfirmed month this definition covers. To change from a specific date, set an end date and add a new one.",
  "recurring.form_invalid": "Fill in the name, code and start date, and enter an amount above 0.",
  "recurring.load_fail": "Could not load fixed allowances",
  "recurring.save_fail": "Could not save the fixed allowance",
  "recurring.status_active": "Active",
  "recurring.status_scheduled": "Scheduled",
  "recurring.status_ended": "Ended",
  "leave.leave_process": "Leave of Absence",
  "leave.return_process": "Return from Leave",
  "leave.termination_process": "Termination",
  "leave.start_date": "Leave Start Date",
  "leave.expected_return": "Expected Return Date",
  "leave.notes": "Notes",
  "leave.notes_placeholder": "Notes (optional)",
  "leave.leave_warning": "The employee status will change to On Leave. They will be excluded from payroll and attendance.",
  "leave.termination_date": "Last Working Day",
  "leave.termination_notes_placeholder": "Handover, settlement notes, etc.",
  "leave.termination_agree": "I confirm the above and agree to proceed with termination.",
  "leave.tenure": "Tenure",
  "leave.usage_rate": "Usage Rate",
  "leave.calculation_basis": "Basis",
  "leave.hire_date_basis": "Hire Date",
  "leave.fiscal_year_basis": "Fiscal Year",
  "leave.rule_desc": "Manage annual leave entitlement rules based on labor standards.",
  "leave.add_rule": "Add Entitlement Rule",
  "leave.template_desc": "Register default annual leave rules per Korean Labor Standards Act (monthly accrual for <1yr, 15 days for 1-3yr, seniority bonus)",
  "leave.register_default_rules": "Register Default Rules",
  "leave.years_of_service": "Years of Service",
  "leave.entitled_days": "Entitled Days",
  "leave.accrual_type": "Accrual Type",
  "leave.max_days": "Max Days",
  "leave.monthly_accrual": "Monthly Accrual",
  "leave.annual_grant": "Annual Grant",
  "leave.no_rules": "No entitlement rules configured. Please add rules.",
  "leave.edit_rule": "Edit Entitlement Rule",
  "leave.add_rule_title": "Add Entitlement Rule",
  "leave.years_start": "Years Start (from)",
  "leave.years_end": "Years End (below, blank=unlimited)",
  "leave.unlimited": "Unlimited",
  "leave.max_days_monthly": "Max Days (monthly accrual cap)",
  "leave.no_limit": "No limit",
  "leave.rule_placeholder": "e.g. Per Labor Standards Act Art. 60",
  "leave.years_or_more": "or more",
  "leave.years_less_than": "yrs less than",
  "leave.voluntary": "Voluntary Resignation",
  "leave.recommended": "Recommended Resignation",
  "leave.job_change": "Job Change",
  "leave.contract_expiry": "Contract Expiry",
  "leave.retirement": "Retirement",
  "leave.dismissal": "Dismissal (Disciplinary)",
  "team.add_member_btn": "Add Member",
  "team.no_data": "No team data",
  "team.no_member_data": "No members",
  "team.remove": "Remove",
  "role.no_permissions_hint": "No permissions",
  "role.permissions_label": "Select Permissions",
  "role.perm_search_placeholder": "Search permissions (item, name)",
  "role.perm_all_resources": "All items",
  "role.perm_scope_any": "All scopes",
  "role.perm_selected_only": "Selected only",
  "role.perm_selected_count": "{n} selected \xB7 {m} total",
  "role.perm_set_all": "Row: all full",
  "role.perm_set_all_tip": "Grant all permissions",
  "role.perm_bundle_help": "Show required permissions",
  "role.perm_clear": "Clear",
  "role.perm_none": "None",
  "role.perm_scope_missing": "No permission exists at this scope",
  "role.perm_compare_none": "No comparison",
  "role.perm_compare_label": "Compare with another role",
  "role.perm_compare_value": "Compared: {s}",
  "role.perm_diff_only": "Differences only",
  "role.perm_no_match": "No permissions match",
  "role.perm_bundles_label": "Start from features",
  "role.perm_bundles_hint": "Turns on what a menu needs in one go. Unchecking turns off only what this feature turned on (cells you changed by hand stay).",
  "role.perm_bundle_full": "Complete",
  "role.perm_bundle_partial": "Partial",
  "role.perm_bundle_none": "None",
  "role.perm_all_confirm": "Turn on all {n} permissions at the widest scope?",
  "role.perm_all_confirm_note": "This role will be able to view and change all organization data.",
  "role.perm_all_confirm_ok": "Turn on all",
  "role.perm_bundle_missing_one": "Missing: {name}",
  "role.perm_bundle_missing_many": "Missing: {name} and {n} more",
  "role.perm_detail_label": "Detailed permissions",
  "role.perm_expand_all": "Expand all",
  "role.perm_collapse_all": "Collapse all",
  "role.perm_group_count": "{n} on",
  "role.perm_area_col": "Area",
  "role.perm_view_total": "{n} permissions",
  "role.perm_view_empty": "No permissions yet. Use the edit button to turn some on.",
  "role.perm_view_show_all": "View all permissions ({n})",
  "role.perm_summary_title": "What this role can do",
  "role.perm_summary_empty": "No permissions yet. Turn some on from the features above or the table.",
  "role.perm_summary_bundles": "Complete features",
  "role.perm_summary_groups": "Permissions on by area",
  "role.org_scope_label": "Role list tags",
  "role.org_scope_hint": "Tags that make the role easy to find in the list. They do not limit permission scope.",
  "role.multi_select": "Select multiple",
  "role.save_needs_name": "Enter a role name to save",
  "role.perm_bundle_add": "Add required permissions for {name}",
  "role.perm_bundle_added": "Added required permissions for {name} ({n} cells)",
  "role.perm_bundle_already": "{name} already has all required permissions",
  "role.perm_bundle_unavailable": "{n} permissions missing from this organization's catalog could not be added",
  "role.perm_bundle_requires": "Required permissions",
  "role.perm_bundle_missing": "Still missing",
  "role.perm_resource_col": "Item",
  "settings.payroll_settings": "Payroll Settings",
  "settings.pay_day": "Pay Day",
  "settings.cutoff_day": "Cutoff Day",
  "settings.fiscal_year_start": "Fiscal Year Start Month",
  "settings.leave_accrual_basis": "Leave Accrual Basis",
  "settings.weekly_hour_limit": "Weekly Hour Limit",
  "settings.daily_standard_hours": "Daily Standard Hours",
  "settings.currency": "Currency",
  "settings.attendance_method": "Attendance Method",
  "settings.attendance_default": "Default Method",
  "settings.attendance_org_note": "Org default \u2014 can be overridden per employee",
  "settings.attendance_app": "App (Web/Mobile)",
  "settings.attendance_secom": "Fingerprint (Secom)",
  "settings.attendance_manual": "Manual Entry",
  "settings.allowed_ips": "Allowed IP Addresses",
  "settings.no_ip_restriction": "No restriction (all IPs allowed)",
  "settings.allowed_ips_app": "Allowed IPs (app method only)",
  "settings.ip_help": "Enter CIDR or exact IP addresses. Leave empty to allow all.",
  "settings.seal_image": "Seal Image",
  "settings.seal": "Seal",
  "settings.seal_not_registered": "Not registered",
  "settings.seal_help": "Transparent PNG recommended (under 500KB)",
  "settings.representative": "Representative",
  "settings.email": "Email",
  "settings.default_work_hours": "Default Work Hours",
  "settings.default_work_hours_desc": "Default shift auto-assigned to new employees",
  "settings.not_set": "Not set",
  "settings.shift_desc": "Manage regular and rotating shift schedules",
  "settings.add_shift": "Add Shift",
  "settings.template_add": "Add from Template",
  "settings.no_shifts": "No shifts configured",
  "settings.default_badge": "Default",
  "settings.overtime_rate": "Allowance Rates",
  "settings.overtime_multiplier": "Overtime Multiplier",
  "settings.work_days": "Work Days",
  "settings.work_hours_label": "Work Hours (h)",
  "settings.break_hours_label": "Break Hours (h)",
  "settings.start_time": "Start Time",
  "settings.end_time": "End Time",
  "settings.shift_type": "Shift Type",
  "settings.shift_day": "Day",
  "settings.shift_evening": "Evening",
  "settings.shift_night": "Night",
  "settings.shift_flexible": "Flexible",
  "settings.shift_on_call": "On-call",
  "settings.shift_off": "Off",
  "settings.shift_code": "Code",
  "settings.shift_name": "Shift Name",
  "settings.shift_name_placeholder": "Enter a name to identify this shift (e.g. Morning, Weekday, 9to6)",
  "settings.shift_classification": "Type",
  "settings.shift_classification_regular": "Regular",
  "settings.shift_classification_overtime": "Overtime",
  "settings.shift_overnight": "Next-day checkout (crosses midnight)",
  "settings.shift_treat_holiday": "Treat as holiday work",
  "settings.shift_night_dedicated": "Night-dedicated",
  "settings.shift_treat_holiday_badge": "Holiday",
  "settings.shift_night_dedicated_badge": "Night",
  "settings.allowance_a_codes": "Allowance Item Codes (A)",
  "settings.deduction_d_codes": "Deduction Item Codes (D)",
  "settings.no_allowance_codes": "No allowance codes registered",
  "settings.no_deduction_codes": "No deduction codes registered",
  "settings.allowance_calc_rules": "Allowance Calculation Rules",
  "settings.deduction_calc_rules": "Deduction Calculation Rules",
  "settings.no_allowance_rules": "No allowance rules registered",
  "settings.no_deduction_rules": "No deduction rules registered",
  "settings.effective_date": "Effective Date",
  "settings.no_cert_data": "No certifications registered",
  "settings.excel_download": "Excel Download",
  "settings.cert_register": "Register Certification",
  "settings.all_types": "All Types",
  "settings.grade_category": "Category",
  "settings.effective_year": "Effective Year",
  "settings.grade_count": "Grade Count",
  "settings.no_grade_data": "No salary grade data",
  "settings.grade_number": "Grade",
  "settings.base_salary": "Base Salary",
  "settings.hobong_amount": "Step Amount",
  "settings.annual_salary": "Annual Salary",
  "settings.minimum_wage": "Min. Hourly Wage",
  "settings.monthly_hours": "Monthly Hours",
  "settings.grade_status_active": "Active",
  "settings.grade_status_inactive": "Inactive",
  "settings.doc_template_desc": "Manage document templates.",
  "settings.add_template": "Add Template",
  "settings.no_templates": "No templates registered",
  "settings.available_variables": "Available Variables",
  "settings.cert_history_title": "Certificate Issuance History",
  "settings.all_employees": "All Employees",
  "settings.no_history": "No history",
  "settings.request_date": "Request Date",
  "settings.purpose": "Purpose",
  "settings.cert_number": "Certificate No.",
  "settings.org_edit_title": "Edit Organization Info",
  "settings.display_order": "Display Order",
  "settings.default_attendance": "Default Attendance Method",
  "settings.basic_allowance": "Base Allowance",
  "settings.manual_entry": "Manual Entry",
  "settings.overtime_allowance": "Overtime Allowance",
  "settings.fixed_incentive": "Fixed Incentive",
  "settings.settlement_allowance": "Settlement",
  "settings.uncategorized": "Uncategorized",
  "settings.notes": "Notes",
  "attendance.attendance_records": "Attendance Records",
  "attendance.date": "Date",
  "attendance.shift": "Shift",
  "attendance.check_in": "Check In",
  "attendance.check_out": "Check Out",
  "attendance.regular": "Regular",
  "attendance.overtime": "Overtime",
  "attendance.night": "Night",
  "attendance.weekend": "Weekend",
  "attendance.total_hours": "Total",
  "attendance.period_total": "Period total",
  "attendance.input_method": "Input Method",
  "attendance.manual": "Manual",
  "attendance.no_records": "No attendance records found",
  "attendance.secom_events": "Secom Fingerprint Events",
  "attendance.no_secom_events": "No Secom events found",
  "attendance.event_datetime": "Event Time",
  "attendance.terminal": "Terminal",
  "attendance.error_message": "Error Message",
  "attendance.shift_selector": "Work Shift",
  "attendance.org_default_shift": "Use org default shift",
  "attendance.recalculate_all": "Recalculate All",
  "attendance.recalculating": "Recalculating...",
  "attendance.recalculate_all_hint": "Recalculate attendance for the entire selected period from Secom fingerprint events (auto-generated records refreshed, manual entries kept)",
  "attendance.recalculate_date_hint": "Recalculate only this date's attendance from Secom fingerprint events (auto-generated records refreshed, manual entries kept)",
  "attendance.auto_infer": "Auto-infer work hours",
  "attendance.auto_infer_desc": "(Auto-classify day/evening/night for rotating nurses based on event time)",
  "attendance.last_month": "Last Month",
  "attendance.last_3_months": "Last 3 Months",
  "cert.cert_name": "Certificate Name",
  "cert.license_number": "License No.",
  "cert.issuing_authority": "Issuing Authority",
  "cert.issue_date": "Issue Date",
  "cert.expiry_date": "Expiry Date",
  "cert.file": "File",
  "cert.view_file": "View",
  "cert.variable_insert": "Insert variable (click to insert at cursor)",
  "cert.body": "Body",
  "cert.request_fields": "Request form fields",
  "cert.request_fields_hint": "Fields the employee fills in when requesting this certificate. Values fill the {{\uC6A9\uB3C4}} {{\uC81C\uCD9C\uCC98}} {{\uC8FC\uC18C}} {{\uC218\uB7C9}} {{\uBE44\uACE0}} placeholders. Purpose is always required.",
  "cert.field_item": "Field",
  "cert.field_use": "Use",
  "cert.field_required": "Required",
  "cert.edit_return": "Back to Edit",
  "cert.approve": "Approve",
  "contract.contract_type": "Contract Type",
  "contract.permanent": "Permanent",
  "contract.temporary": "Temporary",
  "contract.contract": "Contract",
  "contract.internship": "Internship",
  "contract.part_time": "Part-time",
  "contract.wage_type": "Wage Type",
  "contract.monthly": "Monthly",
  "contract.hourly": "Hourly",
  "contract.daily": "Daily",
  "contract.annual": "Annual",
  "contract.base_salary": "Base Salary (KRW)",
  "contract.hobong": "Step Pay (KRW)",
  "contract.longevity": "Longevity Pay (KRW)",
  "contract.meal_allowance": "Meal Allowance (KRW)",
  "contract.transport": "Transport (KRW)",
  "contract.position_allowance": "Position Allowance (KRW)",
  "contract.standard_weekly_hours": "Standard Weekly Hours",
  "contract.max_weekly_hours": "Max Weekly Hours",
  "contract.probation_section": "After probation",
  "contract.probation_end_date": "Probation end date",
  "contract.probation_after_base_salary": "Base salary after probation",
  "contract.probation_after_hourly_rate": "Hourly rate after probation",
  "contract.probation_hint": "Schedules a new contract starting the day after the end date. Sheets during probation use the contract above; afterwards they use these values. Leave empty to skip.",
  "contract.probation_invalid": "The probation end date must be on or after the hire date, and enter a base salary or hourly rate after probation.",
  "contract.probation_review": "Probation until {date} \xB7 from the next day {values}",
  "common.action": "Actions",
  "common.manage": "Manage",
  "common.register": "Register",
  "common.registering": "Registering...",
  "common.view_mode": "Table",
  "common.tree_mode": "Tree",
  "common.edit_btn": "Edit",
  "common.previous": "Previous",
  "dept_type.medical": "Medical",
  "dept_type.nursing": "Nursing",
  "dept_type.support": "Support",
  "dept_type.management": "Management",
  "dept_type.hr": "HR",
  "dept_type.finance": "Finance",
  "dept_type.operations": "Operations",
  "dept_type.other": "Other",
  "dept_type.restructuring": "Restructuring",
  "team_mgr.approve_failed": "Approval failed",
  "team_mgr.config_failed": "Configuration failed",
  "team_mgr.confirm_delete_shift": "Delete this shift configuration?",
  "team_mgr.confirm_delete_training": "Delete this training?",
  "team_mgr.confirm_delete_task": "Delete this task?",
  "team_mgr.confirm_delete_notice": "Delete this notice?",
  "team_mgr.create_failed": "Creation failed",
  "team_mgr.delete_failed": "Deletion failed",
  "team_mgr.incentive_config_load_failed": "Failed to load incentive settings",
  "team_mgr.publish_failed": "Publishing failed",
  "team_mgr.register_failed": "Registration failed",
  "team_mgr.reject_failed": "Rejection failed",
  "team_mgr.save_failed": "Save failed",
  "team_mgr.treatment_registered": "Treatment incentive has been registered.",
  "team_mgr.unknown_error": "Unknown error",
  "team_mgr.update_failed": "Update failed",
  "team_mgr.leave_type_annual": "Annual Leave",
  "team_mgr.leave_type_sick": "Sick Leave",
  "team_mgr.leave_type_personal": "Personal",
  "team_mgr.leave_type_maternity": "Maternity Leave",
  "team_mgr.leave_type_paternity": "Paternity Leave",
  "team_mgr.leave_type_bereavement": "Bereavement Leave",
  "team_mgr.leave_type_military": "Military Service",
  "team_mgr.status_pending": "Pending",
  "team_mgr.status_approved": "Approved",
  "team_mgr.status_rejected": "Rejected",
  "team_mgr.status_cancelled": "Cancelled",
  "team_mgr.status_paid": "Paid",
  "team_mgr.category_weekday": "Weekday",
  "team_mgr.category_saturday": "Saturday",
  "team_mgr.category_holiday": "Holiday",
  "team_mgr.category_night": "Night",
  "team_mgr.shift_type_day": "Day",
  "team_mgr.shift_type_night": "Night",
  "team_mgr.shift_type_evening": "Evening",
  "team_mgr.shift_type_weekend_day": "Weekend (Day)",
  "team_mgr.shift_type_weekend_night": "Weekend (Night)",
  "team_mgr.shift_type_holiday": "Holiday",
  "team_mgr.shift_type_flexible": "Flexible",
  "team_mgr.day_mon": "Mon",
  "team_mgr.day_tue": "Tue",
  "team_mgr.day_wed": "Wed",
  "team_mgr.day_thu": "Thu",
  "team_mgr.day_fri": "Fri",
  "team_mgr.day_sat": "Sat",
  "team_mgr.day_sun": "Sun",
  "team_mgr.incentive_type_referral": "Referral",
  "team_mgr.incentive_type_inpatient_maintenance": "Inpatient Maintenance",
  "team_mgr.incentive_type_shockwave": "Shockwave",
  "team_mgr.doc_category_medical": "Medical",
  "team_mgr.doc_category_certification": "Certification",
  "team_mgr.doc_category_overtime": "Overtime",
  "team_mgr.doc_category_contract": "Contract",
  "general_affairs.training_cat_legal_mandatory": "Legal Mandatory",
  "general_affairs.training_cat_accreditation": "Accreditation Required",
  "general_affairs.training_cat_specialized": "Specialized",
  "general_affairs.freq_monthly": "Monthly",
  "general_affairs.freq_quarterly": "Quarterly",
  "general_affairs.freq_semi_annual": "Semi-annual",
  "general_affairs.freq_annual": "Annual",
  "general_affairs.freq_biennial": "Biennial",
  "general_affairs.freq_triennial": "Triennial",
  "general_affairs.completion_completed": "Completed",
  "general_affairs.completion_expired": "Expired",
  "general_affairs.completion_upcoming": "Upcoming",
  "general_affairs.task_cat_facility": "Facility",
  "general_affairs.task_cat_safety": "Safety Inspection",
  "general_affairs.task_cat_fire": "Fire Safety",
  "general_affairs.task_cat_hygiene": "Hygiene",
  "general_affairs.task_cat_equipment": "Equipment",
  "general_affairs.task_cat_document": "Document",
  "general_affairs.task_cat_compliance": "Compliance",
  "general_affairs.task_freq_daily": "Daily",
  "general_affairs.task_freq_weekly": "Weekly",
  "general_affairs.exec_status_pending": "Pending",
  "general_affairs.exec_status_in_progress": "In Progress",
  "general_affairs.exec_status_completed": "Completed",
  "general_affairs.exec_status_overdue": "Overdue",
  "general_affairs.exec_status_skipped": "Skipped",
  "general_affairs.notice_cat_training_deadline": "Training Deadline",
  "general_affairs.notice_cat_facility": "Facility",
  "general_affairs.notice_cat_safety": "Safety",
  "general_affairs.notice_cat_policy": "Policy",
  "general_affairs.notice_cat_general": "General",
  "general_affairs.priority_low": "FYI",
  "general_affairs.priority_normal": "Normal",
  "general_affairs.priority_high": "Important",
  "general_affairs.priority_urgent": "Urgent",
  "nurse.schedule_status_draft": "Draft",
  "nurse.schedule_status_generating": "AI Generating",
  "nurse.schedule_status_ai_generated": "AI Generated",
  "nurse.schedule_status_editing": "Editing",
  "nurse.schedule_status_confirmed": "Confirmed",
  "nurse.schedule_status_published": "Published",
  "nurse.assignment_annual_leave": "Annual Leave",
  "nurse.assignment_bereavement": "Bereavement",
  "nurse.assignment_education": "Education",
  "nurse.assignment_unavailable": "Unavailable",
  "nurse.confirm_cycle_change": "Change the schedule cycle start day?\n\nThis only affects newly created schedules. Existing schedules are not changed.",
  "nurse.grade_label": "Grade",
  "nurse.tab_schedule": "Schedule",
  "nurse.tab_profiles": "Staff",
  "nurse.tab_preferences": "My Preferences",
  "dashboard.category_rehabilitation": "Rehabilitation",
  "dashboard.category_nursing": "Nursing",
  "dashboard.category_sports_medicine": "Sports Medicine",
  "dashboard.category_home_visit": "Home Visit",
  "dashboard.category_assessment": "Assessment",
  "dashboard.category_on_call": "On Call",
  "dashboard.data_load_failed": "Failed to load data",
  "dashboard.unit_eok": "B",
  "dashboard.unit_man": "M",
  "inventory.confirm_delete": "Are you sure you want to delete?",
  "inventory.expired": "Expired",
  "inventory.quantity_change_failed": "Quantity change failed",
  "inventory.refund_clear_failed": "Clear failed",
  "shift_tracker.attendance_error": "An error occurred during processing",
  "shift_tracker.break_reminder": "hrs continuous work \u2014 break recommended",
  "shift_tracker.field_work_date_required": "Please enter date, start time, and end time",
  "shift_tracker.field_work_error": "Failed to register field work",
  "shift_tracker.field_work_location_required": "Please enter the field work location",
  "shift_tracker.field_work_registered": "Field work has been registered",
  "shift_tracker.risk_critical": "Critical",
  "shift_tracker.risk_safe": "Safe",
  "shift_tracker.risk_warning": "Warning",
  "shift_tracker.shift_type_day": "Day",
  "shift_tracker.shift_type_night": "Night",
  "shift_tracker.shift_type_weekend": "Weekend",
  "shift_tracker.status_absent": "Absent",
  "shift_tracker.status_completed": "Completed",
  "shift_tracker.status_early_leave": "Early Leave",
  "shift_tracker.status_holiday": "Holiday",
  "shift_tracker.status_late": "Late",
  "shift_tracker.status_on_leave": "On Leave",
  "shift_tracker.status_present": "Present",
  "shift_tracker.status_weekend": "Weekend",
  "shift_tracker.week_current": "This Week",
  "shift_tracker.week_last": "Last Week",
  "shift_tracker.week_next": "Next Week",
  "shift_tracker.weeks_ago": "weeks ago",
  "shift_tracker.weeks_later": "weeks later",
  "incentive.category_assessment": "Assessment",
  "incentive.category_home_visit": "Home Visit",
  "incentive.category_nursing": "Nursing",
  "incentive.category_on_call": "On Call",
  "incentive.category_rehabilitation": "Rehabilitation",
  "incentive.category_sports_medicine": "Sports Medicine",
  "incentive.confirm_delete": "Delete this incentive record?",
  "incentive.delete_error": "Failed to delete",
  "incentive.enter_count": "Please enter the count",
  "incentive.registered": "Incentive has been registered",
  "incentive.register_error": "Failed to register incentive",
  "incentive.status_cancelled": "Cancelled",
  "messenger.conversation_label": "Chat",
  "messenger.file_prefix": "File",
  "messenger.file_send_failed": "File send failed",
  "messenger.file_size_limit": "Files must be under 10MB",
  "messenger.group_min_members": "Group chats require at least 2 members",
  "messenger.group_name_required": "Please enter a group name",
  "messenger.group_create_failed": "Failed to create group chat",
  "messenger.invite_failed": "Invitation failed",
  "messenger.kick_confirm": " will be removed. Continue?",
  "messenger.kick_failed": "Failed to remove member",
  "messenger.leave_confirm": "Leave this chat room?\nYou will not be able to see previous messages.",
  "messenger.leave_failed": "Failed to leave chat room",
  "messenger.me": "Me",
  "messenger.member_load_failed": "Failed to load member list",
  "messenger.new_message": "New Message",
  "messenger.notice_cat_event": "Event",
  "messenger.notice_cat_general": "General",
  "messenger.notice_cat_hr": "HR",
  "messenger.notice_cat_policy": "Policy",
  "messenger.notice_cat_safety": "Safety",
  "messenger.notice_cat_system": "System",
  "messenger.notice_priority_high": "Important",
  "messenger.notice_priority_low": "Info",
  "messenger.notice_priority_normal": "Normal",
  "messenger.notice_priority_urgent": "Urgent",
  "messenger.room_name_changed": "Chat room name has been changed",
  "messenger.room_name_change_failed": "Failed to change name",
  "messenger.message_menu": "Message menu",
  "messenger.delete_message": "Delete",
  "messenger.delete_message_confirm": 'Delete this message?\nEveryone in the conversation will see "This message was deleted" instead.',
  "messenger.delete_message_failed": "Failed to delete the message",
  "messenger.deleted_message": "This message was deleted",
  "messenger.preview_blocked": "The messenger is unavailable while previewing permissions. End the preview and open it again.",
  "messenger.mute_on": "Mute notifications",
  "messenger.mute_off": "Unmute notifications",
  "messenger.mute_hint": "Unread counts still show. Mentions and replies to your messages still notify you",
  "messenger.muted": "Muted",
  "messenger.unmuted": "On",
  "messenger.mute_toggle_failed": "Failed to change the notification setting",
  "messenger.mark_read": "Mark as read",
  "messenger.history_start": "This is the beginning of the conversation",
  "messenger.mark_read_failed": "Failed to mark as read",
  "messenger.view_profile": "View profile",
  "messenger.direct_chat": "Direct chat",
  "messenger.mention_user": "Mention",
  "messenger.sender_menu": "Sender menu",
  "messenger.conv_menu": "Conversation menu",
  "messenger.reply": "Reply",
  "messenger.react": "React",
  "messenger.reaction_failed": "Could not save the reaction",
  "messenger.copy": "Copy",
  "messenger.copied": "Copied",
  "messenger.copy_failed": "Could not copy",
  "messenger.select_copy": "Select & copy",
  "messenger.select_copy_hint": "Drag to select the part to copy, then press Copy. Nothing selected copies the whole message.",
  "messenger.copied_selection": "Copied the selection",
  "messenger.forward": "Forward",
  "messenger.forward_title": "Forward to",
  "messenger.forward_search_placeholder": "Search rooms or names",
  "messenger.forwarded": "Forwarded",
  "messenger.forward_failed": "Could not forward",
  "messenger.pin": "Pin",
  "messenger.unpin": "Unpin",
  "messenger.pinned_message": "Pinned message",
  "messenger.pin_failed": "Could not change the pin",
  "messenger.reply_to": "Reply to {name}",
  "messenger.reply_cancel": "Cancel reply",
  "messenger.reply_preview_image": "[Photo]",
  "messenger.reply_preview_file": "[File]",
  "messenger.mention_all": "all",
  "messenger.mention_all_hint": "Notifies everyone in the room",
  "messenger.sender_unknown": "Unknown",
  "messenger.tab_attention_title": "New message received.",
  "messenger.time_days_ago": "d ago",
  "messenger.time_hours_ago": "h ago",
  "messenger.time_just_now": "Just now",
  "messenger.time_minutes_ago": "m ago",
  "messenger.today": "Today",
  "messenger.unassigned": "Unassigned",
  "messenger.yesterday": "Yesterday",
  "approval.cancel_error": "Failed to cancel",
  "approval.document_file_required": "Please select a file",
  "approval.document_submit_error": "Failed to submit document",
  "approval.document_cert_name_required": "Please enter the certificate name",
  "approval.file_size_limit": "File must be 10MB or smaller",
  "approval.leave_date_reason_required": "Please enter both start date and reason",
  "approval.leave_request_error": "Failed to request leave",
  "approval.leave_type_annual": "Annual Leave",
  "approval.leave_type_bereavement": "Bereavement Leave",
  "approval.leave_type_maternity": "Maternity Leave",
  "approval.leave_type_personal": "Personal",
  "approval.leave_type_sick": "Sick Leave",
  "approval.overtime_category_holiday": "Holiday Work",
  "approval.overtime_category_night": "Night Work",
  "approval.overtime_category_saturday": "Saturday Work",
  "approval.overtime_category_weekday": "Weekday Overtime",
  "approval.overtime_date_reason_required": "Please enter both work date and reason",
  "approval.overtime_request_error": "Failed to request overtime",
  "approval.status_approved": "Approved",
  "approval.status_cancelled": "Cancelled",
  "approval.status_pending": "Pending",
  "approval.status_processing": "Processing",
  "approval.status_rejected": "Rejected",
  "approval.status_requires_review": "Review Required",
  "approval.tab_documents": "Documents",
  "approval.tab_leave": "Leave Request",
  "approval.tab_overtime": "Overtime",
  "admin.amount_integer_only": "Amounts must be whole numbers (no decimals).",
  "admin.att_status_absent": "Absent",
  "admin.att_status_checked_in": "Checked In",
  "admin.att_status_checked_out": "Completed",
  "admin.att_status_early_leave": "Early Leave",
  "admin.att_status_holiday": "Holiday",
  "admin.att_status_late": "Late",
  "admin.att_status_leave": "Leave",
  "admin.att_status_scheduled": "Scheduled",
  "admin.att_status_sick_leave": "Sick Leave",
  "admin.attendance_query_failed": "Query failed",
  "admin.attendance_update_failed": "Attendance update failed",
  "admin.attendance_warning_title": "Attendance application review needed",
  "admin.attendance_warning_footer": "No approved overtime/night/weekend work applications found for this time. Submit via Internal Approval or manually edit attendance.",
  "admin.cert_suffix_cert": "Certificate",
  "admin.cert_suffix_license": "License",
  "admin.cert_approve_confirm": "Approve this employment certificate?",
  "admin.cert_approve_failed": "Approval failed",
  "admin.cert_reject_failed": "Rejection failed",
  "admin.cert_reject_reason": "Enter rejection reason:",
  "admin.cert_template_create_failed": "Failed to create default template.",
  "admin.bulk_role_note": "(All active team memberships will be updated)",
  "admin.confirm_bulk_apply": "Apply the following changes to {n} selected employees?\n\n{changes}",
  "admin.confirm_delete_cert": "Delete this certification?",
  "admin.confirm_delete_doc_template": "Delete this template?",
  "admin.confirm_delete_grade": "Delete this salary grade?",
  "admin.confirm_delete_item_code": "Delete this item code?",
  "admin.confirm_delete_role": "Delete this role?",
  "admin.confirm_delete_rule": "Delete this rule?",
  "admin.confirm_delete_shift": "Delete this shift?",
  "admin.confirm_delete_team": 'Delete "{name}" team?',
  "admin.confirm_password_reset": "Reset password?\nA temporary password will be generated and sent via SMS.",
  "admin.confirm_password_set": "Set password manually?",
  "admin.confirm_recalculate": "Recalculate attendance from Secom events?\n(Manual entries preserved; auto-generated records will be regenerated)",
  "admin.confirm_recalculate_date": "Recalculate attendance for {date}?",
  "admin.confirm_recalculate_shift": "Change shift and recalculate attendance from Secom events?\n(Manual entries preserved; auto-generated records will be regenerated)",
  "admin.confirm_remove_member": "Remove this member from the team?",
  "admin.confirm_remove_team": 'Remove from "{team}" team?',
  "admin.confirm_return_from_leave": "Process return from leave for {name}?",
  "admin.confirm_role_change": 'Change role of "{emp}" to "{role}"?',
  "admin.confirm_role_remove": 'Remove "{role}" role from "{emp}"?',
  "admin.confirm_team_add": 'Add "{emp}" to "{team}" team?',
  "admin.confirm_team_exclude": 'Remove "{emp}" from "{team}" team?',
  "admin.create_failed": "Creation failed",
  "admin.delete_failed": "Deletion failed",
  "admin.download_failed": "Download failed",
  "admin.file_load_failed": "Cannot load file",
  "admin.file_size_500kb": "File must be 500KB or smaller.",
  "admin.image_only": "Only image files can be uploaded.",
  "admin.leave_process_failed": "Leave processing failed",
  "admin.leave_processed": "Leave of absence processed for {name}.",
  "admin.leave_rule_template_confirm": "Register default annual leave rules? (Existing rules will be kept)",
  "admin.member_add_failed": "Failed to add member",
  "admin.password_changed": "Password has been changed.",
  "admin.password_change_failed": "Password change failed",
  "admin.password_mismatch": "Passwords do not match.",
  "admin.password_reset_done": "Password has been reset.",
  "admin.password_reset_failed": "Password reset failed",
  "admin.permission_change_failed": "Permission change failed",
  "admin.preview_failed": "Preview failed",
  "admin.recalculate_done": "Recalculation complete",
  "admin.recalculate_failed": "Recalculation failed",
  "admin.required_fields_missing": "Please fill in all required fields.",
  "admin.return_failed": "Return processing failed",
  "admin.return_processed": "Return from leave processed.",
  "employee.reinstate_process": "Cancel termination (reinstate)",
  "employee.reinstate_hint": "This employee has been terminated. If that was a mistake, cancel the termination to reinstate them.",
  "employee.reinstate_go": "Go to cancel termination",
  "employee.reinstate_notice": "Cancelling voids the resignation record (settlement history is kept), returns the status to active, and re-adds the employee to team rooms. Team leader assignment is not restored automatically, and the employee must sign in again.",
  "employee.reinstate_reason": "Reason",
  "employee.reinstate_reason_placeholder": "e.g. Termination was processed by mistake",
  "employee.reinstate_reason_required": "Enter a reason for cancelling the termination.",
  "admin.reinstate_processed": "{name}'s termination was cancelled. Status is back to active.",
  "admin.reinstate_failed": "Failed to cancel termination",
  "admin.role_change_failed": "Role change failed",
  "admin.duplicate_grade": "A salary grade with the same job category, grade, and year already exists.",
  "admin.role_code_duplicate": "This role code is already in use. Please enter a different code.",
  "admin.role_code_name_required": "Please enter both role code and name.",
  "admin.role_code_required": "Please enter a role code.",
  "admin.role_name_required": "Please enter a role name.",
  "admin.role_remove_failed": "Role removal failed",
  "admin.role_type_custom": "Custom",
  "admin.role_type_system": "System",
  "admin.role_type_team": "Team",
  "admin.save_failed": "Save failed",
  "admin.status_change_failed": "Status change failed",
  "admin.secom_check_in": "Check In",
  "admin.secom_check_out": "Check Out",
  "admin.secom_error": "Error",
  "admin.secom_ignored": "Ignored",
  "admin.secom_pending": "Pending",
  "admin.secom_processed": "Processed",
  "admin.secom_unknown": "Unclassified",
  "admin.sms_send_preview": "SMS Send (Coming Soon)",
  "admin.sms_sending": "Sending SMS...",
  "admin.tab_employees": "Employees",
  "admin.tab_esign": "E-Sign",
  "admin.tab_leaves": "Leave",
  "admin.tab_roles": "Roles/Permissions",
  "admin.tab_settings": "Settings",
  "admin.tab_teams": "Teams",
  "admin.team_add_failed": "Team assignment failed",
  "admin.team_code_required": "Please enter a team code.",
  "admin.team_exclude_failed": "Team exclusion failed",
  "admin.team_name_required": "Please enter a team name.",
  "admin.team_remove_failed": "Team removal failed",
  "admin.temp_password_manual_msg": "SMS failed. Temporary password: {pw}\nPlease deliver it manually.",
  "admin.temp_password_sent": "Temporary password sent via SMS.",
  "admin.termination_failed": "Termination processing failed",
  "admin.termination_processed": "Termination processed for {name}.",
  "admin.cert_type_care_worker": "Care Worker",
  "admin.cert_type_clinical_lab": "Clinical Lab Technician",
  "admin.cert_type_dentist": "Dentist",
  "admin.cert_type_dietitian": "Dietitian",
  "admin.cert_type_emergency_medical": "Emergency Medical Technician",
  "admin.cert_type_medical_doctor": "Medical Doctor",
  "admin.cert_type_nurse_aide": "Nurse Aide",
  "admin.cert_type_nursing": "Nurse",
  "admin.cert_type_occupational_therapist": "Occupational Therapist",
  "admin.cert_type_other": "Other",
  "admin.cert_type_pharmacist": "Pharmacist",
  "admin.cert_type_physical_therapist": "Physical Therapist",
  "admin.cert_type_radiologist": "Radiologist",
  "admin.cert_type_social_worker": "Social Worker",
  "admin.cert_type_speech_therapist": "Speech Therapist",
  "admin.day_fri": "Fri",
  "admin.day_mon": "Mon",
  "admin.day_sat": "Sat",
  "admin.day_sun": "Sun",
  "admin.day_thu": "Thu",
  "admin.day_tue": "Tue",
  "admin.day_wed": "Wed",
  "admin.dept_status_active": "Active",
  "admin.dept_status_inactive": "Inactive",
  "admin.dept_status_restructuring": "Restructuring",
  "admin.dept_type_customer_service": "Customer Service",
  "admin.dept_type_engineering": "Engineering",
  "admin.dept_type_it": "IT",
  "admin.dept_type_marketing": "Marketing",
  "admin.dept_type_r_and_d": "R&D",
  "admin.dept_type_sales": "Sales",
  "admin.grade_cat_functional": "Functional",
  "admin.grade_cat_nursing": "Nursing",
  "admin.grade_cat_rehabilitation": "Rehabilitation",
  "admin.shift_tpl_normal": "Regular (09-18)",
  "admin.shift_tpl_three_day": "3-Shift Day (07-15)",
  "admin.shift_tpl_three_evening": "3-Shift Evening (15-23)",
  "admin.shift_tpl_three_night": "3-Shift Night (23-07)",
  "admin.shift_type_day": "Day",
  "admin.shift_type_evening": "Evening",
  "admin.shift_type_flexible": "Flexible",
  "admin.shift_type_holiday": "Holiday",
  "admin.shift_type_night": "Night",
  "admin.shift_type_on_call": "On-call",
  "admin.shift_type_off": "Off",
  "admin.shift_type_weekend_day": "Weekend (Day)",
  "admin.shift_type_weekend_night": "Weekend (Night)",
  "admin.status_active": "Active",
  "admin.status_inactive": "Inactive",
  "admin.status_on_leave": "On Leave",
  "admin.status_terminated": "Terminated",
  "hr.action_add": "Add",
  "hr.action_cancel": "Cancel",
  "hr.already_added": "All matching employees are already added.",
  "hr.allowance_adjustment": "Adjustment",
  "hr.allowance_childcare": "Childcare",
  "hr.allowance_communication": "Communication",
  "hr.allowance_count": "{n} allowances",
  "hr.allowance_cancel_diff": "Allowance Cancel Payroll Update",
  "hr.allowance_family": "Family",
  "hr.allowance_fixed_incentive": "Fixed Incentive",
  "hr.allowance_fixed_incentive_short": "Incentive",
  "hr.allowance_housing": "Housing",
  "hr.allowance_meal": "Meal",
  "hr.allowance_nursing_incentive": "Nursing Incentive",
  "hr.allowance_nursing_incentive_short": "Nursing Incent.",
  "hr.allowance_on_call": "On-Call",
  "hr.allowance_other": "Other",
  "hr.allowance_performance": "Performance",
  "hr.allowance_position": "Position",
  "hr.allowance_special": "Special",
  "hr.allowance_transportation": "Transport",
  "hr.approve_confirm_allowance": "Approve this allowance?",
  "hr.approve_diff_title": "Approval Payroll Update",
  "hr.approve_fail": "Approval failed",
  "hr.approve_grade_confirm": "Approve {n} grade promotions?\nContracts will be auto-renewed.",
  "hr.assign_fail": "Assignment failed",
  "hr.add_employees_first": "Please add employees first.",
  "hr.auto_calc_fail": "Auto-calculation failed. Please enter amounts manually.",
  "hr.auto_calc_prefix": "Auto-calc:",
  "hr.bulk_approve_fail": "Bulk approval failed",
  "hr.bulk_cancel_allowance": "Cancel {n} allowances?",
  "hr.bulk_cancel_deduction": "Cancel {n} deductions?",
  "hr.cancel_confirm_allowance": "Cancel this allowance?",
  "hr.cancel_confirm_deduction": "Cancel this deduction?",
  "hr.cancel_confirm_detail_1": "Confirmed payroll will revert to draft status.",
  "hr.cancel_confirm_detail_2": "Snapshots (confirmation records) will be deleted.",
  "hr.cancel_confirm_detail_3": "Already paid payroll cannot be cancelled.",
  "hr.cancel_confirm_done": "Confirmation has been cancelled.",
  "hr.cancel_confirm_fail": "Cancel confirmation failed",
  "hr.cancel_confirm_title": "Cancel payroll confirmation?",
  "hr.cancel_fail": "Cancellation failed",
  "hr.cancel_settlement_confirm": "Cancel resignation settlement?\nGenerated allowance/deduction records will be deleted.",
  "hr.cancel_settlement_fail": "Settlement cancellation failed",
  "hr.cancel_single_confirm": "Cancel {name}'s payroll confirmation?\nIt will revert to draft and allowances/deductions can be edited again.",
  "hr.category_functional": "Functional",
  "hr.category_nursing": "Nursing",
  "hr.category_rehabilitation": "Rehabilitation",
  "hr.cmd_add_memo": "Add memo to current cell",
  "hr.cmd_clear_selection": "Clear selection",
  "hr.cmd_generate": "Regenerate Payroll",
  "hr.cmd_generate_hint": "Re-run modules + auto-refresh",
  "hr.cmd_memo_history": "Open memo history",
  "hr.cmd_perf_reset": "Reset performance records",
  "hr.cmd_perf_stats": "View performance stats",
  "hr.cmd_perf_stats_hint": "Output avg/max/p95 to console",
  "hr.cmd_refresh": "Refresh Payroll",
  "hr.cmd_refresh_hint": "Recalculate allowance/deduction totals",
  "hr.cmd_reset_columns": "Reset column layout",
  "hr.cmd_select_all": "Select all cells",
  "hr.cmd_shortcuts": "Keyboard shortcuts help",
  "hr.cmd_undo": "Undo last action",
  "hr.cmd_undo_hint": "Allowance add or column change",
  "hr.code_name_input_required": "Please enter code and name.",
  "hr.code_name_required": "Please enter both code and name.",
  "hr.col_base_salary": "Base Salary",
  "hr.col_department": "Department",
  "hr.col_employee_name": "Name",
  "hr.col_employee_number": "Emp. No.",
  "hr.col_gross_pay": "Gross Pay",
  "hr.col_hire_date": "Hire Date",
  "hr.col_net_pay": "Net Pay",
  "hr.col_position": "Position",
  "hr.col_status": "Status",
  "hr.col_total_deductions": "Total Deductions",
  "hr.col_wage_type": "Wage Type",
  "hr.config_load_fail": "Failed to load config",
  "hr.confirm_delete_category": "Delete this category?",
  "hr.confirm_delete_category_items": "Delete this category and all items?",
  "hr.confirm_delete_category_presets": "Delete this category? Presets will be moved to uncategorized.",
  "hr.confirm_delete_config": "Delete this config?",
  "hr.confirm_delete_deduction_config": "Delete this deduction config?",
  "hr.confirm_delete_grade": "Delete this salary grade?",
  "hr.confirm_delete_item": "Delete this item?",
  "hr.confirm_delete_preset": "Delete this preset?",
  "hr.confirm_delete_rate": "Delete this insurance rate config?",
  "hr.confirm_delete_tax": "Delete this tax bracket config?",
  "hr.confirm_fail": "Confirmation failed",
  "hr.confirm_payroll_msg": "Confirm {n} payroll records?",
  "hr.confirm_single_fail": "Confirmation failed",
  "hr.confirm_warnings": "Warnings:",
  "hr.contract_commissioned": "Commissioned",
  "hr.contract_internship": "Internship",
  "hr.contract_part_time": "Part-time",
  "hr.contract_permanent": "Permanent",
  "hr.contract_temporary": "Contract",
  "hr.create_fail": "Registration failed",
  "hr.deduction_advance": "Advance",
  "hr.deduction_absence": "Absence",
  "hr.deduction_cancel_diff": "Deduction Cancel Payroll Update",
  "hr.deduction_count": "{n} deductions",
  "hr.deduction_create_diff": "Deduction Create Payroll Update",
  "hr.deduction_loan": "Loan Repayment",
  "hr.deduction_other": "Other",
  "hr.deduction_penalty": "Penalty",
  "hr.delete_fail": "Deletion failed",
  "hr.dept_admin": "Admin",
  "hr.dept_nursing": "Nursing",
  "hr.dept_rehab": "Rehab",
  "hr.dept_sports": "Sports",
  "hr.detect_fail": "Detection failed",
  "hr.duplicate_grade": "This grade already exists. Please check and try again.",
  "hr.edit_fail": "Edit failed",
  "hr.employee_load_fail": "Failed to load employee info",
  "hr.export_ecount_fail": "eCount export failed",
  "hr.export_no_data": "No export data. Please check if confirmed payroll exists.",
  "hr.fill_diff_title": "Auto-fill Payroll Update",
  "hr.fill_fail": "Auto-fill failed",
  "hr.fill_label_suffix": "(auto-fill)",
  "hr.fill_reason": "Auto-fill",
  "hr.filter_100days": "100-day employees",
  "hr.filter_birthday": "Birthday employees",
  "hr.filter_department": "Department employees",
  "hr.filter_hire_anniversary": "Hire anniversary employees",
  "hr.generic_error": "An error occurred. Please try again later.",
  "hr.grade_mode_disabled": "Disabled",
  "hr.grade_mode_fiscal_year": "Fiscal Year Basis",
  "hr.grade_mode_hire_date": "Hire Date Basis",
  "hr.grade_status_applied": "Applied",
  "hr.grade_status_approved": "Approved",
  "hr.grade_status_pending": "Pending",
  "hr.grade_status_rejected": "Rejected",
  "hr.health_year_end": "Health/Long-term Care Year-end",
  "hr.incentive_inpatient": "Inpatient Maintenance",
  "hr.incentive_other": "Other",
  "hr.incentive_referral": "Referral",
  "hr.incentive_shockwave": "Shockwave",
  "hr.item_code_add_fail": "Failed to add item code",
  "hr.items_saved": "Items have been saved.",
  "hr.locked_allowance_alert": "Cannot add allowances \u2014 the following employees have confirmed payroll:\n{names}\nPlease cancel confirmation first.",
  "hr.locked_deduction_alert": "Cannot add deductions \u2014 the following employees have confirmed payroll:\n{names}\nPlease cancel confirmation first.",
  "hr.locked_payroll_alert": "{name}'s payroll is already confirmed and cannot be edited.\nPlease cancel confirmation first.",
  "hr.memo_resolve_fail": "Failed to resolve memo",
  "hr.memo_save_fail": "Failed to save memo",
  "hr.module_education_subsidy": "Education Subsidy",
  "hr.module_employment_contract": "Employment Contract",
  "hr.module_fixed_incentive": "Fixed Incentive",
  "hr.module_manual": "Manual",
  "hr.module_overtime_record": "Overtime Record",
  "hr.module_payroll_rate_config": "Social Insurance",
  "hr.module_resignation_record": "Resignation Settlement",
  "hr.module_tax_bracket_config": "Income Tax",
  "hr.module_year_end_settlement": "Year-end Settlement",
  "hr.n_registered": "{n} records registered.",
  "hr.n_selected": "{n} selected",
  "hr.no_amount_employees": "No employees with entered amounts.",
  "hr.no_amount_items": "No items with entered amounts.",
  "hr.no_data_to_register": "No data to register. Please add employees and amounts.",
  "hr.no_matching_employees": "No employees match the criteria.",
  "hr.no_employees_to_add": "No employees to add.",
  "hr.not_confirmed_status": "Payroll is not in confirmed status.",
  "hr.overtime_holiday": "Holiday",
  "hr.overtime_night": "Night",
  "hr.overtime_saturday": "Saturday",
  "hr.overtime_weekday": "Weekday",
  "hr.paste_diff_title": "Paste Payroll Update",
  "hr.paste_fail": "Paste failed",
  "hr.paste_label_suffix": "(paste)",
  "hr.paste_reason": "Paste",
  "hr.payment_cash": "Cash",
  "hr.payment_mobile_gift": "Gift Card",
  "hr.payment_salary": "Salary",
  "hr.pending_detail": "Pending:",
  "hr.pending_instruction": "Please approve items in the Earnings/Deductions tabs first.",
  "hr.pending_items_block": "Cannot confirm payroll \u2014 there are pending items.",
  "hr.perm_deductions_desc": "Permission to view deductions, year-end settlements, and resignation settlements for all employees.",
  "hr.perm_deductions_name": "View Deductions",
  "hr.perm_earnings_desc": "Permission to view allowances, overtime, incentives, and education subsidies for all employees.",
  "hr.perm_earnings_name": "View Earnings",
  "hr.perm_payroll_desc": "Permission to view payroll data for all employees including base salary, allowances, deductions, and net pay.",
  "hr.perm_payroll_name": "View Payroll",
  "hr.rate_employment_insurance": "Employment Insurance",
  "hr.rate_health_insurance": "Health Insurance",
  "hr.rate_industrial_accident": "Industrial Accident",
  "hr.rate_long_term_care": "Long-term Care",
  "hr.rate_national_pension": "National Pension",
  "hr.refresh_diff_title": "Payroll Refresh Changes",
  "hr.refresh_fail": "Payroll refresh failed",
  "hr.regenerate_diff_title": "Payroll Regeneration Changes",
  "hr.regenerate_fail": "Payroll generation failed",
  "hr.register_error": "An error occurred during registration.",
  "hr.reject_fail": "Rejection failed",
  "hr.resignation_status_completed": "Completed",
  "hr.resignation_status_pending": "Pending",
  "hr.resignation_status_processing": "Processing",
  "hr.resignation_status_settled": "Settled",
  "hr.review_load_fail": "Failed to load review data",
  "hr.save_fail": "Save failed",
  "hr.saved": "Saved successfully.",
  "hr.select_employee": "Please select an employee.",
  "hr.select_grade_or_salary": "Please select a grade or enter a base salary.",
  "hr.send_payslip_confirm": "Send payslip to {name}?",
  "hr.send_payslip_done": "Sent",
  "hr.send_payslip_fail": "Send failed",
  "hr.settlement_cancelled": "Settlement has been cancelled.",
  "hr.settlement_confirm": "Allowances {allowance} KRW, Deductions {deduction} KRW\nNet difference: {net} KRW\n\nProceed with settlement?",
  "hr.settlement_created": "Settlement records have been created.",
  "hr.settlement_fail": "Settlement failed",
  "hr.settings_saved": "Settings have been saved.",
  "hr.source_auto": "Auto-generated",
  "hr.source_config": "Config",
  "hr.source_manual": "Manual",
  "hr.status_applied": "Applied",
  "hr.status_approved": "Approved",
  "hr.status_calculated": "Calculated",
  "hr.status_cancelled": "Cancelled",
  "hr.status_completed": "Completed",
  "hr.status_confirmed": "Confirmed",
  "hr.status_corrected": "Corrected",
  "hr.status_draft": "Draft",
  "hr.status_paid": "Paid",
  "hr.status_pending": "Pending",
  "hr.status_processing": "Processing",
  "hr.status_settled": "Settled",
  "hr.status_change_fail": "Status change failed",
  "hr.tab_deductions": "Deductions",
  "hr.tab_earnings": "Earnings",
  "hr.tab_payroll": "Payroll (All)",
  "hr.template_apply_fail": "Template apply failed",
  "hr.undo_cancel_diff": "Undo (Ctrl+Z) Payroll Update",
  "hr.undo_cancel_fail": "Undo failed",
  "hr.wage_annual": "Annual",
  "hr.wage_daily": "Daily",
  "hr.wage_hourly": "Hourly",
  "hr.wage_monthly": "Monthly",
  "hr.year_end_adjusted": "Year-end Settlement Adjustment",
  "hr.year_end_applied": "Year-end settlement applied to {n} employees.",
  "hr.year_end_apply_fail": "Apply failed",
  "hr.year_end_create_fail": "Creation failed",
  "hr.year_end_health": "Health/Long-term Care Year-end",
  "messenger.self_chat": "Chat with myself",
  "messenger.self_chat_hint": "Notes and files for yourself",
  "notification.messenger_push_format": "Messenger notification display",
  "notification.messenger_push_format_desc": "Choose what lock-screen notifications show. 'Name + message' shows the text only for conversations this device can decrypt (mobile apps from the next update).",
  "notification.messenger_push_format_name_only": "Sender name only",
  "notification.messenger_push_format_generic": "'New message' only",
  "notification.messenger_push_format_name_body": "Name + message",
  "messenger.unreadable_message": "Can't read this message (no key on this device)",
  "messenger.encrypted_preview": "New message",
  "messenger.encrypted_preview_read": "Open the conversation to read it",
  "messenger.encrypted_push_body": "New message",
  "messenger.lock.key_missing_send": "The conversation key hasn't arrived yet. Please try again shortly.",
  "messenger.lock.title": "Chat lock",
  "messenger.image_download": "Download",
  "messenger.file_too_large": "{name} is {size}; files up to {limit} can be sent.",
  "messenger.uploading": "Uploading {percent}%",
  "messenger.upload_preparing": "Preparing\u2026",
  "messenger.upload_preparing_count": "Preparing {done}/{total}",
  "messenger.upload_failed": "Upload failed. Tap resend to try again.",
  "messenger.image_prev": "Previous photo",
  "messenger.image_next": "Next photo",
  "messenger.image_download_failed": "Could not download the photo. Please try again.",
  "messenger.lock.setup_title": "Set up chat lock",
  "messenger.lock.setup_intro": "Conversations in this organization are encrypted on your device. Create your conversation lock key on this device now. There is no recovery code to write down.",
  "messenger.lock.setup_loss_notice": "The key lives only on this device. On a new device, approve from this one to carry it over. If you lose every device, earlier messages come back only in rooms where another member can resend them.",
  "messenger.lock.policy_notice": "Chats and files are kept as company records and may be accessed through a formal procedure when legally required.",
  "messenger.lock.setup_start": "Create key",
  "messenger.lock.setup_done": "Chat lock is set up.",
  "messenger.lock.creating": "Creating your conversation lock key\u2026",
  "messenger.lock.setup_failed": "Could not set up chat lock. Please try again later.",
  "messenger.lock.missing_key_bar": "This device has no conversation lock key, so messages can't be read here.",
  "messenger.lock.missing_key_action": "Get the key",
  "messenger.lock.setup_bar": "Set up the conversation lock to read and send messages on this device.",
  "messenger.lock.setup_action": "Set up",
  "messenger.lock.restore_title": "Open chats on a new device",
  "messenger.lock.restore_intro": "This device has no conversation lock key. Approve from another device where your conversations already open.",
  "messenger.lock.restore_device": "Approve from another device",
  "messenger.lock.start_fresh": "No device to approve from \u2014 start fresh",
  "messenger.lock.start_fresh_confirm": "Starting with a new key brings earlier messages back only in rooms where another member can resend them. Conversations continue normally from now on. Continue?",
  "messenger.lock.start_fresh_button": "Start fresh",
  "messenger.lock.device_intro": "We notified your devices that already have the key (web or app). Open Messenger there and an approval prompt appears \u2014 check that its number matches the one below, then approve.",
  "messenger.lock.device_waiting": "Waiting for approval (within 10 minutes)",
  "messenger.lock.device_done": "Received the chat lock key from another device.",
  "messenger.lock.device_expired": "The approval request expired or failed. Please try again.",
  "messenger.lock.device_start_failed": "Could not create the approval request.",
  "messenger.lock.status_ready": "This device has a chat lock key",
  "messenger.lock.fingerprint": "Key fingerprint",
  "messenger.lock.pending_links": "New devices waiting for approval",
  "messenger.lock.approve_prompt": "A new device requested your chat lock key. Approve only if that device shows the number {code}.",
  "messenger.lock.approve_button": "Approve",
  "messenger.lock.reject_button": "Reject",
  "messenger.lock.approve_done": "Approved the new device.",
  "messenger.lock.approve_failed": "Could not approve. Please try again from the new device.",
  "messenger.lock.forget": "Remove key from this device",
  "messenger.lock.forget_confirm": "This removes the conversation lock key from this device. Next time you open the messenger you'll need approval from another device. Continue?",
  "messenger.lock.forget_button": "Remove",
  "messenger.lock.reset": "Reset key (when no device can approve)",
  "messenger.lock.reset_confirm": "Creating a new key brings earlier messages back only in rooms where another member can resend them. Other devices must be approved again. Continue?",
  "messenger.lock.reset_button": "Reset",
  "messenger.lock.untrusted_epoch": "This room's key signature can't be verified. The key epoch is unsigned or mis-signed, so messages won't be sent. If this persists after reopening the room, tell your admin.",
  "messenger.lock.rekeyed_epoch": "You re-created your conversation lock key, so a new key epoch was opened for this room. Messages you send from now on are delivered right away, and earlier messages become readable again once another member opens this room.",
  "messenger.lock.untrusted_epoch_send": "The room key signature couldn't be verified, so the message wasn't sent.",
  "messenger.lock.server_minted": "Earlier messages in this room were moved to encryption by the server, so that key epoch has no device signature. From the current epoch on, member devices sign.",
  "messenger.self_chat_cannot_leave": "You can't leave your own chat",
  "messenger.self_chat_members_hint": "Only you are here. Keep notes and files, and find them again with search.",
  "messenger.search_mine_only": "Only my messages",
  "messenger.self_chat_open_failed": "Couldn't open your chat. Please try again.",
  "messenger.chat_with_me": "Chat with me"
};

// src/locales/en/domain.json
var domain_default = {
  "domain.attendance.check_in": "Check In",
  "domain.attendance.check_out": "Check Out",
  "domain.attendance.overtime": "Overtime",
  "domain.attendance.shift": "Shift",
  "domain.attendance.work_hours": "Work Hours",
  "domain.employee.department": "Department",
  "domain.employee.email": "Email",
  "domain.employee.employee_number": "Employee No.",
  "domain.employee.hire_date": "Hire Date",
  "domain.employee.name": "Name",
  "domain.employee.phone": "Phone",
  "domain.employee.status": "Status",
  "domain.employee.team": "Team",
  "domain.leave.annual_leave": "Annual Leave",
  "domain.leave.leave_of_absence": "Leave of Absence",
  "domain.leave.remaining": "Remaining Leave",
  "domain.leave.sick_leave": "Sick Leave",
  "domain.leave.used": "Used Leave",
  "domain.payroll.allowance": "Allowance",
  "domain.payroll.base_salary": "Base Salary",
  "domain.payroll.deduction": "Deduction",
  "domain.payroll.employment_insurance": "Employment Insurance",
  "domain.payroll.gross_pay": "Gross Pay",
  "domain.payroll.health_insurance": "Health Insurance",
  "domain.payroll.hobong": "Pay Step",
  "domain.payroll.income_tax": "Income Tax",
  "domain.payroll.local_income_tax": "Local Income Tax",
  "domain.payroll.long_term_care": "Long-term Care Insurance",
  "domain.payroll.national_pension": "National Pension",
  "domain.payroll.net_pay": "Net Pay",
  "domain.payroll.ordinary_wage": "Ordinary Wage",
  "domain.payroll.salary_grade": "Salary Grade",
  "domain.payroll.total_deduction": "Total Deductions",
  "domain.payroll.withholding_tax": "Withholding Tax",
  "payroll.status_paid": "Paid",
  "payroll.status_confirmed": "Confirmed",
  "payroll.status_approved": "Approved",
  "payroll.status_draft": "Draft",
  "payroll.status_calculated": "Calculated",
  "payroll.status_cancelled": "Cancelled",
  "payroll.load_error": "Failed to load payslips"
};

// src/locales/en/enums.json
var enums_default = {
  "enums.AllowanceType.ADJUSTMENT": "Adjustment",
  "enums.AllowanceType.FIXED_INCENTIVE": "Fixed Incentive",
  "enums.AllowanceType.NURSING_INCENTIVE": "Nursing Incentive",
  "enums.AllowanceType.ON_CALL": "On-Call",
  "enums.AllowanceType.OTHER": "Other",
  "enums.AllowanceType.SPECIAL": "Special",
  "enums.AssignmentType.ANNUAL_LEAVE": "Annual Leave",
  "enums.AssignmentType.BEREAVEMENT": "Bereavement",
  "enums.AssignmentType.DAY": "Day",
  "enums.AssignmentType.EDUCATION": "Education",
  "enums.AssignmentType.EVENING": "Evening",
  "enums.AssignmentType.NIGHT": "Night",
  "enums.AssignmentType.OFF": "Off",
  "enums.AssignmentType.UNAVAILABLE": "Unavailable",
  "enums.AttendanceMethod.APP": "App Check-in",
  "enums.AttendanceMethod.MANUAL": "Manual Entry",
  "enums.AttendanceMethod.SECOM": "Fingerprint",
  "enums.AttendanceStatus.ABSENT": "Absent",
  "enums.AttendanceStatus.CHECKED_IN": "Checked In",
  "enums.AttendanceStatus.CHECKED_OUT": "Checked Out",
  "enums.AttendanceStatus.EARLY_LEAVE": "Early Leave",
  "enums.AttendanceStatus.HOLIDAY": "Holiday",
  "enums.AttendanceStatus.LATE": "Late",
  "enums.AttendanceStatus.LEAVE": "On Leave",
  "enums.AttendanceStatus.SCHEDULED": "Scheduled",
  "enums.AttendanceStatus.SICK_LEAVE": "Sick Leave",
  "enums.CertificationType.CARE_WORKER": "Care Worker",
  "enums.CertificationType.CLINICAL_LAB": "Clinical Lab Technician",
  "enums.CertificationType.DENTIST": "Dentist",
  "enums.CertificationType.DIETITIAN": "Dietitian",
  "enums.CertificationType.EMERGENCY_MEDICAL": "Emergency Medical Technician",
  "enums.CertificationType.MEDICAL_DOCTOR": "Medical Doctor",
  "enums.CertificationType.NURSE_AIDE": "Nurse Aide",
  "enums.CertificationType.NURSING": "Registered Nurse",
  "enums.CertificationType.OCCUPATIONAL_THERAPIST": "Occupational Therapist",
  "enums.CertificationType.OTHER": "Other",
  "enums.CertificationType.PHARMACIST": "Pharmacist",
  "enums.CertificationType.PHYSICAL_THERAPIST": "Physical Therapist",
  "enums.CertificationType.RADIOLOGIST": "Radiologist",
  "enums.CertificationType.SOCIAL_WORKER": "Social Worker",
  "enums.CertificationType.SPEECH_THERAPIST": "Speech Therapist",
  "enums.ContractStatus.ACTIVE": "Active",
  "enums.ContractStatus.DRAFT": "Draft",
  "enums.ContractStatus.EXPIRED": "Expired",
  "enums.ContractStatus.PENDING_SIGNATURE": "Pending Signature",
  "enums.ContractStatus.RENEWED": "Renewed",
  "enums.ContractStatus.SUSPENDED": "Suspended",
  "enums.ContractStatus.TERMINATED": "Terminated",
  "enums.ContractType.CONSULTANT": "Consultant",
  "enums.ContractType.CONTRACT": "Contract",
  "enums.ContractType.CONTRACTOR": "Contractor",
  "enums.ContractType.FIXED_TERM": "Fixed-Term",
  "enums.ContractType.FREELANCE": "Freelance",
  "enums.ContractType.INTERNSHIP": "Internship",
  "enums.ContractType.PART_TIME": "Part-Time",
  "enums.ContractType.PERMANENT": "Permanent",
  "enums.ContractType.TEMPORARY": "Temporary",
  "enums.DocumentCategory.CERTIFICATION": "Certification",
  "enums.DocumentCategory.CONTRACT": "Contract",
  "enums.DocumentCategory.MEDICAL": "Medical",
  "enums.DocumentCategory.OTHER": "Other",
  "enums.DocumentCategory.OVERTIME": "Overtime",
  "enums.DocumentStatus.APPROVED": "Approved",
  "enums.DocumentStatus.PROCESSING": "Processing",
  "enums.DocumentStatus.REJECTED": "Rejected",
  "enums.DocumentStatus.REQUIRES_REVIEW": "Review Required",
  "enums.EmployeeStatus.ACTIVE": "Active",
  "enums.EmployeeStatus.INACTIVE": "Inactive",
  "enums.EmployeeStatus.ON_LEAVE": "On Leave",
  "enums.EmployeeStatus.TERMINATED": "Terminated",
  "enums.ExecutionStatus.COMPLETED": "Completed",
  "enums.ExecutionStatus.IN_PROGRESS": "In Progress",
  "enums.ExecutionStatus.OVERDUE": "Overdue",
  "enums.ExecutionStatus.PENDING": "Pending",
  "enums.ExecutionStatus.SKIPPED": "Skipped",
  "enums.FixedIncentiveStatus.APPROVED": "Approved",
  "enums.FixedIncentiveStatus.CANCELLED": "Cancelled",
  "enums.FixedIncentiveStatus.PAID": "Paid",
  "enums.FixedIncentiveStatus.PENDING": "Pending",
  "enums.HalfDayPeriod.AFTERNOON": "Afternoon",
  "enums.HalfDayPeriod.MORNING": "Morning",
  "enums.IncentiveCategory.ASSESSMENT": "Assessment",
  "enums.IncentiveCategory.HOME_VISIT": "Home Visit",
  "enums.IncentiveCategory.NURSING": "Nursing",
  "enums.IncentiveCategory.ON_CALL": "On-Call",
  "enums.IncentiveCategory.OTHER": "Other",
  "enums.IncentiveCategory.REHABILITATION": "Rehabilitation",
  "enums.IncentiveCategory.SPORTS_MEDICINE": "Sports Medicine",
  "enums.LeaveOfAbsenceStatus.ACTIVE": "On Leave",
  "enums.LeaveOfAbsenceStatus.CANCELLED": "Cancelled",
  "enums.LeaveOfAbsenceStatus.RETURNED": "Returned",
  "enums.LeaveStatus.APPROVED": "Approved",
  "enums.LeaveStatus.CANCELLED": "Cancelled",
  "enums.LeaveStatus.PENDING": "Pending",
  "enums.LeaveStatus.REJECTED": "Rejected",
  "enums.LeaveType.ANNUAL": "Annual Leave",
  "enums.LeaveType.BEREAVEMENT": "Bereavement Leave",
  "enums.LeaveType.MATERNITY": "Maternity Leave",
  "enums.LeaveType.MILITARY": "Military Service",
  "enums.LeaveType.OTHER": "Other",
  "enums.LeaveType.PATERNITY": "Paternity Leave",
  "enums.LeaveType.PERSONAL": "Personal Leave",
  "enums.LeaveType.SICK": "Sick Leave",
  "enums.NoticePriority.HIGH": "High",
  "enums.NoticePriority.LOW": "Low",
  "enums.NoticePriority.NORMAL": "Normal",
  "enums.NoticePriority.URGENT": "Urgent",
  "enums.NotificationAction.APPROVED": "Approved",
  "enums.NotificationAction.CANCELLED": "Cancelled",
  "enums.NotificationAction.CREATED": "New Request",
  "enums.NotificationAction.REJECTED": "Rejected",
  "enums.NotificationAction.REMINDER": "Reminder",
  "enums.NotificationAction.UPDATED": "Updated",
  "enums.NotificationType.ALLOWANCE": "Allowance",
  "enums.NotificationType.CERTIFICATE": "Certificate",
  "enums.NotificationType.DEDUCTION": "Deduction",
  "enums.NotificationType.DOCUMENT": "Document",
  "enums.NotificationType.EDUCATION": "Education",
  "enums.NotificationType.GENERAL": "General",
  "enums.NotificationType.INCENTIVE": "Incentive",
  "enums.NotificationType.LEAVE_REQUEST": "Leave Request",
  "enums.NotificationType.OVERTIME": "Overtime",
  "enums.NotificationType.PERMISSION_REQUEST": "Permission Request",
  "enums.NotificationType.SYSTEM": "System",
  "enums.NurseWorkType.DAY_DEDICATED": "Day Dedicated",
  "enums.NurseWorkType.EVENING_DEDICATED": "Evening Dedicated",
  "enums.NurseWorkType.NIGHT_DEDICATED": "Night Dedicated",
  "enums.NurseWorkType.THREE_SHIFT": "Three Shift",
  "enums.OrganizationType.CLINIC": "Clinic",
  "enums.OrganizationType.DENTAL_HOSPITAL": "Dental Hospital",
  "enums.OrganizationType.GENERAL_HOSPITAL": "General Hospital",
  "enums.OrganizationType.HOSPITAL": "Hospital",
  "enums.OrganizationType.LONG_TERM_CARE_HOSPITAL": "Long-term Care Hospital",
  "enums.OrganizationType.MENTAL_HOSPITAL": "Mental Hospital",
  "enums.OrganizationType.MIDWIFERY_CENTER": "Midwifery Center",
  "enums.OrganizationType.ORIENTAL_HOSPITAL": "Oriental Medicine Hospital",
  "enums.OrganizationType.OTHER": "Other",
  "enums.OrganizationType.TERTIARY_HOSPITAL": "Tertiary Hospital",
  "enums.OvertimeCategory.HOLIDAY": "Holiday",
  "enums.OvertimeCategory.NIGHT": "Night",
  "enums.OvertimeCategory.SATURDAY": "Saturday",
  "enums.OvertimeCategory.WEEKDAY": "Weekday",
  "enums.OvertimeStatus.APPROVED": "Approved",
  "enums.OvertimeStatus.PENDING": "Pending",
  "enums.OvertimeStatus.REJECTED": "Rejected",
  "enums.PaymentMethod.CASH": "Cash",
  "enums.PaymentMethod.MOBILE_GIFT": "Mobile Gift Card",
  "enums.PaymentMethod.SALARY": "Salary",
  "enums.PayrollStatus.APPROVED": "Approved",
  "enums.PayrollStatus.CALCULATED": "Calculated",
  "enums.PayrollStatus.CANCELLED": "Cancelled",
  "enums.PayrollStatus.CONFIRMED": "Confirmed",
  "enums.PayrollStatus.CORRECTED": "Corrected",
  "enums.PayrollStatus.DRAFT": "Draft",
  "enums.PayrollStatus.PAID": "Paid",
  "enums.PromotionStatus.APPLIED": "Applied",
  "enums.PromotionStatus.APPROVED": "Approved",
  "enums.PromotionStatus.PENDING": "Pending",
  "enums.PromotionStatus.REJECTED": "Rejected",
  "enums.ScheduleStatus.AI_GENERATED": "AI Generated",
  "enums.ScheduleStatus.CONFIRMED": "Confirmed",
  "enums.ScheduleStatus.DRAFT": "Draft",
  "enums.ScheduleStatus.EDITING": "Editing",
  "enums.ScheduleStatus.GENERATING": "Generating",
  "enums.ScheduleStatus.PUBLISHED": "Published",
  "enums.ShiftType.DAY": "Day",
  "enums.ShiftType.EVENING": "Evening",
  "enums.ShiftType.FLEXIBLE": "Flexible",
  "enums.ShiftType.HOLIDAY": "Holiday",
  "enums.ShiftType.NIGHT": "Night",
  "enums.ShiftType.WEEKEND_DAY": "Weekend Day",
  "enums.ShiftType.WEEKEND_NIGHT": "Weekend Night",
  "enums.TaskCategory.COMPLIANCE": "Compliance",
  "enums.TaskCategory.DOCUMENT": "Document",
  "enums.TaskCategory.EQUIPMENT": "Equipment",
  "enums.TaskCategory.FACILITY": "Facility",
  "enums.TaskCategory.FIRE": "Fire Safety",
  "enums.TaskCategory.HYGIENE": "Hygiene",
  "enums.TaskCategory.OTHER": "Other",
  "enums.TaskCategory.SAFETY": "Safety",
  "enums.TrainingCategory.ACCREDITATION": "Accreditation",
  "enums.TrainingCategory.LEGAL_MANDATORY": "Legal Mandatory",
  "enums.TrainingCategory.OTHER": "Other",
  "enums.TrainingCategory.SPECIALIZED": "Specialized",
  "enums.WageType.ANNUAL": "Annual Salary",
  "enums.WageType.COMMISSION": "Commission",
  "enums.WageType.DAILY": "Daily Wage",
  "enums.WageType.HOURLY": "Hourly Wage",
  "enums.WageType.MONTHLY": "Monthly Salary",
  "enums.WageType.PROJECT": "Project-Based",
  "enums.WageType.WEEKLY": "Weekly Wage"
};

// src/locales/en/errors.json
var errors_default = {
  "errors.auth.invalid_credentials": "Invalid email/phone or password.",
  "errors.auth.not_authenticated": "Authentication required.",
  "errors.auth.password_current_incorrect": "Current password is incorrect.",
  "errors.auth.password_current_required": "Current password is required.",
  "errors.auth.password_mismatch": "Passwords do not match.",
  "errors.auth.password_too_weak": "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.",
  "errors.auth.session_expired": "Session expired. Please log in again.",
  "errors.auth.sms_failed": "Failed to send SMS. Please try again later.",
  "errors.auth.token_invalid": "Invalid or expired token.",
  "errors.common.conflict": "This data already exists.",
  "errors.common.forbidden": "Access denied.",
  "errors.common.internal": "Server error. Please try again later.",
  "errors.common.not_found": "Data not found.",
  "errors.common.validation": "Please check your input.",
  "errors.employee.no_phone": "No phone number registered for SMS delivery.",
  "errors.employee.not_found": "Employee not found.",
  "errors.payroll.already_confirmed": "Payroll has already been confirmed.",
  "errors.payroll.not_calculated": "Payroll has not been calculated yet.",
  "errors.permission.denied": "Permission denied."
};

// src/locales/en/permissions.json
var permissions_default = {
  "perm.action.approve": "Approve",
  "perm.action.create": "Create",
  "perm.action.delete": "Delete",
  "perm.action.execute": "Execute",
  "perm.action.manage": "Manage",
  "perm.action.read": "View",
  "perm.action.update": "Edit",
  "perm.action.write": "Write",
  "perm.action.calculate": "Calculate",
  "perm.action.admin": "Admin",
  "perm.resource.ai": "AI Assistant",
  "perm.resource.aiApp": "Employee App AI Assistant",
  "perm.resource.allowance": "Allowance",
  "perm.resource.annualLeavePromotion": "Annual Leave Promotion",
  "perm.resource.attendance": "Attendance",
  "perm.resource.certification": "Certification",
  "perm.resource.conversation": "Messenger \u2014 rooms",
  "perm.resource.csReport": "CS Report",
  "perm.resource.deduction": "Deduction",
  "perm.resource.department": "Department",
  "perm.resource.document": "Document",
  "perm.resource.education": "Education",
  "perm.resource.educationSubsidy": "Education Subsidy",
  "perm.resource.employee": "Employee",
  "perm.resource.fixedIncentive": "Fixed Incentive",
  "perm.resource.generalAffairs": "General Affairs",
  "perm.resource.incentive": "Incentive",
  "perm.resource.inventory": "Inventory",
  "perm.resource.leave": "Leave",
  "perm.resource.leave-request": "Leave settings",
  "perm.resource.message": "Messenger \u2014 messages",
  "perm.resource.notification": "Notification",
  "perm.resource.nurse-scheduler": "Scheduler administration",
  "perm.resource.offsiteWork": "Offsite Work",
  "perm.resource.organization": "Organization",
  "perm.resource.overtime": "Overtime",
  "perm.resource.payroll": "Payroll",
  "perm.resource.resignation": "Resignation",
  "perm.resource.role": "Role",
  "perm.resource.salaryGrade": "Salary Grade",
  "perm.resource.schedule": "Work roster",
  "perm.resource.setting": "Settings",
  "perm.resource.storage": "Storage",
  "perm.resource.system": "System",
  "perm.resource.team": "Team",
  "perm.resource.teamDrive": "Drive",
  "perm.resource.impersonation": "Permission preview",
  "perm.resource.chatRecovery": "Chat recovery",
  "perm.resource.sheet": "Sheet administration",
  "perm.resource.ward": "Ward",
  "perm.resource.yearEndSettlement": "Year-End Settlement",
  "perm.scope.all": "All",
  "perm.scope.department": "Department",
  "perm.scope.self": "Own",
  "perm.scope.team": "Team"
};

// src/locales/ko/common.json
var common_default2 = {
  "term.role": "\uC5ED\uD560",
  "common.action_items": "\uCC98\uB9AC \uB300\uAE30",
  "common.active": "\uD65C\uC131",
  "common.add": "\uCD94\uAC00",
  "common.all": "\uC804\uCCB4",
  "common.apply": "\uC801\uC6A9",
  "common.assign": "\uBC30\uC815",
  "common.back": "\uB4A4\uB85C",
  "common.cancel": "\uCDE8\uC18C",
  "common.open": "\uC5F4\uAE30",
  "common.change": "\uBCC0\uACBD",
  "common.close": "\uB2EB\uAE30",
  "common.expand": "\uD3BC\uCE58\uAE30",
  "common.collapse": "\uC811\uAE30",
  "common.code": "\uCF54\uB4DC",
  "common.confirm": "\uD655\uC778",
  "common.confirm_delete": "\uC815\uB9D0 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "common.count_suffix": "\uAC74",
  "common.create": "\uB4F1\uB85D",
  "common.dashboard": "\uB300\uC2DC\uBCF4\uB4DC",
  "common.delete": "\uC0AD\uC81C",
  "common.description": "\uC124\uBA85",
  "common.exclude": "\uC81C\uC678",
  "common.remove": "\uC81C\uAC70",
  "common.detail": "\uC0C1\uC138",
  "common.download": "\uB2E4\uC6B4\uB85C\uB4DC",
  "common.edit": "\uC218\uC815",
  "common.export": "\uB0B4\uBCF4\uB0B4\uAE30",
  "common.failed": "\uCC98\uB9AC\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.",
  "common.filter": "\uD544\uD130",
  "common.import": "\uAC00\uC838\uC624\uAE30",
  "common.inactive": "\uBE44\uD65C\uC131",
  "common.items": "\uAC1C",
  "common.list": "\uBAA9\uB85D",
  "common.loading": "\uB85C\uB529 \uC911...",
  "common.login": "\uB85C\uADF8\uC778",
  "common.logout": "\uB85C\uADF8\uC544\uC6C3",
  "common.name": "\uC774\uB984",
  "common.network_error": "\uB124\uD2B8\uC6CC\uD06C \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.",
  "common.next": "\uB2E4\uC74C",
  "common.no": "\uC544\uB2C8\uC624",
  "common.no_data": "\uB370\uC774\uD130\uAC00 \uC5C6\uC5B4\uC694.",
  "common.no_results": "\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC5B4\uC694.",
  "common.none": "\uC5C6\uC74C",
  "common.not_selected": "\uBBF8\uC120\uD0DD",
  "common.notification": "\uC54C\uB9BC",
  "common.off": "OFF",
  "common.on": "ON",
  "common.optional": "\uC120\uD0DD\uC0AC\uD56D",
  "common.people_suffix": "\uBA85",
  "common.prev": "\uC774\uC804",
  "common.refresh": "\uC0C8\uB85C\uACE0\uCE68",
  "common.request": "\uC2E0\uCCAD",
  "common.required": "\uD544\uC218",
  "common.reset": "\uCD08\uAE30\uD654",
  "common.save": "\uC800\uC7A5",
  "common.saving": "\uC800\uC7A5 \uC911...",
  "common.search": "\uAC80\uC0C9",
  "common.select": "\uC120\uD0DD",
  "common.settings": "\uC124\uC815",
  "common.status": "\uC0C1\uD0DC",
  "common.submit": "\uC81C\uCD9C",
  "common.success": "\uC131\uACF5\uC801\uC73C\uB85C \uCC98\uB9AC\uB418\uC5C8\uC5B4\uC694.",
  "common.table": "\uD45C",
  "common.total": "\uD569\uACC4",
  "common.tree": "\uD2B8\uB9AC",
  "common.type": "\uC720\uD615",
  "common.unassigned": "\uBBF8\uC9C0\uC815",
  "common.upload": "\uC5C5\uB85C\uB4DC",
  "common.won_suffix": "\uC6D0",
  "common.year_suffix": "\uB144",
  "common.month_suffix": "\uC6D4",
  "common.day_suffix": "\uC77C",
  "common.hour_suffix": "\uC2DC\uAC04",
  "common.minute_suffix": "\uBD84",
  "common.yes": "\uC608",
  "common.from": "\uBD80\uD130",
  "common.to": "\uAE4C\uC9C0",
  "auth.login_subtitle": "\uB85C\uADF8\uC778\uD558\uC138\uC694",
  "auth.admin_login_subtitle": "\uAD00\uB9AC\uC790 \uACC4\uC815\uC73C\uB85C \uB85C\uADF8\uC778\uD558\uC138\uC694",
  "auth.employee_login_subtitle": "\uC9C1\uC6D0 \uC571\uC5D0 \uB85C\uADF8\uC778\uD558\uC138\uC694",
  "auth.change_password_title": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD",
  "auth.change_password_subtitle": "\uBCF4\uC548\uC744 \uC704\uD574 \uC0C8 \uBE44\uBC00\uBC88\uD638\uB97C \uC124\uC815\uD574\uC8FC\uC138\uC694.",
  "auth.new_password": "\uC0C8 \uBE44\uBC00\uBC88\uD638",
  "auth.confirm_password": "\uBE44\uBC00\uBC88\uD638 \uD655\uC778",
  "auth.password_mismatch": "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC544\uC694.",
  "auth.password_mismatch_current": "\uBE44\uBC00\uBC88\uD638\uB97C \uB2E4\uC2DC \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  "auth.permission_denied_title": "\uC811\uADFC \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694",
  "auth.permission_denied_message": "\uC774 \uD654\uBA74\uC5D0 \uC811\uADFC\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694.",
  "auth.logout_confirm_title": "\uB85C\uADF8\uC544\uC6C3 \uD558\uC2DC\uACA0\uC5B4\uC694?",
  "auth.logout_confirm_desc": "\uB85C\uADF8\uC544\uC6C3\uD558\uBA74 \uD604\uC7AC \uC138\uC158\uC774 \uC885\uB8CC\uB3FC\uC694. \uB2E4\uC2DC \uC774\uC6A9\uD558\uB824\uBA74 \uB85C\uADF8\uC778\uC774 \uD544\uC694\uD574\uC694.",
  "auth.request_permission": "\uAD8C\uD55C \uC694\uCCAD",
  "auth.identifier_label": "ID",
  "auth.identifier_placeholder": "ID",
  "auth.password_label": "\uBE44\uBC00\uBC88\uD638",
  "auth.password_placeholder": "\uBE44\uBC00\uBC88\uD638",
  "auth.password_toggle_show": "\uBE44\uBC00\uBC88\uD638 \uD45C\uC2DC",
  "auth.password_toggle_hide": "\uBE44\uBC00\uBC88\uD638 \uC228\uAE30\uAE30",
  "auth.logging_in": "\uB85C\uADF8\uC778 \uC911...",
  "auth.no_account": "\uACC4\uC815\uC774 \uC5C6\uC73C\uC2E0\uAC00\uC694?",
  "auth.signup": "\uD68C\uC6D0\uAC00\uC785",
  "auth.create_account": "\uC0C8 \uACC4\uC815\uC744 \uB9CC\uB4DC\uC138\uC694",
  "auth.step_account": "\uACC4\uC815 \uC815\uBCF4",
  "auth.step_org": "\uAE30\uAD00 \uC815\uBCF4",
  "auth.family_name": "\uC131",
  "auth.given_name": "\uC774\uB984",
  "auth.family_name_placeholder": "\uD64D",
  "auth.given_name_placeholder": "\uAE38\uB3D9",
  "auth.email_label": "\uC774\uBA54\uC77C",
  "auth.phone_label": "\uC804\uD654\uBC88\uD638",
  "auth.new_password_label": "\uC0C8 \uBE44\uBC00\uBC88\uD638",
  "auth.password_rule_change_later": "\uBE44\uBC00\uBC88\uD638 \uADDC\uCE59\uC740 \uC774\uD6C4 \uC124\uC815\uC5D0\uC11C \uBCC0\uACBD\uD560 \uC218 \uC788\uC5B4\uC694.",
  "auth.new_password_confirm_label": "\uC0C8 \uBE44\uBC00\uBC88\uD638 \uD655\uC778",
  "auth.password_confirm_placeholder": "\uBE44\uBC00\uBC88\uD638\uB97C \uB2E4\uC2DC \uC785\uB825",
  "auth.new_password_confirm_placeholder": "\uC0C8 \uBE44\uBC00\uBC88\uD638\uB97C \uB2E4\uC2DC \uC785\uB825",
  "auth.org_name_label": "\uAE30\uAD00\uBA85",
  "auth.org_name_placeholder": "\uC608: \uC11C\uC6B8\uC7AC\uD65C\uBCD1\uC6D0",
  "auth.org_code_label": "\uAE30\uAD00 \uCF54\uB4DC",
  "auth.org_code_placeholder": "\uC608: SeoulRehab (\uC601\uBB38 \uC2DC\uC791, 3~50\uC790)",
  "auth.accept_terms": "\uC774\uC6A9\uC57D\uAD00 \uBC0F \uAC1C\uC778\uC815\uBCF4\uCC98\uB9AC\uBC29\uCE68\uC5D0 \uB3D9\uC758\uD574\uC694",
  "auth.processing": "\uCC98\uB9AC \uC911...",
  "auth.already_have_account": "\uC774\uBBF8 \uACC4\uC815\uC774 \uC788\uC73C\uC2E0\uAC00\uC694?",
  "auth.login_failed": "\uB85C\uADF8\uC778\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.",
  "auth.device_login_title": "\uAE30\uAE30 \uC7A0\uAE08\uC73C\uB85C \uB85C\uADF8\uC778",
  "auth.device_login_greeting": "{name} \uB2D8, \uAE30\uAE30 \uC7A0\uAE08\uC73C\uB85C \uB85C\uADF8\uC778",
  "auth.device_login_desc": "\uC774 \uAE30\uAE30\uC5D0 \uB4F1\uB85D\uB41C \uD0A4\uB85C \uB85C\uADF8\uC778\uD574\uC694. \uC9C0\uBB38\xB7\uC5BC\uAD74 \uB610\uB294 \uAE30\uAE30 PIN \uC73C\uB85C \uBCF8\uC778\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  "auth.device_login_button": "\uC9C0\uBB38\xB7\uAE30\uAE30 \uC7A0\uAE08\uC73C\uB85C \uB85C\uADF8\uC778",
  "auth.device_login_cancelled": "\uBCF8\uC778 \uD655\uC778\uC774 \uCDE8\uC18C\uB410\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "auth.device_login_rejected": "\uC774 \uAE30\uAE30\uC758 \uB85C\uADF8\uC778 \uD0A4\uAC00 \uB354 \uC774\uC0C1 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC544\uC694. \uBE44\uBC00\uBC88\uD638\uB85C \uB85C\uADF8\uC778\uD558\uBA74 \uB2E4\uC2DC \uB4F1\uB85D\uB3FC\uC694.",
  "auth.device_login_use_password": "\uC544\uC774\uB514\xB7\uBE44\uBC00\uBC88\uD638\uB85C \uB85C\uADF8\uC778",
  "auth.device_login_use_key": "\uC9C0\uBB38\xB7\uAE30\uAE30 \uC7A0\uAE08\uC73C\uB85C \uB85C\uADF8\uC778",
  "auth.passkey_login_button": "\uD328\uC2A4\uD0A4\uB85C \uB85C\uADF8\uC778",
  "auth.passkey_register": "\uD328\uC2A4\uD0A4 \uB4F1\uB85D",
  "auth.passkey_offer": "\uC774 \uBE0C\uB77C\uC6B0\uC800\uC5D0 \uD328\uC2A4\uD0A4\uB97C \uB4F1\uB85D\uD560\uAE4C\uC694?\n\uB2E4\uC74C\uBD80\uD130 \uC9C0\uBB38\xB7Face ID\xB7Windows Hello \uB85C \uBE44\uBC00\uBC88\uD638 \uC5C6\uC774 \uB85C\uADF8\uC778\uD574\uC694.",
  "auth.captcha_title": "\uBCF4\uC548 \uD655\uC778",
  "auth.captcha_desc": "\uD3C9\uC18C\uC640 \uB2E4\uB978 \uD658\uACBD\uC5D0\uC11C \uB85C\uADF8\uC778\uD558\uACE0 \uC788\uC5B4\uC694. \uC544\uB798 \uD655\uC778\uC744 \uB9C8\uCE58\uBA74 \uACC4\uC18D\uD560 \uC218 \uC788\uC5B4\uC694.",
  "auth.captcha_failed": "\uBCF4\uC548 \uD655\uC778\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "auth.passkey_offer_unusual": "\uD3C9\uC18C\uC640 \uB2E4\uB978 \uD658\uACBD\uC5D0\uC11C \uB85C\uADF8\uC778\uD588\uC5B4\uC694.\n\uC774 \uBE0C\uB77C\uC6B0\uC800\uC5D0 \uD328\uC2A4\uD0A4\uB97C \uB4F1\uB85D\uD558\uBA74 \uBE44\uBC00\uBC88\uD638\uAC00 \uC0C8\uC5B4 \uB098\uAC00\uB3C4 \uB2E4\uB978 \uC0AC\uB78C\uC774 \uB85C\uADF8\uC778\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC9C0\uAE08 \uB4F1\uB85D\uD560\uAE4C\uC694?",
  "auth.passkey_offer_later": "\uB098\uC911\uC5D0",
  "auth.passkey_default_name": "\uC774 \uBE0C\uB77C\uC6B0\uC800",
  "auth.device_key_register": "\uC774 \uAE30\uAE30 \uB4F1\uB85D",
  "auth.device_login_section": "\uAE30\uAE30 \uB85C\uADF8\uC778",
  "auth.device_login_section_desc": "\uBE44\uBC00\uBC88\uD638 \uC5C6\uC774 \uD328\uC2A4\uD0A4\xB7\uC9C0\uBB38\xB7\uAE30\uAE30 \uC7A0\uAE08\uC73C\uB85C \uB85C\uADF8\uC778\uD558\uB294 \uAE30\uAE30\uC608\uC694. \uD68C\uC218\uD558\uBA74 \uADF8 \uAE30\uAE30\uB294 \uBE44\uBC00\uBC88\uD638\uB85C \uB3CC\uC544\uAC00\uC694.",
  "auth.device_credential_passkey": "\uD328\uC2A4\uD0A4",
  "auth.device_credential_device_key": "\uAE30\uAE30 \uD0A4",
  "auth.device_credential_last_used": "\uB9C8\uC9C0\uB9C9 \uC0AC\uC6A9",
  "auth.device_credential_never_used": "\uC544\uC9C1 \uC0AC\uC6A9 \uC548 \uD568",
  "auth.device_login_unsupported_build": "\uC774 \uC571 \uBC84\uC804\uC740 \uC9C0\uBB38\xB7\uAE30\uAE30 \uC7A0\uAE08 \uB85C\uADF8\uC778\uC744 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC544\uC694. \uC2A4\uD1A0\uC5B4\uC5D0\uC11C \uC571\uC744 \uCD5C\uC2E0 \uBC84\uC804\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8\uD574 \uC8FC\uC138\uC694.",
  "auth.device_login_no_webcrypto": "\uC774 \uAE30\uAE30\uC758 \uC571 \uD658\uACBD\uC5D0\uC11C\uB294 \uAE30\uAE30 \uD0A4\uB97C \uB9CC\uB4E4 \uC218 \uC5C6\uC5B4\uC694. \uC571\uC744 \uCD5C\uC2E0 \uBC84\uC804\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8\uD574 \uC8FC\uC138\uC694.",
  "security.title": "\uC778\uC99D/\uBCF4\uC548 \uC124\uC815",
  "security.account_section": "\uB85C\uADF8\uC778 \uACC4\uC815",
  "security.id_employee_number": "\uC0AC\uBC88",
  "security.id_email": "\uC774\uBA54\uC77C",
  "security.id_phone": "\uC804\uD654\uBC88\uD638",
  "security.last_login": "\uCD5C\uADFC \uB85C\uADF8\uC778",
  "security.password_change": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD",
  "security.current_password": "\uD604\uC7AC \uBE44\uBC00\uBC88\uD638",
  "security.new_password": "\uC0C8 \uBE44\uBC00\uBC88\uD638",
  "security.new_password_confirm": "\uC0C8 \uBE44\uBC00\uBC88\uD638 \uD655\uC778",
  "security.new_password_mismatch": "\uC0C8 \uBE44\uBC00\uBC88\uD638\uC640 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC544\uC694.",
  "security.two_factor": "2\uB2E8\uACC4 \uC778\uC99D",
  "security.two_factor_desc": "\uBE44\uBC00\uBC88\uD638 \uB85C\uADF8\uC778 \uB54C \uC778\uC99D \uC571(Google Authenticator \uB4F1)\uC758 6\uC790\uB9AC \uCF54\uB4DC\uB97C \uD55C \uBC88 \uB354 \uD655\uC778\uD574\uC694. \uD328\uC2A4\uD0A4\xB7\uAE30\uAE30 \uD0A4 \uB85C\uADF8\uC778\uC740 \uBB3B\uC9C0 \uC54A\uC544\uC694.",
  "security.two_factor_enable": "\uB4F1\uB85D",
  "security.two_factor_disable": "\uB044\uAE30",
  "security.two_factor_on": "\uC0AC\uC6A9 \uC911",
  "security.two_factor_required_by_org": "\uC870\uC9C1 \uD544\uC218",
  "security.backup_codes_left": "\uBC31\uC5C5 \uCF54\uB4DC {n}\uAC1C \uB0A8\uC74C",
  "security.two_factor_scan": "\uC778\uC99D \uC571\uC73C\uB85C QR \uCF54\uB4DC\uB97C \uC77D\uACE0, \uC571\uC5D0 \uD45C\uC2DC\uB41C 6\uC790\uB9AC \uCF54\uB4DC\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
  "security.two_factor_manual": "QR \uC744 \uBABB \uC77D\uC73C\uBA74 \uC774 \uD0A4\uB97C \uC9C1\uC811 \uC785\uB825:",
  "security.two_factor_code_placeholder": "6\uC790\uB9AC \uCF54\uB4DC",
  "security.two_factor_code_or_backup": "6\uC790\uB9AC \uCF54\uB4DC \uB610\uB294 \uBC31\uC5C5 \uCF54\uB4DC",
  "security.two_factor_code_format": "\uC778\uC99D \uC571\uC758 6\uC790\uB9AC \uCF54\uB4DC\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
  "security.two_factor_failed": "2\uB2E8\uACC4 \uC778\uC99D \uCC98\uB9AC\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "security.two_factor_required_notice": "\uC870\uC9C1 \uC815\uCC45\uC5D0 \uB530\uB77C 2\uB2E8\uACC4 \uC778\uC99D \uB4F1\uB85D\uC774 \uD544\uC694\uD574\uC694. \uC544\uB798 \u300C2\uB2E8\uACC4 \uC778\uC99D\u300D\uC5D0\uC11C \uB4F1\uB85D\uD574 \uC8FC\uC138\uC694.",
  "security.two_factor_login_title": "2\uB2E8\uACC4 \uC778\uC99D",
  "security.two_factor_login_desc": "\uC778\uC99D \uC571\uC5D0 \uD45C\uC2DC\uB41C 6\uC790\uB9AC \uCF54\uB4DC\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694. \uC571\uC744 \uC4F8 \uC218 \uC5C6\uC73C\uBA74 \uBC31\uC5C5 \uCF54\uB4DC\uB3C4 \uB3FC\uC694.",
  "security.two_factor_verify": "\uD655\uC778",
  "security.backup_codes_title": "\uBC31\uC5C5 \uCF54\uB4DC\uB97C \uC548\uC804\uD55C \uACF3\uC5D0 \uBCF4\uAD00\uD574 \uC8FC\uC138\uC694",
  "security.backup_codes_desc": "\uC778\uC99D \uC571\uC744 \uC4F8 \uC218 \uC5C6\uC744 \uB54C \uCF54\uB4DC \uD558\uB098\uB85C \uD55C \uBC88\uC529 \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uC5B4\uC694. \uC9C0\uAE08\uB9CC \uBCF4\uC5EC \uB4DC\uB824\uC694.",
  "security.backup_codes_copy": "\uBCF5\uC0AC",
  "security.backup_codes_copied": "\uBC31\uC5C5 \uCF54\uB4DC\uB97C \uBCF5\uC0AC\uD588\uC5B4\uC694.",
  "security.sessions": "\uB85C\uADF8\uC778\uD55C \uAE30\uAE30",
  "security.sessions_desc": "\uC9C0\uAE08 \uB85C\uADF8\uC778\uB418\uC5B4 \uC788\uB294 \uAE30\uAE30\uC608\uC694. \uBAA8\uB974\uB294 \uAE30\uAE30\uB294 \uB85C\uADF8\uC544\uC6C3\uD574 \uC8FC\uC138\uC694.",
  "security.sessions_empty": "\uB85C\uADF8\uC778\uD55C \uAE30\uAE30\uAC00 \uC5C6\uC5B4\uC694.",
  "security.session_current": "\uD604\uC7AC \uAE30\uAE30",
  "security.session_last_used": "\uB9C8\uC9C0\uB9C9 \uC0AC\uC6A9",
  "security.session_logout": "\uB85C\uADF8\uC544\uC6C3",
  "security.session_logout_confirm": "{device} \uAE30\uAE30\uB97C \uB85C\uADF8\uC544\uC6C3\uD560\uAE4C\uC694?\n\uADF8 \uAE30\uAE30\uB294 \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574\uC57C \uD574\uC694.",
  "security.session_logout_current_confirm": "\uC9C0\uAE08 \uC4F0\uB294 \uAE30\uAE30\uB97C \uB85C\uADF8\uC544\uC6C3\uD560\uAE4C\uC694?",
  "security.session_logout_failed": "\uB85C\uADF8\uC544\uC6C3 \uCC98\uB9AC\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "security.sessions_logout_others": "\uD604\uC7AC \uAE30\uAE30 \uC678 \uBAA8\uB450 \uB85C\uADF8\uC544\uC6C3",
  "security.sessions_logout_others_confirm": "\uC9C0\uAE08 \uC4F0\uB294 \uAE30\uAE30\uB97C \uBE7C\uACE0 \uB85C\uADF8\uC778\uB41C \uBAA8\uB4E0 \uAE30\uAE30\uB97C \uB85C\uADF8\uC544\uC6C3\uD560\uAE4C\uC694?\n\uADF8 \uAE30\uAE30\uB4E4\uC740 \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574\uC57C \uD574\uC694.",
  "security.sessions_logout_others_done": "\uB2E4\uB978 \uAE30\uAE30\uB97C \uBAA8\uB450 \uB85C\uADF8\uC544\uC6C3\uD588\uC5B4\uC694.",
  "security.chat_lock_desc": "\uBA54\uC2E0\uC800 \uC554\uD638\uD654 \uD0A4 \xB7 \uBCF5\uAD6C \uCF54\uB4DC \xB7 \uAE30\uAE30 \uC2B9\uC778",
  "security.passkey_only": "\uD328\uC2A4\uD0A4\xB7\uAE30\uAE30 \uD0A4\uB85C\uB9CC \uB85C\uADF8\uC778",
  "security.passkey_only_desc": "\uCF1C\uBA74 \uBE44\uBC00\uBC88\uD638\xB7\uBB38\uC790 \uC778\uC99D\uBC88\uD638\uB85C\uB294 \uB85C\uADF8\uC778\uD560 \uC218 \uC5C6\uC5B4\uC694. \uBE44\uBC00\uBC88\uD638\uAC00 \uC0C8\uC5B4 \uB098\uAC00\uB3C4 \uB2E4\uB978 \uC0AC\uB78C\uC774 \uB4E4\uC5B4\uC62C \uC218 \uC5C6\uC5B4\uC694. \uAE30\uAE30\uB97C \uC783\uC73C\uBA74 \uAD00\uB9AC\uC790\uAC00 \uD574\uC81C\uD574 \uC918\uC694.",
  "security.passkey_only_need_credential": "\uD328\uC2A4\uD0A4\uB098 \uAE30\uAE30 \uD0A4\uB97C \uBA3C\uC800 \uB4F1\uB85D\uD574\uC57C \uCF24 \uC218 \uC788\uC5B4\uC694.",
  "security.passkey_only_confirm": "\uC9C0\uAE08\uBD80\uD130 \uBE44\uBC00\uBC88\uD638\xB7\uBB38\uC790 \uC778\uC99D\uBC88\uD638\uB85C\uB294 \uB85C\uADF8\uC778\uD560 \uC218 \uC5C6\uC5B4\uC694.\n\uB4F1\uB85D\uB41C \uD328\uC2A4\uD0A4\xB7\uAE30\uAE30 \uD0A4\uAC00 \uC788\uB294 \uAE30\uAE30\uC5D0\uC11C\uB9CC \uB85C\uADF8\uC778\uB3FC\uC694. \uCF24\uAE4C\uC694?",
  "employee.passkey_only_login": "\uD328\uC2A4\uD0A4 \uC804\uC6A9 \uB85C\uADF8\uC778",
  "employee.passkey_only_login_on": "\uC774 \uC9C1\uC6D0\uC740 \uBE44\uBC00\uBC88\uD638\xB7\uBB38\uC790 \uC778\uC99D\uBC88\uD638\uB85C \uB85C\uADF8\uC778\uD560 \uC218 \uC5C6\uC5B4\uC694. \uAE30\uAE30\uB97C \uC783\uC5C8\uB2E4\uBA74 \uD574\uC81C\uD574 \uC8FC\uC138\uC694.",
  "employee.passkey_only_login_will_disable": "\uC800\uC7A5\uD558\uBA74 \uBE44\uBC00\uBC88\uD638\xB7\uBB38\uC790 \uC778\uC99D\uBC88\uD638 \uB85C\uADF8\uC778\uC774 \uB2E4\uC2DC \uC5F4\uB824\uC694.",
  "employee.passkey_only_login_disable": "\uD574\uC81C",
  "settings.two_factor_required": "2\uB2E8\uACC4 \uC778\uC99D \uD544\uC218",
  "settings.two_factor_required_desc": "\uCF1C\uBA74 \uC544\uC9C1 \uB4F1\uB85D\uD558\uC9C0 \uC54A\uC740 \uC9C1\uC6D0\uC740 \uB85C\uADF8\uC778 \uC9C1\uD6C4 \uC778\uC99D/\uBCF4\uC548 \uC124\uC815\uC73C\uB85C \uC548\uB0B4\uB418\uACE0, \uB4F1\uB85D\uD55C \uC9C1\uC6D0\uC740 2\uB2E8\uACC4 \uC778\uC99D\uC744 \uB04C \uC218 \uC5C6\uC5B4\uC694. \uD328\uC2A4\uD0A4\xB7\uAE30\uAE30 \uD0A4 \uB85C\uADF8\uC778\uC740 2\uB2E8\uACC4 \uC778\uC99D\uC744 \uBB3B\uC9C0 \uC54A\uC544\uC694.",
  "auth.device_credential_revoke": "\uD68C\uC218",
  "auth.device_credential_revoke_confirm": "\uC774 \uAE30\uAE30\uC758 \uB85C\uADF8\uC778 \uD0A4\uB97C \uD68C\uC218\uD560\uAE4C\uC694?\n\uADF8 \uAE30\uAE30\uB294 \uB2E4\uC74C\uBD80\uD130 \uBE44\uBC00\uBC88\uD638\uB85C \uB85C\uADF8\uC778\uD574\uC694.",
  "auth.device_credentials_empty": "\uB4F1\uB85D\uB41C \uAE30\uAE30\uAC00 \uC5C6\uC5B4\uC694.",
  "auth.device_credential_failed": "\uAE30\uAE30 \uB85C\uADF8\uC778 \uC124\uC815\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.",
  "auth.device_key_registered_toast": "\uB2E4\uC74C\uBD80\uD130 \uC9C0\uBB38\xB7\uAE30\uAE30 \uC7A0\uAE08\uC73C\uB85C \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uC5B4\uC694.",
  "auth.api_unreachable": "API \uC11C\uBC84\uC5D0 \uC5F0\uACB0\uD560 \uC218 \uC5C6\uC5B4\uC694. API\uAC00 \uC2E4\uD589 \uC911\uC778\uC9C0(\uAE30\uBCF8 http://localhost:3000)\uC640 \uBC29\uD654\uBCBD \uC124\uC815\uC744 \uD655\uC778\uD558\uC138\uC694.",
  "auth.identifier_required": "\uC0AC\uBC88(\uB610\uB294 \uC774\uBA54\uC77C)\uACFC \uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "auth.change_password_failed": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.",
  "auth.password_changed": "\uBE44\uBC00\uBC88\uD638\uAC00 \uC131\uACF5\uC801\uC73C\uB85C \uBCC0\uACBD\uB418\uC5C8\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uC774\uB3D9\uD574\uC694...",
  "auth.changing_password": "\uBCC0\uACBD \uC911...",
  "auth.forgot_password": "\uBE44\uBC00\uBC88\uD638 \uCC3E\uAE30",
  "auth.forgot_password_subtitle": "SMS\uB97C \uBC1B\uC9C0 \uBABB\uD55C \uACBD\uC6B0 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758\uD574 \uC8FC\uC138\uC694.",
  "auth.forgot_password_submit": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638 \uBC1C\uC1A1",
  "auth.forgot_password_submitting": "\uBC1C\uC1A1 \uC911...",
  "auth.forgot_password_success": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638\uAC00 SMS\uB85C \uBC1C\uC1A1\uB418\uC5C8\uC5B4\uC694. \uB85C\uADF8\uC778 \uD6C4 \uBE44\uBC00\uBC88\uD638\uB97C \uBCC0\uACBD\uD574\uC8FC\uC138\uC694.",
  "auth.forgot_password_info": "\uC0AC\uBC88 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uC78A\uC73C\uC2E0 \uACBD\uC6B0 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758\uD574 \uC8FC\uC138\uC694.",
  "auth.forgot_password_back": "\uB85C\uADF8\uC778\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
  "auth.forgot_password_failed": "\uC694\uCCAD \uCC98\uB9AC \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694.",
  "auth.login_method_password": "\uBE44\uBC00\uBC88\uD638",
  "auth.login_method_otp": "\uD734\uB300\uD3F0 \uC778\uC99D",
  "auth.code_request_button": "\uC778\uC99D\uBC88\uD638 \uBC1B\uAE30",
  "auth.code_requesting": "\uBC1C\uC1A1 \uC911...",
  "auth.code_label": "\uC778\uC99D\uBC88\uD638",
  "auth.code_placeholder": "6\uC790\uB9AC \uC22B\uC790",
  "auth.code_sent_message": "\uB4F1\uB85D\uB41C \uD734\uB300\uD3F0\uC73C\uB85C \uC778\uC99D\uBC88\uD638\uAC00 \uBC1C\uC1A1\uB418\uC5C8\uC5B4\uC694.",
  "auth.code_verify_button": "\uD655\uC778",
  "auth.code_resend": "\uB2E4\uC2DC \uBCF4\uB0B4\uAE30",
  "auth.code_change_identifier": "\uB2E4\uC2DC \uC785\uB825",
  "auth.code_required": "\uC778\uC99D\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "auth.code_format_invalid": "\uC778\uC99D\uBC88\uD638\uB294 6\uC790\uB9AC \uC22B\uC790\uC785\uB2C8\uB2E4.",
  "settings.self_password_reset": "\uBE44\uBC00\uBC88\uD638 \uCC3E\uAE30 \uD5C8\uC6A9",
  "settings.self_password_reset_desc": "\uC9C1\uC6D0\uC774 \uB85C\uADF8\uC778 \uD398\uC774\uC9C0\uC5D0\uC11C \uBE44\uBC00\uBC88\uD638 \uCC3E\uAE30\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694.",
  "auth.signup_failed": "\uD68C\uC6D0\uAC00\uC785\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.",
  "auth.first_name_required": "\uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "auth.last_name_required": "\uC131\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "auth.email_invalid": "\uC62C\uBC14\uB978 \uC774\uBA54\uC77C \uD615\uC2DD\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "auth.phone_invalid": "\uC62C\uBC14\uB978 \uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694. (\uC608: 010-1234-5678)",
  "auth.org_name_required": "\uAE30\uAD00\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "auth.org_code_invalid": "\uAE30\uAD00 \uCF54\uB4DC\uB294 \uC601\uBB38\uC73C\uB85C \uC2DC\uC791\uD558\uACE0 3~50\uC790\uC758 \uC601\uBB38, \uC22B\uC790, \uD558\uC774\uD508, \uBC11\uC904\uB9CC \uC0AC\uC6A9 \uAC00\uB2A5\uD574\uC694.",
  "auth.hospital_code_title": "\uD68C\uC0AC \uCF54\uB4DC\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694",
  "auth.hospital_code_label": "\uD68C\uC0AC \uCF54\uB4DC",
  "auth.hospital_code_placeholder": "\uC601\uBB38\xB7\uC22B\uC790 \uCF54\uB4DC",
  "auth.hospital_code_help": "\uC548\uB0B4 \uBB38\uC790\uB098 \uC774\uBA54\uC77C\uC5D0 \uC801\uD78C \uC601\uBB38\xB7\uC22B\uC790 \uCF54\uB4DC\uC608\uC694.",
  "auth.hospital_code_contact": "\uCF54\uB4DC\uB97C \uBAA8\uB974\uBA74 \uD68C\uC0AC \uB2F4\uB2F9\uC790\uC5D0\uAC8C \uBB38\uC758\uD574 \uC8FC\uC138\uC694.",
  "auth.hospital_code_search": "\uCC3E\uAE30",
  "auth.hospital_code_searching": "\uCC3E\uB294 \uC911...",
  "auth.hospital_code_invalid": "\uD68C\uC0AC \uCF54\uB4DC\uB97C \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  "auth.hospital_code_not_found": "\uC774 \uCF54\uB4DC\uB85C \uCC3E\uC740 \uD68C\uC0AC\uAC00 \uC5C6\uC5B4\uC694. \uC548\uB0B4 \uBB38\uC790\uC758 \uCF54\uB4DC\uB97C \uB2E4\uC2DC \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  "auth.hospital_code_unreachable": "\uC9C0\uAE08 \uC5F0\uACB0\uC774 \uC5B4\uB824\uC6CC\uC694. \uC7A0\uC2DC \uB4A4 \uB2E4\uC2DC \uB20C\uB7EC \uC8FC\uC138\uC694.",
  "auth.hospital_code_missing_discovery": "\uC9C0\uAE08\uC740 \uD68C\uC0AC\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694. \uD68C\uC0AC \uB2F4\uB2F9\uC790\uC5D0\uAC8C \uBB38\uC758\uD574 \uC8FC\uC138\uC694.",
  "auth.hospital_confirm_title": "\uC5F0\uACB0\uD560 \uD68C\uC0AC\uAC00 \uB9DE\uB098\uC694?",
  "auth.hospital_confirm_subtitle": "\uB9DE\uC73C\uBA74 \uB85C\uADF8\uC778 \uD654\uBA74\uC73C\uB85C \uB118\uC5B4\uAC00\uC694.",
  "auth.hospital_confirm_name": "\uD68C\uC0AC \uC774\uB984",
  "auth.hospital_confirm_connect": "\uB9DE\uC544\uC694, \uC5F0\uACB0\uD558\uAE30",
  "auth.hospital_confirm_search_again": "\uB2E4\uC2DC \uC785\uB825",
  "auth.hospital_change": "\uC870\uC9C1 \uBCC0\uACBD",
  "auth.hospital_change_confirm": "\uB2E4\uB978 \uC870\uC9C1\uC73C\uB85C \uB2E4\uC2DC \uC5F0\uACB0\uD560\uAE4C\uC694?",
  "auth.accept_terms_required": "\uC774\uC6A9\uC57D\uAD00\uC5D0 \uB3D9\uC758\uD574\uC8FC\uC138\uC694.",
  "auth.permission_required_title": "\uC811\uADFC \uAD8C\uD55C\uC774 \uD544\uC694\uD574\uC694",
  "auth.permission_required_message": "\uC774 \uAE30\uB2A5\uC744 \uC0AC\uC6A9\uD558\uB824\uBA74 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uAD8C\uD55C\uC744 \uC694\uCCAD\uD558\uC138\uC694.",
  "auth.required_permission": "\uD544\uC694 \uAD8C\uD55C:",
  "auth.permission_request_reason": "\uAD8C\uD55C \uC694\uCCAD \uC0AC\uC720",
  "auth.permission_request_placeholder": "\uAD8C\uD55C\uC774 \uD544\uC694\uD55C \uC0AC\uC720\uB97C \uC791\uC131\uD574 \uC8FC\uC138\uC694...",
  "auth.permission_request_sent": "\uAD8C\uD55C \uC694\uCCAD\uC774 \uC804\uC1A1\uB418\uC5C8\uC5B4\uC694.",
  "auth.permission_request_sent_detail": "\uAD00\uB9AC\uC790\uAC00 \uC2B9\uC778\uD558\uBA74 \uC54C\uB9BC\uC744 \uBC1B\uAC8C \uB3FC\uC694.",
  "auth.requesting": "\uC694\uCCAD \uC911...",
  "nav.employees": "\uC9C1\uC6D0",
  "nav.teams": "\uD300",
  "nav.roles": "{@role}",
  "nav.leaves": "\uC5F0\uCC28/\uD734\uAC00",
  "nav.settings": "\uC124\uC815",
  "nav.payroll": "\uAE09\uC5EC",
  "nav.admin": "\uAD00\uB9AC\uC790",
  "nav.employee_app": "\uC9C1\uC6D0 \uC571",
  "nav.module_manager": "\uBAA8\uB4C8 \uAD00\uB9AC",
  "nav.team_management": "\uB0B4\uBD80 \uACB0\uC7AC",
  "nav.nurse_scheduler": "\uAC04\uD638 \uC2A4\uCF00\uC904",
  "nav.general_affairs": "\uCD1D\uBB34",
  "nav.inventory": "\uC7AC\uACE0\uAD00\uB9AC",
  "nav.management_dashboard": "\uACBD\uC601 \uB300\uC2DC\uBCF4\uB4DC",
  "nav.drive": "\uB4DC\uB77C\uC774\uBE0C",
  "team_drive.title": "\uB4DC\uB77C\uC774\uBE0C",
  "team_drive.search_placeholder": "\uD3F4\uB354\uBA85 / \uD30C\uC77C\uBA85",
  "team_drive.upload": "\uD30C\uC77C \uC5C5\uB85C\uB4DC",
  "team_drive.create_folder": "\uD3F4\uB354 \uB9CC\uB4E4\uAE30",
  "team_drive.parent_folder": "\uC0C1\uC704 \uD3F4\uB354",
  "team_drive.folder_name": "\uD3F4\uB354\uBA85",
  "team_drive.name_placeholder": "\uD3F4\uB354\uBA85",
  "team_drive.desc_placeholder": "\uC124\uBA85",
  "team_drive.folder_hint": "\uD3F4\uB354",
  "team_drive.file_hint": "\uC5C5\uB85C\uB4DC\uD55C \uD30C\uC77C",
  "team_drive.col_name": "\uC774\uB984",
  "team_drive.col_size": "\uD06C\uAE30",
  "team_drive.col_uploader": "\uC62C\uB9B0 \uC0AC\uB78C",
  "team_drive.col_date": "\uC218\uC815\uD55C \uB0A0\uC9DC",
  "team_drive.col_comments": "\uB313\uAE00",
  "team_drive.new_comment_badge": "\uC0C8 \uB313\uAE00\uC774 \uC788\uC5B4\uC694",
  "team_drive.empty_root": "\uD3F4\uB354\uAC00 \uC5C6\uC5B4\uC694. \uD3F4\uB354\uB97C \uB9CC\uB4E4\uC5B4 \uC8FC\uC138\uC694.",
  "team_drive.empty_folder": "\uC774 \uD3F4\uB354\uC5D0 \uD30C\uC77C\uC774 \uC5C6\uC5B4\uC694.",
  "team_drive.toast_folder_created": "\uD3F4\uB354\uB97C \uB9CC\uB4E4\uC5C8\uC5B4\uC694.",
  "team_drive.toast_uploaded": "\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD588\uC5B4\uC694.",
  "team_drive.toast_uploaded_n": "{n}\uAC1C \uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD588\uC5B4\uC694.",
  "team_drive.toast_upload_rejected": "\uC77C\uBD80 \uD30C\uC77C\uC740 \uD615\uC2DD \uB610\uB294 \uC6A9\uB7C9(\uCD5C\uB300 10MB) \uB54C\uBB38\uC5D0 \uC81C\uC678\uB410\uC5B4\uC694.",
  "team_drive.toast_upload_failed": "\uC5C5\uB85C\uB4DC\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "team_drive.error_name_required": "\uD3F4\uB354\uBA85\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
  "team_drive.error_name_duplicate": "\uC774\uBBF8 \uC788\uB294 \uD3F4\uB354\uBA85\uC774\uC5D0\uC694. \uB2E4\uB978 \uC774\uB984\uC744 \uC0AC\uC6A9\uD574 \uC8FC\uC138\uC694.",
  "team_drive.menu_new_folder": "\uC0C8 \uD3F4\uB354",
  "team_drive.menu_rename": "\uC774\uB984 \uBCC0\uACBD",
  "team_drive.menu_delete": "\uC0AD\uC81C",
  "team_drive.menu_move": "\uC774\uB3D9",
  "team_drive.trash": "\uD734\uC9C0\uD1B5",
  "team_drive.trash_notice": "\uD734\uC9C0\uD1B5\uC758 \uD56D\uBAA9\uC740 30\uC77C\uC774 \uC9C0\uB098\uBA74 \uC790\uB3D9\uC73C\uB85C \uC601\uAD6C \uC0AD\uC81C\uB3FC\uC694.",
  "team_drive.trash_empty": "\uD734\uC9C0\uD1B5\uC774 \uBE44\uC5B4 \uC788\uC5B4\uC694.",
  "team_drive.trash_restore": "\uBCF5\uC6D0",
  "team_drive.trash_purge": "\uC601\uAD6C \uC0AD\uC81C",
  "team_drive.trash_empty_all": "\uD734\uC9C0\uD1B5 \uBE44\uC6B0\uAE30",
  "team_drive.col_original_location": "\uC6D0\uB798 \uC704\uCE58",
  "team_drive.col_deleted_by": "\uC9C0\uC6B4 \uC0AC\uB78C",
  "team_drive.col_deleted_at": "\uC9C0\uC6B4 \uB0A0\uC9DC",
  "team_drive.original_missing": "\uC6D0\uB798 \uC704\uCE58 \uC5C6\uC74C",
  "team_drive.confirm_purge": "\u300C{name}\u300D\uC744(\uB97C) \uC601\uAD6C \uC0AD\uC81C\uD560\uAE4C\uC694?",
  "team_drive.purge_irreversible": "\uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC5B4\uC694. \uD3F4\uB354\uB294 \uD558\uC704 \uD3F4\uB354\xB7\uD30C\uC77C\uAE4C\uC9C0 \uD568\uAED8 \uC9C0\uC6CC\uC838\uC694.",
  "team_drive.confirm_empty_trash": "\uD734\uC9C0\uD1B5\uC758 {n}\uAC1C \uD56D\uBAA9\uC744 \uBAA8\uB450 \uC601\uAD6C \uC0AD\uC81C\uD560\uAE4C\uC694?",
  "team_drive.toast_restored": "\uBCF5\uC6D0\uD588\uC5B4\uC694.",
  "team_drive.toast_restored_relocated": "\uC6D0\uB798 \uC704\uCE58\uAC00 \uC5C6\uC5B4 \u300C\uC804\uCCB4\u300D\uB85C \uBCF5\uC6D0\uD588\uC5B4\uC694.",
  "team_drive.toast_purged": "\uC601\uAD6C \uC0AD\uC81C\uD588\uC5B4\uC694.",
  "team_drive.toast_trash_failed": "\uCC98\uB9AC\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "team_drive.selection_count": "{n}\uAC1C \uC120\uD0DD",
  "team_drive.selection_clear": "\uC120\uD0DD \uD574\uC81C",
  "team_drive.selection_no_permission": "\uD3B8\uC9D1 \uAD8C\uD55C\uC774 \uC5C6\uB294 \uD56D\uBAA9\uC774 \uC788\uC5B4\uC694.",
  "team_drive.select_all": "\uC804\uCCB4 \uC120\uD0DD",
  "team_drive.select_row": "\uC120\uD0DD",
  "team_drive.confirm_delete_many": "\uC120\uD0DD\uD55C {n}\uAC1C \uD56D\uBAA9\uC744 \uC0AD\uC81C\uD560\uAE4C\uC694?",
  "team_drive.move_title": "\uC774\uB3D9",
  "team_drive.move_target": "\uC774\uB3D9\uD560 \uC704\uCE58",
  "team_drive.move_confirm": "\uC774\uB3D9",
  "team_drive.move_current_location": "\uC9C0\uAE08 \uC788\uB294 \uC704\uCE58",
  "team_drive.move_items_summary": "\uD3F4\uB354 {folders}\uAC1C, \uD30C\uC77C {files}\uAC1C",
  "team_drive.toast_moved": "\uC774\uB3D9\uD588\uC5B4\uC694.",
  "team_drive.toast_move_failed": "\uC774\uB3D9\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.",
  "team_drive.confirm_delete_folder": "\u300C{name}\u300D \uD3F4\uB354\uB97C \uC0AD\uC81C\uD560\uAE4C\uC694?",
  "team_drive.confirm_delete_file": "\u300C{name}\u300D \uD30C\uC77C\uC744 \uC0AD\uC81C\uD560\uAE4C\uC694?",
  "team_drive.delete_subtree_note": "\uD558\uC704 \uD3F4\uB354 {folders}\uAC1C, \uD30C\uC77C {files}\uAC1C\uAC00 \uD568\uAED8 \uC0AD\uC81C\uB3FC\uC694.",
  "team_drive.delete_confirm": "\uC0AD\uC81C",
  "team_drive.toast_deleted": "\uC0AD\uC81C\uD588\uC5B4\uC694.",
  "team_drive.toast_delete_failed": "\uC0AD\uC81C\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.",
  "team_drive.edit_folder": "\uD3F4\uB354 \uC218\uC815",
  "team_drive.rename_file_message": "\uC0C8 \uD30C\uC77C\uBA85\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
  "team_drive.rename_confirm": "\uBCC0\uACBD",
  "team_drive.toast_renamed": "\uC774\uB984\uC744 \uBC14\uAFE8\uC5B4\uC694.",
  "team_drive.toast_folder_updated": "\uD3F4\uB354\uB97C \uC218\uC815\uD588\uC5B4\uC694.",
  "team_drive.error_file_name_invalid": "\uC4F8 \uC218 \uC5C6\uB294 \uD30C\uC77C\uBA85\uC774\uC5D0\uC694.",
  "team_drive.menu_permissions": "\uAD8C\uD55C \uAD00\uB9AC",
  "team_drive.menu_share": "\uACF5\uC720 \uB9C1\uD06C",
  "team_drive.menu_preview": "\uBBF8\uB9AC\uBCF4\uAE30",
  "team_drive.menu_download": "\uB2E4\uC6B4\uB85C\uB4DC",
  "team_drive.drop_hint": "\uC5EC\uAE30\uC5D0 \uB193\uC544 \uC5C5\uB85C\uB4DC",
  "team_drive.restricted_badge": "\uC81C\uD55C\uB428",
  "team_drive.access_title": "\uAD8C\uD55C \uAD00\uB9AC",
  "team_drive.access_mode": "\uB204\uAC00 \uBCFC \uC218 \uC788\uB098\uC694",
  "team_drive.access_open": "\uC870\uC9C1 \uC804\uCCB4",
  "team_drive.access_restricted": "\uC9C0\uC815\uD55C \uB300\uC0C1\uB9CC",
  "team_drive.grant_add": "\uB300\uC0C1 \uCD94\uAC00",
  "team_drive.grant_team": "\uD300",
  "team_drive.grant_employee": "\uC9C1\uC6D0",
  "team_drive.role_viewer": "\uBCF4\uAE30 \uAD8C\uD55C",
  "team_drive.role_editor": "\uD3B8\uC9D1 \uAD8C\uD55C",
  "team_drive.grant_inherited": "\uC0C1\uC704\uC5D0\uC11C",
  "team_drive.no_grants": "\uB300\uC0C1\uC774 \uC5C6\uC73C\uBA74 \uB9CC\uB4E0 \uC0AC\uB78C\uACFC \uAD00\uB9AC\uC790\uB9CC \uBCFC \uC218 \uC788\uC5B4\uC694.",
  "team_drive.toast_access_saved": "\uAD8C\uD55C \uC124\uC815\uC744 \uC800\uC7A5\uD588\uC5B4\uC694.",
  "team_drive.access_open_desc": "\uC870\uC9C1\uC758 \uBAA8\uB4E0 \uC9C1\uC6D0\uC774 \uBCFC \uC218 \uC788\uC5B4\uC694",
  "team_drive.access_restricted_desc": "\uBAA9\uB85D\uC758 \uD300\xB7\uC9C1\uC6D0\uACFC \uAD00\uB9AC\uC790\uB9CC \uBCFC \uC218 \uC788\uC5B4\uC694",
  "team_drive.access_open_locked": "\uC0C1\uC704 \uD3F4\uB354\uAC00 \uC81C\uD55C\uC774\uB77C \uACE0\uB97C \uC218 \uC5C6\uC5B4\uC694",
  "team_drive.access_from_parent": "\uC0C1\uC704 \uD3F4\uB354 \u300C{name}\u300D\uC758 \uC81C\uD55C\uC744 \uB530\uB77C\uC694",
  "team_drive.access_from_ancestor": "\uC0C1\uC704 \uD3F4\uB354\uC5D0\uC11C",
  "team_drive.grant_list": "\uBCFC \uC218 \uC788\uB294 \uB300\uC0C1",
  "team_drive.grant_new": "\uC0C8\uB85C",
  "team_drive.grant_sub_teams": "\uD558\uC704 \uD300 {n}\uAC1C \uD3EC\uD568",
  "team_drive.access_pending": "\uBCC0\uACBD {n}\uAC74 \xB7 \uC544\uC9C1 \uC800\uC7A5 \uC548 \uB428",
  "team_drive.access_save_without_targets": "\uB300\uC0C1 \uC5C6\uC774 \uC800\uC7A5",
  "team_drive.toast_access_failed": "{n}\uAC74\uC744 \uC800\uC7A5\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC800\uC7A5\uD574 \uC8FC\uC138\uC694.",
  "team_drive.share_title": "\uACF5\uC720 \uB9C1\uD06C",
  "team_drive.share_create": "\uB9C1\uD06C \uB9CC\uB4E4\uAE30",
  "team_drive.share_copy": "\uBCF5\uC0AC",
  "team_drive.share_copied": "\uB9C1\uD06C\uB97C \uBCF5\uC0AC\uD588\uC5B4\uC694.",
  "team_drive.share_revoke": "\uD3D0\uAE30",
  "team_drive.share_none": "\uACF5\uC720 \uB9C1\uD06C\uAC00 \uC5C6\uC5B4\uC694.",
  "team_drive.share_no_expiry": "\uB9CC\uB8CC \uC5C6\uC74C",
  "team_drive.share_login_note": "\uB9C1\uD06C\uB294 \uC870\uC9C1\uC5D0 \uB85C\uADF8\uC778\uD55C \uC0AC\uC6A9\uC790\uB9CC \uC5F4 \uC218 \uC788\uC5B4\uC694.",
  "team_drive.share_invalid": "\uB9C1\uD06C\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uAC70\uB098 \uB9CC\uB8CC\uB410\uC5B4\uC694.",
  "team_drive.preview_unsupported": "\uBBF8\uB9AC\uBCF4\uAE30\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uB294 \uD615\uC2DD\uC774\uC5D0\uC694. \uB2E4\uC6B4\uB85C\uB4DC\uD574\uC11C \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  "team_drive.preview_open_tab": "\uC0C8 \uD0ED\uC5D0\uC11C \uC5F4\uAE30",
  "employee.employee": "\uC9C1\uC6D0",
  "employee.employee_list": "\uC9C1\uC6D0\uBA85\uBD80",
  "employee.add_employee": "\uC9C1\uC6D0 \uCD94\uAC00",
  "employee.input_btn": "\uC785\uB825",
  "employee.edit_employee": "\uC9C1\uC6D0 \uC815\uBCF4 \uC218\uC815",
  "employee.search_placeholder": "\uC774\uB984 / \uC774\uBA54\uC77C / \uC0AC\uBC88",
  "employee.all_status": "\uC804\uCCB4 \uC0C1\uD0DC",
  "employee.download_list": "\uC9C1\uC6D0\uBA85\uBD80 \uB2E4\uC6B4\uB85C\uB4DC",
  "employee.selected_count": "{n}\uBA85 \uC120\uD0DD",
  "employee.bulk_status_change": "\uC0C1\uD0DC \uC77C\uAD04\uBCC0\uACBD",
  "employee.bulk_role_change": "{@role} \uC77C\uAD04\uBCC0\uACBD",
  "employee.family_name": "\uC131",
  "employee.given_name": "\uC774\uB984",
  "employee.email": "\uC774\uBA54\uC77C",
  "employee.organization": "\uC18C\uC18D \uC870\uC9C1",
  "employee.phone": "\uC804\uD654\uBC88\uD638",
  "employee.employee_number": "\uC0AC\uBC88",
  "employee.hire_date": "\uC785\uC0AC\uC77C",
  "employee.birth_date": "\uC0DD\uB144\uC6D4\uC77C",
  "employee.auto_generated": "\uC790\uB3D9\uC0DD\uC131",
  "employee.basic_info": "\uAE30\uBCF8\uC815\uBCF4",
  "employee.hr_info": "\uC778\uC0AC\uC815\uBCF4",
  "employee.contract": "\uADFC\uB85C\uACC4\uC57D",
  "employee.my_info": "\uB0B4 \uC815\uBCF4",
  "employee.address": "\uC8FC\uC18C",
  "employee.street_address": "\uB3C4\uB85C\uBA85 \uC8FC\uC18C",
  "employee.city": "\uC2DC/\uAD70/\uAD6C",
  "employee.postal_code": "\uC6B0\uD3B8\uBC88\uD638",
  "employee.emergency_contact": "\uBE44\uC0C1\uC5F0\uB77D\uCC98",
  "employee.emergency_contact_help": "\uC785\uB825 \uC2DC \uC774\uB984\uACFC \uC804\uD654\uBC88\uD638\uB294 \uD544\uC218\uC785\uB2C8\uB2E4",
  "employee.relationship": "\uAD00\uACC4 (\uBC30\uC6B0\uC790, \uBD80\uBAA8 \uB4F1)",
  "employee.bank_account": "\uACC4\uC88C\uC815\uBCF4",
  "employee.bank_account_help": "\uC785\uB825 \uC2DC \uBAA8\uB4E0 \uD56D\uBAA9\uC740 \uD544\uC218\uC785\uB2C8\uB2E4",
  "employee.bank_name": "\uC740\uD589\uBA85",
  "employee.account_number": "\uACC4\uC88C\uBC88\uD638",
  "employee.account_holder": "\uC608\uAE08\uC8FC",
  "employee.my_info_load_error": "\uB0B4 \uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uB294 \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "employee.phone_invalid": "\uC804\uD654\uBC88\uD638\uB97C \uC62C\uBC14\uB974\uAC8C \uC785\uB825\uD574\uC8FC\uC138\uC694 (10~11\uC790\uB9AC)",
  "employee.postal_code_invalid": "\uC6B0\uD3B8\uBC88\uD638\uB294 \uC22B\uC790 5\uC790\uB9AC\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694 (\uBE44\uC6CC \uB450\uC5B4\uB3C4 \uB3FC\uC694)",
  "employee.emergency_name_required": "\uBE44\uC0C1\uC5F0\uB77D\uCC98 \uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "employee.emergency_phone_required": "\uBE44\uC0C1\uC5F0\uB77D\uCC98 \uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "employee.bank_name_required": "\uC740\uD589\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "employee.account_number_required": "\uACC4\uC88C\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "employee.account_holder_required": "\uC608\uAE08\uC8FC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "employee.info_saved": "\uC815\uBCF4\uAC00 \uC800\uC7A5\uB418\uC5C8\uC5B4\uC694",
  "employee.save_error": "\uC800\uC7A5 \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "employee.work_type_required": "\uBCC0\uACBD\uD560 \uADFC\uBB34 \uD615\uD0DC\uC640 \uC0AC\uC720\uB97C \uBAA8\uB450 \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "employee.work_type_requested": "\uADFC\uBB34 \uD615\uD0DC \uBCC0\uACBD\uC774 \uC2E0\uCCAD\uB418\uC5C8\uC5B4\uC694",
  "employee.request_error": "\uC2E0\uCCAD \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "employee.work_type_cancel_confirm": "\uADFC\uBB34 \uD615\uD0DC \uBCC0\uACBD \uC2E0\uCCAD\uC744 \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "employee.request_cancelled": "\uC2E0\uCCAD\uC774 \uCDE8\uC18C\uB418\uC5C8\uC5B4\uC694",
  "employee.cancel_error": "\uCDE8\uC18C \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "employee.image_size_limit": "\uC774\uBBF8\uC9C0 \uD06C\uAE30\uB294 10MB \uC774\uD558\uC5EC\uC57C \uD574\uC694",
  "employee.profile_picture_changed": "\uD504\uB85C\uD544 \uC0AC\uC9C4\uC774 \uBCC0\uACBD\uB418\uC5C8\uC5B4\uC694",
  "employee.profile_picture_error": "\uD504\uB85C\uD544 \uC0AC\uC9C4 \uC5C5\uB85C\uB4DC \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "team.team": "\uD300",
  "team.add_team": "\uD300 \uCD94\uAC00",
  "team.edit_team": "\uD300 \uC218\uC815",
  "team.team_code": "\uD300\uCF54\uB4DC",
  "team.team_name": "\uD300\uBA85",
  "team.leader": "\uD300\uC7A5",
  "team.member_count": "\uC778\uC6D0\uC218",
  "team.members": "\uD300 \uBA64\uBC84",
  "team.add_member": "\uD300 \uBA64\uBC84 \uCD94\uAC00",
  "team.select_employee": "\uC9C1\uC6D0\uC744 \uC120\uD0DD\uD558\uC138\uC694",
  "team.search_placeholder": "\uD300\uBA85, \uCF54\uB4DC \uAC80\uC0C9...",
  "team.code_immutable": "\uD300 \uCF54\uB4DC\uB294 \uC0DD\uC131 \uD6C4 \uBCC0\uACBD\uD560 \uC218 \uC5C6\uC5B4\uC694.",
  "team.name_placeholder": "\uD300\uBA85",
  "team.desc_placeholder": "\uC124\uBA85",
  "team.no_members": "\uD300\uC6D0\uC774 \uC5C6\uC5B4\uC694. \uD300\uC6D0\uC744 \uBA3C\uC800 \uCD94\uAC00\uD558\uC138\uC694.",
  "role.role": "{@role}",
  "role.add_role": "{@role} \uCD94\uAC00",
  "role.edit_role": "{@role} \uC218\uC815",
  "role.role_code": "{@role} \uCF54\uB4DC",
  "role.role_name": "{@role}\uBA85",
  "role.code_placeholder": "\uC608: ROLE_MANAGER",
  "role.name_placeholder": "{@role}",
  "role.desc_placeholder": "\uC124\uBA85",
  "role.form_name_placeholder": "\uC2E0\uADDC\uB85C \uCD94\uAC00\uD560 \uC5ED\uD560 \uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694",
  "role.form_desc_placeholder": "\uC5ED\uD560\uC5D0 \uB300\uD55C \uAC04\uB7B5\uD55C \uC124\uBA85 \uC785\uB825",
  "role.no_search_results": "\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC5B4\uC694",
  "role.delete_blocked": "\uD574\uB2F9 {@role|\uC744/\uB97C} \uAC00\uC9C4 \uC9C1\uC6D0\uC774 \uC788\uC5B4\uC11C \uC0AD\uC81C\uD560 \uC218 \uC5C6\uC5B4\uC694.",
  "role.admin_delete_blocked": "\uCD5C\uACE0 \uAD00\uB9AC\uC790\uB294 \uC0AD\uC81C\uD560 \uC218 \uC5C6\uC5B4\uC694.",
  "role.inactive_status": "\uBE44\uD65C\uC131 \uC0C1\uD0DC\uC608\uC694.",
  "role.code_immutable": "{@role} \uCF54\uB4DC\uB294 \uC0DD\uC131 \uD6C4 \uBCC0\uACBD\uD560 \uC218 \uC5C6\uC5B4\uC694.",
  "role.assigned_permissions": "\uD560\uB2F9\uB41C \uAD8C\uD55C",
  "role.no_permissions": "\uD560\uB2F9\uB41C \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694",
  "role.select_all": "\uBAA8\uB4E0 \uAD8C\uD55C \uCF1C\uAE30",
  "role.deselect_all": "\uC804\uCCB4 \uD574\uC81C",
  "role.no_data": "{@role} \uB370\uC774\uD130\uAC00 \uC5C6\uC5B4\uC694",
  "role.permissions_selected": "{n}\uAC1C \uAD8C\uD55C \uC120\uD0DD\uB428",
  "role.permission_management": "{@role}\uAD00\uB9AC",
  "leave.leave": "\uC5F0\uCC28/\uD734\uAC00",
  "leave.leave_status": "\uC5F0\uCC28\uD604\uD669",
  "leave.entitlement_rules": "\uBD80\uC5EC \uAE30\uC900",
  "leave.search_placeholder": "\uC774\uB984, \uC0AC\uBC88 \uAC80\uC0C9...",
  "leave.target_count": "\uB300\uC0C1 \uC778\uC6D0",
  "leave.avg_used": "\uD3C9\uADE0 \uC0AC\uC6A9",
  "leave.avg_remaining": "\uD3C9\uADE0 \uC794\uC5EC",
  "leave.total_granted": "\uCD1D \uBD80\uC5EC",
  "leave.used": "\uC0AC\uC6A9",
  "leave.remaining": "\uC794\uC5EC",
  "leave.days_remaining": "{n}\uC77C \uB0A8\uC74C",
  "leave.leave_of_absence_confirm": "\uD734\uC9C1 \uCC98\uB9AC \uD655\uC778",
  "leave.leave_reason": "\uD734\uC9C1 \uC0AC\uC720",
  "leave.select_reason": "\uC0AC\uC720\uB97C \uC120\uD0DD\uD558\uC138\uC694",
  "leave.childcare": "\uC721\uC544\uD734\uC9C1",
  "leave.medical": "\uBCD1\uAC00 (\uC9C8\uBCD1/\uBD80\uC0C1)",
  "leave.family": "\uAC00\uC0AC\uD734\uC9C1",
  "leave.family_care": "\uAC00\uC871\uB3CC\uBD04\uD734\uC9C1",
  "leave.education": "\uD559\uC5C5\uD734\uC9C1",
  "leave.military": "\uBCD1\uC5ED\uD734\uC9C1",
  "leave.personal": "\uAC1C\uC778 \uC0AC\uC720",
  "leave.other": "\uAE30\uD0C0",
  "leave.other_reason": "\uAE30\uD0C0 \uC0AC\uC720",
  "leave.termination_confirm": "\uD1F4\uC9C1 \uCC98\uB9AC \uD655\uC778",
  "leave.termination_reason": "\uD1F4\uC9C1\uC0AC\uC720",
  "payroll.payroll": "\uAE09\uC5EC",
  "payroll.allowance_config": "\uC218\uB2F9/\uC778\uC13C\uD2F0\uBE0C \uC124\uC815",
  "payroll.base_allowance": "\uAE30\uBCF8\uC218\uB2F9",
  "payroll.base_allowance_desc": "\uADFC\uB85C\uACC4\uC57D \uAE30\uBC18 \uAE30\uBCF8 \uC218\uB2F9",
  "payroll.manual_entry": "\uC218\uB3D9\uC785\uB825",
  "payroll.manual_entry_desc": "HR \uB2F4\uB2F9\uC790\uAC00 \uC9C1\uC811 \uB4F1\uB85D\uD558\uB294 \uC218\uB2F9 (\uD2B9\uBCC4\uC218\uB2F9, \uAE30\uD0C0\uC218\uB2F9 \uB4F1)",
  "payroll.overtime_allowance": "\uCD08\uACFC\uADFC\uBB34\uC218\uB2F9",
  "payroll.overtime_allowance_desc": "\uC2DC\uAE09 \xD7 \uBC30\uC218\uB85C \uC790\uB3D9 \uACC4\uC0B0",
  "payroll.fixed_incentive": "\uACE0\uC815 \uC778\uC13C\uD2F0\uBE0C",
  "payroll.fixed_incentive_desc": "\uACE0\uC815 \uB2E8\uAC00, \uC9C1\uC6D0 \uC9C1\uC811 \uC2E0\uCCAD + \uC2B9\uC778",
  "payroll.linked_module": "\uC5F0\uACB0\uBAA8\uB4C8",
  "payroll.calc_value": "\uACC4\uC0B0 \uAC12",
  "payroll.item_code": "\uD56D\uBAA9\uCF54\uB4DC",
  "payroll.item_code_edit": "\uD56D\uBAA9\uCF54\uB4DC \uC218\uC815",
  "payroll.item_code_add": "\uD56D\uBAA9\uCF54\uB4DC \uCD94\uAC00",
  "payroll.allowance": "\uC218\uB2F9",
  "payroll.deduction": "\uACF5\uC81C",
  "payroll.effective_period": "\uC801\uC6A9\uAE30\uAC04",
  "payroll.no_base_allowance": "\uB4F1\uB85D\uB41C \uAE30\uBCF8\uC218\uB2F9\uC774 \uC5C6\uC5B4\uC694.",
  "payroll.no_manual_entry": "\uB4F1\uB85D\uB41C \uC218\uB3D9\uC785\uB825 \uC218\uB2F9\uC774 \uC5C6\uC5B4\uC694.",
  "payroll.no_overtime_allowance": "\uB4F1\uB85D\uB41C \uCD08\uACFC\uADFC\uBB34\uC218\uB2F9\uC774 \uC5C6\uC5B4\uC694.",
  "payroll.add_category": "\uCE74\uD14C\uACE0\uB9AC \uCD94\uAC00",
  "payroll.add_preset": "\uD504\uB9AC\uC14B \uCD94\uAC00",
  "payroll.uncategorized": "\uBBF8\uBD84\uB958",
  "payroll.request_amount": "\uC2E0\uCCAD\uAE08\uC561",
  "payroll.all_departments": "\uC804\uCCB4 \uC0AC\uC6A9",
  "payroll.load_error": "\uAE09\uC5EC\uBA85\uC138\uC11C\uB97C \uBD88\uB7EC\uC624\uB294 \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "payroll.no_permission": "\uAE09\uC5EC\uBA85\uC138\uC11C\uB97C \uBCFC \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694. \uAD00\uB9AC\uC790\uC5D0\uAC8C \uAD8C\uD55C\uC744 \uC694\uCCAD\uD574 \uC8FC\uC138\uC694.",
  "payroll.status_draft": "\uC791\uC131 \uC911",
  "payroll.status_calculated": "\uACC4\uC0B0\uB428",
  "payroll.status_approved": "\uC2B9\uC778",
  "payroll.status_paid": "\uC9C0\uAE09\uC644\uB8CC",
  "payroll.status_cancelled": "\uCDE8\uC18C",
  "payroll.status_corrected": "\uC815\uC815",
  "overtime.overtime_request": "\uC5F0\uC7A5\uADFC\uBB34 \uC2E0\uCCAD",
  "overtime.work_date": "\uADFC\uBB34\uC77C",
  "overtime.start_time": "\uC2DC\uC791 \uC2DC\uAC04",
  "overtime.end_time": "\uC885\uB8CC \uC2DC\uAC04",
  "overtime.duration": "\uC5F0\uC7A5 \uC2DC\uAC04",
  "overtime.category": "\uAD6C\uBD84",
  "overtime.weekday": "\uD3C9\uC77C \uC5F0\uC7A5",
  "overtime.saturday": "\uD1A0\uC694 \uADFC\uBB34",
  "overtime.holiday": "\uD734\uC77C \uADFC\uBB34",
  "overtime.night": "\uC57C\uAC04 \uADFC\uBB34",
  "overtime.reason": "\uC0AC\uC720",
  "overtime.reason_placeholder": "\uC5F0\uC7A5\uADFC\uBB34 \uC0AC\uC720\uB97C \uC785\uB825\uD558\uC138\uC694",
  "incentive.no_records": "\uC774\uBC88 \uB2EC \uB4F1\uB85D\uB41C \uC778\uC13C\uD2F0\uBE0C\uAC00 \uC5C6\uC5B4\uC694",
  "incentive.weekend": "\uC8FC\uB9D0",
  "incentive.incentive_register": "\uC778\uC13C\uD2F0\uBE0C \uB4F1\uB85D",
  "incentive.work_date": "\uADFC\uBB34\uC77C",
  "incentive.today_only": "\uB2F9\uC77C \uC778\uC13C\uD2F0\uBE0C\uB9CC \uB4F1\uB85D \uAC00\uB2A5\uD574\uC694",
  "incentive.count": "\uAC74\uC218",
  "incentive.memo": "\uBA54\uBAA8",
  "incentive.memo_placeholder": "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694",
  "incentive.registering": "\uB4F1\uB85D \uC911...",
  "incentive.register": "\uB4F1\uB85D\uD558\uAE30",
  "incentive.monthly_title": "{month}\uC6D4 \uC778\uC13C\uD2F0\uBE0C",
  "incentive.registered_count": "{n}\uAC74 \uB4F1\uB85D",
  "incentive.monthly_history": "\uC774\uBC88 \uB2EC \uB4F1\uB85D \uB0B4\uC5ED",
  "settings.basic_info": "\uAE30\uBCF8\uC815\uBCF4",
  "settings.work_hours": "\uADFC\uBB34\uC2DC\uAC04",
  "grades.grade_suffix": "\uD638\uBD09",
  "settings.salary_grade": "\uD638\uBD09\uD45C",
  "settings.allowance_deduction": "\uC218\uB2F9/\uACF5\uC81C",
  "settings.calculation_rules": "\uACC4\uC0B0\uADDC\uCE59",
  "settings.certifications": "\uC790\uACA9\uC99D/\uBA74\uD5C8",
  "settings.doc_templates": "\uC99D\uBA85\uC11C \uC591\uC2DD",
  "settings.doc_history": "\uC99D\uBA85\uC11C \uBC1C\uAE09\uB0B4\uC5ED",
  "settings.org_loading": "\uC870\uC9C1 \uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uB294 \uC911...",
  "settings.org_settings": "\uC870\uC9C1 \uC124\uC815",
  "settings.org_basic_info": "\uAE30\uBCF8 \uC815\uBCF4",
  "settings.hospital_name": "\uC0C1\uD638",
  "settings.corp_name": "\uBC95\uC778\uBA85",
  "settings.org_code": "\uAE30\uAD00\uCF54\uB4DC",
  "settings.business_number": "\uC0AC\uC5C5\uC790\uBC88\uD638",
  "settings.main_phone": "\uB300\uD45C\uC804\uD654",
  "settings.fax": "\uD329\uC2A4",
  "settings.website": "\uC6F9\uC0AC\uC774\uD2B8",
  "cert.cert_edit": "\uC790\uACA9\uC99D/\uBA74\uD5C8 \uC218\uC815",
  "cert.cert_register": "\uC790\uACA9\uC99D/\uBA74\uD5C8 \uB4F1\uB85D",
  "cert.cert_type": "\uC790\uACA9\uC720\uD615",
  "cert.doc_template_edit": "\uC99D\uBA85\uC11C \uC591\uC2DD \uC218\uC815",
  "cert.doc_template_add": "\uC99D\uBA85\uC11C \uC591\uC2DD \uCD94\uAC00",
  "cert.select_template": "\uAE30\uBCF8 \uC591\uC2DD \uC120\uD0DD",
  "cert.template_code": "\uC591\uC2DD \uCF54\uB4DC",
  "cert.template_name": "\uC591\uC2DD\uBA85",
  "cert.preview": "\uC99D\uBA85\uC11C \uBBF8\uB9AC\uBCF4\uAE30",
  "cert.pending_approval": "\uC2B9\uC778 \uB300\uAE30",
  "cert.approved": "\uC2B9\uC778\uC644\uB8CC",
  "cert.rejected": "\uBC18\uB824",
  "cert.request_error": "\uC7AC\uC9C1\uC99D\uBA85\uC11C \uC2E0\uCCAD \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "nurse.work_type_three_shift": "3\uAD50\uB300",
  "nurse.work_type_night_dedicated": "\uC57C\uAC04\uC804\uB2F4",
  "nurse.work_type_day_dedicated": "\uB370\uC774\uC804\uB2F4",
  "nurse.work_type_evening_dedicated": "\uC774\uBE0C\uB2DD\uC804\uB2F4",
  "grade.grade_edit": "\uD638\uBD09 \uC218\uC815",
  "grade.grade_add": "\uD638\uBD09 \uCD94\uAC00",
  "grade.job_category": "\uC9C1\uC885",
  "grade.rehabilitation": "\uC7AC\uD65C",
  "grade.functional": "\uAE30\uB2A5",
  "shift.shift_edit": "\uADFC\uBB34 \uC2DC\uAC04 \uC218\uC815",
  "shift.shift_add": "\uADFC\uBB34 \uC2DC\uAC04 \uCD94\uAC00",
  "shift.regular": "\uC77C\uBC18\uADFC\uBB34",
  "attendance.attendance_management": "\uADFC\uD0DC \uAD00\uB9AC",
  "attendance.this_week": "\uC774\uBC88 \uC8FC",
  "attendance.last_week": "\uC9C0\uB09C 1\uC8FC",
  "attendance.this_month": "\uC774\uBC88 \uB2EC",
  "messenger.invite_do": "\uCD08\uB300\uD558\uAE30",
  "messenger.loading_more": "\uBD88\uB7EC\uC624\uB294 \uC911...",
  "approval.request_history": "\uC2E0\uCCAD \uB0B4\uC5ED",
  "approval.no_leave_requests": "\uD734\uAC00 \uC2E0\uCCAD \uB0B4\uC5ED\uC774 \uC5C6\uC5B4\uC694",
  "approval.no_overtime_requests": "\uC5F0\uC7A5\uADFC\uBB34 \uC2E0\uCCAD \uB0B4\uC5ED\uC774 \uC5C6\uC5B4\uC694",
  "approval.no_documents": "\uC81C\uCD9C\uB41C \uC11C\uB958\uAC00 \uC5C6\uC5B4\uC694",
  "approval.approver": "\uC2B9\uC778\uC790:",
  "approval.cancel": "\uCDE8\uC18C",
  "messenger.connecting": "\uC5F0\uACB0 \uC911...",
  "messenger.disconnected": "\uC5F0\uACB0 \uB04A\uAE40 \u2014 \uC7AC\uC2DC\uB3C4 \uC911",
  "messenger.conversations": "\uB300\uD654",
  "messenger.contacts": "\uC5F0\uB77D\uCC98",
  "messenger.conv_search_placeholder": "\uB300\uD654 \uAC80\uC0C9...",
  "messenger.notice": "\uACF5\uC9C0",
  "messenger.new_notices": "\uC0C8\uB85C\uC6B4 \uACF5\uC9C0",
  "messenger.channels": "\uCC44\uB110",
  "messenger.messages": "\uBA54\uC2DC\uC9C0",
  "messenger.no_conversations": "\uC544\uC9C1 \uB300\uD654\uAC00 \uC5C6\uC5B4\uC694",
  "messenger.start_conversation": "\uC5F0\uB77D\uCC98\uC5D0\uC11C \uB300\uD654\uB97C \uC2DC\uC791\uD574\uBCF4\uC138\uC694",
  "messenger.msg_search_placeholder": "\uB300\uD654 \uB0B4\uC6A9 \uAC80\uC0C9",
  "messenger.no_search_results": "\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC5B4\uC694",
  "messenger.load_older": "\uC774\uC804 \uBA54\uC2DC\uC9C0 \uBD88\uB7EC\uC624\uAE30",
  "messenger.new_messages_below": "\uC0C8 \uBA54\uC2DC\uC9C0 {count}\uAC1C",
  "messenger.new_messages_jump": "\uC0C8 \uBA54\uC2DC\uC9C0 {count}\uAC1C, \uB9E8 \uC544\uB798\uB85C \uC774\uB3D9",
  "messenger.msg_input_placeholder": "\uBA54\uC2DC\uC9C0\uB97C \uC785\uB825\uD558\uC138\uC694...",
  "messenger.sending": "\uC804\uC1A1 \uC911...",
  "messenger.resend": "\uC7AC\uC804\uC1A1",
  "messenger.read": "\uC77D\uC74C",
  "messenger.read_status": "\uC77D\uC74C \uC0C1\uD0DC",
  "messenger.read_by": "\uC77D\uC740 \uC0AC\uB78C",
  "messenger.unread_by": "\uC548 \uC77D\uC740 \uC0AC\uB78C",
  "messenger.group_chat": "\uADF8\uB8F9 \uB300\uD654",
  "messenger.group_create": "\uADF8\uB8F9 \uB9CC\uB4E4\uAE30",
  "messenger.creating": "\uC0DD\uC131 \uC911...",
  "messenger.group_title_placeholder": "\uADF8\uB8F9 \uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694",
  "messenger.contact_search_placeholder": "\uC774\uB984 \uB610\uB294 {@role|\uC73C\uB85C/\uB85C} \uAC80\uC0C9...",
  "messenger.contact_search_mode": "\uAC80\uC0C9",
  "messenger.contact_search_by_name": "\uC774\uB984",
  "messenger.contact_search_by_team": "\uBD80\uC11C(\uD300)",
  "messenger.contact_team_filter_clear": "\uBD80\uC11C \uAC70\uB974\uAE30 \uD574\uC81C",
  "messenger.expand_all": "\uC804\uCCB4 \uC5F4\uAE30",
  "messenger.collapse_all": "\uC804\uCCB4 \uB2EB\uAE30",
  "messenger.notices_more": "\uB354\uBCF4\uAE30",
  "messenger.notices_less": "\uB354\uBCF4\uAE30 \uB2EB\uAE30",
  "messenger.notices_more_unacknowledged": "\uD655\uC778\uD558\uC9C0 \uC54A\uC740 {n}\uAC1C\uC758 \uACF5\uC9C0\uAC00 \uC788\uC2B5\uB2C8\uB2E4.",
  "messenger.team_message": "\uB2E8\uCCB4 \uCC44\uD305",
  "messenger.chat_settings": "\uB300\uD654 \uC124\uC815",
  "messenger.room_name_label": "\uB300\uD654\uBC29 \uC774\uB984 (\uB098\uC5D0\uAC8C\uB9CC \uBCF4\uC784)",
  "messenger.room_name_placeholder": "\uB300\uD654\uBC29 \uC774\uB984",
  "messenger.member_invite": "\uBA64\uBC84 \uCD08\uB300",
  "messenger.invite_btn": "+ \uCD08\uB300",
  "messenger.owner": "\uBC29\uC7A5",
  "messenger.kick_member": "\uB0B4\uBCF4\uB0B4\uAE30",
  "messenger.leave_room": "\uB300\uD654\uBC29 \uB098\uAC00\uAE30",
  "messenger.invite_search_placeholder": "\uC774\uB984\uC73C\uB85C \uAC80\uC0C9...",
  "messenger.inviting": "\uCD08\uB300 \uC911...",
  "messenger.later": "\uB098\uC911\uC5D0",
  "messenger.fold": "\uC811\uAE30",
  "messenger.view_all": "\uC804\uCCB4\uBCF4\uAE30",
  "messenger.search_results_count": "\uAC74\uC758 \uACB0\uACFC",
  "messenger.search_jump_not_found": "\uBA54\uC2DC\uC9C0\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC5B4\uC694",
  "messenger.members_count": "\uBA64\uBC84",
  "messenger.acknowledged": "\uD655\uC778\uD588\uC5B4\uC694",
  "messenger.notice_no_ack_required": "\uD655\uC778\uC774 \uD544\uC694 \uC5C6\uB294 \uC815\uBCF4 \uAC8C\uC2DC\uAE00\uC774\uC5D0\uC694",
  "messenger.acknowledged_done": "\uD655\uC778 \uC644\uB8CC",
  "messenger.notice_detail": "\uACF5\uC9C0\uC0AC\uD56D",
  "messenger.team_group_message": "\uD300 \uB2E8\uCCB4 \uBA54\uC2DC\uC9C0",
  "messenger.selected_count": "\uBA85 \uC120\uD0DD",
  "messenger.select_all": "\uC804\uCCB4 \uC120\uD0DD",
  "notification.settings": "\uC54C\uB9BC \uC124\uC815",
  "notification.push_title": "\uC571 \uD478\uC2DC \uC54C\uB9BC",
  "notification.push_desc": "\uADFC\uBB34 \uBCC0\uACBD, \uC2B9\uC778 \uACB0\uACFC \uB4F1\uC744 \uD478\uC2DC\uB85C \uBC1B\uC2B5\uB2C8\uB2E4",
  "notification.mark_all_read": "\uBAA8\uB450 \uC77D\uC74C",
  "notification.no_notifications": "\uC54C\uB9BC\uC774 \uC5C6\uC5B4\uC694",
  "notification.no_action_items": "\uCC98\uB9AC\uD560 \uD56D\uBAA9\uC774 \uC5C6\uC5B4\uC694",
  "notification.mute_actor": "\uC774 \uC0AC\uB78C \uC54C\uB9BC \uB044\uAE30",
  "notification.push_notifications": "\uD478\uC2DC \uC54C\uB9BC",
  "notification.all_types": "\uC804\uCCB4 \uC54C\uB9BC \uBC1B\uAE30",
  "notification.all_types_desc": "\uB044\uBA74 \uBAA8\uB4E0 \uC720\uD615\uC758 \uC54C\uB9BC\uC774 \uC77C\uC2DC\uC911\uC9C0\uB3FC\uC694.",
  "notification.muted_people": "\uC74C\uC18C\uAC70\uB41C \uC0AC\uC6A9\uC790",
  "notification.unmute": "\uD574\uC81C",
  "notification.mute_confirm": "\uB2D8\uC758 \uC54C\uB9BC\uC744 \uBAA8\uB450 \uB044\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "notification.org_not_found": "\uC870\uC9C1 \uC815\uBCF4\uB97C \uBD88\uB7EC\uC62C \uC218 \uC5C6\uC5B4\uC694. \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574\uC8FC\uC138\uC694.",
  "notification.muted_success": "\uB2D8\uC758 \uC54C\uB9BC\uC774 \uCC28\uB2E8\uB418\uC5C8\uC5B4\uC694",
  "notification.mute_error": "\uC54C\uB9BC \uCC28\uB2E8 \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "notification.settings_error": "\uC54C\uB9BC \uC124\uC815 \uBCC0\uACBD \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "notification.time_just_now": "\uBC29\uAE08 \uC804",
  "notification.time_minutes_ago": "\uBD84 \uC804",
  "notification.time_hours_ago": "\uC2DC\uAC04 \uC804",
  "notification.time_days_ago": "\uC77C \uC804",
  "notification.event_leave_request": "\uD734\uAC00 \uC2E0\uCCAD",
  "notification.event_overtime": "\uCD08\uACFC\uADFC\uBB34",
  "notification.event_offsite_work": "\uC678\uADFC",
  "notification.event_incentive": "\uC778\uC13C\uD2F0\uBE0C",
  "notification.event_allowance": "\uC218\uB2F9",
  "notification.event_deduction": "\uACF5\uC81C",
  "notification.event_document": "\uBB38\uC11C",
  "notification.event_education": "\uAD50\uC721\uBE44",
  "notification.event_general": "\uC77C\uBC18",
  "notification.event_system": "\uC2DC\uC2A4\uD15C",
  "update.new_version_ready": "\uC0C8 \uBC84\uC804\uC774 \uC900\uBE44\uB418\uC5C8\uC5B4\uC694",
  "update.version": "\uBC84\uC804",
  "update.restart_prompt": "\uC571\uC744 \uC7AC\uC2DC\uC791\uD558\uC5EC \uC801\uC6A9\uD558\uC138\uC694",
  "update.later": "\uB098\uC911\uC5D0",
  "update.restart": "\uC7AC\uC2DC\uC791",
  "update.applying": "\uC5C5\uB370\uC774\uD2B8\uB97C \uC801\uC6A9\uD558\uACE0 \uC788\uC5B4\uC694",
  "update.apply_failed": "\uC5C5\uB370\uC774\uD2B8\uB97C \uC801\uC6A9\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "update.retry": "\uB2E4\uC2DC \uC2DC\uB3C4",
  "update.required_title": "\uC571 \uC5C5\uB370\uC774\uD2B8\uAC00 \uD544\uC694\uD574\uC694",
  "update.required_description": "\uD604\uC7AC \uBC84\uC804\uC740 \uB354 \uC774\uC0C1 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC544\uC694. \uCD5C\uC2E0 \uBC84\uC804\uC744 \uC124\uCE58\uD55C \uB4A4 \uB2E4\uC2DC \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  "update.update_now": "\uC5C5\uB370\uC774\uD2B8\uD558\uB7EC \uAC00\uAE30",
  "update.check_again": "\uB2E4\uC2DC \uD655\uC778",
  "update.checking": "\uBC84\uC804\uC744 \uD655\uC778\uD558\uACE0 \uC788\uC5B4\uC694",
  "update.check_failed": "\uC9C0\uC6D0 \uBC84\uC804\uC744 \uD655\uC778\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694. \uB124\uD2B8\uC6CC\uD06C \uC5F0\uACB0\uC744 \uD655\uC778\uD558\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "update.optional_title": "\uC0C8 \uBC84\uC804\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694",
  "update.optional_description": "\uACC4\uC18D \uC0AC\uC6A9\uD558\uBA74\uC11C \uB098\uC911\uC5D0 \uC5C5\uB370\uC774\uD2B8\uD574\uB3C4 \uB3FC\uC694.",
  "admin.hospital_settings": "Workspace \uC124\uC815",
  "admin.admin_only_message": "\uC774 \uAD00\uB9AC\uC790 \uD654\uBA74\uC740 \uC2DC\uC2A4\uD15C \uAD00\uB9AC\uC790 \uACC4\uC815\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694.",
  "status.active_employee": "\uC7AC\uC9C1",
  "status.on_leave": "\uD734\uC9C1",
  "status.terminated": "\uD1F4\uC9C1",
  "employee.total_employees": "\uC804\uCCB4 \uC9C1\uC6D0",
  "employee.no_team": "\uD300 \uBC30\uC815",
  "employee.no_team_hint": "\uD300\uC774 \uC5C6\uC5B4\uC694",
  "employee.no_role_hint": "{@role|\uC774/\uAC00} \uC5C6\uC5B4\uC694",
  "employee.team_required": "\uD300 \uBC30\uC815 \uD544\uC694",
  "employee.no_data": "\uC9C1\uC6D0 \uB370\uC774\uD130\uAC00 \uC5C6\uC5B4\uC694",
  "employee.registration_complete": "\uC9C1\uC6D0 \uB4F1\uB85D\uC774 \uC644\uB8CC\uB418\uC5C8\uC5B4\uC694",
  "employee.temp_password_issued": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638\uAC00 \uBC1C\uAE09\uB418\uC5C8\uC5B4\uC694",
  "employee.password_label": "\uBE44\uBC00\uBC88\uD638",
  "employee.copy": "\uBCF5\uC0AC",
  "employee.copied": "\uBCF5\uC0AC\uB428!",
  "employee.temp_password_notice": "\uC9C1\uC6D0\uC5D0\uAC8C \uC774 \uBE44\uBC00\uBC88\uD638\uB97C \uC804\uB2EC\uD574 \uC8FC\uC138\uC694. \uCD5C\uCD08 \uB85C\uADF8\uC778 \uC2DC \uBCC0\uACBD\uB3FC\uC694.",
  "employee.send_password_sms": "SMS\uB85C \uBE44\uBC00\uBC88\uD638 \uBC1C\uC1A1",
  "employee.no_team_warning": "\uD300\uC744 \uBC30\uC815\uD558\uC9C0 \uC54A\uC73C\uBA74 {@role|\uC744/\uB97C} \uD560\uB2F9\uD560 \uC218 \uC5C6\uC5B4\uC694. {@role} \uBBF8\uC9C0\uC815\uC73C\uB85C \uB4F1\uB85D\uB41C \uC9C1\uC6D0\uC740 \uAD8C\uD55C\uC774 \uC5C6\uC73C\uBBC0\uB85C, \uB4F1\uB85D \uD6C4 \uD300 \uAD00\uB9AC\uC5D0\uC11C {@role|\uC744/\uB97C} \uC9C0\uC815\uD574 \uC8FC\uC138\uC694.",
  "employee.select_role_after_team": "\uD300 \uBC30\uC815 \uD6C4 \uC120\uD0DD \uAC00\uB2A5",
  "employee.select_role": "{@role} \uC120\uD0DD",
  "employee.select_dept": "\uBD80\uC11C\uB97C \uC120\uD0DD\uD558\uC138\uC694",
  "employee.system_admin": "\uC2DC\uC2A4\uD15C \uAD00\uB9AC\uC790",
  "employee.system_admin_desc": "\uBAA8\uB4E0 \uAD8C\uD55C\uC744 \uC6B0\uD68C\uD558\uB294 \uCD5C\uACE0 \uAD00\uB9AC\uC790 \uAD8C\uD55C\uC785\uB2C8\uB2E4",
  "employee.phone_otp_login": "\uD734\uB300\uD3F0 \uC778\uC99D \uB85C\uADF8\uC778 \uD5C8\uC6A9",
  "employee.phone_otp_login_desc": "\uC9C1\uC6D0\uC774 SMS \uC778\uC99D\uBC88\uD638\uB85C \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uB3C4\uB85D \uD5C8\uC6A9\uD574\uC694",
  "employee.password_change": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD",
  "employee.temp_password_sms": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638 (SMS)",
  "employee.manual_password": "\uC9C1\uC811 \uC124\uC815",
  "employee.temp_password_sms_desc": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638\uB97C \uC0DD\uC131\uD558\uC5EC \uC9C1\uC6D0\uC5D0\uAC8C SMS\uB85C \uBC1C\uC1A1\uD574\uC694.",
  "employee.temp_password_sms_btn": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638 \uC0DD\uC131 \uBC0F SMS \uBC1C\uC1A1",
  "employee.new_password_placeholder": "\uC0C8 \uBE44\uBC00\uBC88\uD638 ({min}\uC790 \uC774\uC0C1)",
  "employee.confirm_password_placeholder": "\uBE44\uBC00\uBC88\uD638 \uD655\uC778",
  "employee.change_password_btn": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD",
  "employee.team_role_assignment": "\uD300\uBCC4 {@role} \uBC30\uC815",
  "employee.add_team": "\uD300 \uCD94\uAC00",
  "employee.no_role": "{@role} \uBBF8\uC9C0\uC815",
  "employee.no_team_membership": "\uC18C\uC18D\uB41C \uD300\uC774 \uC5C6\uC5B4\uC694.",
  "employee.select_team": "\uD300 \uC120\uD0DD",
  "employee.search_team_placeholder": "\uD300 \uAC80\uC0C9",
  "employee.leave_history": "\uD734\uC9C1/\uD1F4\uC9C1 \uC774\uB825",
  "employee.on_leave_label": "\uD734\uC9C1 \uC911",
  "employee.returned_label": "\uBCF5\uC9C1",
  "employee.leave_cancelled_label": "\uD734\uC9C1 \uCDE8\uC18C",
  "employee.terminated_label": "\uD1F4\uC9C1",
  "employee.termination_leave_balance": "\uC785\uC0AC\uC77C \uAE30\uC900 \uC794\uC5EC \uC5F0\uCC28",
  "employee.termination_leave_balance_hint": "\uD1F4\uC0AC \uC815\uC0B0 \uAE30\uC900\uAC12\uC774\uC5D0\uC694.",
  "employee.termination_leave_balance_reference": "\uC870\uC9C1\uC740 \uD68C\uACC4\uB144\uB3C4 \uAE30\uC900\uC774\uB77C \uC785\uC0AC\uC77C \uAE30\uC900\uC73C\uB85C \uD658\uC0B0\uD55C \uCC38\uACE0\uAC12\uC774\uC5D0\uC694.",
  "resignation.status_pending": "\uB300\uAE30",
  "resignation.status_processing": "\uCC98\uB9AC \uC911",
  "resignation.status_settled": "\uC815\uC0B0 \uC644\uB8CC",
  "resignation.status_completed": "\uC644\uB8CC",
  "employee.attendance_method": "\uCD9C\uADFC \uAE30\uB85D \uBC29\uC2DD",
  "employee.attendance_method_desc": "\uC870\uC9C1 \uAE30\uBCF8\uAC12\uC744 \uB530\uB974\uAC70\uB098, \uC774 \uC9C1\uC6D0\uB9CC \uB2E4\uB978 \uBC29\uC2DD\uC73C\uB85C \uC124\uC815\uD560 \uC218 \uC788\uC5B4\uC694.",
  "employee.attendance_org_default": "\uC870\uC9C1 \uAE30\uBCF8\uAC12 \uC0AC\uC6A9",
  "employee.work_group": "\uADFC\uBB34 \uADF8\uB8F9",
  "employee.work_group_unassigned": "\uADF8\uB8F9 \uBBF8\uC9C0\uC815",
  "employee.default_shift_empty": "\uADFC\uBB34\uAC00 \uBE44\uC5B4 \uC788\uC5B4\uC694. \uADFC\uD0DC\uB294 \uC9C1\uBB34 \uAE30\uBCF8 \uADFC\uBB34 \u300C{name}\u300D\uC73C\uB85C \uD310\uC815\uB3FC\uC694.",
  "employee.default_shift_differs": "\uC9C1\uBB34 \uAE30\uBCF8 \uADFC\uBB34 \u300C{name}\u300D \u2260 \uAC1C\uBCC4 \uC9C0\uC815 \u300C{current}\u300D",
  "employee.apply_default_shift": "\uC9C1\uBB34 \uAE30\uBCF8\uC73C\uB85C \uB9DE\uCD94\uAE30",
  "employee.work_group_from_job_duty": "\uC9C1\uBB34 \u300C{name}\u300D\uC758 \uAE30\uBCF8 \uADFC\uBB34\uAC00 \uC120\uD0DD\uB410\uC5B4\uC694. \uB2E4\uB974\uBA74 \uBC14\uAFD4 \uC8FC\uC138\uC694.",
  "employee.job_duty_select_placeholder": "\uC9C1\uBB34\uB97C \uC120\uD0DD\uD558\uC138\uC694",
  "employee.job_duty_none_registered": "\uB4F1\uB85D\uB41C \uC9C1\uBB34\uAC00 \uC5C6\uC5B4\uC694. \uC124\uC815 \u203A \uADFC\uBB34 \uC124\uC815 \u203A \uC9C1\uBB34\uC5D0\uC11C \uBA3C\uC800 \uB4F1\uB85D\uD574 \uC8FC\uC138\uC694.",
  "employee.work_pattern": "\uADFC\uB85C\uD615\uD0DC",
  "employee.work_pattern_select_placeholder": "\uADFC\uB85C\uD615\uD0DC\uB97C \uC120\uD0DD\uD558\uC138\uC694 (\uC120\uD0DD)",
  "employee.work_pattern_none_registered": "\uB4F1\uB85D\uB41C \uADFC\uB85C\uD615\uD0DC\uAC00 \uC5C6\uC5B4\uC694. \uC124\uC815 \u203A \uADFC\uB85C\uD615\uD0DC\uC5D0\uC11C \uB4F1\uB85D\uD558\uBA74 \uC6D4 \uADFC\uB85C\uC2DC\uAC04\xB7\uD1B5\uC0C1\uC2DC\uAE09\uC774 \uC790\uB3D9\uC73C\uB85C \uCC44\uC6CC\uC838\uC694.",
  "employee.work_pattern_from_job_duty": "\uC9C1\uBB34 \u300C{name}\u300D\uC758 \uAE30\uBCF8 \uADFC\uB85C\uD615\uD0DC\uAC00 \uC120\uD0DD\uB410\uC5B4\uC694. \uB2E4\uB974\uBA74 \uBC14\uAFD4 \uC8FC\uC138\uC694.",
  "employee.work_pattern_derived_hint": "\uADFC\uB85C\uD615\uD0DC\uB97C \uC9C0\uC815\uD558\uBA74 \uC6D4 \uADFC\uB85C\uC2DC\uAC04\xB7\uC5F0\uC7A5\xB7\uC57C\uAC04\xB7\uD3EC\uAD04\uC2DC\uAC04\xB7\uD1B5\uC0C1\uC2DC\uAE09\uC774 \uADFC\uB85C\uD615\uD0DC \uAE30\uC900\uC73C\uB85C \uCC44\uC6CC\uC838\uC694. \uC9C1\uC811 \uACE0\uCE5C \uAC12\uC740 \uC218\uB3D9\uC73C\uB85C \uB0A8\uC544\uC694.",
  "employee.work_group_from_team": "\uC18C\uC18D \uD300\uC758 \uB300\uD45C \uADFC\uBB34\uAC00 \uC120\uD0DD\uB410\uC5B4\uC694. \uB2E4\uB974\uBA74 \uBC14\uAFD4 \uC8FC\uC138\uC694.",
  "employee.work_group_needs_team": "\uC18C\uC18D\uC744 \uBA3C\uC800 \uCD94\uAC00\uD574 \uC8FC\uC138\uC694. \uC18C\uC18D \uD300\uC758 \uADFC\uBB34 \uADF8\uB8F9\uC774 \uC790\uB3D9\uC73C\uB85C \uB4E4\uC5B4\uAC00\uC694.",
  "employee.primary_shift": "\uC8FC \uC18C\uC18D",
  "employee.set_primary_shift": "\uC8FC \uC18C\uC18D\uC73C\uB85C \uC9C0\uC815",
  "employee.primary_shift_notice": "\uCD9C\uD1F4\uADFC \uAE30\uC900 \uC2DC\uAC01\uACFC \uC5F0\uCC28\uB294 \uC8FC \uC18C\uC18D\uC758 \uADFC\uBB34\uB97C \uB530\uB77C\uC694. \uAE09\uC5EC \uC2DC\uD2B8\uC758 \uD300\uB3C4 \uC8FC \uC18C\uC18D\uC73C\uB85C \uD45C\uC2DC\uB3FC\uC694.",
  "employee.effective_shift_label": "\uD604\uC7AC \uD310\uC815\uC5D0 \uC0AC\uC6A9 \uC911\uC778 \uADFC\uBB34",
  "employee.effective_shift_source": "\uCD9C\uCC98: {source}",
  "employee.effective_shift_group_auto": "{group} \uADF8\uB8F9 \xB7 \uC694\uC77C\uBCC4 \uD615\uD0DC \uC790\uB3D9 \uC120\uD0DD({count}\uAC1C)",
  "employee.effective_shift_none": "\uC870\uC9C1 \uAE30\uBCF8 \uAE30\uC900\uC2DC\uAC04",
  "employee.remove_row_shift_group": "\uC774 \uC18C\uC18D\uC758 \uADFC\uBB34 \uADF8\uB8F9 \uC9C0\uC6B0\uAE30",
  "employee.remove_row_shift_group_confirm": "\u300C{team}\u300D \uC18C\uC18D\uC758 \uADFC\uBB34 \uADF8\uB8F9\uC744 \uC9C0\uC6B8\uAE4C\uC694?\n\uC800\uC7A5\uD558\uBA74 \uB2F9\uC77C \uADFC\uD0DC\uB294 \uB2E4\uC2DC \uD310\uC815\uB418\uACE0, \uADFC\uBB34\uD45C(\uC2A4\uCF00\uC904\uB7EC) \uBC30\uC815\uC740 \uADF8\uB300\uB85C \uC720\uC9C0\uB3FC\uC694.",
  "employee.remove_row_shift_group_primary_hint": "\uC8FC \uC18C\uC18D\uC758 \uADFC\uBB34\uB294 \uC9C0\uC6B8 \uC218 \uC5C6\uC5B4\uC694. \uB2E4\uB978 \uC18C\uC18D\uC758 \uADFC\uBB34\uB97C \uC8FC \uADFC\uBB34\uB85C \uC9C0\uC815\uD55C \uB4A4 \uC9C0\uC6B8 \uC218 \uC788\uC5B4\uC694.",
  "employee.remove_row_shift_group_pending": "\uC800\uC7A5\uD558\uBA74 \uC774 \uC18C\uC18D\uC758 \uADFC\uBB34 \uADF8\uB8F9\uC774 \uBE44\uC6CC\uC838\uC694.",
  "employee.team_permission_required": "\uC18C\uC18D\uC744 \uC800\uC7A5\uD558\uB824\uBA74 \uD300 \uC218\uC815 \uAD8C\uD55C\uC774 \uD544\uC694\uD574\uC694. \uAD8C\uD55C\uC774 \uC788\uB294 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uC694\uCCAD\uD574 \uC8FC\uC138\uC694.",
  "employee.membership_save_failed": "\uC18C\uC18D\uC744 \uC800\uC7A5\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694: {teams}. \uC9C1\uC6D0 \uBAA9\uB85D\uC758 \uC218\uC815\uC5D0\uC11C \uC18C\uC18D\uACFC \uADFC\uBB34\uB97C \uB2E4\uC2DC \uC9C0\uC815\uD574 \uC8FC\uC138\uC694.",
  "employee.shift_assignment": "\uADFC\uBB34\uD615\uD0DC",
  "employee.resident_number": "\uC8FC\uBBFC\uB4F1\uB85D\uBC88\uD638",
  "employee.rrn_invalid": "\uC62C\uBC14\uB978 \uC8FC\uBBFC\uB4F1\uB85D\uBC88\uD638 \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4.",
  "employee.rrn_invalid_date": "\uC8FC\uBBFC\uB4F1\uB85D\uBC88\uD638\uC758 \uC0DD\uB144\uC6D4\uC77C\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694.",
  "employee.rrn_invalid_checksum": "\uC8FC\uBBFC\uB4F1\uB85D\uBC88\uD638 \uAC80\uC99D\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uB2E4\uC2DC \uD655\uC778\uD574\uC8FC\uC138\uC694.",
  "employee.required_missing": "\uD544\uC218 \uD56D\uBAA9 \uB204\uB77D",
  "employee.section_required_basic_html": '<span class="text-primary">\uD544\uC218</span> \uAE30\uBCF8\uC815\uBCF4',
  "employee.section_required_hr_html": '<span class="text-primary">\uD544\uC218</span> \uC778\uC0AC\uC815\uBCF4',
  "employee.section_other_personal": "\uAE30\uD0C0 \uC778\uC801\uC0AC\uD56D",
  "employee.section_other_hr": "\uAE30\uD0C0 \uC778\uC0AC\uC815\uBCF4",
  "employee.auto_generate": "\uC790\uB3D9 \uC0DD\uC131",
  "employee.email_invalid_format": "\uC62C\uBC14\uB978 \uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
  "employee.lunar": "\uC74C\uB825",
  "employee.rrn_front_placeholder": "\uC0DD\uB144\uC6D4\uC77C \uBA3C\uC800 \uC785\uB825",
  "employee.phone_as_id_tip": "\uC804\uD654\uBC88\uD638\uB97C ID\uB85C \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694.",
  "employee.phone_sms_notice": "\uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD574\uC57C, \uC784\uC2DC \uBE44\uBC00\uBC88\uD638\uB97C SMS\uB85C \uBC1C\uC1A1\uC744 \uD560 \uC218 \uC788\uC5B4\uC694.",
  "employee.address_search_placeholder": "\uC8FC\uC18C\uB97C \uAC80\uC0C9\uD574\uC8FC\uC138\uC694.(\uB3C4\uB85C\uBA85, \uC9C0\uBC88)",
  "employee.clear_address": "\uC8FC\uC18C \uC9C0\uC6B0\uAE30",
  "employee.address_detail_placeholder": "\uC0C1\uC138\uC8FC\uC18C",
  "employee.select_date": "\uB0A0\uC9DC \uC120\uD0DD",
  "employee.today": "\uC624\uB298",
  "employee.org_default_or_custom": "\uC870\uC9C1 \uAE30\uBCF8\uAC12 \uB610\uB294 \uAC1C\uBCC4 \uC124\uC815",
  "employee.affiliation_team_role": "\uC18C\uC18D (\uD300 \xB7 {@role})",
  "employee.job_duty": "\uC9C1\uBB34",
  "employee.job_duty_placeholder": "\uC608: \uAC04\uD638\uC0AC",
  "employee.change_team": "\uD300 \uBCC0\uACBD",
  "employee.change_role": "{@role} \uBCC0\uACBD",
  "employee.no_role_assigned": "{@role} \uC5C6\uC74C",
  "employee.add_affiliation": "\uC18C\uC18D \uCD94\uAC00",
  "employee.add_without_role": "{@role} \uC5C6\uC774 \uCD94\uAC00",
  "employee.change_without_role": "{@role} \uC5C6\uC774 \uBCC0\uACBD",
  "employee.status_inactive_notice": "\uBE44\uD65C\uC131 \uC0C1\uD0DC\uB85C \uB4F1\uB85D\uB3FC\uC694. \uC0AC\uC6A9\uD558\uAE30 \uC704\uD574\uC11C\uB294 \uC7AC\uC9C1\uC73C\uB85C \uBCC0\uACBD\uD574 \uC8FC\uC138\uC694.",
  "employee.status_active_notice": "\uC7AC\uC9C1 \uC0C1\uD0DC\uB85C \uB4F1\uB85D\uB3FC\uC694. \uC0AC\uC6A9\uC790\uAC00 \uBC14\uB85C \uB85C\uADF8\uC778\uD574\uC11C \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694.",
  "employee.shift_notice_html": '\uADFC\uBB34 \uD615\uD0DC\uB294 <strong class="font-semibold">\uADFC\uD0DC \uD604\uD669</strong>\uC758 <strong class="font-semibold">\uADFC\uBB34 \uC124\uC815</strong>\uC5D0\uC11C \uCD94\uAC00/\uC218\uC815 \uAC00\uB2A5\uD574\uC694.',
  "employee.allowed_shifts": "\uD5C8\uC6A9 \uADFC\uBB34 \uC720\uD615",
  "employee.allowed_shifts_help": "\uBC30\uC815\uB41C \uADFC\uBB34 \uADF8\uB8F9 \uBC16\uC5D0\uC11C\uB3C4 \uC9C1\uC6D0\uC774 \uC571 \u300C\uADFC\uBB34 \uC2DC\uAC04 \uC124\uC815\u300D\uC5D0\uC11C \uACE0\uB97C \uC218 \uC788\uB294 \uADFC\uBB34\uC608\uC694. \uC18C\uC18D \uD300\uC758 \uD5C8\uC6A9 \uC720\uD615\uACFC \uD569\uCCD0\uC9C0\uACE0, \uAE09\uC5EC \uADFC\uB85C\uD615\uD0DC\uB294 \uBC14\uB00C\uC9C0 \uC54A\uC544\uC694.",
  "employee.view_all_shift_types": "\uADFC\uBB34 \uC720\uD615 \uC804\uCCB4 \uBCF4\uAE30",
  "employee.registered_shift_types": "\uB4F1\uB85D\uB41C \uADFC\uBB34 \uC720\uD615",
  "employee.no_registered_shift_types": "\uB4F1\uB85D\uB41C \uADFC\uBB34 \uC720\uD615\uC774 \uC5C6\uC5B4\uC694.",
  "employee.select_cert_type": "\uC790\uACA9 \uC720\uD615 \uC120\uD0DD",
  "employee.cert_submit_notice_html": `\uC9C1\uC6D0\uC774 \uC81C\uCD9C\uD574\uC57C \uD560 \uC790\uACA9\uC99D/\uBA74\uD5C8\uB97C \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.<br />\uC120\uD0DD\uD55C \uD56D\uBAA9\uC740 \uC790\uACA9\uC99D/\uBA74\uD5C8 \uD654\uBA74\uC5D0 <strong class="font-semibold">'\uD30C\uC77C \uBBF8\uC81C\uCD9C'</strong> \uC0C1\uD0DC\uB85C \uB4F1\uB85D\uB3FC\uC694.<br />\uC785\uC0AC \uD6C4 <strong class="font-semibold">'\uBB38\uC11C \uACB0\uC7AC'</strong> > <strong class="font-semibold">'\uC790\uACA9\uC99D/\uBA74\uD5C8'</strong> \uD0ED\uC5D0\uC11C \uC790\uACA9 \uC815\uBCF4\uB97C \uB4F1\uB85D\uD560 \uC218 \uC788\uC5B4\uC694.`,
  "employee.cert_request_count": "{n}\uAC1C\uC758 \uC790\uACA9\uC99D \uC81C\uCD9C\uC744 \uC694\uCCAD\uD569\uB2C8\uB2E4.",
  "employee.cert_no_request": "\uC790\uACA9\uC99D \uC81C\uCD9C\uC744 \uC694\uCCAD\uD558\uC9C0 \uC54A\uC544\uC694.",
  "employee.contract_info": "\uACC4\uC57D \uC815\uBCF4",
  "employee.salary_basis": "\uAE09\uC5EC \uAE30\uC900",
  "employee.salary_grade": "\uD638\uBD09",
  "employee.grade_locked_hint": "\uD638\uBD09 \uC120\uD0DD \uC2DC \uD638\uBD09\uD45C \uAC12\uC774 \uC801\uC6A9\uB418\uC5B4 \uC9C1\uC811 \uC218\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC9C1\uC811 \uC785\uB825\uD558\uB824\uBA74 \uD638\uBD09\uC744 \uBBF8\uC120\uD0DD\uC73C\uB85C \uBC14\uAFB8\uC138\uC694.",
  "employee.work_hours_section": "\uADFC\uBB34 \uC2DC\uAC04",
  "employee.preview": "\uBBF8\uB9AC\uBCF4\uAE30",
  "employee.reg_success_title": "\uC131\uACF5\uC801\uC73C\uB85C \uC9C1\uC6D0\uC774 \uB4F1\uB85D\uB418\uC5C8\uC5B4\uC694!",
  "employee.temp_password_created": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638\uAC00 \uC0DD\uC131\uB418\uC5C8\uC5B4\uC694. \uC9C1\uC6D0\uC5D0\uAC8C \uBE44\uBC00\uBC88\uD638\uB97C \uC804\uB2EC\uD574 \uC8FC\uC138\uC694.",
  "employee.password_copied": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638\uAC00 \uBCF5\uC0AC\uB418\uC5C8\uC5B4\uC694.",
  "employee.password_once_warning_html": "\uC774 \uCC3D\uC744 \uB2EB\uC73C\uC2DC\uBA74 \uC9C0\uAE08 \uBC1C\uAE09\uB41C \uBE44\uBC00\uBC88\uD638\uB294 \uB2E4\uC2DC \uBCFC \uC218 \uC5C6\uC73C\uB2C8 \uC8FC\uC758\uD574 \uC8FC\uC138\uC694! \uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815 \uBC0F \uBC1C\uAE09\uC740 <strong>\uC9C1\uC6D0 \uC815\uBCF4 \uC218\uC815</strong>\uC5D0\uC11C \uAC00\uB2A5\uD574\uC694.",
  "employee.address_search": "\uC8FC\uC18C \uAC80\uC0C9",
  "employee.address_search_loading": "\uC8FC\uC18C \uAC80\uC0C9\uC744 \uBD88\uB7EC\uC624\uB294 \uC911...",
  "employee.full_name": "\uC131\uBA85",
  "employee.not_entered": "\uBBF8\uC785\uB825",
  "employee.certification": "\uC790\uACA9\uC99D/\uBA74\uD5C8",
  "employee.not_submitted": "\uBBF8\uC81C\uCD9C",
  "employee.weekly_hours_summary": "{std}h/\uC8FC (\uCD5C\uB300 {max}h)",
  "employee.hobong_label": "\uD638\uBD09",
  "employee.longevity_label": "\uADFC\uC18D\uC218\uB2F9",
  "employee.meal_label": "\uC2DD\uB300",
  "employee.transport_label": "\uAD50\uD1B5\uBE44",
  "employee.position_label": "\uC9C1\uCC45\uC218\uB2F9",
  "employee.close_confirm_title": "\uCC3D\uC744 \uB2EB\uC73C\uBA74 \uC785\uB825\uD55C \uB0B4\uC6A9\uC774 \uBAA8\uB450 \uCDE8\uC18C\uB3FC\uC694.",
  "employee.close_confirm_desc": "\uC800\uC7A5\uB418\uC9C0 \uC54A\uC740 \uC815\uBCF4\uB294 \uBCF5\uAD6C\uD560 \uC218 \uC5C6\uC5B4\uC694.",
  "employee.continue_editing": "\uACC4\uC18D\uD3B8\uC9D1",
  "employee.leave_page": "\uB098\uAC00\uAE30",
  "employee.employee_number_change_notice": "\uC0AC\uBC88\uC744 \uBCC0\uACBD\uD558\uBA74 \uB85C\uADF8\uC778 ID\uAC00 \uD568\uAED8 \uBC14\uB00C\uC5B4\uC694.",
  "employee.employee_number_uppercase_hint": "\uC0AC\uBC88\uC740 \uC785\uB825\uD55C \uB300\uB85C \uC800\uC7A5\uB3FC\uC694. \uB85C\uADF8\uC778\xB7\uAC80\uC0C9\xB7\uC911\uBCF5 \uD655\uC778\uC740 \uB300\uC18C\uBB38\uC790\uB97C \uAC00\uB9AC\uC9C0 \uC54A\uC544\uC694.",
  "employee.return_notice": "\uBCF5\uC9C1 \uCC98\uB9AC\uD558\uBA74 \uD734\uC9C1 \uAE30\uB85D\uC774 \uC885\uB8CC\uB418\uACE0 \uC0C1\uD0DC\uAC00 \uC7AC\uC9C1\uC73C\uB85C \uBCC0\uACBD\uB429\uB2C8\uB2E4.",
  "employee.cert_edit_notice_html": '\uC790\uACA9\uC99D/\uBA74\uD5C8 \uC815\uBCF4\uB294 <strong class="font-semibold">\uBB38\uC11C\uACB0\uC7AC</strong>\uC758 <strong class="font-semibold">\uC790\uACA9\uC99D/\uBA74\uD5C8</strong> \uD0ED\uC5D0\uC11C \uB4F1\uB85D/\uC218\uC815\uD560 \uC218 \uC788\uC5B4\uC694.',
  "employee.no_certifications": "\uB4F1\uB85D\uB41C \uC790\uACA9\uC99D/\uBA74\uD5C8\uAC00 \uC5C6\uC5B4\uC694.",
  "employee.license_number": "\uBA74\uD5C8/\uC790\uACA9\uBC88\uD638",
  "employee.registered_date": "\uB4F1\uB85D\uC77C",
  "employee.next_reporting_deadline": "\uCC28\uAE30 \uC2E0\uACE0 \uAE30\uD55C",
  "employee.attachment_preview": "\uCCA8\uBD80\uD30C\uC77C \uBBF8\uB9AC\uBCF4\uAE30",
  "employee.manual_password_desc": "\uAD00\uB9AC\uC790\uAC00 \uC0C8 \uBE44\uBC00\uBC88\uD638\uB97C \uC9C1\uC811 \uC785\uB825\uD569\uB2C8\uB2E4.",
  "employee.manual_password_rule": "{min}\uC790 \uC774\uC0C1\uC774\uAC70\uB098 \uC870\uC9C1\uC758 \uC784\uC2DC \uBE44\uBC00\uBC88\uD638 \uD615\uC2DD\uACFC \uAC19\uC544\uC57C \uD574\uC694.",
  "employee.manual_password_rule_with_format": "{min}\uC790 \uC774\uC0C1, \uB610\uB294 \uC784\uC2DC \uBE44\uBC00\uBC88\uD638 \uD615\uC2DD({format})\uC73C\uB85C \uC785\uB825\uD560 \uC218 \uC788\uC5B4\uC694.",
  "employee.manual_password_temp_hint": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638 \uD615\uC2DD\uC774\uC5D0\uC694. \uC800\uC7A5\uD558\uBA74 \uC9C1\uC6D0\uC774 \uCCAB \uB85C\uADF8\uC778 \uB54C \uBE44\uBC00\uBC88\uD638\uB97C \uBC14\uAFD4\uC57C \uD574\uC694.",
  "employee.confirm_temp_format_password": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638 \uD615\uC2DD\uC73C\uB85C \uC124\uC815\uD560\uAE4C\uC694? \uC9C1\uC6D0\uC740 \uCCAB \uB85C\uADF8\uC778 \uB54C \uBE44\uBC00\uBC88\uD638\uB97C \uBC14\uAFD4\uC57C \uD574\uC694.",
  "employee.sms_login_allow": "SMS \uB85C\uADF8\uC778 \uD5C8\uC6A9",
  "employee.saved": "\uC800\uC7A5\uB428",
  "employee.save_partial": "\uC911\uAC04 \uC800\uC7A5",
  "employee.saving_reflect": "\uBC18\uC601 \uC911",
  "employee.shift_unassigned": "\uBBF8\uBC30\uC815",
  "employee.system_admin_change": "\uC2DC\uC2A4\uD15C \uAD00\uB9AC\uC790 \uBCC0\uACBD",
  "employee.system_admin_confirm_html": '\uD574\uB2F9 \uC0AC\uC6A9\uC790\uB97C <span style="font-weight: 700;">\uC2DC\uC2A4\uD15C \uAD00\uB9AC\uC790</span>\uB85C \uBCC0\uACBD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C? \uAD00\uB9AC\uC790\uB294 \uBAA8\uB4E0 \uAE30\uB2A5\uC5D0 \uC811\uADFC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
  "employee.close_confirm_edit": "\uBCC0\uACBD\uB41C \uB0B4\uC6A9\uC744 \uC800\uC7A5\uD558\uC9C0 \uC54A\uACE0 \uB098\uAC00\uC2DC\uACA0\uC5B4\uC694?",
  "employee.loading": "\uBD88\uB7EC\uC624\uB294 \uC911...",
  "employee.preview_unsupported_html": "\uC774 \uD615\uC2DD\uC740 \uD654\uBA74 \uBBF8\uB9AC\uBCF4\uAE30\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC544\uC694.<br />\uC0C8 \uCC3D\uC5D0\uC11C \uC5F4\uC5B4 \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
  "employee.open_new_window": "\uC0C8 \uCC3D\uC5D0\uC11C \uC5F4\uAE30",
  "employee.expected_return_prefix": "(\uC608\uC815 ",
  "employee.enter_birth_first": "\uC0DD\uB144\uC6D4\uC77C\uC744 \uBA3C\uC800 \uC785\uB825\uD558\uC138\uC694.",
  "employee.phone_required_disabled": "\uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD558\uC9C0 \uC54A\uC544 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC5B4\uC694.",
  "employee.change_preview": "\uBCC0\uACBD \uB0B4\uC6A9 \uBBF8\uB9AC\uBCF4\uAE30",
  "employee.certification_register": "\uC790\uACA9\uC99D/\uBA74\uD5C8 \uB4F1\uB85D",
  "employee.account_security": "\uACC4\uC815\xB7\uBCF4\uC548",
  "employee.recurring_allowances": "\uACE0\uC815 \uC218\uB2F9",
  "recurring.hint": "\uB9E4\uB2EC \uBC18\uBCF5\uB418\uB294 \uACE0\uC815 \uC218\uB2F9(\uC790\uACA9 \uC218\uB2F9\xB7\uC9C1\uCC45 \uC218\uB2F9 \uB4F1)\uC744 \uAE30\uAC04\uC73C\uB85C \uC815\uC758\uD574\uC694. \uC2DC\uD2B8\uB294 \uADF8 \uB2EC\uC5D0 \uC720\uD6A8\uD55C \uC815\uC758\uB97C \uC77D\uC73C\uBBC0\uB85C \uC885\uB8CC\uC77C\uC774 \uC9C0\uB098\uBA74 \uB2E4\uC74C \uB2EC\uBD80\uD130 \uC790\uB3D9\uC73C\uB85C \uBE60\uC9C0\uACE0, \uC9C0\uB09C\uB2EC \uC2DC\uD2B8 \uAC12\uC740 \uADF8\uB300\uB85C\uC608\uC694.",
  "recurring.list_title": "\uC815\uC758\uB41C \uACE0\uC815 \uC218\uB2F9",
  "recurring.empty": "\uC815\uC758\uB41C \uACE0\uC815 \uC218\uB2F9\uC774 \uC5C6\uC5B4\uC694.",
  "recurring.add_title": "\uACE0\uC815 \uC218\uB2F9 \uCD94\uAC00",
  "recurring.label": "\uC218\uB2F9 \uC774\uB984",
  "recurring.code": "\uCF54\uB4DC",
  "recurring.code_hint": "\uC2DC\uD2B8 \uC5F4 \uC124\uC815\uC758 \u300C\uBC18\uBCF5 \uACE0\uC815 \uC218\uB2F9\u300D \uC6D0\uCC9C\uC5D0\uC11C \uC774 \uCF54\uB4DC\uB85C \uAC70\uB97C \uC218 \uC788\uC5B4\uC694(\uC601\uBB38 \uC18C\uBB38\uC790\xB7\uC22B\uC790\xB7\uBC11\uC904).",
  "recurring.amount": "\uC6D4 \uAE08\uC561",
  "recurring.note": "\uBA54\uBAA8 (\uC120\uD0DD)",
  "recurring.valid_from": "\uC2DC\uC791\uC77C",
  "recurring.valid_until": "\uC885\uB8CC\uC77C",
  "recurring.valid_until_optional": "\uC885\uB8CC\uC77C (\uC120\uD0DD \xB7 \uBE44\uC6B0\uBA74 \uBB34\uAE30\uD55C)",
  "recurring.open_ended": "\uBB34\uAE30\uD55C",
  "recurring.add": "\uCD94\uAC00",
  "recurring.end": "\uC885\uB8CC\uC77C \uC800\uC7A5",
  "recurring.correct": "\uAE08\uC561 \uC815\uC815",
  "recurring.correct_confirm": "\uAE08\uC561\uC744 \uC815\uC815\uD560\uAE4C\uC694? \uC774 \uC815\uC758\uAC00 \uAC78\uCE5C \uC544\uC9C1 \uD655\uC815\uD558\uC9C0 \uC54A\uC740 \uB2EC\uC5D0 \uBAA8\uB450 \uBC18\uC601\uB3FC\uC694. \uD2B9\uC815 \uB0A0\uBD80\uD130 \uBC14\uAFB8\uB824\uBA74 \uC885\uB8CC\uC77C\uC744 \uB123\uACE0 \uC0C8\uB85C \uCD94\uAC00\uD574 \uC8FC\uC138\uC694.",
  "recurring.form_invalid": "\uC218\uB2F9 \uC774\uB984\xB7\uCF54\uB4DC\xB7\uC2DC\uC791\uC77C\uC744 \uCC44\uC6B0\uACE0 \uAE08\uC561\uC744 0\uBCF4\uB2E4 \uD06C\uAC8C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
  "recurring.load_fail": "\uACE0\uC815 \uC218\uB2F9\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694",
  "recurring.save_fail": "\uACE0\uC815 \uC218\uB2F9 \uC800\uC7A5 \uC2E4\uD328",
  "recurring.status_active": "\uC801\uC6A9 \uC911",
  "recurring.status_scheduled": "\uC608\uC815",
  "recurring.status_ended": "\uC885\uB8CC",
  "leave.leave_process": "\uD734\uC9C1",
  "leave.return_process": "\uBCF5\uC9C1",
  "leave.termination_process": "\uD1F4\uC9C1",
  "leave.start_date": "\uD734\uC9C1 \uC2DC\uC791\uC77C",
  "leave.expected_return": "\uBCF5\uC9C1 \uC608\uC815\uC77C",
  "leave.notes": "\uBE44\uACE0",
  "leave.notes_placeholder": "\uCC38\uACE0 \uC0AC\uD56D (\uC120\uD0DD)",
  "leave.leave_warning": "\uD734\uC9C1 \uCC98\uB9AC \uC2DC \uD574\uB2F9 \uC9C1\uC6D0\uC758 \uC0C1\uD0DC\uAC00 \uD734\uC9C1\uC73C\uB85C \uBCC0\uACBD\uB3FC\uC694. \uAE09\uC5EC \uACC4\uC0B0 \uBC0F \uADFC\uD0DC \uAD00\uB9AC\uC5D0\uC11C \uC81C\uC678\uB3FC\uC694.",
  "leave.termination_date": "\uCD5C\uC885 \uADFC\uBB34\uC77C",
  "leave.termination_notes_placeholder": "\uC778\uC218\uC778\uACC4 \uC0AC\uD56D, \uC815\uC0B0 \uAD00\uB828 \uBA54\uBAA8 \uB4F1",
  "leave.termination_agree": "\uC704 \uB0B4\uC6A9\uC744 \uD655\uC778\uD558\uC600\uC73C\uBA70, \uD1F4\uC9C1 \uCC98\uB9AC\uC5D0 \uB3D9\uC758\uD574\uC694.",
  "leave.tenure": "\uADFC\uC18D\uAE30\uAC04",
  "leave.usage_rate": "\uC0AC\uC6A9\uB960",
  "leave.calculation_basis": "\uC0B0\uC815\uAE30\uC900",
  "leave.hire_date_basis": "\uC785\uC0AC\uC77C",
  "leave.fiscal_year_basis": "\uD68C\uACC4\uC5F0\uB3C4",
  "leave.rule_desc": "\uADFC\uB85C\uAE30\uC900\uBC95 \uC81C60\uC870 \uAE30\uBC18 \uC5F0\uCC28 \uBD80\uC5EC \uAE30\uC900\uC744 \uAD00\uB9AC\uD574\uC694.",
  "leave.add_rule": "\uBD80\uC5EC \uAE30\uC900 \uADDC\uCE59 \uCD94\uAC00",
  "leave.template_desc": "\uADFC\uB85C\uAE30\uC900\uBC95 \uC81C60\uC870 \uAE30\uBCF8 \uC5F0\uCC28\uADDC\uCE59\uC744 \uC77C\uAD04 \uB4F1\uB85D\uD574\uC694 (\uC785\uC0AC 1\uB144 \uBBF8\uB9CC \uC6D4\uBCC4\uBC1C\uC0DD, 1~3\uB144 15\uC77C, 3\uB144 \uC774\uC0C1 \uADFC\uC18D\uAC00\uC0B0)",
  "leave.register_default_rules": "\uAE30\uBCF8 \uADDC\uCE59 \uB4F1\uB85D",
  "leave.years_of_service": "\uADFC\uC18D\uC5F0\uC218",
  "leave.entitled_days": "\uBD80\uC5EC\uC77C\uC218",
  "leave.accrual_type": "\uBC1C\uC0DD\uC720\uD615",
  "leave.max_days": "\uCD5C\uB300\uC77C\uC218",
  "leave.monthly_accrual": "\uC6D4\uBCC4 \uBC1C\uC0DD",
  "leave.annual_grant": "\uC5F0\uAC04 \uBD80\uC5EC",
  "leave.no_rules": "\uBD80\uC5EC \uAE30\uC900\uC774 \uC124\uC815\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4. \uADDC\uCE59\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694.",
  "leave.edit_rule": "\uBD80\uC5EC \uAE30\uC900 \uC218\uC815",
  "leave.add_rule_title": "\uBD80\uC5EC \uAE30\uC900 \uCD94\uAC00",
  "leave.years_start": "\uADFC\uC18D\uC5F0\uC218 \uC2DC\uC791 (\uC774\uC0C1)",
  "leave.years_end": "\uADFC\uC18D\uC5F0\uC218 \uB05D (\uBBF8\uB9CC, \uBE48\uCE78=\uBB34\uC81C\uD55C)",
  "leave.unlimited": "\uBB34\uC81C\uD55C",
  "leave.max_days_monthly": "\uCD5C\uB300\uC77C\uC218 (\uC6D4\uBCC4 \uBC1C\uC0DD \uC2DC \uC0C1\uD55C)",
  "leave.no_limit": "\uC81C\uD55C \uC5C6\uC74C",
  "leave.rule_placeholder": "\uC608: \uADFC\uB85C\uAE30\uC900\uBC95 \uC81C60\uC870 \uAE30\uC900",
  "leave.years_or_more": "\uC774\uC0C1",
  "leave.years_less_than": "\uB144 \uBBF8\uB9CC",
  "leave.voluntary": "\uC790\uC9C4 \uD1F4\uC0AC",
  "leave.recommended": "\uAD8C\uACE0 \uC0AC\uC9C1",
  "leave.job_change": "\uC774\uC9C1",
  "leave.contract_expiry": "\uACC4\uC57D \uB9CC\uB8CC",
  "leave.retirement": "\uC815\uB144 \uD1F4\uC9C1",
  "leave.dismissal": "\uD574\uACE0 (\uC9D5\uACC4)",
  "team.add_member_btn": "\uBA64\uBC84\uCD94\uAC00",
  "team.no_data": "\uD300 \uB370\uC774\uD130\uAC00 \uC5C6\uC5B4\uC694",
  "team.no_member_data": "\uBA64\uBC84\uAC00 \uC5C6\uC5B4\uC694",
  "team.remove": "\uC81C\uAC70",
  "role.no_permissions_hint": "\uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694",
  "role.permissions_label": "\uAD8C\uD55C \uC120\uD0DD",
  "role.perm_search_placeholder": "\uAD8C\uD55C \uAC80\uC0C9 (\uD56D\uBAA9\xB7\uAD8C\uD55C \uC774\uB984)",
  "role.perm_all_resources": "\uC804\uCCB4 \uD56D\uBAA9",
  "role.perm_scope_any": "\uBAA8\uB4E0 \uBC94\uC704",
  "role.perm_selected_only": "\uC120\uD0DD\uB41C \uAD8C\uD55C\uB9CC \uBCF4\uAE30",
  "role.perm_selected_count": "{n}\uAC1C \uC120\uD0DD \xB7 \uCD1D {m}\uAC1C",
  "role.perm_set_all": "\uC774 \uC904 \uBAA8\uB450 \uC804\uCCB4",
  "role.perm_set_all_tip": "\uBAA8\uB4E0 \uAD8C\uD55C\uC744 \uBD80\uC5EC",
  "role.perm_bundle_help": "\uD544\uC694\uD55C \uAD8C\uD55C \uBCF4\uAE30",
  "role.perm_clear": "\uD574\uC81C",
  "role.perm_none": "\uC5C6\uC74C",
  "role.perm_scope_missing": "\uC774 \uBC94\uC704\uC758 \uAD8C\uD55C\uC740 \uC5C6\uC5B4\uC694",
  "role.perm_compare_none": "\uBE44\uAD50 \uC548 \uD568",
  "role.perm_compare_label": "\uB2E4\uB978 {@role|\uACFC/\uC640} \uBE44\uAD50",
  "role.perm_compare_value": "\uBE44\uAD50: {s}",
  "role.perm_diff_only": "\uCC28\uC774\uB9CC \uBCF4\uAE30",
  "role.perm_no_match": "\uC870\uAC74\uC5D0 \uB9DE\uB294 \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694",
  "role.perm_bundles_label": "\uAE30\uB2A5 \uBB36\uC74C\uC73C\uB85C \uC2DC\uC791\uD558\uAE30",
  "role.perm_bundles_hint": "\uBA54\uB274\uB97C \uC4F0\uB294 \uB370 \uD544\uC694\uD55C \uAD8C\uD55C\uC744 \uD55C \uBC88\uC5D0 \uCF1C\uC694. \uCCB4\uD06C\uB97C \uD480\uBA74 \uC774 \uBB36\uC74C\uC774 \uCF20 \uAD8C\uD55C\uB9CC \uB2E4\uC2DC \uAEBC\uC694(\uC9C1\uC811 \uBC14\uAFBC \uCE78\uC740 \uADF8\uB300\uB85C).",
  "role.perm_bundle_full": "\uCDA9\uC871",
  "role.perm_bundle_partial": "\uC77C\uBD80",
  "role.perm_bundle_none": "\uC5C6\uC74C",
  "role.perm_all_confirm": "\uBAA8\uB4E0 \uAD8C\uD55C({n}\uAC1C)\uC744 \uAC00\uC7A5 \uB113\uC740 \uBC94\uC704\uB85C \uCF24\uAE4C\uC694?",
  "role.perm_all_confirm_note": "\uC774 \uC5ED\uD560\uC740 \uC870\uC9C1\uC758 \uBAA8\uB4E0 \uB370\uC774\uD130\uB97C \uBCF4\uACE0 \uBC14\uAFC0 \uC218 \uC788\uAC8C \uB3FC\uC694.",
  "role.perm_all_confirm_ok": "\uBAA8\uB450 \uCF1C\uAE30",
  "role.perm_bundle_missing_one": "\uBE60\uC9C4 \uAD8C\uD55C: {name}",
  "role.perm_bundle_missing_many": "\uBE60\uC9C4 \uAD8C\uD55C: {name} \uC678 {n}\uAC1C",
  "role.perm_detail_label": "\uC138\uBD80 \uAD8C\uD55C",
  "role.perm_expand_all": "\uBAA8\uB450 \uD3BC\uCE58\uAE30",
  "role.perm_collapse_all": "\uBAA8\uB450 \uC811\uAE30",
  "role.perm_group_count": "{n}\uAC1C \uCF1C\uC9D0",
  "role.perm_area_col": "\uC601\uC5ED",
  "role.perm_view_total": "\uAD8C\uD55C {n}\uAC1C",
  "role.perm_view_empty": "\uCF20 \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694. \uBA38\uB9AC\uC758 \uC218\uC815 \uBC84\uD2BC\uC73C\uB85C \uAD8C\uD55C\uC744 \uCF1C \uC8FC\uC138\uC694.",
  "role.perm_view_show_all": "\uC804\uCCB4 \uAD8C\uD55C \uD655\uC778 ({n}\uAC1C)",
  "role.perm_summary_title": "\uC774 \uC5ED\uD560\uC774 \uD560 \uC218 \uC788\uB294 \uC77C",
  "role.perm_summary_empty": "\uC544\uC9C1 \uCF20 \uAD8C\uD55C\uC774 \uC5C6\uC5B4\uC694. \uC704 \uAE30\uB2A5 \uBB36\uC74C\uC774\uB098 \uC67C\uCABD \uD45C\uC5D0\uC11C \uCF1C \uC8FC\uC138\uC694.",
  "role.perm_summary_bundles": "\uB2E4 \uAC16\uCD98 \uAE30\uB2A5",
  "role.perm_summary_groups": "\uC601\uC5ED\uBCC4 \uCF1C\uC9C4 \uAD8C\uD55C",
  "role.org_scope_label": "\uC5ED\uD560 \uBAA9\uB85D \uBD84\uB958",
  "role.org_scope_hint": "\uBAA9\uB85D\uC5D0\uC11C \uCC3E\uAE30 \uC27D\uAC8C \uBD99\uC774\uB294 \uD45C\uC2DC\uC608\uC694. \uAD8C\uD55C \uBC94\uC704\uC640\uB294 \uAD00\uACC4\uC5C6\uC5B4\uC694.",
  "role.multi_select": "\uC5EC\uB7EC \uAC1C \uC120\uD0DD",
  "role.save_needs_name": "\uC5ED\uD560\uBA85\uC744 \uC785\uB825\uD558\uBA74 \uC800\uC7A5\uD560 \uC218 \uC788\uC5B4\uC694",
  "role.perm_bundle_add": "{name} \uD544\uC218 \uAD8C\uD55C \uCD94\uAC00",
  "role.perm_bundle_added": "{name} \uD544\uC218 \uAD8C\uD55C\uC744 \uB354\uD588\uC5B4\uC694 ({n}\uCE78)",
  "role.perm_bundle_already": "{name} \uD544\uC218 \uAD8C\uD55C\uC740 \uC774\uBBF8 \uB2E4 \uAC16\uCDC4\uC5B4\uC694",
  "role.perm_bundle_unavailable": "\uC774 \uC870\uC9C1 \uCE74\uD0C8\uB85C\uADF8\uC5D0 \uC5C6\uB294 \uAD8C\uD55C {n}\uAC1C\uB294 \uB354\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694",
  "role.perm_bundle_requires": "\uD544\uC694\uD55C \uAD8C\uD55C",
  "role.perm_bundle_missing": "\uBAA8\uC790\uB780 \uAD8C\uD55C",
  "role.perm_resource_col": "\uD56D\uBAA9",
  "settings.payroll_settings": "\uAE09\uC5EC \uC124\uC815",
  "settings.pay_day": "\uAE09\uC5EC \uC9C0\uAE09\uC77C",
  "settings.cutoff_day": "\uB9C8\uAC10\uC77C",
  "settings.fiscal_year_start": "\uD68C\uACC4\uC5F0\uB3C4 \uC2DC\uC791\uC6D4",
  "settings.leave_accrual_basis": "\uC5F0\uCC28 \uC0B0\uC815 \uAE30\uC900",
  "settings.weekly_hour_limit": "\uC8FC\uB2F9 \uADFC\uBB34\uC2DC\uAC04 \uD55C\uB3C4",
  "settings.daily_standard_hours": "1\uC77C \uAE30\uBCF8 \uADFC\uBB34\uC2DC\uAC04",
  "settings.currency": "\uD1B5\uD654",
  "settings.attendance_method": "\uCD9C\uADFC \uAE30\uB85D \uBC29\uC2DD",
  "settings.attendance_default": "\uAE30\uBCF8 \uBC29\uC2DD",
  "settings.attendance_org_note": "\uC870\uC9C1 \uAE30\uBCF8\uAC12 \u2014 \uC9C1\uC6D0\uBCC4\uB85C \uAC1C\uBCC4 \uC124\uC815 \uAC00\uB2A5",
  "settings.attendance_app": "\uC571 (Web/Mobile)",
  "settings.attendance_secom": "\uC9C0\uBB38 \uB2E8\uB9D0\uAE30 (Secom)",
  "settings.attendance_manual": "\uAD00\uB9AC\uC790 \uC218\uB3D9 \uC785\uB825",
  "settings.allowed_ips": "\uD5C8\uC6A9 IP \uC8FC\uC18C",
  "settings.no_ip_restriction": "\uC81C\uD55C \uC5C6\uC74C (\uBAA8\uB4E0 IP \uD5C8\uC6A9)",
  "settings.allowed_ips_app": "\uD5C8\uC6A9 IP \uC8FC\uC18C (\uC571 \uBC29\uC2DD \uC804\uC6A9)",
  "settings.ip_help": "CIDR \uD45C\uAE30 \uB610\uB294 \uC815\uD655\uD55C IP \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694. \uBE44\uC6CC\uB450\uBA74 \uBAA8\uB4E0 IP\uC5D0\uC11C \uD5C8\uC6A9\uB3FC\uC694.",
  "settings.seal_image": "\uC9C1\uC778 \uC774\uBBF8\uC9C0",
  "settings.seal": "\uC9C1\uC778",
  "settings.seal_not_registered": "\uBBF8\uB4F1\uB85D",
  "settings.seal_help": "\uD22C\uBA85 \uBC30\uACBD PNG \uAD8C\uC7A5 (500KB \uC774\uD558)",
  "settings.representative": "\uB300\uD45C\uC790\uBA85",
  "settings.email": "\uC774\uBA54\uC77C",
  "settings.default_work_hours": "\uAE30\uBCF8 \uADFC\uBB34\uC2DC\uAC04",
  "settings.default_work_hours_desc": "\uC2E0\uADDC \uC9C1\uC6D0\uC5D0\uAC8C \uC790\uB3D9 \uBC30\uC815\uB418\uB294 \uAE30\uBCF8 \uADFC\uBB34\uD615\uD0DC\uC785\uB2C8\uB2E4",
  "settings.not_set": "\uBBF8\uC124\uC815",
  "settings.shift_desc": "\uC77C\uBC18\uADFC\uBB34 \uBC0F 3\uAD50\uB300 \uADFC\uBB34\uC2DC\uAC04\uC744 \uAD00\uB9AC\uD574\uC694",
  "settings.add_shift": "\uADFC\uBB34 \uCD94\uAC00",
  "settings.template_add": "\uD15C\uD50C\uB9BF\uC5D0\uC11C \uCD94\uAC00",
  "settings.no_shifts": "\uB4F1\uB85D\uB41C \uADFC\uBB34 \uC124\uC815\uC774 \uC5C6\uC5B4\uC694",
  "settings.default_badge": "\uAE30\uBCF8",
  "settings.overtime_rate": "\uC218\uB2F9 \uBC30\uC728",
  "settings.overtime_multiplier": "\uCD08\uACFC\uADFC\uBB34 \uBC30\uC728",
  "settings.work_days": "\uADFC\uBB34 \uC694\uC77C",
  "settings.work_hours_label": "\uADFC\uBB34\uC2DC\uAC04 (h)",
  "settings.break_hours_label": "\uD734\uC2DD\uC2DC\uAC04 (h)",
  "settings.start_time": "\uC2DC\uC791\uC2DC\uAC04",
  "settings.end_time": "\uC885\uB8CC\uC2DC\uAC04",
  "settings.shift_type": "\uADFC\uBB34\uC720\uD615",
  "settings.shift_day": "\uC8FC\uAC04",
  "settings.shift_evening": "\uC624\uD6C4",
  "settings.shift_night": "\uC57C\uAC04",
  "settings.shift_flexible": "\uC720\uC5F0",
  "settings.shift_on_call": "\uB2F9\uC9C1",
  "settings.shift_off": "\uD734\uBB34",
  "settings.shift_code": "\uCF54\uB4DC",
  "settings.shift_name": "\uADFC\uBB34 \uC774\uB984",
  "settings.shift_name_placeholder": "\uC774 \uADFC\uBB34\uB97C \uAD6C\uBD84\uD558\uAE30 \uC704\uD55C \uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694. (\uC608: \uC624\uC804\uC870, \uD3C9\uC77C \uADFC\uBB34, 9to6)",
  "settings.shift_classification": "\uAD6C\uBD84",
  "settings.shift_classification_regular": "\uC18C\uC815",
  "settings.shift_classification_overtime": "\uC5F0\uC7A5",
  "settings.shift_overnight": "\uC775\uC77C \uD1F4\uADFC (\uC790\uC815 \uB118\uAE40)",
  "settings.shift_treat_holiday": "\uD734\uC77C \uADFC\uBB34\uB85C \uAC04\uC8FC",
  "settings.shift_night_dedicated": "\uC57C\uAC04 \uC804\uB2F4",
  "settings.shift_treat_holiday_badge": "\uD734\uC77C",
  "settings.shift_night_dedicated_badge": "\uC57C\uAC04\uC804\uB2F4",
  "settings.allowance_a_codes": "\uC218\uB2F9 \uD56D\uBAA9\uCF54\uB4DC (A\uCF54\uB4DC)",
  "settings.deduction_d_codes": "\uACF5\uC81C \uD56D\uBAA9\uCF54\uB4DC (D\uCF54\uB4DC)",
  "settings.no_allowance_codes": "\uB4F1\uB85D\uB41C \uC218\uB2F9 \uCF54\uB4DC\uAC00 \uC5C6\uC5B4\uC694",
  "settings.no_deduction_codes": "\uB4F1\uB85D\uB41C \uACF5\uC81C \uCF54\uB4DC\uAC00 \uC5C6\uC5B4\uC694",
  "settings.allowance_calc_rules": "\uC218\uB2F9 \uACC4\uC0B0\uADDC\uCE59",
  "settings.deduction_calc_rules": "\uACF5\uC81C \uACC4\uC0B0\uADDC\uCE59",
  "settings.no_allowance_rules": "\uB4F1\uB85D\uB41C \uC218\uB2F9 \uACC4\uC0B0\uADDC\uCE59\uC774 \uC5C6\uC5B4\uC694",
  "settings.no_deduction_rules": "\uB4F1\uB85D\uB41C \uACF5\uC81C \uACC4\uC0B0\uADDC\uCE59\uC774 \uC5C6\uC5B4\uC694",
  "settings.effective_date": "\uC801\uC6A9\uC77C",
  "settings.no_cert_data": "\uB4F1\uB85D\uB41C \uC790\uACA9\uC99D/\uBA74\uD5C8\uC774 \uC5C6\uC5B4\uC694",
  "settings.excel_download": "Excel \uB2E4\uC6B4\uB85C\uB4DC",
  "settings.cert_register": "\uC790\uACA9\uC99D/\uBA74\uD5C8 \uB4F1\uB85D",
  "settings.all_types": "\uC804\uCCB4 \uC720\uD615",
  "settings.grade_category": "\uBD84\uB958",
  "settings.effective_year": "\uC801\uC6A9\uC5F0\uB3C4",
  "settings.grade_count": "\uD638\uBD09 \uC218",
  "settings.no_grade_data": "\uD638\uBD09 \uB370\uC774\uD130\uAC00 \uC5C6\uC5B4\uC694",
  "settings.grade_number": "\uD638\uBD09",
  "settings.base_salary": "\uAE30\uBCF8\uAE09",
  "settings.hobong_amount": "\uD638\uBD09\uC561",
  "settings.annual_salary": "\uC5F0\uBD09",
  "settings.minimum_wage": "\uCD5C\uC800\uC2DC\uAE09",
  "settings.monthly_hours": "\uC6D4\uC18C\uC815\uC2DC\uAC04",
  "settings.grade_status_active": "\uD65C\uC131",
  "settings.grade_status_inactive": "\uBE44\uD65C\uC131",
  "settings.doc_template_desc": "\uC99D\uBA85\uC11C \uC591\uC2DD\uC744 \uAD00\uB9AC\uD574\uC694.",
  "settings.add_template": "\uC591\uC2DD \uCD94\uAC00",
  "settings.no_templates": "\uB4F1\uB85D\uB41C \uC591\uC2DD\uC774 \uC5C6\uC5B4\uC694",
  "settings.available_variables": "\uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uBCC0\uC218",
  "settings.cert_history_title": "\uC7AC\uC9C1\uC99D\uBA85\uC11C \uC2E0\uCCAD/\uBC1C\uAE09\uB0B4\uC5ED",
  "settings.all_employees": "\uC804\uCCB4 \uC9C1\uC6D0",
  "settings.no_history": "\uC2E0\uCCAD \uB0B4\uC5ED\uC774 \uC5C6\uC5B4\uC694",
  "settings.request_date": "\uC2E0\uCCAD\uC77C",
  "settings.purpose": "\uC6A9\uB3C4",
  "settings.cert_number": "\uC99D\uBA85\uC11C \uBC88\uD638",
  "settings.org_edit_title": "\uAE30\uBCF8 \uC815\uBCF4 \uC218\uC815",
  "settings.display_order": "\uD45C\uC2DC\uC21C\uC11C",
  "settings.default_attendance": "\uAE30\uBCF8 \uCD9C\uADFC \uAE30\uB85D \uBC29\uC2DD",
  "settings.basic_allowance": "\uAE30\uBCF8\uC218\uB2F9",
  "settings.manual_entry": "\uC218\uB3D9\uC785\uB825",
  "settings.overtime_allowance": "\uCD08\uACFC\uADFC\uBB34\uC218\uB2F9",
  "settings.fixed_incentive": "\uACE0\uC815 \uC778\uC13C\uD2F0\uBE0C",
  "settings.settlement_allowance": "\uC815\uC0B0\uC218\uB2F9",
  "settings.uncategorized": "\uBBF8\uBD84\uB958",
  "settings.notes": "\uBE44\uACE0",
  "attendance.attendance_records": "\uCD9C\uD1F4\uADFC \uAE30\uB85D",
  "attendance.date": "\uB0A0\uC9DC",
  "attendance.shift": "\uADFC\uBB34",
  "attendance.check_in": "\uCD9C\uADFC",
  "attendance.check_out": "\uD1F4\uADFC",
  "attendance.regular": "\uC815\uADDC",
  "attendance.overtime": "\uC5F0\uC7A5",
  "attendance.night": "\uC57C\uAC04",
  "attendance.weekend": "\uC8FC\uB9D0",
  "attendance.total_hours": "\uD569\uACC4",
  "attendance.period_total": "\uAE30\uAC04 \uD569\uACC4",
  "attendance.input_method": "\uC785\uB825\uBC29\uC2DD",
  "attendance.manual": "\uC218\uB3D9",
  "attendance.no_records": "\uC870\uD68C\uB41C \uCD9C\uD1F4\uADFC \uAE30\uB85D\uC774 \uC5C6\uC5B4\uC694",
  "attendance.secom_events": "Secom \uC9C0\uBB38 \uC774\uBCA4\uD2B8",
  "attendance.no_secom_events": "\uC870\uD68C\uB41C Secom \uC774\uBCA4\uD2B8\uAC00 \uC5C6\uC5B4\uC694",
  "attendance.event_datetime": "\uC774\uBCA4\uD2B8 \uC77C\uC2DC",
  "attendance.terminal": "\uB2E8\uB9D0\uAE30",
  "attendance.error_message": "\uC624\uB958 \uBA54\uC2DC\uC9C0",
  "attendance.shift_selector": "\uADFC\uBB34\uC2DC\uAC04",
  "attendance.org_default_shift": "\uC870\uC9C1 \uAE30\uBCF8 \uADFC\uBB34\uC2DC\uAC04 \uC0AC\uC6A9",
  "attendance.recalculate_all": "\uC804\uCCB4 \uAE30\uAC04 \uC7AC\uACC4\uC0B0",
  "attendance.recalculating": "\uC7AC\uACC4\uC0B0 \uC911...",
  "attendance.recalculate_all_hint": "\uC870\uD68C \uAE30\uAC04 \uC804\uCCB4\uC758 \uCD9C\uD1F4\uADFC \uAE30\uB85D\uC744 Secom \uC9C0\uBB38 \uC774\uBCA4\uD2B8 \uAE30\uC900\uC73C\uB85C \uB2E4\uC2DC \uACC4\uC0B0\uD574\uC694 (\uC790\uB3D9 \uC0DD\uC131\uBD84\uB9CC \uAC31\uC2E0, \uC218\uB3D9 \uC785\uB825\uC740 \uBCF4\uC874)",
  "attendance.recalculate_date_hint": "\uC774 \uB0A0\uC9DC\uC758 \uCD9C\uD1F4\uADFC \uAE30\uB85D\uB9CC Secom \uC9C0\uBB38 \uC774\uBCA4\uD2B8 \uAE30\uC900\uC73C\uB85C \uB2E4\uC2DC \uACC4\uC0B0\uD574\uC694 (\uC790\uB3D9 \uC0DD\uC131\uBD84\uB9CC \uAC31\uC2E0, \uC218\uB3D9 \uC785\uB825\uC740 \uBCF4\uC874)",
  "attendance.auto_infer": "\uC790\uB3D9 \uADFC\uBB34\uC2DC\uAC04 \uCD94\uB860 \uC0AC\uC6A9",
  "attendance.auto_infer_desc": "(3\uAD50\uB300 \uAC04\uD638\uC0AC\uC77C \uACBD\uC6B0 \uC774\uBCA4\uD2B8 \uC2DC\uAC01 \uAE30\uBC18\uC73C\uB85C \uC8FC\uAC04/\uC624\uD6C4/\uC57C\uAC04 \uC790\uB3D9 \uBD84\uB958)",
  "attendance.last_month": "\uC9C0\uB09C 1\uAC1C\uC6D4",
  "attendance.last_3_months": "\uC9C0\uB09C 3\uAC1C\uC6D4",
  "cert.cert_name": "\uC790\uACA9\uC99D\uBA85",
  "cert.license_number": "\uBA74\uD5C8\uBC88\uD638",
  "cert.issuing_authority": "\uBC1C\uAE09\uAE30\uAD00",
  "cert.issue_date": "\uBC1C\uAE09\uC77C",
  "cert.expiry_date": "\uB9CC\uB8CC\uC77C",
  "cert.file": "\uD30C\uC77C",
  "cert.view_file": "\uBCF4\uAE30",
  "cert.variable_insert": "\uBCC0\uC218 \uC0BD\uC785 (\uD074\uB9AD\uD558\uBA74 \uCEE4\uC11C \uC704\uCE58\uC5D0 \uC0BD\uC785)",
  "cert.body": "\uBCF8\uBB38",
  "cert.request_fields": "\uC2E0\uCCAD \uC2DC \uC785\uB825 \uD56D\uBAA9",
  "cert.request_fields_hint": "\uC9C1\uC6D0\uC774 \uC774 \uC591\uC2DD\uC744 \uC2E0\uCCAD\uD560 \uB54C \uC785\uB825\uD558\uB294 \uD56D\uBAA9\uC774\uC5D0\uC694. \uC785\uB825\uAC12\uC740 \uBCF8\uBB38\uC758 {{\uC6A9\uB3C4}} {{\uC81C\uCD9C\uCC98}} {{\uC8FC\uC18C}} {{\uC218\uB7C9}} {{\uBE44\uACE0}} \uC790\uB9AC\uC5D0 \uB4E4\uC5B4\uAC00\uC694. \uC6A9\uB3C4\uB294 \uD56D\uC0C1 \uD544\uC218\uC608\uC694.",
  "cert.field_item": "\uD56D\uBAA9",
  "cert.field_use": "\uC0AC\uC6A9",
  "cert.field_required": "\uD544\uC218",
  "cert.edit_return": "\uD3B8\uC9D1\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
  "cert.approve": "\uC2B9\uC778",
  "contract.contract_type": "\uACC4\uC57D\uC720\uD615",
  "contract.permanent": "\uC815\uADDC\uC9C1",
  "contract.temporary": "\uC784\uC2DC\uC9C1",
  "contract.contract": "\uACC4\uC57D\uC9C1",
  "contract.internship": "\uC778\uD134",
  "contract.part_time": "\uD30C\uD2B8\uD0C0\uC784",
  "contract.wage_type": "\uAE09\uC5EC\uD615\uD0DC",
  "contract.monthly": "\uC6D4\uAE09",
  "contract.hourly": "\uC2DC\uAE09",
  "contract.daily": "\uC77C\uAE09",
  "contract.annual": "\uC5F0\uBD09",
  "contract.base_salary": "\uAE30\uBCF8\uAE09 (\uC6D0)",
  "contract.hobong": "\uD638\uBD09 (\uC6D0)",
  "contract.longevity": "\uADFC\uC18D\uC218\uB2F9 (\uC6D0)",
  "contract.meal_allowance": "\uC2DD\uB300 (\uC6D0)",
  "contract.transport": "\uAD50\uD1B5\uBE44 (\uC6D0)",
  "contract.position_allowance": "\uC9C1\uCC45\uC218\uB2F9 (\uC6D0)",
  "contract.standard_weekly_hours": "\uC8FC\uB2F9 \uAE30\uBCF8\uADFC\uBB34\uC2DC\uAC04",
  "contract.max_weekly_hours": "\uC8FC\uB2F9 \uCD5C\uB300\uADFC\uBB34\uC2DC\uAC04",
  "contract.probation_section": "\uC218\uC2B5 \uC885\uB8CC \uD6C4",
  "contract.probation_end_date": "\uC218\uC2B5 \uC885\uB8CC\uC77C",
  "contract.probation_after_base_salary": "\uC218\uC2B5 \uD6C4 \uAE30\uBCF8\uAE09",
  "contract.probation_after_hourly_rate": "\uC218\uC2B5 \uD6C4 \uD1B5\uC0C1\uC2DC\uAE09",
  "contract.probation_hint": "\uC885\uB8CC\uC77C \uB2E4\uC74C \uB0A0\uBD80\uD130 \uC801\uC6A9\uB418\uB294 \uC0C8 \uACC4\uC57D\uC744 \uC608\uC57D\uD574\uC694. \uC218\uC2B5 \uAE30\uAC04\uC758 \uC2DC\uD2B8\uB294 \uC704 \uACC4\uC57D \uAC12\uC73C\uB85C, \uADF8 \uB4A4\uB294 \uC5EC\uAE30 \uAC12\uC73C\uB85C \uACC4\uC0B0\uB3FC\uC694. \uBE44\uC6B0\uBA74 \uC608\uC57D\uD558\uC9C0 \uC54A\uC544\uC694.",
  "contract.probation_invalid": "\uC218\uC2B5 \uC885\uB8CC\uC77C\uC740 \uC785\uC0AC\uC77C \uC774\uD6C4\uC5EC\uC57C \uD558\uACE0, \uC218\uC2B5 \uD6C4 \uAE30\uBCF8\uAE09\uC774\uB098 \uD1B5\uC0C1\uC2DC\uAE09 \uC911 \uD558\uB098\uB294 \uC785\uB825\uD574\uC57C \uD574\uC694.",
  "contract.probation_review": "{date} \uAE4C\uC9C0 \uC218\uC2B5 \xB7 \uB2E4\uC74C \uB0A0\uBD80\uD130 {values}",
  "common.action": "\uAD00\uB9AC",
  "common.manage": "\uAD00\uB9AC",
  "common.register": "\uB4F1\uB85D",
  "common.registering": "\uB4F1\uB85D \uC911...",
  "common.view_mode": "\uD45C",
  "common.tree_mode": "\uD2B8\uB9AC",
  "common.edit_btn": "\uD3B8\uC9D1",
  "common.previous": "\uC774\uC804",
  "dept_type.medical": "\uC9C4\uB8CC",
  "dept_type.nursing": "\uAC04\uD638",
  "dept_type.support": "\uC9C4\uB8CC\uC9C0\uC6D0",
  "dept_type.management": "\uACBD\uC601",
  "dept_type.hr": "\uC778\uC0AC",
  "dept_type.finance": "\uC7AC\uBB34",
  "dept_type.operations": "\uC6B4\uC601",
  "dept_type.other": "\uAE30\uD0C0",
  "dept_type.restructuring": "\uAD6C\uC870\uC870\uC815",
  "admin.amount_integer_only": "\uAE08\uC561\uC740 \uC18C\uC218\uC810 \uC5C6\uC774 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "admin.att_status_absent": "\uACB0\uADFC",
  "admin.att_status_checked_in": "\uCD9C\uADFC",
  "admin.att_status_checked_out": "\uC644\uB8CC",
  "admin.att_status_early_leave": "\uC870\uD1F4",
  "admin.att_status_holiday": "\uACF5\uD734\uC77C",
  "admin.att_status_late": "\uC9C0\uAC01",
  "admin.att_status_leave": "\uD734\uAC00",
  "admin.att_status_scheduled": "\uC608\uC815",
  "admin.att_status_sick_leave": "\uBCD1\uAC00",
  "admin.attendance_query_failed": "\uC870\uD68C \uC2E4\uD328",
  "admin.attendance_update_failed": "\uADFC\uD0DC \uC218\uC815 \uC2E4\uD328",
  "admin.attendance_warning_title": "\uADFC\uBB34 \uC2E0\uCCAD\uB0B4\uC5ED \uD655\uC778 \uD544\uC694",
  "admin.attendance_warning_footer": "\uD574\uB2F9 \uC2DC\uAC04\uC5D0 \uB300\uD55C \uC2B9\uC778\uB41C \uC5F0\uC7A5/\uC57C\uAC04/\uC8FC\uB9D0\uADFC\uBB34 \uC2E0\uCCAD\uB0B4\uC5ED\uC774 \uC5C6\uC5B4\uC694. \uC2E0\uCCAD\uC774 \uD544\uC694\uD558\uBA74 \uB0B4\uBD80 \uACB0\uC7AC \uC571\uC5D0\uC11C \uCC98\uB9AC\uD558\uAC70\uB098, \uC218\uB3D9\uC73C\uB85C \uADFC\uD0DC \uAE30\uB85D\uC744 \uC218\uC815\uD558\uC138\uC694.",
  "admin.cert_suffix_cert": "\uC790\uACA9\uC99D",
  "admin.cert_suffix_license": "\uBA74\uD5C8\uC99D",
  "admin.cert_approve_confirm": "\uC774 \uC7AC\uC9C1\uC99D\uBA85\uC11C\uB97C \uC2B9\uC778\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.cert_approve_failed": "\uC2B9\uC778 \uC2E4\uD328",
  "admin.cert_reject_failed": "\uBC18\uB824 \uC2E4\uD328",
  "admin.cert_reject_reason": "\uBC18\uB824 \uC0AC\uC720\uB97C \uC785\uB825\uD558\uC138\uC694:",
  "admin.cert_template_create_failed": "\uAE30\uBCF8 \uC591\uC2DD \uC0DD\uC131\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.",
  "admin.bulk_role_note": "(\uBAA8\uB4E0 \uD65C\uC131 \uD300 \uBA64\uBC84\uC2ED\uC758 {@role|\uC774/\uAC00} \uBCC0\uACBD\uB3FC\uC694)",
  "admin.confirm_bulk_apply": "\uC120\uD0DD\uD55C {n}\uBA85\uC5D0 \uB2E4\uC74C \uBCC0\uACBD\uC744 \uC801\uC6A9\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?\n\n{changes}",
  "admin.confirm_delete_cert": "\uC774 \uC790\uACA9\uC99D\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_delete_doc_template": "\uC774 \uC591\uC2DD\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_delete_grade": "\uC774 \uD638\uBD09\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_delete_item_code": "\uC774 \uD56D\uBAA9\uCF54\uB4DC\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_delete_role": "\uC774 {@role|\uC744/\uB97C} \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_delete_rule": "\uC774 \uADDC\uCE59\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_delete_shift": "\uC774 \uADFC\uBB34 \uC124\uC815\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_delete_team": '"{name}"\uD300\uC744 \uC0AD\uC81C\uD558\uACA0\uC2B5\uB2C8\uAE4C?',
  "admin.confirm_password_reset": "\uBE44\uBC00\uBC88\uD638\uB97C \uCD08\uAE30\uD654\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?\n\uC784\uC2DC \uBE44\uBC00\uBC88\uD638\uAC00 \uC0DD\uC131\uB418\uC5B4 SMS\uB85C \uBC1C\uC1A1\uB3FC\uC694.",
  "admin.confirm_password_set": "\uBE44\uBC00\uBC88\uD638\uB97C \uC9C1\uC811 \uC124\uC815\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_recalculate": "Secom \uC774\uBCA4\uD2B8\uB85C\uBD80\uD130 \uCD9C\uD1F4\uADFC \uAE30\uB85D\uC744 \uC7AC\uACC4\uC0B0\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?\n(\uC218\uB3D9 \uC785\uB825 \uAE30\uB85D\uC740 \uC720\uC9C0\uB418\uACE0, \uC790\uB3D9 \uC0DD\uC131\uB41C \uAE30\uB85D\uB9CC \uC0AD\uC81C \uD6C4 \uC7AC\uC0DD\uC131\uB3FC\uC694)",
  "admin.confirm_recalculate_date": "{date} \uCD9C\uD1F4\uADFC \uAE30\uB85D\uC744 \uC7AC\uACC4\uC0B0\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_recalculate_shift": "\uADFC\uBB34\uC2DC\uAC04\uC744 \uBCC0\uACBD\uD558\uACE0 Secom \uC774\uBCA4\uD2B8\uB85C\uBD80\uD130 \uCD9C\uD1F4\uADFC \uAE30\uB85D\uC744 \uC7AC\uACC4\uC0B0\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?\n(\uC218\uB3D9 \uC785\uB825 \uAE30\uB85D\uC740 \uC720\uC9C0\uB418\uACE0, \uC790\uB3D9 \uC0DD\uC131\uB41C \uAE30\uB85D\uB9CC \uC0AD\uC81C \uD6C4 \uC7AC\uC0DD\uC131\uB3FC\uC694)",
  "admin.confirm_remove_member": "\uC774 \uBA64\uBC84\uB97C \uD300\uC5D0\uC11C \uC81C\uAC70\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_remove_team": '"{team}" \uD300\uC5D0\uC11C \uC81C\uAC70\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
  "admin.confirm_return_from_leave": "{name} \uB2D8\uC744 \uBCF5\uC9C1 \uCC98\uB9AC\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "admin.confirm_role_change": '"{emp}"\uC758 {@role|\uC744/\uB97C} "{role}"(\uC73C)\uB85C \uBCC0\uACBD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
  "admin.confirm_role_remove": '"{emp}"\uC758 "{role}" {@role|\uC744/\uB97C} \uD574\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
  "admin.confirm_team_add": '"{emp}"\uC744(\uB97C) "{team}" \uD300\uC5D0 \uCD94\uAC00\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
  "admin.confirm_team_exclude": '"{emp}"\uC744(\uB97C) "{team}" \uD300\uC5D0\uC11C \uC81C\uC678\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
  "admin.create_failed": "\uB4F1\uB85D \uC2E4\uD328",
  "admin.delete_failed": "\uC0AD\uC81C \uC2E4\uD328",
  "admin.download_failed": "\uB2E4\uC6B4\uB85C\uB4DC \uC2E4\uD328",
  "admin.file_load_failed": "\uD30C\uC77C\uC744 \uBD88\uB7EC\uC62C \uC218 \uC5C6\uC5B4\uC694",
  "admin.file_size_500kb": "\uD30C\uC77C \uD06C\uAE30\uB294 500KB \uC774\uD558\uC5EC\uC57C \uD574\uC694.",
  "admin.image_only": "\uC774\uBBF8\uC9C0 \uD30C\uC77C\uB9CC \uC5C5\uB85C\uB4DC \uAC00\uB2A5\uD574\uC694.",
  "admin.leave_process_failed": "\uD734\uC9C1 \uCC98\uB9AC \uC2E4\uD328",
  "admin.leave_processed": "{name} \uB2D8\uC758 \uD734\uC9C1\uC774 \uCC98\uB9AC\uB418\uC5C8\uC5B4\uC694.",
  "admin.leave_rule_template_confirm": "\uADFC\uB85C\uAE30\uC900\uBC95 \uAE30\uBCF8 \uC5F0\uCC28\uADDC\uCE59\uC744 \uB4F1\uB85D\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C? (\uAE30\uC874 \uADDC\uCE59\uC740 \uC720\uC9C0\uB3FC\uC694)",
  "admin.member_add_failed": "\uBA64\uBC84 \uCD94\uAC00 \uC2E4\uD328",
  "admin.password_changed": "\uBE44\uBC00\uBC88\uD638\uAC00 \uBCC0\uACBD\uB418\uC5C8\uC5B4\uC694.",
  "admin.password_change_failed": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD \uC2E4\uD328",
  "admin.password_mismatch": "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC544\uC694.",
  "admin.password_reset_done": "\uBE44\uBC00\uBC88\uD638\uAC00 \uCD08\uAE30\uD654\uB418\uC5C8\uC5B4\uC694.",
  "admin.password_reset_failed": "\uBE44\uBC00\uBC88\uD638 \uCD08\uAE30\uD654 \uC2E4\uD328",
  "admin.permission_change_failed": "\uAD8C\uD55C \uBCC0\uACBD \uC2E4\uD328",
  "admin.preview_failed": "\uBBF8\uB9AC\uBCF4\uAE30 \uC2E4\uD328",
  "admin.recalculate_done": "\uC7AC\uACC4\uC0B0 \uC644\uB8CC",
  "admin.recalculate_failed": "\uC7AC\uACC4\uC0B0 \uC2E4\uD328",
  "admin.required_fields_missing": "\uD544\uC218 \uD56D\uBAA9\uC744 \uBAA8\uB450 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "admin.return_failed": "\uBCF5\uC9C1 \uCC98\uB9AC \uC2E4\uD328",
  "admin.return_processed": "\uBCF5\uC9C1 \uCC98\uB9AC\uB418\uC5C8\uC5B4\uC694.",
  "employee.reinstate_process": "\uD1F4\uC9C1 \uCDE8\uC18C(\uC7AC\uC9C1 \uBCF5\uADC0)",
  "employee.reinstate_hint": "\uD1F4\uC9C1 \uCC98\uB9AC\uB41C \uC9C1\uC6D0\uC774\uC5D0\uC694. \uC2E4\uC218\uB77C\uBA74 \u300C\uD1F4\uC9C1 \uCDE8\uC18C\u300D\uB85C \uC7AC\uC9C1\uC73C\uB85C \uB418\uB3CC\uB9B4 \uC218 \uC788\uC5B4\uC694.",
  "employee.reinstate_go": "\uD1F4\uC9C1 \uCDE8\uC18C\uD558\uB7EC \uAC00\uAE30",
  "employee.reinstate_notice": "\uD1F4\uC9C1 \uCDE8\uC18C\uD558\uBA74 \uD1F4\uC0AC \uAE30\uB85D\uC774 \uBB34\uD6A8 \uCC98\uB9AC\uB418\uACE0(\uC815\uC0B0 \uC774\uB825\uC740 \uBCF4\uC874) \uC0C1\uD0DC\uAC00 \uC7AC\uC9C1\uC73C\uB85C \uB3CC\uC544\uC624\uBA70, \uD300 \uB2E8\uD1A1\uBC29\uC5D0\uB3C4 \uB2E4\uC2DC \uB4E4\uC5B4\uAC00\uC694. \uD300\uC7A5 \uC9C0\uC815\uC740 \uC790\uB3D9\uC73C\uB85C \uB418\uC0B4\uC544\uB098\uC9C0 \uC54A\uC73C\uB2C8 \uD300 \uAD00\uB9AC\uC5D0\uC11C \uB2E4\uC2DC \uC9C0\uC815\uD558\uACE0, \uC9C1\uC6D0\uC740 \uC571\uC5D0 \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574\uC57C \uD574\uC694.",
  "employee.reinstate_reason": "\uCDE8\uC18C \uC0AC\uC720",
  "employee.reinstate_reason_placeholder": "\uC608: \uD1F4\uC9C1 \uCC98\uB9AC\uB97C \uC798\uBABB \uB20C\uB800\uC5B4\uC694",
  "employee.reinstate_reason_required": "\uD1F4\uC9C1 \uCDE8\uC18C \uC0AC\uC720\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
  "admin.reinstate_processed": "{name} \uB2D8\uC758 \uD1F4\uC9C1\uC744 \uCDE8\uC18C\uD588\uC5B4\uC694. \uC0C1\uD0DC\uAC00 \uC7AC\uC9C1\uC73C\uB85C \uB3CC\uC544\uC654\uC5B4\uC694.",
  "admin.reinstate_failed": "\uD1F4\uC9C1 \uCDE8\uC18C \uC2E4\uD328",
  "admin.role_change_failed": "{@role} \uBCC0\uACBD \uC2E4\uD328",
  "admin.duplicate_grade": "\uB3D9\uC77C\uD55C \uD638\uBD09\uC774 \uC774\uBBF8 \uC874\uC7AC\uD574\uC694. (\uC9C1\uC885, \uD638\uBD09, \uC801\uC6A9\uB144\uB3C4\uAC00 \uAC19\uC740 \uD56D\uBAA9\uC740 \uCD94\uAC00\uD560 \uC218 \uC5C6\uC5B4\uC694.)",
  "admin.role_code_duplicate": "\uC774\uBBF8 \uC0AC\uC6A9 \uC911\uC778 {@role} \uCF54\uB4DC\uC785\uB2C8\uB2E4. \uB2E4\uB978 \uCF54\uB4DC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "admin.role_code_name_required": "{@role} \uCF54\uB4DC\uC640 {@role}\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "admin.role_code_required": "{@role} \uCF54\uB4DC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "admin.role_name_required": "{@role}\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "admin.role_remove_failed": "{@role} \uD574\uC81C \uC2E4\uD328",
  "admin.role_type_custom": "\uC0AC\uC6A9\uC790\uC815\uC758",
  "admin.role_type_system": "\uC2DC\uC2A4\uD15C",
  "admin.role_type_team": "\uD300",
  "admin.save_failed": "\uC800\uC7A5 \uC2E4\uD328",
  "admin.status_change_failed": "\uC0C1\uD0DC \uBCC0\uACBD \uC2E4\uD328",
  "admin.secom_check_in": "\uCD9C\uADFC",
  "admin.secom_check_out": "\uD1F4\uADFC",
  "admin.secom_error": "\uC624\uB958",
  "admin.secom_ignored": "\uBB34\uC2DC",
  "admin.secom_pending": "\uB300\uAE30",
  "admin.secom_processed": "\uCC98\uB9AC\uC644\uB8CC",
  "admin.secom_unknown": "\uBBF8\uBD84\uB958",
  "admin.sms_send_preview": "SMS \uBC1C\uC1A1 (\uC900\uBE44 \uC911)",
  "admin.sms_sending": "SMS \uBC1C\uC1A1 \uC911...",
  "admin.tab_employees": "\uC9C1\uC6D0 \uAD00\uB9AC",
  "admin.tab_esign": "\uC804\uC790 \uC11C\uBA85",
  "admin.tab_leaves": "\uC5F0\uCC28\uAD00\uB9AC",
  "admin.tab_roles": "{@role} \uAD00\uB9AC",
  "admin.tab_settings": "\uC124\uC815",
  "admin.tab_teams": "\uD300\uAD00\uB9AC",
  "admin.tab_wards": "\uBCD1\uB3D9 \uAD00\uB9AC",
  "admin.team_add_failed": "\uD300 \uCD94\uAC00 \uC2E4\uD328",
  "admin.team_code_required": "\uD300 \uCF54\uB4DC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "admin.team_dept_required": "\uD300 \uC0DD\uC131\uC744 \uC704\uD574 \uC18C\uC18D \uBD80\uC11C\uB97C \uBA3C\uC800 \uC120\uD0DD\uD574\uC57C \uD574\uC694.",
  "admin.team_exclude_failed": "\uD300 \uC81C\uC678 \uC2E4\uD328",
  "admin.team_name_required": "\uD300\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "admin.team_remove_failed": "\uD300 \uC81C\uAC70 \uC2E4\uD328",
  "admin.temp_password_manual_msg": "SMS \uBC1C\uC1A1 \uC2E4\uD328. \uC784\uC2DC \uBE44\uBC00\uBC88\uD638: {pw}\n\uC9C1\uC811 \uC804\uB2EC\uD574\uC8FC\uC138\uC694.",
  "admin.temp_password_sent": "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638\uAC00 SMS\uB85C \uBC1C\uC1A1\uB418\uC5C8\uC5B4\uC694.",
  "admin.termination_failed": "\uD1F4\uC9C1 \uCC98\uB9AC \uC2E4\uD328",
  "admin.termination_processed": "{name} \uB2D8\uC758 \uD1F4\uC9C1\uC774 \uCC98\uB9AC\uB418\uC5C8\uC5B4\uC694.",
  "admin.cert_type_care_worker": "\uC694\uC591\uBCF4\uD638\uC0AC",
  "admin.cert_type_clinical_lab": "\uC784\uC0C1\uBCD1\uB9AC\uC0AC",
  "admin.cert_type_dentist": "\uCE58\uACFC\uC758\uC0AC",
  "admin.cert_type_dietitian": "\uC601\uC591\uC0AC",
  "admin.cert_type_emergency_medical": "\uC751\uAE09\uAD6C\uC870\uC0AC",
  "admin.cert_type_medical_doctor": "\uC758\uC0AC",
  "admin.cert_type_nurse_aide": "\uAC04\uD638\uC870\uBB34\uC0AC",
  "admin.cert_type_nursing": "\uAC04\uD638\uC0AC",
  "admin.cert_type_occupational_therapist": "\uC791\uC5C5\uCE58\uB8CC\uC0AC",
  "admin.cert_type_other": "\uAE30\uD0C0",
  "admin.cert_type_pharmacist": "\uC57D\uC0AC",
  "admin.cert_type_physical_therapist": "\uBB3C\uB9AC\uCE58\uB8CC\uC0AC",
  "admin.cert_type_radiologist": "\uBC29\uC0AC\uC120\uC0AC",
  "admin.cert_type_social_worker": "\uC0AC\uD68C\uBCF5\uC9C0\uC0AC",
  "admin.cert_type_speech_therapist": "\uC5B8\uC5B4\uCE58\uB8CC\uC0AC",
  "admin.day_fri": "\uAE08",
  "admin.day_mon": "\uC6D4",
  "admin.day_sat": "\uD1A0",
  "admin.day_sun": "\uC77C",
  "admin.day_thu": "\uBAA9",
  "admin.day_tue": "\uD654",
  "admin.day_wed": "\uC218",
  "admin.dept_status_active": "\uD65C\uC131",
  "admin.dept_status_inactive": "\uBE44\uD65C\uC131",
  "admin.dept_status_restructuring": "\uAD6C\uC870\uC870\uC815",
  "admin.dept_type_customer_service": "\uACE0\uAC1D\uC11C\uBE44\uC2A4",
  "admin.dept_type_engineering": "\uAE30\uC220",
  "admin.dept_type_it": "IT",
  "admin.dept_type_marketing": "\uB9C8\uCF00\uD305",
  "admin.dept_type_r_and_d": "R&D",
  "admin.dept_type_sales": "\uC601\uC5C5",
  "admin.grade_cat_functional": "\uAE30\uB2A5",
  "admin.grade_cat_nursing": "\uAC04\uD638",
  "admin.grade_cat_rehabilitation": "\uC7AC\uD65C",
  "admin.shift_tpl_normal": "\uC77C\uBC18\uADFC\uBB34 (09-18)",
  "admin.shift_tpl_three_day": "3\uAD50\uB300 \uC8FC\uAC04 (07-15)",
  "admin.shift_tpl_three_evening": "3\uAD50\uB300 \uC624\uD6C4 (15-23)",
  "admin.shift_tpl_three_night": "3\uAD50\uB300 \uC57C\uAC04 (23-07)",
  "admin.shift_type_day": "\uC8FC\uAC04",
  "admin.shift_type_evening": "\uC624\uD6C4",
  "admin.shift_type_flexible": "\uC720\uC5F0\uADFC\uBB34",
  "admin.shift_type_holiday": "\uACF5\uD734\uC77C",
  "admin.shift_type_night": "\uC57C\uAC04",
  "admin.shift_type_on_call": "\uB2F9\uC9C1",
  "admin.shift_type_off": "\uD734\uBB34",
  "admin.shift_type_weekend_day": "\uC8FC\uB9D0(\uC8FC\uAC04)",
  "admin.shift_type_weekend_night": "\uC8FC\uB9D0(\uC57C\uAC04)",
  "admin.status_active": "\uC7AC\uC9C1",
  "admin.status_inactive": "\uBE44\uD65C\uC131",
  "admin.status_on_leave": "\uD734\uC9C1",
  "admin.status_terminated": "\uD1F4\uC9C1",
  "team_mgr.approve_failed": "\uC2B9\uC778 \uC2E4\uD328",
  "team_mgr.config_failed": "\uC124\uC815 \uC2E4\uD328",
  "team_mgr.confirm_delete_shift": "\uC774 \uADFC\uBB34 \uC124\uC815\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "team_mgr.confirm_delete_training": "\uC774 \uAD50\uC721\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "team_mgr.confirm_delete_task": "\uC774 \uC5C5\uBB34\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "team_mgr.confirm_delete_notice": "\uACF5\uC9C0\uB97C \uC0AD\uC81C\uD560\uAE4C\uC694?",
  "team_mgr.create_failed": "\uC0DD\uC131 \uC2E4\uD328",
  "team_mgr.delete_failed": "\uC0AD\uC81C \uC2E4\uD328",
  "team_mgr.incentive_config_load_failed": "\uC778\uC13C\uD2F0\uBE0C \uC124\uC815 \uB85C\uB529 \uC2E4\uD328",
  "team_mgr.publish_failed": "\uAC8C\uC2DC \uC2E4\uD328",
  "team_mgr.register_failed": "\uB4F1\uB85D \uC2E4\uD328",
  "team_mgr.reject_failed": "\uBC18\uB824 \uC2E4\uD328",
  "team_mgr.save_failed": "\uC800\uC7A5 \uC2E4\uD328",
  "team_mgr.treatment_registered": "\uCE58\uB8CC \uC778\uC13C\uD2F0\uBE0C\uAC00 \uB4F1\uB85D\uB418\uC5C8\uC5B4\uC694.",
  "team_mgr.unknown_error": "\uC54C \uC218 \uC5C6\uB294 \uC624\uB958",
  "team_mgr.update_failed": "\uC5C5\uB370\uC774\uD2B8 \uC2E4\uD328",
  "team_mgr.leave_type_annual": "\uC5F0\uCC28",
  "team_mgr.leave_type_sick": "\uBCD1\uAC00",
  "team_mgr.leave_type_personal": "\uAC1C\uC778\uC0AC\uC720",
  "team_mgr.leave_type_maternity": "\uCD9C\uC0B0\uD734\uAC00",
  "team_mgr.leave_type_paternity": "\uBC30\uC6B0\uC790\uCD9C\uC0B0\uD734\uAC00",
  "team_mgr.leave_type_bereavement": "\uACBD\uC870\uD734\uAC00",
  "team_mgr.leave_type_military": "\uBCD1\uC5ED",
  "team_mgr.status_pending": "\uB300\uAE30",
  "team_mgr.status_approved": "\uC2B9\uC778",
  "team_mgr.status_rejected": "\uBC18\uB824",
  "team_mgr.status_cancelled": "\uCDE8\uC18C",
  "team_mgr.status_paid": "\uC9C0\uAE09\uC644\uB8CC",
  "team_mgr.category_weekday": "\uD3C9\uC77C",
  "team_mgr.category_saturday": "\uD1A0\uC694\uC77C",
  "team_mgr.category_holiday": "\uACF5\uD734\uC77C",
  "team_mgr.category_night": "\uC57C\uAC04",
  "team_mgr.shift_type_day": "\uC8FC\uAC04",
  "team_mgr.shift_type_night": "\uC57C\uAC04",
  "team_mgr.shift_type_evening": "\uC624\uD6C4",
  "team_mgr.shift_type_weekend_day": "\uC8FC\uB9D0(\uC8FC\uAC04)",
  "team_mgr.shift_type_weekend_night": "\uC8FC\uB9D0(\uC57C\uAC04)",
  "team_mgr.shift_type_holiday": "\uACF5\uD734\uC77C",
  "team_mgr.shift_type_flexible": "\uC720\uC5F0\uADFC\uBB34",
  "team_mgr.day_mon": "\uC6D4",
  "team_mgr.day_tue": "\uD654",
  "team_mgr.day_wed": "\uC218",
  "team_mgr.day_thu": "\uBAA9",
  "team_mgr.day_fri": "\uAE08",
  "team_mgr.day_sat": "\uD1A0",
  "team_mgr.day_sun": "\uC77C",
  "team_mgr.incentive_type_referral": "\uC758\uB8B0",
  "team_mgr.incentive_type_inpatient_maintenance": "\uC785\uC6D0\uC720\uC9C0",
  "team_mgr.incentive_type_shockwave": "\uCDA9\uACA9\uD30C",
  "team_mgr.doc_category_medical": "\uC758\uB8CC",
  "team_mgr.doc_category_certification": "\uC790\uACA9\uC99D",
  "team_mgr.doc_category_overtime": "\uC5F0\uC7A5\uADFC\uBB34",
  "team_mgr.doc_category_contract": "\uACC4\uC57D",
  "general_affairs.training_cat_legal_mandatory": "\uBC95\uC815\uC758\uBB34\uAD50\uC721",
  "general_affairs.training_cat_accreditation": "\uC778\uC99D\uD544\uC218\uAD50\uC721",
  "general_affairs.training_cat_specialized": "\uC804\uBB38\uAD50\uC721",
  "general_affairs.freq_monthly": "\uB9E4\uC6D4",
  "general_affairs.freq_quarterly": "\uBD84\uAE30",
  "general_affairs.freq_semi_annual": "\uBC18\uAE30",
  "general_affairs.freq_annual": "\uC5F0\uAC04",
  "general_affairs.freq_biennial": "2\uB144",
  "general_affairs.freq_triennial": "3\uB144",
  "general_affairs.completion_completed": "\uC774\uC218\uC644\uB8CC",
  "general_affairs.completion_expired": "\uB9CC\uB8CC",
  "general_affairs.completion_upcoming": "\uC608\uC815",
  "general_affairs.task_cat_facility": "\uC2DC\uC124\uAD00\uB9AC",
  "general_affairs.task_cat_safety": "\uC548\uC804\uC810\uAC80",
  "general_affairs.task_cat_fire": "\uC18C\uBC29",
  "general_affairs.task_cat_hygiene": "\uC704\uC0DD",
  "general_affairs.task_cat_equipment": "\uC7A5\uBE44",
  "general_affairs.task_cat_document": "\uBB38\uC11C",
  "general_affairs.task_cat_compliance": "\uADDC\uC815\uC900\uC218",
  "general_affairs.task_freq_daily": "\uB9E4\uC77C",
  "general_affairs.task_freq_weekly": "\uB9E4\uC8FC",
  "general_affairs.exec_status_pending": "\uB300\uAE30",
  "general_affairs.exec_status_in_progress": "\uC9C4\uD589\uC911",
  "general_affairs.exec_status_completed": "\uC644\uB8CC",
  "general_affairs.exec_status_overdue": "\uC9C0\uC5F0",
  "general_affairs.exec_status_skipped": "\uAC74\uB108\uB700",
  "general_affairs.notice_cat_training_deadline": "\uAD50\uC721\uB9C8\uAC10",
  "general_affairs.notice_cat_facility": "\uC2DC\uC124",
  "general_affairs.notice_cat_safety": "\uC548\uC804",
  "general_affairs.notice_cat_policy": "\uC815\uCC45",
  "general_affairs.notice_cat_general": "\uC77C\uBC18",
  "general_affairs.priority_low": "\uCC38\uACE0",
  "general_affairs.priority_normal": "\uC77C\uBC18",
  "general_affairs.priority_high": "\uC911\uC694",
  "general_affairs.priority_urgent": "\uAE34\uAE09",
  "nurse.schedule_status_draft": "\uCD08\uC548",
  "nurse.schedule_status_generating": "AI \uC0DD\uC131 \uC911",
  "nurse.schedule_status_ai_generated": "AI \uC0DD\uC131",
  "nurse.schedule_status_editing": "\uC218\uC815 \uC911",
  "nurse.schedule_status_confirmed": "\uD655\uC815",
  "nurse.schedule_status_published": "\uACF5\uC720\uB428",
  "nurse.assignment_annual_leave": "\uC5F0\uCC28",
  "nurse.assignment_bereavement": "\uACBD\uC870",
  "nurse.assignment_education": "\uAD50\uC721",
  "nurse.assignment_unavailable": "\uBD88\uAC00",
  "nurse.confirm_cycle_change": "\uADFC\uBB34\uD45C \uC8FC\uAE30 \uC2DC\uC791\uC77C\uC744 \uBCC0\uACBD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?\n\n\uC774 \uC124\uC815\uC740 \uC0C8\uB85C \uC0DD\uC131\uB418\uB294 \uADFC\uBB34\uD45C\uC5D0\uB9CC \uC801\uC6A9\uB418\uBA70, \uAE30\uC874\uC5D0 \uC0DD\uC131\uB41C \uADFC\uBB34\uD45C\uC758 \uAE30\uAC04\uC740 \uBCC0\uACBD\uB418\uC9C0 \uC54A\uC544\uC694.",
  "nurse.grade_label": "\uB4F1\uAE09",
  "nurse.tab_schedule": "\uADFC\uBB34\uD45C",
  "nurse.tab_profiles": "\uC778\uB825",
  "nurse.tab_preferences": "\uB0B4 \uD76C\uB9DD \uC77C\uC815",
  "dashboard.category_rehabilitation": "\uC7AC\uD65C\uCE58\uB8CC",
  "dashboard.category_nursing": "\uAC04\uD638",
  "dashboard.category_sports_medicine": "\uC2A4\uD3EC\uCE20\uC758\uD559",
  "dashboard.category_home_visit": "\uBC29\uBB38\uC7AC\uD65C",
  "dashboard.category_assessment": "\uD3C9\uAC00",
  "dashboard.category_on_call": "\uB2F9\uC9C1",
  "dashboard.data_load_failed": "\uB370\uC774\uD130 \uB85C\uB529 \uC2E4\uD328",
  "dashboard.unit_eok": "\uC5B5",
  "dashboard.unit_man": "\uB9CC",
  "inventory.confirm_delete": "\uC815\uB9D0 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "inventory.expired": "\uB9CC\uB8CC\uB428",
  "inventory.quantity_change_failed": "\uC218\uB7C9 \uBCC0\uACBD \uC2E4\uD328",
  "inventory.refund_clear_failed": "\uD574\uC81C \uC2E4\uD328",
  "shift_tracker.attendance_error": "\uCC98\uB9AC \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "shift_tracker.break_reminder": "\uC2DC\uAC04 \uC5F0\uC18D \uADFC\uBB34 \uC911 \u2014 \uD734\uC2DD\uC774 \uD544\uC694\uD574\uC694",
  "shift_tracker.field_work_date_required": "\uB0A0\uC9DC, \uC2DC\uC791 \uC2DC\uAC04, \uC885\uB8CC \uC2DC\uAC04\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "shift_tracker.field_work_error": "\uC678\uADFC \uB4F1\uB85D \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "shift_tracker.field_work_location_required": "\uC678\uADFC \uC7A5\uC18C\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "shift_tracker.field_work_registered": "\uC678\uADFC\uC774 \uB4F1\uB85D\uB418\uC5C8\uC5B4\uC694",
  "shift_tracker.risk_critical": "\uC704\uD5D8",
  "shift_tracker.risk_safe": "\uC548\uC804",
  "shift_tracker.risk_warning": "\uC8FC\uC758",
  "shift_tracker.shift_type_day": "\uC8FC\uAC04",
  "shift_tracker.shift_type_night": "\uC57C\uAC04",
  "shift_tracker.shift_type_weekend": "\uC8FC\uB9D0",
  "shift_tracker.status_absent": "\uACB0\uADFC",
  "shift_tracker.status_completed": "\uC644\uB8CC",
  "shift_tracker.status_early_leave": "\uC870\uD1F4",
  "shift_tracker.status_holiday": "\uD734\uC77C",
  "shift_tracker.status_late": "\uC9C0\uAC01",
  "shift_tracker.status_on_leave": "\uD734\uAC00",
  "shift_tracker.status_present": "\uCD9C\uADFC",
  "shift_tracker.status_weekend": "\uC8FC\uB9D0",
  "shift_tracker.week_current": "\uC774\uBC88 \uC8FC",
  "shift_tracker.week_last": "\uC9C0\uB09C \uC8FC",
  "shift_tracker.week_next": "\uB2E4\uC74C \uC8FC",
  "shift_tracker.weeks_ago": "\uC8FC \uC804",
  "shift_tracker.weeks_later": "\uC8FC \uD6C4",
  "incentive.category_assessment": "\uD3C9\uAC00",
  "incentive.category_home_visit": "\uAC00\uC815\uBC29\uBB38",
  "incentive.category_nursing": "\uAC04\uD638",
  "incentive.category_on_call": "\uB2F9\uC9C1",
  "incentive.category_rehabilitation": "\uC7AC\uD65C\uCE58\uB8CC",
  "incentive.category_sports_medicine": "\uC2A4\uD3EC\uCE20\uC758\uD559",
  "incentive.confirm_delete": "\uC774 \uC778\uC13C\uD2F0\uBE0C \uAE30\uB85D\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "incentive.delete_error": "\uC0AD\uC81C \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "incentive.enter_count": "\uAC74\uC218\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "incentive.registered": "\uC778\uC13C\uD2F0\uBE0C\uAC00 \uB4F1\uB85D\uB418\uC5C8\uC5B4\uC694",
  "incentive.register_error": "\uC778\uC13C\uD2F0\uBE0C \uB4F1\uB85D \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "incentive.status_cancelled": "\uCDE8\uC18C",
  "messenger.conversation_label": "\uB300\uD654",
  "messenger.file_prefix": "\uD30C\uC77C",
  "messenger.file_send_failed": "\uD30C\uC77C \uC804\uC1A1 \uC2E4\uD328",
  "messenger.file_size_limit": "10MB \uC774\uD558 \uD30C\uC77C\uB9CC \uC804\uC1A1 \uAC00\uB2A5\uD574\uC694",
  "messenger.group_min_members": "\uADF8\uB8F9 \uB300\uD654\uB294 2\uBA85 \uC774\uC0C1 \uC120\uD0DD\uD574\uC57C \uD574\uC694",
  "messenger.group_name_required": "\uADF8\uB8F9 \uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "messenger.group_create_failed": "\uADF8\uB8F9 \uB300\uD654 \uC0DD\uC131\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694",
  "messenger.invite_failed": "\uCD08\uB300\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694",
  "messenger.kick_confirm": "\uB2D8\uC744 \uB0B4\uBCF4\uB0B4\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "messenger.kick_failed": "\uBA64\uBC84 \uB0B4\uBCF4\uB0B4\uAE30\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694",
  "messenger.leave_confirm": "\uC774 \uB300\uD654\uBC29\uC744 \uB098\uAC00\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?\n\uB098\uAC04 \uD6C4\uC5D0\uB294 \uC774\uC804 \uB300\uD654 \uB0B4\uC6A9\uC744 \uBCFC \uC218 \uC5C6\uC5B4\uC694.",
  "messenger.leave_failed": "\uB300\uD654\uBC29 \uB098\uAC00\uAE30\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694",
  "messenger.me": "\uB098",
  "messenger.member_load_failed": "\uBA64\uBC84 \uBAA9\uB85D\uC744 \uBD88\uB7EC\uC62C \uC218 \uC5C6\uC5B4\uC694",
  "messenger.new_message": "\uC0C8 \uBA54\uC2DC\uC9C0",
  "messenger.notice_cat_event": "\uD589\uC0AC",
  "messenger.notice_cat_general": "\uC77C\uBC18",
  "messenger.notice_cat_hr": "\uC778\uC0AC",
  "messenger.notice_cat_policy": "\uC815\uCC45",
  "messenger.notice_cat_safety": "\uC548\uC804",
  "messenger.notice_cat_system": "\uC2DC\uC2A4\uD15C",
  "messenger.notice_priority_high": "\uC911\uC694",
  "messenger.notice_priority_low": "\uCC38\uACE0",
  "messenger.notice_priority_normal": "\uC77C\uBC18",
  "messenger.notice_priority_urgent": "\uAE34\uAE09",
  "messenger.room_name_changed": "\uB300\uD654\uBC29 \uC774\uB984\uC774 \uBCC0\uACBD\uB418\uC5C8\uC5B4\uC694",
  "messenger.room_name_change_failed": "\uC774\uB984 \uBCC0\uACBD\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694",
  "messenger.message_menu": "\uBA54\uC2DC\uC9C0 \uBA54\uB274",
  "messenger.delete_message": "\uC0AD\uC81C",
  "messenger.delete_message_confirm": "\uC774 \uBA54\uC2DC\uC9C0\uB97C \uC0AD\uC81C\uD560\uAE4C\uC694?\n\uB300\uD654 \uCC38\uC5EC\uC790 \uBAA8\uB450\uC5D0\uAC8C \u300C\uC0AD\uC81C\uB41C \uBA54\uC2DC\uC9C0\uC785\uB2C8\uB2E4\u300D\uB85C \uBCF4\uC5EC\uC694.",
  "messenger.delete_message_failed": "\uBA54\uC2DC\uC9C0 \uC0AD\uC81C\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694",
  "messenger.deleted_message": "\uC0AD\uC81C\uB41C \uBA54\uC2DC\uC9C0\uC785\uB2C8\uB2E4",
  "messenger.preview_blocked": "\uAD8C\uD55C \uBBF8\uB9AC\uBCF4\uAE30 \uC911\uC5D0\uB294 \uBA54\uC2E0\uC800\uB97C \uBCFC \uC218 \uC5C6\uC5B4\uC694. \uBBF8\uB9AC\uBCF4\uAE30\uB97C \uB05D\uB0B8 \uB4A4 \uB2E4\uC2DC \uC5F4\uC5B4 \uC8FC\uC138\uC694.",
  "messenger.mute_on": "\uC54C\uB9BC \uB044\uAE30",
  "messenger.mute_off": "\uC54C\uB9BC \uCF1C\uAE30",
  "messenger.mute_hint": "\uAEBC\uB3C4 \uC548 \uC77D\uC740 \uC218\uB294 \uD45C\uC2DC\uB418\uACE0, \uB098\uB97C \uC5B8\uAE09\uD558\uAC70\uB098 \uB0B4 \uBA54\uC2DC\uC9C0\uC5D0 \uB2F5\uAE00\uC774 \uB2EC\uB9AC\uBA74 \uC54C\uB9BC\uC774 \uC640\uC694",
  "messenger.muted": "\uC54C\uB9BC \uAEBC\uC9D0",
  "messenger.unmuted": "\uC54C\uB9BC \uCF1C\uC9D0",
  "messenger.mute_toggle_failed": "\uC54C\uB9BC \uC124\uC815\uC744 \uBC14\uAFB8\uC9C0 \uBABB\uD588\uC5B4\uC694",
  "messenger.mark_read": "\uC77D\uC74C\uC73C\uB85C \uD45C\uC2DC",
  "messenger.history_start": "\uB300\uD654\uC758 \uCC98\uC74C\uC774\uC5D0\uC694",
  "messenger.mark_read_failed": "\uC77D\uC74C \uCC98\uB9AC\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694",
  "messenger.view_profile": "\uD504\uB85C\uD544 \uBCF4\uAE30",
  "messenger.direct_chat": "1:1 \uCC44\uD305",
  "messenger.mention_user": "\uBA58\uC158\uD558\uAE30",
  "messenger.sender_menu": "\uBCF4\uB0B8 \uC0AC\uB78C \uBA54\uB274",
  "messenger.conv_menu": "\uB300\uD654\uBC29 \uBA54\uB274",
  "messenger.reply": "\uB2F5\uAE00",
  "messenger.react": "\uBC18\uC751",
  "messenger.reaction_failed": "\uBC18\uC751\uC744 \uB0A8\uAE30\uC9C0 \uBABB\uD588\uC5B4\uC694",
  "messenger.copy": "\uBCF5\uC0AC",
  "messenger.copied": "\uBCF5\uC0AC\uD588\uC5B4\uC694",
  "messenger.copy_failed": "\uBCF5\uC0AC\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694",
  "messenger.select_copy": "\uC120\uD0DD \uBCF5\uC0AC",
  "messenger.select_copy_hint": "\uBCF5\uC0AC\uD560 \uBD80\uBD84\uC744 \uB4DC\uB798\uADF8\uD574\uC11C \uACE0\uB978 \uB4A4 \uBCF5\uC0AC\uB97C \uB204\uB974\uC138\uC694. \uACE0\uB974\uC9C0 \uC54A\uC73C\uBA74 \uC804\uCCB4\uAC00 \uBCF5\uC0AC\uB3FC\uC694.",
  "messenger.copied_selection": "\uC120\uD0DD\uD55C \uBD80\uBD84\uC744 \uBCF5\uC0AC\uD588\uC5B4\uC694",
  "messenger.forward": "\uBCF4\uB0B4\uAE30",
  "messenger.forward_title": "\uBCF4\uB0BC \uB300\uD654\uBC29",
  "messenger.forward_search_placeholder": "\uB300\uD654\uBC29\xB7\uC774\uB984 \uAC80\uC0C9",
  "messenger.forwarded": "\uBCF4\uB0C8\uC5B4\uC694",
  "messenger.forward_failed": "\uBCF4\uB0B4\uC9C0 \uBABB\uD588\uC5B4\uC694",
  "messenger.pin": "\uACE0\uC815",
  "messenger.unpin": "\uACE0\uC815 \uD574\uC81C",
  "messenger.pinned_message": "\uACE0\uC815\uB41C \uBA54\uC2DC\uC9C0",
  "messenger.pin_failed": "\uACE0\uC815\uC744 \uBC14\uAFB8\uC9C0 \uBABB\uD588\uC5B4\uC694",
  "messenger.reply_to": "{name}\uC5D0\uAC8C \uB2F5\uAE00",
  "messenger.reply_cancel": "\uB2F5\uAE00 \uCDE8\uC18C",
  "messenger.reply_preview_image": "[\uC0AC\uC9C4]",
  "messenger.reply_preview_file": "[\uD30C\uC77C]",
  "messenger.mention_all": "\uC804\uCCB4",
  "messenger.mention_all_hint": "\uBC29 \uCC38\uC5EC\uC790 \uC804\uC6D0\uC5D0\uAC8C \uC54C\uB9BC",
  "messenger.sender_unknown": "\uC54C \uC218 \uC5C6\uC74C",
  "messenger.tab_attention_title": "\uC2E0\uADDC \uBA54\uC2DC\uC9C0\uAC00 \uB3C4\uCC29\uD588\uC2B5\uB2C8\uB2E4.",
  "messenger.time_days_ago": "\uC77C \uC804",
  "messenger.time_hours_ago": "\uC2DC\uAC04 \uC804",
  "messenger.time_just_now": "\uBC29\uAE08",
  "messenger.time_minutes_ago": "\uBD84 \uC804",
  "messenger.today": "\uC624\uB298",
  "messenger.unassigned": "\uBBF8\uBC30\uC815",
  "messenger.yesterday": "\uC5B4\uC81C",
  "approval.cancel_error": "\uCDE8\uC18C \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "approval.document_file_required": "\uD30C\uC77C\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "approval.document_submit_error": "\uC11C\uB958 \uC81C\uCD9C \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "approval.document_cert_name_required": "\uC790\uACA9\uC99D\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "approval.file_size_limit": "\uD30C\uC77C \uD06C\uAE30\uB294 10MB \uC774\uD558\uC5EC\uC57C \uD574\uC694",
  "approval.leave_date_reason_required": "\uC2DC\uC791\uC77C\uACFC \uC0AC\uC720\uB97C \uBAA8\uB450 \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "approval.leave_request_error": "\uD734\uAC00 \uC2E0\uCCAD \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "approval.leave_type_annual": "\uC5F0\uCC28",
  "approval.leave_type_bereavement": "\uACBD\uC870 \uD734\uAC00",
  "approval.leave_type_maternity": "\uCD9C\uC0B0 \uD734\uAC00",
  "approval.leave_type_personal": "\uAC1C\uC778 \uC0AC\uC720",
  "approval.leave_type_sick": "\uBCD1\uAC00",
  "approval.overtime_category_holiday": "\uD734\uC77C \uADFC\uBB34",
  "approval.overtime_category_night": "\uC57C\uAC04 \uADFC\uBB34",
  "approval.overtime_category_saturday": "\uD1A0\uC694 \uADFC\uBB34",
  "approval.overtime_category_weekday": "\uD3C9\uC77C \uC5F0\uC7A5",
  "approval.overtime_date_reason_required": "\uADFC\uBB34\uC77C\uACFC \uC0AC\uC720\uB97C \uBAA8\uB450 \uC785\uB825\uD574\uC8FC\uC138\uC694",
  "approval.overtime_request_error": "\uC5F0\uC7A5\uADFC\uBB34 \uC2E0\uCCAD \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694",
  "approval.status_approved": "\uC2B9\uC778",
  "approval.status_cancelled": "\uCDE8\uC18C",
  "approval.status_pending": "\uB300\uAE30",
  "approval.status_processing": "\uB300\uAE30 \uC911",
  "approval.status_rejected": "\uBC18\uB824",
  "approval.status_requires_review": "\uAC80\uD1A0 \uD544\uC694",
  "approval.tab_documents": "\uC11C\uB958\uAD00\uB9AC",
  "approval.tab_leave": "\uD734\uAC00\uC2E0\uCCAD",
  "approval.tab_overtime": "\uC5F0\uC7A5\uADFC\uBB34",
  "hr.action_add": "\uCD94\uAC00",
  "hr.action_cancel": "\uCDE8\uC18C",
  "hr.already_added": "\uD574\uB2F9 \uC9C1\uC6D0\uC774 \uC774\uBBF8 \uBAA8\uB450 \uCD94\uAC00\uB418\uC5B4 \uC788\uC5B4\uC694.",
  "hr.allowance_adjustment": "\uC870\uC815\uC218\uB2F9",
  "hr.allowance_childcare": "\uBCF4\uC721\uC218\uB2F9",
  "hr.allowance_communication": "\uD1B5\uC2E0\uBE44",
  "hr.allowance_count": "\uC218\uB2F9 {n}\uAC74",
  "hr.allowance_cancel_diff": "\uC218\uB2F9 \uCDE8\uC18C \uAE09\uC5EC \uAC31\uC2E0",
  "hr.allowance_family": "\uAC00\uC871\uC218\uB2F9",
  "hr.allowance_fixed_incentive": "\uACE0\uC815 \uC778\uC13C\uD2F0\uBE0C",
  "hr.allowance_fixed_incentive_short": "\uC5C5\uBB34\uC778\uC13C",
  "hr.allowance_housing": "\uC8FC\uAC70\uC218\uB2F9",
  "hr.allowance_meal": "\uC2DD\uB300",
  "hr.allowance_nursing_incentive": "\uAC04\uD638\uC778\uC13C\uD2F0\uBE0C",
  "hr.allowance_nursing_incentive_short": "\uAC04\uD638\uAC04\uBCD1\uC778\uC13C",
  "hr.allowance_on_call": "\uD734\uC77C\uB2F9\uC9C1",
  "hr.allowance_other": "\uAE30\uD0C0\uC218\uB2F9",
  "hr.allowance_performance": "\uC131\uACFC\uC218\uB2F9",
  "hr.allowance_position": "\uC9C1\uCC45\uC218\uB2F9",
  "hr.allowance_special": "\uD2B9\uBCC4\uC218\uB2F9",
  "hr.allowance_transportation": "\uAD50\uD1B5\uBE44",
  "hr.approve_confirm_allowance": "\uC774 \uC218\uB2F9\uC744 \uC2B9\uC778\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.approve_diff_title": "\uC2B9\uC778 \uAE09\uC5EC \uAC31\uC2E0",
  "hr.approve_fail": "\uC2B9\uC778 \uC2E4\uD328",
  "hr.approve_grade_confirm": "{n}\uAC74\uC758 \uD638\uBD09 \uC2B9\uAE09\uC744 \uC2B9\uC778\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?\n\uC2B9\uC778 \uC2DC \uADFC\uB85C\uACC4\uC57D\uC774 \uC790\uB3D9 \uAC31\uC2E0\uB3FC\uC694.",
  "hr.assign_fail": "\uBC30\uC815 \uC2E4\uD328",
  "hr.add_employees_first": "\uBA3C\uC800 \uC9C1\uC6D0\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694.",
  "hr.auto_calc_fail": "\uC790\uB3D9 \uACC4\uC0B0\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uAE08\uC561\uC744 \uC9C1\uC811 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "hr.auto_calc_prefix": "\uC790\uB3D9\uACC4\uC0B0:",
  "hr.bulk_approve_fail": "\uC77C\uAD04 \uC2B9\uC778 \uC2E4\uD328",
  "hr.bulk_cancel_allowance": "{n}\uAC74\uC758 \uC218\uB2F9\uC744 \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.bulk_cancel_deduction": "{n}\uAC74\uC758 \uACF5\uC81C\uB97C \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.cancel_confirm_allowance": "\uC774 \uC218\uB2F9\uC744 \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.cancel_confirm_deduction": "\uC774 \uACF5\uC81C\uB97C \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.cancel_confirm_detail_1": "\uD655\uC815\uB41C \uAE09\uC5EC\uAC00 '\uC791\uC131' \uC0C1\uD0DC\uB85C \uB3CC\uC544\uAC11\uB2C8\uB2E4.",
  "hr.cancel_confirm_detail_2": "\uC2A4\uB0C5\uC0F7(\uD655\uC815 \uC2DC\uC810 \uAE30\uB85D)\uC774 \uC0AD\uC81C\uB3FC\uC694.",
  "hr.cancel_confirm_detail_3": "\uC774\uBBF8 \uC9C0\uAE09\uB41C \uAE09\uC5EC\uB294 \uCDE8\uC18C\uD560 \uC218 \uC5C6\uC5B4\uC694.",
  "hr.cancel_confirm_done": "\uD655\uC815\uC774 \uCDE8\uC18C\uB418\uC5C8\uC5B4\uC694.",
  "hr.cancel_confirm_fail": "\uD655\uC815 \uCDE8\uC18C \uC2E4\uD328",
  "hr.cancel_confirm_title": "\uAE09\uC5EC \uD655\uC815\uC744 \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.cancel_fail": "\uCDE8\uC18C \uC2E4\uD328",
  "hr.cancel_settlement_confirm": "\uD1F4\uC9C1\uC815\uC0B0\uC744 \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?\n\uC0DD\uC131\uB41C \uC218\uB2F9/\uACF5\uC81C\uB0B4\uC5ED\uC774 \uC0AD\uC81C\uB3FC\uC694.",
  "hr.cancel_settlement_fail": "\uC815\uC0B0 \uCDE8\uC18C \uC2E4\uD328",
  "hr.cancel_single_confirm": "{name}\uB2D8\uC758 \uAE09\uC5EC \uD655\uC815\uC744 \uCDE8\uC18C\uD560\uAE4C\uC694?\n\uC791\uC131 \uC0C1\uD0DC\uB85C \uB3CC\uC544\uAC00\uBA70 \uC218\uB2F9\xB7\uACF5\uC81C\uB97C \uB2E4\uC2DC \uC218\uC815\uD560 \uC218 \uC788\uC5B4\uC694.",
  "hr.category_functional": "\uAE30\uB2A5\uC9C1",
  "hr.category_nursing": "\uAC04\uD638\uBD80",
  "hr.category_rehabilitation": "\uC7AC\uD65C",
  "hr.cmd_add_memo": "\uD604\uC7AC \uC140\uC5D0 \uBA54\uBAA8 \uCD94\uAC00",
  "hr.cmd_clear_selection": "\uC120\uD0DD \uD574\uC81C",
  "hr.cmd_generate": "\uAE09\uC5EC \uC7AC\uC0DD\uC131",
  "hr.cmd_generate_hint": "\uBAA8\uB4C8 \uC7AC\uC2E4\uD589 + \uC790\uB3D9 \uAC31\uC2E0",
  "hr.cmd_memo_history": "\uBA54\uBAA8 \uC774\uB825 \uC5F4\uAE30",
  "hr.cmd_perf_reset": "\uC131\uB2A5 \uCE21\uC815 \uAE30\uB85D \uCD08\uAE30\uD654",
  "hr.cmd_perf_stats": "\uC131\uB2A5 \uCE21\uC815 \uD1B5\uACC4 \uBCF4\uAE30",
  "hr.cmd_perf_stats_hint": "\uCF58\uC194\uC5D0 avg/max/p95 \uCD9C\uB825",
  "hr.cmd_refresh": "\uAE09\uC5EC \uAC31\uC2E0",
  "hr.cmd_refresh_hint": "\uC218\uB2F9/\uACF5\uC81C \uD569\uACC4 \uB2E4\uC2DC \uACC4\uC0B0",
  "hr.cmd_reset_columns": "\uC5F4 \uC124\uC815 \uCD08\uAE30\uD654",
  "hr.cmd_select_all": "\uBAA8\uB4E0 \uC140 \uC120\uD0DD",
  "hr.cmd_shortcuts": "\uD0A4\uBCF4\uB4DC \uB2E8\uCD95\uD0A4 \uB3C4\uC6C0\uB9D0",
  "hr.cmd_undo": "\uB9C8\uC9C0\uB9C9 \uC791\uC5C5 \uB418\uB3CC\uB9AC\uAE30",
  "hr.cmd_undo_hint": "\uC218\uB2F9 \uCD94\uAC00 \uB610\uB294 \uC5F4 \uBCC0\uACBD",
  "hr.code_name_input_required": "\uCF54\uB4DC\uC640 \uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "hr.code_name_required": "\uCF54\uB4DC\uC640 \uC774\uB984\uC744 \uBAA8\uB450 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "hr.col_base_salary": "\uAE30\uBCF8\uAE09",
  "hr.col_department": "\uBD80\uC11C",
  "hr.col_employee_name": "\uC131\uBA85",
  "hr.col_employee_number": "\uC0AC\uBC88",
  "hr.col_gross_pay": "\uCD1D \uC9C0\uAE09\uC561",
  "hr.col_hire_date": "\uC785\uC0AC\uC77C",
  "hr.col_net_pay": "\uC2E4\uC218\uB839\uC561",
  "hr.col_position": "{@role}",
  "hr.col_status": "\uC0C1\uD0DC",
  "hr.col_total_deductions": "\uCD1D \uACF5\uC81C\uC561",
  "hr.col_wage_type": "\uAE09\uC5EC\uD615\uD0DC",
  "hr.config_load_fail": "\uC124\uC815 \uB85C\uB4DC \uC2E4\uD328",
  "hr.confirm_delete_category": "\uC774 \uCE74\uD14C\uACE0\uB9AC\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.confirm_delete_category_items": "\uC774 \uCE74\uD14C\uACE0\uB9AC\uC640 \uBAA8\uB4E0 \uD56D\uBAA9\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.confirm_delete_category_presets": "\uC774 \uCE74\uD14C\uACE0\uB9AC\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C? \uD504\uB9AC\uC14B\uC740 \uBBF8\uBD84\uB958\uB85C \uC774\uB3D9\uB3FC\uC694.",
  "hr.confirm_delete_config": "\uC774 \uC124\uC815\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.confirm_delete_deduction_config": "\uC774 \uACF5\uC81C \uC124\uC815\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.confirm_delete_grade": "\uC774 \uD638\uBD09 \uB370\uC774\uD130\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.confirm_delete_item": "\uC774 \uD56D\uBAA9\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.confirm_delete_preset": "\uC774 \uD504\uB9AC\uC14B\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.confirm_delete_rate": "\uC774 \uBCF4\uD5D8\uB8CC\uC728 \uC124\uC815\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.confirm_delete_tax": "\uC774 \uC138\uC728 \uC124\uC815\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.confirm_fail": "\uD655\uC815 \uC2E4\uD328",
  "hr.confirm_payroll_msg": "{n}\uAC74\uC758 \uAE09\uC5EC\uB97C \uD655\uC815\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.confirm_single_fail": "\uD655\uC815 \uC2E4\uD328",
  "hr.confirm_warnings": "\uC8FC\uC758\uC0AC\uD56D:",
  "hr.contract_commissioned": "\uC704\uCD09\uC9C1",
  "hr.contract_internship": "\uC778\uD134",
  "hr.contract_part_time": "\uD30C\uD2B8\uD0C0\uC784",
  "hr.contract_permanent": "\uC815\uADDC\uC9C1",
  "hr.contract_temporary": "\uACC4\uC57D\uC9C1",
  "hr.create_fail": "\uB4F1\uB85D \uC2E4\uD328",
  "hr.deduction_advance": "\uC120\uAE09\uAE08",
  "hr.deduction_absence": "\uACB0\uADFC\uACF5\uC81C",
  "hr.deduction_cancel_diff": "\uACF5\uC81C \uCDE8\uC18C \uAE09\uC5EC \uAC31\uC2E0",
  "hr.deduction_count": "\uACF5\uC81C {n}\uAC74",
  "hr.deduction_create_diff": "\uACF5\uC81C \uB4F1\uB85D \uAE09\uC5EC \uAC31\uC2E0",
  "hr.deduction_loan": "\uB300\uCD9C\uC0C1\uD658",
  "hr.deduction_other": "\uAE30\uD0C0\uACF5\uC81C",
  "hr.deduction_penalty": "\uBC8C\uAE08",
  "hr.delete_fail": "\uC0AD\uC81C \uC2E4\uD328",
  "hr.dept_admin": "\uD589\uC815",
  "hr.dept_nursing": "\uAC04\uD638",
  "hr.dept_rehab": "\uC7AC\uD65C",
  "hr.dept_sports": "\uC2A4\uD3EC\uCE20",
  "hr.detect_fail": "\uAC10\uC9C0 \uC2E4\uD328",
  "hr.duplicate_grade": "\uC774\uBBF8 \uB4F1\uB85D\uB41C \uD638\uBD09\uC785\uB2C8\uB2E4. \uD655\uC778 \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "hr.edit_fail": "\uC218\uC815 \uC2E4\uD328",
  "hr.employee_load_fail": "\uC9C1\uC6D0 \uC815\uBCF4 \uB85C\uB4DC \uC2E4\uD328",
  "hr.export_ecount_fail": "\uC774\uCE74\uC6B4\uD2B8 Export \uC2E4\uD328",
  "hr.export_no_data": "Export \uB370\uC774\uD130\uAC00 \uC5C6\uC5B4\uC694. \uD655\uC815\uB41C \uAE09\uC5EC\uAC00 \uC788\uB294\uC9C0 \uD655\uC778\uD574\uC8FC\uC138\uC694.",
  "hr.fill_diff_title": "\uC790\uB3D9 \uCC44\uC6B0\uAE30 \uAE09\uC5EC \uAC31\uC2E0",
  "hr.fill_fail": "\uC790\uB3D9 \uCC44\uC6B0\uAE30 \uC2E4\uD328",
  "hr.fill_label_suffix": "(\uC790\uB3D9 \uCC44\uC6B0\uAE30)",
  "hr.fill_reason": "\uC790\uB3D9 \uCC44\uC6B0\uAE30",
  "hr.filter_100days": "\uC785\uC0AC 100\uC77C \uC9C1\uC6D0",
  "hr.filter_birthday": "\uC0DD\uC77C \uC9C1\uC6D0",
  "hr.filter_department": "\uC18C\uC18D \uC9C1\uC6D0",
  "hr.filter_hire_anniversary": "\uC785\uC0AC \uAE30\uB150\uC77C \uC9C1\uC6D0",
  "hr.generic_error": "\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "hr.grade_mode_disabled": "\uBE44\uD65C\uC131",
  "hr.grade_mode_fiscal_year": "\uD68C\uACC4\uC5F0\uB3C4 \uAE30\uC900",
  "hr.grade_mode_hire_date": "\uC785\uC0AC\uC77C \uAE30\uC900",
  "hr.grade_status_applied": "\uC801\uC6A9",
  "hr.grade_status_approved": "\uC2B9\uC778",
  "hr.grade_status_pending": "\uB300\uAE30",
  "hr.grade_status_rejected": "\uBC18\uB824",
  "hr.health_year_end": "\uAC74\uAC15/\uC7A5\uAE30\uC694\uC591 \uC5F0\uB9D0\uC815\uC0B0",
  "hr.incentive_inpatient": "\uC785\uC6D0\uC720\uC9C0",
  "hr.incentive_other": "\uAE30\uD0C0",
  "hr.incentive_referral": "\uC758\uB8B0",
  "hr.incentive_shockwave": "\uCCB4\uC678\uCDA9\uACA9\uD30C",
  "hr.item_code_add_fail": "\uD56D\uBAA9\uCF54\uB4DC \uCD94\uAC00 \uC2E4\uD328",
  "hr.items_saved": "\uD56D\uBAA9\uC774 \uC800\uC7A5\uB418\uC5C8\uC5B4\uC694.",
  "hr.locked_allowance_alert": "\uB2E4\uC74C \uC9C1\uC6D0\uC758 \uAE09\uC5EC\uB294 \uC774\uBBF8 \uD655\uC815\uB418\uC5B4 \uC218\uB2F9\uC744 \uCD94\uAC00\uD560 \uC218 \uC5C6\uC5B4\uC694:\n{names}\n\uBA3C\uC800 \uD655\uC815\uC744 \uCDE8\uC18C\uD574 \uC8FC\uC138\uC694.",
  "hr.locked_deduction_alert": "\uB2E4\uC74C \uC9C1\uC6D0\uC758 \uAE09\uC5EC\uB294 \uC774\uBBF8 \uD655\uC815\uB418\uC5B4 \uACF5\uC81C\uB97C \uCD94\uAC00\uD560 \uC218 \uC5C6\uC5B4\uC694:\n{names}\n\uBA3C\uC800 \uD655\uC815\uC744 \uCDE8\uC18C\uD574 \uC8FC\uC138\uC694.",
  "hr.locked_payroll_alert": "{name}\uB2D8\uC758 \uAE09\uC5EC\uB294 \uC774\uBBF8 \uD655\uC815\uB418\uC5B4 \uC218\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694.\n\uBA3C\uC800 \uD655\uC815\uC744 \uCDE8\uC18C\uD574 \uC8FC\uC138\uC694.",
  "hr.memo_resolve_fail": "\uBA54\uBAA8 \uD574\uACB0 \uC2E4\uD328",
  "hr.memo_save_fail": "\uBA54\uBAA8 \uC800\uC7A5 \uC2E4\uD328",
  "hr.module_education_subsidy": "\uAD50\uC721\uBE44 \uBCF4\uC870\uAE08",
  "hr.module_employment_contract": "\uADFC\uB85C\uACC4\uC57D",
  "hr.module_fixed_incentive": "\uACE0\uC815 \uC778\uC13C\uD2F0\uBE0C",
  "hr.module_manual": "\uC218\uB3D9\uC785\uB825",
  "hr.module_overtime_record": "\uCD08\uACFC\uADFC\uBB34\uAE30\uB85D",
  "hr.module_payroll_rate_config": "4\uB300\uBCF4\uD5D8",
  "hr.module_resignation_record": "\uD1F4\uC0AC\uC815\uC0B0",
  "hr.module_tax_bracket_config": "\uC18C\uB4DD\uC138",
  "hr.module_year_end_settlement": "\uC5F0\uB9D0\uC815\uC0B0",
  "hr.n_registered": "{n}\uAC74\uC774 \uB4F1\uB85D\uB418\uC5C8\uC5B4\uC694.",
  "hr.n_selected": "{n}\uAC74 \uC120\uD0DD",
  "hr.no_amount_employees": "\uAE08\uC561\uC774 \uC785\uB825\uB41C \uC9C1\uC6D0\uC774 \uC5C6\uC5B4\uC694.",
  "hr.no_amount_items": "\uAE08\uC561\uC774 \uC785\uB825\uB41C \uD56D\uBAA9\uC774 \uC5C6\uC5B4\uC694.",
  "hr.no_data_to_register": "\uB4F1\uB85D\uD560 \uB370\uC774\uD130\uAC00 \uC5C6\uC5B4\uC694. \uC9C1\uC6D0\uACFC \uAE08\uC561\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "hr.no_matching_employees": "\uD574\uB2F9 \uC870\uAC74\uC5D0 \uB9DE\uB294 \uC9C1\uC6D0\uC774 \uC5C6\uC5B4\uC694.",
  "hr.not_confirmed_status": "\uD655\uC815\uB41C \uC0C1\uD0DC\uC758 \uAE09\uC5EC\uAC00 \uC544\uB2D9\uB2C8\uB2E4.",
  "hr.overtime_holiday": "\uD734\uC77C",
  "hr.overtime_night": "\uC57C\uAC04",
  "hr.overtime_saturday": "\uD1A0\uC694",
  "hr.overtime_weekday": "\uD3C9\uC77C",
  "hr.paste_diff_title": "\uBD99\uC5EC\uB123\uAE30 \uAE09\uC5EC \uAC31\uC2E0",
  "hr.paste_fail": "\uBD99\uC5EC\uB123\uAE30 \uC2E4\uD328",
  "hr.paste_label_suffix": "(\uBD99\uC5EC\uB123\uAE30)",
  "hr.paste_reason": "\uBD99\uC5EC\uB123\uAE30",
  "hr.payment_cash": "\uD604\uAE08",
  "hr.payment_mobile_gift": "\uC0C1\uD488\uAD8C",
  "hr.payment_salary": "\uAE09\uC5EC\uD569\uC0B0",
  "hr.pending_detail": "\uB300\uAE30 \uC911:",
  "hr.pending_instruction": "\uC218\uB2F9\uB0B4\uC5ED/\uACF5\uC81C\uB0B4\uC5ED\uC5D0\uC11C \uBA3C\uC800 \uC2B9\uC778 \uCC98\uB9AC\uD574\uC8FC\uC138\uC694.",
  "hr.pending_items_block": "\uC2B9\uC778 \uB300\uAE30 \uC911\uC778 \uD56D\uBAA9\uC774 \uC788\uC5B4 \uAE09\uC5EC\uB97C \uD655\uC815\uD560 \uC218 \uC5C6\uC5B4\uC694.",
  "hr.perm_deductions_desc": "\uC9C1\uC6D0\uBCC4 \uACF5\uC81C, \uC5F0\uB9D0\uC815\uC0B0, \uD1F4\uC0AC\uC815\uC0B0 \uB4F1 \uBAA8\uB4E0 \uACF5\uC81C \uB0B4\uC5ED\uC744 \uC870\uD68C\uD560 \uC218 \uC788\uB294 \uAD8C\uD55C\uC785\uB2C8\uB2E4.",
  "hr.perm_deductions_name": "\uACF5\uC81C\uB0B4\uC5ED \uC870\uD68C",
  "hr.perm_earnings_desc": "\uC9C1\uC6D0\uBCC4 \uC218\uB2F9, \uC5F0\uC7A5\uADFC\uBB34, \uC778\uC13C\uD2F0\uBE0C, \uAD50\uC721\uBE44 \uB4F1 \uBAA8\uB4E0 \uC9C0\uAE09 \uB0B4\uC5ED\uC744 \uC870\uD68C\uD560 \uC218 \uC788\uB294 \uAD8C\uD55C\uC785\uB2C8\uB2E4.",
  "hr.perm_earnings_name": "\uC218\uB2F9\uB0B4\uC5ED \uC870\uD68C",
  "hr.perm_payroll_desc": "\uC804\uCCB4 \uC9C1\uC6D0\uC758 \uAE09\uC5EC\uB300\uC7A5 \uB370\uC774\uD130\uB97C \uC870\uD68C\uD560 \uC218 \uC788\uB294 \uAD8C\uD55C\uC774\uC5D0\uC694. \uAE30\uBCF8\uAE09, \uC218\uB2F9, \uACF5\uC81C\uB0B4\uC5ED, \uC2E4\uC218\uB839\uC561 \uB4F1\uC758 \uC815\uBCF4\uB97C \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694.",
  "hr.perm_payroll_name": "\uAE09\uC5EC\uB300\uC7A5 \uC870\uD68C",
  "hr.rate_employment_insurance": "\uACE0\uC6A9\uBCF4\uD5D8",
  "hr.rate_health_insurance": "\uAC74\uAC15\uBCF4\uD5D8",
  "hr.rate_industrial_accident": "\uC0B0\uC7AC\uBCF4\uD5D8",
  "hr.rate_long_term_care": "\uC7A5\uAE30\uC694\uC591\uBCF4\uD5D8",
  "hr.rate_national_pension": "\uAD6D\uBBFC\uC5F0\uAE08",
  "hr.refresh_diff_title": "\uAE09\uC5EC \uAC31\uC2E0 \uBCC0\uACBD\uB0B4\uC5ED",
  "hr.refresh_fail": "\uAE09\uC5EC \uAC31\uC2E0 \uC2E4\uD328",
  "hr.regenerate_diff_title": "\uAE09\uC5EC \uC7AC\uC0DD\uC131 \uBCC0\uACBD\uB0B4\uC5ED",
  "hr.regenerate_fail": "\uAE09\uC5EC \uC0DD\uC131 \uC2E4\uD328",
  "hr.register_error": "\uB4F1\uB85D \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694.",
  "hr.reject_fail": "\uBC18\uB824 \uC2E4\uD328",
  "hr.resignation_status_completed": "\uC644\uB8CC",
  "hr.resignation_status_pending": "\uB300\uAE30",
  "hr.resignation_status_processing": "\uCC98\uB9AC\uC911",
  "hr.resignation_status_settled": "\uC815\uC0B0\uC644\uB8CC",
  "hr.review_load_fail": "\uAC80\uD1A0 \uB370\uC774\uD130 \uB85C\uB529 \uC2E4\uD328",
  "hr.save_fail": "\uC800\uC7A5 \uC2E4\uD328",
  "hr.saved": "\uC800\uC7A5\uB418\uC5C8\uC5B4\uC694.",
  "hr.select_employee": "\uC9C1\uC6D0\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
  "hr.select_grade_or_salary": "\uD638\uBD09\uC744 \uC120\uD0DD\uD558\uAC70\uB098 \uAE30\uBCF8\uAE09\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "hr.send_payslip_confirm": "{name}\uB2D8\uC5D0\uAC8C \uAE09\uC5EC\uBA85\uC138\uC11C\uB97C \uBC1C\uC1A1\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.send_payslip_done": "\uBC1C\uC1A1 \uC644\uB8CC",
  "hr.send_payslip_fail": "\uBC1C\uC1A1 \uC2E4\uD328",
  "hr.settlement_cancelled": "\uC815\uC0B0\uC774 \uCDE8\uC18C\uB418\uC5C8\uC5B4\uC694.",
  "hr.settlement_confirm": "\uC218\uB2F9 {allowance}\uC6D0, \uACF5\uC81C {deduction}\uC6D0\n\uC2E4\uC218\uB839 \uCC28\uC561: {net}\uC6D0\n\n\uC815\uC0B0\uC744 \uC2E4\uD589\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
  "hr.settlement_created": "\uC815\uC0B0 \uB0B4\uC5ED\uC774 \uC0DD\uC131\uB418\uC5C8\uC5B4\uC694.",
  "hr.settlement_fail": "\uC815\uC0B0 \uC2E4\uD589 \uC2E4\uD328",
  "hr.settings_saved": "\uC124\uC815\uC774 \uC800\uC7A5\uB418\uC5C8\uC5B4\uC694.",
  "hr.source_auto": "\uC790\uB3D9\uC0DD\uC131",
  "hr.source_config": "\uC218\uB2F9\uC124\uC815",
  "hr.source_manual": "\uC218\uB3D9\uC785\uB825",
  "hr.status_applied": "\uC801\uC6A9",
  "hr.status_approved": "\uC2B9\uC778",
  "hr.status_calculated": "\uACC4\uC0B0",
  "hr.status_cancelled": "\uCDE8\uC18C",
  "hr.status_completed": "\uC644\uB8CC",
  "hr.status_confirmed": "\uD655\uC815",
  "hr.status_corrected": "\uC218\uC815",
  "hr.status_draft": "\uC791\uC131",
  "hr.status_paid": "\uC9C0\uAE09",
  "hr.status_pending": "\uB300\uAE30",
  "hr.status_processing": "\uCC98\uB9AC\uC911",
  "hr.status_settled": "\uC815\uC0B0",
  "hr.tab_deductions": "\uACF5\uC81C\uB0B4\uC5ED",
  "hr.tab_earnings": "\uC218\uB2F9\uB0B4\uC5ED",
  "hr.tab_payroll": "\uAE09\uC5EC\uB300\uC7A5(\uC804\uCCB4)",
  "hr.template_apply_fail": "\uD15C\uD50C\uB9BF \uC801\uC6A9 \uC2E4\uD328",
  "hr.undo_cancel_diff": "\uC218\uB2F9 \uCDE8\uC18C (Ctrl+Z) \uAE09\uC5EC \uAC31\uC2E0",
  "hr.undo_cancel_fail": "\uCDE8\uC18C \uC2E4\uD328",
  "hr.wage_annual": "\uC5F0\uBD09",
  "hr.wage_daily": "\uC77C\uAE09",
  "hr.wage_hourly": "\uC2DC\uAE09",
  "hr.wage_monthly": "\uC6D4\uAE09",
  "hr.year_end_adjusted": "\uC5F0\uB9D0\uC815\uC0B0 \uC870\uC815",
  "hr.year_end_applied": "{n}\uBA85\uC758 \uC5F0\uB9D0\uC815\uC0B0\uC774 \uAE09\uC5EC\uC5D0 \uBC18\uC601\uB418\uC5C8\uC5B4\uC694.",
  "hr.year_end_apply_fail": "\uBC18\uC601 \uC2E4\uD328",
  "hr.year_end_create_fail": "\uC0DD\uC131 \uC2E4\uD328",
  "hr.year_end_health": "\uAC74\uAC15/\uC7A5\uAE30\uC694\uC591 \uC5F0\uB9D0\uC815\uC0B0",
  "hr.no_employees_to_add": "\uCD94\uAC00\uD560 \uC9C1\uC6D0\uC774 \uC5C6\uC5B4\uC694.",
  "hr.status_change_fail": "\uC0C1\uD0DC \uBCC0\uACBD \uC2E4\uD328",
  "perm.resource.employee": "\uC9C1\uC6D0",
  "perm.resource.team": "\uD300",
  "perm.resource.organization": "\uC870\uC9C1",
  "perm.resource.role": "{@role}",
  "perm.resource.attendance": "\uADFC\uD0DC",
  "perm.resource.leave": "\uD734\uAC00",
  "perm.resource.annualLeavePromotion": "\uC5F0\uCC28 \uCD09\uC9C4",
  "perm.resource.leave-request": "\uD734\uAC00 \uC2E0\uCCAD",
  "perm.resource.overtime": "\uCD08\uACFC\uADFC\uBB34",
  "perm.resource.payroll": "\uAE09\uC5EC",
  "perm.resource.allowance": "\uC218\uB2F9",
  "perm.resource.deduction": "\uACF5\uC81C",
  "perm.resource.salaryGrade": "\uD638\uBD09",
  "perm.resource.incentive": "\uC778\uC13C\uD2F0\uBE0C",
  "perm.resource.fixedIncentive": "\uACE0\uC815 \uC778\uC13C\uD2F0\uBE0C",
  "perm.resource.certification": "\uC790\uACA9\uC99D",
  "perm.resource.education": "\uAD50\uC721",
  "perm.resource.educationSubsidy": "\uAD50\uC721\uBE44",
  "perm.resource.resignation": "\uD1F4\uC0AC",
  "perm.resource.yearEndSettlement": "\uC5F0\uB9D0\uC815\uC0B0",
  "perm.resource.document": "\uBB38\uC11C",
  "perm.resource.schedule": "\uC2A4\uCF00\uC904",
  "perm.resource.nurse-scheduler": "\uAC04\uD638\uC0AC \uC2A4\uCF00\uC904",
  "perm.resource.inventory": "\uC7AC\uACE0",
  "perm.resource.generalAffairs": "\uCD1D\uBB34",
  "perm.resource.conversation": "\uB300\uD654\uBC29",
  "perm.resource.message": "\uBA54\uC2DC\uC9C0",
  "perm.resource.notification": "\uC54C\uB9BC",
  "perm.resource.storage": "\uD30C\uC77C",
  "perm.resource.teamDrive": "\uB4DC\uB77C\uC774\uBE0C",
  "perm.resource.setting": "\uC124\uC815",
  "perm.resource.system": "\uC2DC\uC2A4\uD15C",
  "perm.resource.ai": "AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8",
  "perm.resource.aiApp": "\uC9C1\uC6D0 \uC571 AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8",
  "perm.resource.leaveRequest": "\uD734\uAC00 \uC2E0\uCCAD",
  "perm.action.create": "\uC0DD\uC131",
  "perm.action.read": "\uC870\uD68C",
  "perm.action.update": "\uC218\uC815",
  "perm.action.delete": "\uC0AD\uC81C",
  "perm.action.approve": "\uC2B9\uC778",
  "perm.action.manage": "\uAD00\uB9AC",
  "perm.action.execute": "\uC2E4\uD589",
  "perm.scope.self": "\uBCF8\uC778",
  "perm.scope.team": "\uD300",
  "perm.scope.all": "\uC804\uCCB4",
  "messenger.self_chat": "\uB098\uC640\uC758 \uB300\uD654",
  "messenger.self_chat_hint": "\uB098\uC5D0\uAC8C \uBCF4\uB0B4\uB294 \uBA54\uBAA8\xB7\uD30C\uC77C",
  "notification.messenger_push_format": "\uBA54\uC2E0\uC800 \uC54C\uB9BC \uD45C\uC2DC",
  "notification.messenger_push_format_desc": "\uC7A0\uAE08 \uD654\uBA74 \uC54C\uB9BC\uC5D0 \uBB34\uC5C7\uC744 \uBCF4\uC77C\uC9C0 \uC815\uD574\uC694. \u300C\uC774\uB984 + \uBCF8\uBB38\u300D\uC740 \uC774 \uAE30\uAE30\uC5D0\uC11C \uD480 \uC218 \uC788\uB294 \uB300\uD654\uB9CC \uBCF8\uBB38\uC774 \uBCF4\uC5EC\uC694(\uC571\uC740 \uB2E4\uC74C \uC5C5\uB370\uC774\uD2B8\uBD80\uD130).",
  "notification.messenger_push_format_name_only": "\uBCF4\uB0B8 \uC0AC\uB78C \uC774\uB984\uB9CC",
  "notification.messenger_push_format_generic": "\u300C\uC0C8 \uBA54\uC2DC\uC9C0\u300D\uB9CC",
  "notification.messenger_push_format_name_body": "\uC774\uB984 + \uBCF8\uBB38",
  "messenger.unreadable_message": "\uC77D\uC744 \uC218 \uC5C6\uB294 \uBA54\uC2DC\uC9C0\uC608\uC694 (\uC774 \uAE30\uAE30\uC5D0 \uD0A4\uAC00 \uC5C6\uC5B4\uC694)",
  "messenger.encrypted_preview": "\uC0C8 \uBA54\uC2DC\uC9C0\uAC00 \uB3C4\uCC29\uD588\uC5B4\uC694",
  "messenger.encrypted_preview_read": "\uB300\uD654\uB97C \uC5F4\uC5B4 \uD655\uC778\uD574 \uBCF4\uC138\uC694",
  "messenger.encrypted_push_body": "\uC0C8 \uBA54\uC2DC\uC9C0\uAC00 \uB3C4\uCC29\uD588\uC5B4\uC694",
  "messenger.lock.key_missing_send": "\uB300\uD654\uBC29 \uD0A4\uB97C \uC544\uC9C1 \uBC1B\uC9C0 \uBABB\uD588\uC5B4\uC694. \uC7A0\uC2DC \uB4A4 \uB2E4\uC2DC \uBCF4\uB0B4 \uC8FC\uC138\uC694.",
  "messenger.lock.title": "\uB300\uD654 \uC7A0\uAE08",
  "messenger.image_download": "\uB0B4\uB824\uBC1B\uAE30",
  "messenger.file_too_large": "{name} \uC740(\uB294) {size} \uB77C\uC11C \uBCF4\uB0BC \uC218 \uC5C6\uC5B4\uC694. {limit} \uC774\uD558\uB9CC \uBCF4\uB0BC \uC218 \uC788\uC5B4\uC694.",
  "messenger.uploading": "\uC62C\uB9AC\uB294 \uC911 {percent}%",
  "messenger.upload_preparing": "\uC900\uBE44 \uC911\u2026",
  "messenger.upload_preparing_count": "\uC900\uBE44 \uC911 {done}/{total}",
  "messenger.upload_failed": "\uD30C\uC77C \uC804\uC1A1\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uB2E4\uC2DC \uBCF4\uB0B4\uAE30\uB97C \uB20C\uB7EC \uC8FC\uC138\uC694.",
  "messenger.image_prev": "\uC774\uC804 \uC0AC\uC9C4",
  "messenger.image_next": "\uB2E4\uC74C \uC0AC\uC9C4",
  "messenger.image_download_failed": "\uC0AC\uC9C4\uC744 \uB0B4\uB824\uBC1B\uC9C0 \uBABB\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "messenger.lock.setup_title": "\uB300\uD654 \uC7A0\uAE08 \uC124\uC815",
  "messenger.lock.setup_intro": "\uC774 \uC870\uC9C1\uC758 \uB300\uD654\uB294 \uB0B4 \uAE30\uAE30\uC5D0\uC11C \uC554\uD638\uD654\uB3FC\uC694. \uC9C0\uAE08 \uC774 \uAE30\uAE30\uC5D0 \uB300\uD654 \uC7A0\uAE08 \uD0A4\uB97C \uB9CC\uB4E4\uC5B4\uC694. \uBCF5\uAD6C \uCF54\uB4DC\uB97C \uB530\uB85C \uC801\uC5B4 \uB458 \uD544\uC694\uB294 \uC5C6\uC5B4\uC694.",
  "messenger.lock.setup_loss_notice": "\uD0A4\uB294 \uC774 \uAE30\uAE30\uC5D0\uB9CC \uC788\uC5B4\uC694. \uC0C8 \uAE30\uAE30\uC5D0\uC11C\uB294 \uC774 \uAE30\uAE30\uB85C \uC2B9\uC778\uD574 \uAC00\uC838\uC624\uACE0, \uAE30\uAE30\uB97C \uBAA8\uB450 \uC783\uC73C\uBA74 \uC9C0\uB09C \uB300\uD654\uB294 \uB2E4\uB978 \uBA64\uBC84\uAC00 \uB2E4\uC2DC \uBCF4\uB0B4 \uC904 \uC218 \uC788\uB294 \uBC29\uC5D0\uC11C\uB9CC \uB3CC\uC544\uC640\uC694.",
  "messenger.lock.policy_notice": "\uB300\uD654\uC640 \uD30C\uC77C\uC740 \uD68C\uC0AC \uC790\uB8CC\uB85C \uBCF4\uAD00\uB418\uBA70, \uBC95\uC801 \uC694\uCCAD\uC774 \uC788\uC744 \uB54C \uC815\uD574\uC9C4 \uC808\uCC28\uC5D0 \uB530\uB77C \uC5F4\uB78C\uB420 \uC218 \uC788\uC5B4\uC694.",
  "messenger.lock.setup_start": "\uD0A4 \uB9CC\uB4E4\uAE30",
  "messenger.lock.setup_done": "\uB300\uD654 \uC7A0\uAE08\uC744 \uC124\uC815\uD588\uC5B4\uC694.",
  "messenger.lock.creating": "\uB300\uD654 \uC7A0\uAE08 \uD0A4\uB97C \uB9CC\uB4DC\uB294 \uC911\uC774\uC5D0\uC694\u2026",
  "messenger.lock.setup_failed": "\uB300\uD654 \uC7A0\uAE08 \uC124\uC815\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "messenger.lock.missing_key_bar": "\uC774 \uAE30\uAE30\uC5D0 \uB300\uD654 \uC7A0\uAE08 \uD0A4\uAC00 \uC5C6\uC5B4 \uB300\uD654\uB97C \uC77D\uC744 \uC218 \uC5C6\uC5B4\uC694.",
  "messenger.lock.missing_key_action": "\uD0A4 \uAC00\uC838\uC624\uAE30",
  "messenger.lock.setup_bar": "\uB300\uD654 \uC7A0\uAE08\uC744 \uC124\uC815\uD558\uBA74 \uC774 \uAE30\uAE30\uC5D0\uC11C \uB300\uD654\uB97C \uC77D\uACE0 \uBCF4\uB0BC \uC218 \uC788\uC5B4\uC694.",
  "messenger.lock.setup_action": "\uC124\uC815\uD558\uAE30",
  "messenger.lock.restore_title": "\uC0C8 \uAE30\uAE30\uC5D0\uC11C \uB300\uD654 \uC5F4\uAE30",
  "messenger.lock.restore_intro": "\uC774 \uAE30\uAE30\uC5D0 \uB300\uD654 \uC7A0\uAE08 \uD0A4\uAC00 \uC5C6\uC5B4\uC694. \uC774\uBBF8 \uB300\uD654\uAC00 \uC5F4\uB9AC\uB294 \uB2E4\uB978 \uAE30\uAE30\uC5D0\uC11C \uC2B9\uC778\uD574 \uAC00\uC838\uC640\uC694.",
  "messenger.lock.restore_device": "\uB2E4\uB978 \uAE30\uAE30\uC5D0\uC11C \uC2B9\uC778\uD558\uAE30",
  "messenger.lock.start_fresh": "\uC2B9\uC778\uD574 \uC904 \uAE30\uAE30\uAC00 \uC5C6\uC5B4\uC694 \u2014 \uC0C8\uB85C \uC2DC\uC791",
  "messenger.lock.start_fresh_confirm": "\uC0C8 \uD0A4\uB85C \uC2DC\uC791\uD558\uBA74 \uC9C0\uB09C \uB300\uD654\uB294 \uB2E4\uB978 \uBA64\uBC84\uAC00 \uB2E4\uC2DC \uBCF4\uB0B4 \uC904 \uC218 \uC788\uB294 \uBC29\uC5D0\uC11C\uB9CC \uB3CC\uC544\uC640\uC694. \uC55E\uC73C\uB85C\uC758 \uB300\uD654\uB294 \uC815\uC0C1\uC73C\uB85C \uC774\uC5B4\uC838\uC694. \uACC4\uC18D\uD560\uAE4C\uC694?",
  "messenger.lock.start_fresh_button": "\uC0C8\uB85C \uC2DC\uC791",
  "messenger.lock.device_intro": "\uC774\uBBF8 \uD0A4\uAC00 \uC788\uB294 \uAE30\uAE30(\uC6F9\xB7\uC571)\uC5D0 \uC54C\uB9BC\uC744 \uBCF4\uB0C8\uC5B4\uC694. \uADF8 \uAE30\uAE30\uC5D0\uC11C \uBA54\uC2E0\uC800\uB97C \uC5F4\uBA74 \uC2B9\uC778 \uCC3D\uC774 \uB5A0\uC694 \u2014 \uADF8 \uD654\uBA74\uC758 \uC22B\uC790\uAC00 \uC544\uB798\uC640 \uAC19\uC740\uC9C0 \uD655\uC778\uD558\uACE0 \uC2B9\uC778\uD574 \uC8FC\uC138\uC694.",
  "messenger.lock.device_waiting": "\uC2B9\uC778\uC744 \uAE30\uB2E4\uB9AC\uB294 \uC911\uC774\uC5D0\uC694 (10\uBD84 \uC548\uC5D0)",
  "messenger.lock.device_done": "\uB2E4\uB978 \uAE30\uAE30\uC758 \uC2B9\uC778\uC73C\uB85C \uB300\uD654 \uC7A0\uAE08 \uD0A4\uB97C \uBC1B\uC558\uC5B4\uC694.",
  "messenger.lock.device_expired": "\uC2B9\uC778 \uC694\uCCAD\uC774 \uB9CC\uB8CC\uB410\uAC70\uB098 \uC2E4\uD328\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "messenger.lock.device_start_failed": "\uC2B9\uC778 \uC694\uCCAD\uC744 \uB9CC\uB4E4\uC9C0 \uBABB\uD588\uC5B4\uC694.",
  "messenger.lock.status_ready": "\uC774 \uAE30\uAE30\uC5D0 \uB300\uD654 \uC7A0\uAE08 \uD0A4\uAC00 \uC788\uC5B4\uC694",
  "messenger.lock.fingerprint": "\uD0A4 \uC9C0\uBB38",
  "messenger.lock.pending_links": "\uC2B9\uC778 \uAE30\uB2E4\uB9AC\uB294 \uC0C8 \uAE30\uAE30",
  "messenger.lock.approve_prompt": "\uC0C8 \uAE30\uAE30\uAC00 \uB300\uD654 \uC7A0\uAE08 \uD0A4\uB97C \uC694\uCCAD\uD588\uC5B4\uC694. \uADF8 \uAE30\uAE30 \uD654\uBA74\uC758 \uC22B\uC790\uAC00 {code} \uC778\uC9C0 \uD655\uC778\uD55C \uB4A4 \uC2B9\uC778\uD574 \uC8FC\uC138\uC694.",
  "messenger.lock.approve_button": "\uC2B9\uC778",
  "messenger.lock.reject_button": "\uAC70\uC808",
  "messenger.lock.approve_done": "\uC0C8 \uAE30\uAE30\uB97C \uC2B9\uC778\uD588\uC5B4\uC694.",
  "messenger.lock.approve_failed": "\uC2B9\uC778\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694. \uC0C8 \uAE30\uAE30\uC5D0\uC11C \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "messenger.lock.forget": "\uC774 \uAE30\uAE30\uC5D0\uC11C \uD0A4 \uC0AD\uC81C",
  "messenger.lock.forget_confirm": "\uC774 \uAE30\uAE30\uC5D0\uC11C \uB300\uD654 \uC7A0\uAE08 \uD0A4\uB97C \uC9C0\uC6CC\uC694. \uB2E4\uC74C\uC5D0 \uBA54\uC2E0\uC800\uB97C \uC5F4\uBA74 \uB2E4\uB978 \uAE30\uAE30 \uC2B9\uC778\uC774 \uD544\uC694\uD574\uC694. \uACC4\uC18D\uD560\uAE4C\uC694?",
  "messenger.lock.forget_button": "\uC0AD\uC81C",
  "messenger.lock.reset": "\uD0A4 \uC7AC\uC124\uC815(\uC2B9\uC778\uD574 \uC904 \uAE30\uAE30\uB97C \uC783\uC5C8\uC744 \uB54C)",
  "messenger.lock.reset_confirm": "\uD0A4\uB97C \uC0C8\uB85C \uB9CC\uB4E4\uBA74 \uC9C0\uB09C \uB300\uD654\uB294 \uB2E4\uB978 \uBA64\uBC84\uAC00 \uB2E4\uC2DC \uBCF4\uB0B4 \uC904 \uC218 \uC788\uB294 \uBC29\uC5D0\uC11C\uB9CC \uB3CC\uC544\uC640\uC694. \uB2E4\uB978 \uAE30\uAE30\uB3C4 \uB2E4\uC2DC \uC2B9\uC778\uD574\uC57C \uD574\uC694. \uACC4\uC18D\uD560\uAE4C\uC694?",
  "messenger.lock.reset_button": "\uC7AC\uC124\uC815",
  "messenger.lock.untrusted_epoch": "\uC774 \uBC29\uC758 \uD0A4 \uC11C\uBA85\uC744 \uD655\uC778\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC11C\uBA85\uC774 \uC5C6\uAC70\uB098 \uB9DE\uC9C0 \uC54A\uB294 \uC138\uB300\uB77C \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0B4\uC9C0 \uC54A\uC544\uC694. \uBC29\uC744 \uB2E4\uC2DC \uC5F4\uC5B4\uB3C4 \uAC19\uC73C\uBA74 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uC54C\uB824 \uC8FC\uC138\uC694.",
  "messenger.lock.rekeyed_epoch": "\uB300\uD654 \uC7A0\uAE08 \uD0A4\uB97C \uB2E4\uC2DC \uB9CC\uB4E4\uC5B4 \uC774 \uBC29\uC758 \uD0A4 \uC138\uB300\uB97C \uC0C8\uB85C \uC5F4\uC5C8\uC5B4\uC694. \uC9C0\uAE08\uBD80\uD130 \uBCF4\uB0B4\uB294 \uBA54\uC2DC\uC9C0\uB294 \uBC14\uB85C \uC804\uB2EC\uB418\uACE0, \uC9C0\uB09C \uB300\uD654\uB294 \uB2E4\uB978 \uBA64\uBC84\uAC00 \uC774 \uBC29\uC744 \uC5F4\uBA74 \uB2E4\uC2DC \uC77D\uC744 \uC218 \uC788\uC5B4\uC694.",
  "messenger.lock.untrusted_epoch_send": "\uC774 \uBC29\uC758 \uD0A4 \uC11C\uBA85\uC744 \uD655\uC778\uD560 \uC218 \uC5C6\uC5B4 \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0B4\uC9C0 \uC54A\uC558\uC5B4\uC694.",
  "messenger.lock.server_minted": "\uC774 \uBC29\uC758 \uC9C0\uB09C \uB300\uD654\uB294 \uC11C\uBC84\uAC00 \uC554\uD638\uD654\uB85C \uC62E\uAE30\uBA70 \uB9CC\uB4E0 \uC138\uB300\uB77C \uAE30\uAE30 \uC11C\uBA85\uC774 \uC5C6\uC5B4\uC694. \uC9C0\uAE08 \uC138\uB300\uBD80\uD130\uB294 \uBA64\uBC84 \uAE30\uAE30\uAC00 \uC11C\uBA85\uD574\uC694.",
  "messenger.self_chat_cannot_leave": "\uB098\uC640\uC758 \uB300\uD654\uB294 \uB098\uAC08 \uC218 \uC5C6\uC5B4\uC694",
  "messenger.self_chat_members_hint": "\uB098\uB9CC \uC788\uB294 \uBC29\uC774\uC5D0\uC694. \uBA54\uBAA8\xB7\uD30C\uC77C\uC744 \uBCF4\uAD00\uD558\uACE0, \uAC80\uC0C9\uC73C\uB85C \uB2E4\uC2DC \uCC3E\uC544\uC694.",
  "messenger.search_mine_only": "\uB0B4\uAC00 \uBCF4\uB0B8 \uBA54\uC2DC\uC9C0\uB9CC",
  "messenger.self_chat_open_failed": "\uB098\uC640\uC758 \uB300\uD654\uB97C \uC5F4\uC9C0 \uBABB\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
  "messenger.chat_with_me": "\uB098\uC5D0\uAC8C \uCC44\uD305"
};

// src/locales/ko/domain.json
var domain_default2 = {
  "domain.attendance.check_in": "\uCD9C\uADFC",
  "domain.attendance.check_out": "\uD1F4\uADFC",
  "domain.attendance.overtime": "\uCD08\uACFC\uADFC\uBB34",
  "domain.attendance.shift": "\uADFC\uBB34\uC870",
  "domain.attendance.work_hours": "\uADFC\uBB34\uC2DC\uAC04",
  "domain.employee.department": "\uBD80\uC11C",
  "domain.employee.email": "\uC774\uBA54\uC77C",
  "domain.employee.employee_number": "\uC0AC\uBC88",
  "domain.employee.hire_date": "\uC785\uC0AC\uC77C",
  "domain.employee.name": "\uC774\uB984",
  "domain.employee.phone": "\uC804\uD654\uBC88\uD638",
  "domain.employee.status": "\uADFC\uBB34\uC0C1\uD0DC",
  "domain.employee.team": "\uD300",
  "domain.leave.annual_leave": "\uC5F0\uCC28",
  "domain.leave.leave_of_absence": "\uD734\uC9C1",
  "domain.leave.remaining": "\uC794\uC5EC \uC5F0\uCC28",
  "domain.leave.sick_leave": "\uBCD1\uAC00",
  "domain.leave.used": "\uC0AC\uC6A9 \uC5F0\uCC28",
  "domain.payroll.allowance": "\uC218\uB2F9",
  "domain.payroll.base_salary": "\uAE30\uBCF8\uAE09",
  "domain.payroll.deduction": "\uACF5\uC81C",
  "domain.payroll.employment_insurance": "\uACE0\uC6A9\uBCF4\uD5D8",
  "domain.payroll.gross_pay": "\uCD1D \uC9C0\uAE09\uC561",
  "domain.payroll.health_insurance": "\uAC74\uAC15\uBCF4\uD5D8",
  "domain.payroll.hobong": "\uD638\uBD09",
  "domain.payroll.income_tax": "\uC18C\uB4DD\uC138",
  "domain.payroll.local_income_tax": "\uC8FC\uBBFC\uC138",
  "domain.payroll.long_term_care": "\uC7A5\uAE30\uC694\uC591\uBCF4\uD5D8",
  "domain.payroll.national_pension": "\uAD6D\uBBFC\uC5F0\uAE08",
  "domain.payroll.net_pay": "\uC2E4\uC218\uB839\uC561",
  "domain.payroll.ordinary_wage": "\uD1B5\uC0C1\uC784\uAE08",
  "domain.payroll.salary_grade": "\uD638\uBD09",
  "domain.payroll.total_deduction": "\uCD1D \uACF5\uC81C\uC561",
  "domain.payroll.withholding_tax": "\uC6D0\uCC9C\uC9D5\uC218",
  "payroll.status_paid": "\uC9C0\uAE09\uC644\uB8CC",
  "payroll.status_confirmed": "\uC815\uC0B0\uC644\uB8CC",
  "payroll.status_approved": "\uC2B9\uC778\uC644\uB8CC",
  "payroll.status_draft": "\uC791\uC131\uC911",
  "payroll.status_calculated": "\uACC4\uC0B0\uC644\uB8CC",
  "payroll.status_cancelled": "\uCDE8\uC18C\uB428",
  "payroll.load_error": "\uAE09\uC5EC\uBA85\uC138\uC11C\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4"
};

// src/locales/ko/enums.json
var enums_default2 = {
  "enums.AllowanceType.ADJUSTMENT": "\uC815\uC0B0",
  "enums.AllowanceType.FIXED_INCENTIVE": "\uACE0\uC815 \uC778\uC13C\uD2F0\uBE0C",
  "enums.AllowanceType.NURSING_INCENTIVE": "\uAC04\uD638 \uC778\uC13C\uD2F0\uBE0C",
  "enums.AllowanceType.ON_CALL": "\uB2F9\uC9C1 \uC218\uB2F9",
  "enums.AllowanceType.OTHER": "\uAE30\uD0C0",
  "enums.AllowanceType.SPECIAL": "\uD2B9\uBCC4 \uC218\uB2F9",
  "enums.AssignmentType.ANNUAL_LEAVE": "\uC5F0\uCC28",
  "enums.AssignmentType.BEREAVEMENT": "\uACBD\uC870\uD734\uAC00",
  "enums.AssignmentType.DAY": "\uC8FC\uAC04",
  "enums.AssignmentType.EDUCATION": "\uAD50\uC721",
  "enums.AssignmentType.EVENING": "\uC800\uB141",
  "enums.AssignmentType.NIGHT": "\uC57C\uAC04",
  "enums.AssignmentType.OFF": "\uBE44\uBC88",
  "enums.AssignmentType.UNAVAILABLE": "\uADFC\uBB34\uBD88\uAC00",
  "enums.AttendanceMethod.APP": "\uC571 \uCD9C\uD1F4\uADFC",
  "enums.AttendanceMethod.MANUAL": "\uC218\uB3D9 \uC785\uB825",
  "enums.AttendanceMethod.SECOM": "\uC9C0\uBB38 \uC778\uC2DD",
  "enums.AttendanceStatus.ABSENT": "\uACB0\uADFC",
  "enums.AttendanceStatus.CHECKED_IN": "\uCD9C\uADFC",
  "enums.AttendanceStatus.CHECKED_OUT": "\uD1F4\uADFC",
  "enums.AttendanceStatus.EARLY_LEAVE": "\uC870\uD1F4",
  "enums.AttendanceStatus.HOLIDAY": "\uACF5\uD734\uC77C",
  "enums.AttendanceStatus.LATE": "\uC9C0\uAC01",
  "enums.AttendanceStatus.LEAVE": "\uD734\uAC00",
  "enums.AttendanceStatus.SCHEDULED": "\uC608\uC815",
  "enums.AttendanceStatus.SICK_LEAVE": "\uBCD1\uAC00",
  "enums.CertificationType.CARE_WORKER": "\uC694\uC591\uBCF4\uD638\uC0AC",
  "enums.CertificationType.CLINICAL_LAB": "\uC784\uC0C1\uBCD1\uB9AC\uC0AC",
  "enums.CertificationType.DENTIST": "\uCE58\uACFC\uC758\uC0AC",
  "enums.CertificationType.DIETITIAN": "\uC601\uC591\uC0AC",
  "enums.CertificationType.EMERGENCY_MEDICAL": "\uC751\uAE09\uAD6C\uC870\uC0AC",
  "enums.CertificationType.MEDICAL_DOCTOR": "\uC758\uC0AC",
  "enums.CertificationType.NURSE_AIDE": "\uAC04\uD638\uC870\uBB34\uC0AC",
  "enums.CertificationType.NURSING": "\uAC04\uD638\uC0AC",
  "enums.CertificationType.OCCUPATIONAL_THERAPIST": "\uC791\uC5C5\uCE58\uB8CC\uC0AC",
  "enums.CertificationType.OTHER": "\uAE30\uD0C0",
  "enums.CertificationType.PHARMACIST": "\uC57D\uC0AC",
  "enums.CertificationType.PHYSICAL_THERAPIST": "\uBB3C\uB9AC\uCE58\uB8CC\uC0AC",
  "enums.CertificationType.RADIOLOGIST": "\uBC29\uC0AC\uC120\uC0AC",
  "enums.CertificationType.SOCIAL_WORKER": "\uC0AC\uD68C\uBCF5\uC9C0\uC0AC",
  "enums.CertificationType.SPEECH_THERAPIST": "\uC5B8\uC5B4\uCE58\uB8CC\uC0AC",
  "enums.ContractStatus.ACTIVE": "\uACC4\uC57D\uC911",
  "enums.ContractStatus.DRAFT": "\uCD08\uC548",
  "enums.ContractStatus.EXPIRED": "\uB9CC\uB8CC",
  "enums.ContractStatus.PENDING_SIGNATURE": "\uC11C\uBA85 \uB300\uAE30",
  "enums.ContractStatus.RENEWED": "\uAC31\uC2E0",
  "enums.ContractStatus.SUSPENDED": "\uC815\uC9C0",
  "enums.ContractStatus.TERMINATED": "\uD574\uC9C0",
  "enums.ContractType.CONSULTANT": "\uC790\uBB38",
  "enums.ContractType.CONTRACT": "\uACC4\uC57D\uC9C1",
  "enums.ContractType.CONTRACTOR": "\uB3C4\uAE09",
  "enums.ContractType.FIXED_TERM": "\uAE30\uAC04\uC81C",
  "enums.ContractType.FREELANCE": "\uD504\uB9AC\uB79C\uC11C",
  "enums.ContractType.INTERNSHIP": "\uC778\uD134",
  "enums.ContractType.PART_TIME": "\uD30C\uD2B8\uD0C0\uC784",
  "enums.ContractType.PERMANENT": "\uC815\uADDC\uC9C1",
  "enums.ContractType.TEMPORARY": "\uC784\uC2DC\uC9C1",
  "enums.DocumentCategory.CERTIFICATION": "\uC99D\uBA85\uC11C",
  "enums.DocumentCategory.CONTRACT": "\uACC4\uC57D\uC11C",
  "enums.DocumentCategory.MEDICAL": "\uC758\uB8CC",
  "enums.DocumentCategory.OTHER": "\uAE30\uD0C0",
  "enums.DocumentCategory.OVERTIME": "\uCD08\uACFC\uADFC\uBB34",
  "enums.DocumentStatus.APPROVED": "\uC2B9\uC778",
  "enums.DocumentStatus.PROCESSING": "\uCC98\uB9AC\uC911",
  "enums.DocumentStatus.REJECTED": "\uBC18\uB824",
  "enums.DocumentStatus.REQUIRES_REVIEW": "\uAC80\uD1A0 \uD544\uC694",
  "enums.EmployeeStatus.ACTIVE": "\uC7AC\uC9C1",
  "enums.EmployeeStatus.INACTIVE": "\uBE44\uD65C\uC131",
  "enums.EmployeeStatus.ON_LEAVE": "\uD734\uC9C1",
  "enums.EmployeeStatus.TERMINATED": "\uD1F4\uC9C1",
  "enums.ExecutionStatus.COMPLETED": "\uC644\uB8CC",
  "enums.ExecutionStatus.IN_PROGRESS": "\uC9C4\uD589\uC911",
  "enums.ExecutionStatus.OVERDUE": "\uAE30\uD55C\uCD08\uACFC",
  "enums.ExecutionStatus.PENDING": "\uB300\uAE30",
  "enums.ExecutionStatus.SKIPPED": "\uAC74\uB108\uB700",
  "enums.FixedIncentiveStatus.APPROVED": "\uC2B9\uC778",
  "enums.FixedIncentiveStatus.CANCELLED": "\uCDE8\uC18C",
  "enums.FixedIncentiveStatus.PAID": "\uC9C0\uAE09\uC644\uB8CC",
  "enums.FixedIncentiveStatus.PENDING": "\uB300\uAE30",
  "enums.HalfDayPeriod.AFTERNOON": "\uC624\uD6C4",
  "enums.HalfDayPeriod.MORNING": "\uC624\uC804",
  "enums.IncentiveCategory.ASSESSMENT": "\uD3C9\uAC00",
  "enums.IncentiveCategory.HOME_VISIT": "\uBC29\uBB38",
  "enums.IncentiveCategory.NURSING": "\uAC04\uD638",
  "enums.IncentiveCategory.ON_CALL": "\uB2F9\uC9C1",
  "enums.IncentiveCategory.OTHER": "\uAE30\uD0C0",
  "enums.IncentiveCategory.REHABILITATION": "\uC7AC\uD65C",
  "enums.IncentiveCategory.SPORTS_MEDICINE": "\uC2A4\uD3EC\uCE20\uC758\uD559",
  "enums.LeaveOfAbsenceStatus.ACTIVE": "\uD734\uC9C1\uC911",
  "enums.LeaveOfAbsenceStatus.CANCELLED": "\uCDE8\uC18C",
  "enums.LeaveOfAbsenceStatus.RETURNED": "\uBCF5\uC9C1",
  "enums.LeaveStatus.APPROVED": "\uC2B9\uC778",
  "enums.LeaveStatus.CANCELLED": "\uCDE8\uC18C",
  "enums.LeaveStatus.PENDING": "\uB300\uAE30",
  "enums.LeaveStatus.REJECTED": "\uBC18\uB824",
  "enums.LeaveType.ANNUAL": "\uC5F0\uCC28",
  "enums.LeaveType.BEREAVEMENT": "\uACBD\uC870\uD734\uAC00",
  "enums.LeaveType.MATERNITY": "\uCD9C\uC0B0\uD734\uAC00",
  "enums.LeaveType.MILITARY": "\uBCD1\uC5ED",
  "enums.LeaveType.OTHER": "\uAE30\uD0C0",
  "enums.LeaveType.PATERNITY": "\uBC30\uC6B0\uC790\uCD9C\uC0B0\uD734\uAC00",
  "enums.LeaveType.PERSONAL": "\uAC1C\uC778\uC0AC\uC720",
  "enums.LeaveType.SICK": "\uBCD1\uAC00",
  "enums.NoticePriority.HIGH": "\uB192\uC74C",
  "enums.NoticePriority.LOW": "\uB0AE\uC74C",
  "enums.NoticePriority.NORMAL": "\uBCF4\uD1B5",
  "enums.NoticePriority.URGENT": "\uAE34\uAE09",
  "enums.NotificationAction.APPROVED": "\uC2B9\uC778\uB428",
  "enums.NotificationAction.CANCELLED": "\uCDE8\uC18C\uB428",
  "enums.NotificationAction.CREATED": "\uC2E0\uADDC \uC694\uCCAD",
  "enums.NotificationAction.REJECTED": "\uBC18\uB824\uB428",
  "enums.NotificationAction.REMINDER": "\uB9AC\uB9C8\uC778\uB354",
  "enums.NotificationAction.UPDATED": "\uC218\uC815\uB428",
  "enums.NotificationType.ALLOWANCE": "\uC218\uB2F9",
  "enums.NotificationType.CERTIFICATE": "\uC99D\uBA85\uC11C",
  "enums.NotificationType.DEDUCTION": "\uACF5\uC81C",
  "enums.NotificationType.DOCUMENT": "\uBB38\uC11C",
  "enums.NotificationType.EDUCATION": "\uAD50\uC721",
  "enums.NotificationType.GENERAL": "\uC77C\uBC18",
  "enums.NotificationType.INCENTIVE": "\uC778\uC13C\uD2F0\uBE0C",
  "enums.NotificationType.LEAVE_REQUEST": "\uC5F0\uCC28/\uD734\uAC00",
  "enums.NotificationType.OVERTIME": "\uCD08\uACFC\uADFC\uBB34",
  "enums.NotificationType.PERMISSION_REQUEST": "\uAD8C\uD55C \uC694\uCCAD",
  "enums.NotificationType.SYSTEM": "\uC2DC\uC2A4\uD15C",
  "enums.NurseWorkType.DAY_DEDICATED": "\uC8FC\uAC04 \uC804\uB2F4",
  "enums.NurseWorkType.EVENING_DEDICATED": "\uC800\uB141 \uC804\uB2F4",
  "enums.NurseWorkType.NIGHT_DEDICATED": "\uC57C\uAC04 \uC804\uB2F4",
  "enums.NurseWorkType.THREE_SHIFT": "3\uAD50\uB300",
  "enums.OrganizationType.CLINIC": "\uC758\uC6D0",
  "enums.OrganizationType.DENTAL_HOSPITAL": "\uCE58\uACFC\uBCD1\uC6D0",
  "enums.OrganizationType.GENERAL_HOSPITAL": "\uC885\uD569\uBCD1\uC6D0",
  "enums.OrganizationType.HOSPITAL": "\uBCD1\uC6D0",
  "enums.OrganizationType.LONG_TERM_CARE_HOSPITAL": "\uC694\uC591\uBCD1\uC6D0",
  "enums.OrganizationType.MENTAL_HOSPITAL": "\uC815\uC2E0\uBCD1\uC6D0",
  "enums.OrganizationType.MIDWIFERY_CENTER": "\uC870\uC0B0\uC6D0",
  "enums.OrganizationType.ORIENTAL_HOSPITAL": "\uD55C\uBC29\uBCD1\uC6D0",
  "enums.OrganizationType.OTHER": "\uAE30\uD0C0",
  "enums.OrganizationType.TERTIARY_HOSPITAL": "\uC0C1\uAE09\uC885\uD569\uBCD1\uC6D0",
  "enums.OvertimeCategory.HOLIDAY": "\uD734\uC77C",
  "enums.OvertimeCategory.NIGHT": "\uC57C\uAC04",
  "enums.OvertimeCategory.SATURDAY": "\uD1A0\uC694\uC77C",
  "enums.OvertimeCategory.WEEKDAY": "\uD3C9\uC77C",
  "enums.OvertimeStatus.APPROVED": "\uC2B9\uC778",
  "enums.OvertimeStatus.PENDING": "\uB300\uAE30",
  "enums.OvertimeStatus.REJECTED": "\uBC18\uB824",
  "enums.PaymentMethod.CASH": "\uD604\uAE08",
  "enums.PaymentMethod.MOBILE_GIFT": "\uBAA8\uBC14\uC77C \uC0C1\uD488\uAD8C",
  "enums.PaymentMethod.SALARY": "\uAE09\uC5EC",
  "enums.PayrollStatus.APPROVED": "\uC2B9\uC778",
  "enums.PayrollStatus.CALCULATED": "\uACC4\uC0B0\uC644\uB8CC",
  "enums.PayrollStatus.CANCELLED": "\uCDE8\uC18C",
  "enums.PayrollStatus.CONFIRMED": "\uD655\uC815",
  "enums.PayrollStatus.CORRECTED": "\uC218\uC815",
  "enums.PayrollStatus.DRAFT": "\uCD08\uC548",
  "enums.PayrollStatus.PAID": "\uC9C0\uAE09\uC644\uB8CC",
  "enums.PromotionStatus.APPLIED": "\uC801\uC6A9\uC644\uB8CC",
  "enums.PromotionStatus.APPROVED": "\uC2B9\uC778",
  "enums.PromotionStatus.PENDING": "\uB300\uAE30",
  "enums.PromotionStatus.REJECTED": "\uBC18\uB824",
  "enums.ScheduleStatus.AI_GENERATED": "AI \uC0DD\uC131",
  "enums.ScheduleStatus.CONFIRMED": "\uD655\uC815",
  "enums.ScheduleStatus.DRAFT": "\uCD08\uC548",
  "enums.ScheduleStatus.EDITING": "\uD3B8\uC9D1\uC911",
  "enums.ScheduleStatus.GENERATING": "\uC0DD\uC131\uC911",
  "enums.ScheduleStatus.PUBLISHED": "\uAC8C\uC2DC\uB428",
  "enums.ShiftType.DAY": "\uC8FC\uAC04",
  "enums.ShiftType.EVENING": "\uC800\uB141",
  "enums.ShiftType.FLEXIBLE": "\uC720\uC5F0",
  "enums.ShiftType.HOLIDAY": "\uACF5\uD734\uC77C",
  "enums.ShiftType.NIGHT": "\uC57C\uAC04",
  "enums.ShiftType.WEEKEND_DAY": "\uC8FC\uB9D0 \uC8FC\uAC04",
  "enums.ShiftType.WEEKEND_NIGHT": "\uC8FC\uB9D0 \uC57C\uAC04",
  "enums.TaskCategory.COMPLIANCE": "\uADDC\uC815\uC900\uC218",
  "enums.TaskCategory.DOCUMENT": "\uC11C\uB958",
  "enums.TaskCategory.EQUIPMENT": "\uC7A5\uBE44",
  "enums.TaskCategory.FACILITY": "\uC2DC\uC124",
  "enums.TaskCategory.FIRE": "\uC18C\uBC29",
  "enums.TaskCategory.HYGIENE": "\uC704\uC0DD",
  "enums.TaskCategory.OTHER": "\uAE30\uD0C0",
  "enums.TaskCategory.SAFETY": "\uC548\uC804",
  "enums.TrainingCategory.ACCREDITATION": "\uC778\uC99D",
  "enums.TrainingCategory.LEGAL_MANDATORY": "\uBC95\uC815\uD544\uC218",
  "enums.TrainingCategory.OTHER": "\uAE30\uD0C0",
  "enums.TrainingCategory.SPECIALIZED": "\uC804\uBB38",
  "enums.WageType.ANNUAL": "\uC5F0\uBD09\uC81C",
  "enums.WageType.COMMISSION": "\uC131\uACFC\uAE09",
  "enums.WageType.DAILY": "\uC77C\uAE09\uC81C",
  "enums.WageType.HOURLY": "\uC2DC\uAE09\uC81C",
  "enums.WageType.MONTHLY": "\uC6D4\uAE09\uC81C",
  "enums.WageType.PROJECT": "\uD504\uB85C\uC81D\uD2B8",
  "enums.WageType.WEEKLY": "\uC8FC\uAE09\uC81C"
};

// src/locales/ko/errors.json
var errors_default2 = {
  "errors.auth.invalid_credentials": "\uC544\uC774\uB514 \uB610\uB294 \uBE44\uBC00\uBC88\uD638\uAC00 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
  "errors.auth.not_authenticated": "\uB85C\uADF8\uC778\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.",
  "errors.auth.password_current_incorrect": "\uD604\uC7AC \uBE44\uBC00\uBC88\uD638\uAC00 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
  "errors.auth.password_current_required": "\uD604\uC7AC \uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
  "errors.auth.password_mismatch": "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
  "errors.auth.password_too_weak": "\uBE44\uBC00\uBC88\uD638\uB294 \uB300\uBB38\uC790, \uC18C\uBB38\uC790, \uC22B\uC790, \uD2B9\uC218\uBB38\uC790\uB97C \uAC01\uAC01 1\uAC1C \uC774\uC0C1 \uD3EC\uD568\uD574\uC57C \uD569\uB2C8\uB2E4.",
  "errors.auth.session_expired": "\uC138\uC158\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574\uC8FC\uC138\uC694.",
  "errors.auth.sms_failed": "SMS \uBC1C\uC1A1\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.",
  "errors.auth.token_invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uAC70\uB098 \uB9CC\uB8CC\uB41C \uD1A0\uD070\uC785\uB2C8\uB2E4.",
  "errors.common.conflict": "\uC774\uBBF8 \uC874\uC7AC\uD558\uB294 \uB370\uC774\uD130\uC785\uB2C8\uB2E4.",
  "errors.common.forbidden": "\uC811\uADFC \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
  "errors.common.internal": "\uC11C\uBC84 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.",
  "errors.common.not_found": "\uB370\uC774\uD130\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
  "errors.common.validation": "\uC785\uB825\uAC12\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.",
  "errors.employee.no_phone": "SMS \uBC1C\uC1A1\uC744 \uC704\uD55C \uC804\uD654\uBC88\uD638\uAC00 \uB4F1\uB85D\uB418\uC5B4 \uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
  "errors.employee.not_found": "\uC9C1\uC6D0\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
  "errors.payroll.already_confirmed": "\uC774\uBBF8 \uD655\uC815\uB41C \uAE09\uC5EC\uC785\uB2C8\uB2E4.",
  "errors.payroll.not_calculated": "\uAE09\uC5EC\uAC00 \uC544\uC9C1 \uACC4\uC0B0\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.",
  "errors.permission.denied": "\uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
};

// src/locales/ko/permissions.json
var permissions_default2 = {
  "perm.action.approve": "\uC2B9\uC778",
  "perm.action.create": "\uB4F1\uB85D",
  "perm.action.delete": "\uC0AD\uC81C",
  "perm.action.execute": "\uC2E4\uD589",
  "perm.action.manage": "\uAD00\uB9AC",
  "perm.action.read": "\uC870\uD68C",
  "perm.action.update": "\uC218\uC815",
  "perm.action.write": "\uAE30\uB85D/\uC218\uC815",
  "perm.action.calculate": "\uACC4\uC0B0",
  "perm.action.admin": "\uAD00\uB9AC\uC790",
  "perm.resource.ai": "AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8",
  "perm.resource.aiApp": "\uC9C1\uC6D0 \uC571 AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8",
  "perm.resource.allowance": "\uC218\uB2F9",
  "perm.resource.annualLeavePromotion": "\uC5F0\uCC28 \uCD09\uC9C4",
  "perm.resource.attendance": "\uADFC\uD0DC",
  "perm.resource.certification": "\uC790\uACA9\uC99D",
  "perm.resource.conversation": "\uBA54\uC2E0\uC800 \u2014 \uB300\uD654\uBC29",
  "perm.resource.csReport": "CS \uB9AC\uD3EC\uD2B8",
  "perm.resource.deduction": "\uACF5\uC81C",
  "perm.resource.department": "\uBD80\uC11C",
  "perm.resource.document": "\uBB38\uC11C",
  "perm.resource.education": "\uAD50\uC721",
  "perm.resource.educationSubsidy": "\uAD50\uC721\uBE44 \uC9C0\uC6D0",
  "perm.resource.employee": "\uC9C1\uC6D0",
  "perm.resource.fixedIncentive": "\uACE0\uC815 \uC778\uC13C\uD2F0\uBE0C",
  "perm.resource.generalAffairs": "\uCD1D\uBB34",
  "perm.resource.incentive": "\uC778\uC13C\uD2F0\uBE0C",
  "perm.resource.inventory": "\uC7AC\uACE0",
  "perm.resource.leave": "\uC5F0\uCC28/\uD734\uAC00",
  "perm.resource.leave-request": "\uC5F0\uCC28 \uC124\uC815",
  "perm.resource.message": "\uBA54\uC2E0\uC800 \u2014 \uBA54\uC2DC\uC9C0",
  "perm.resource.notification": "\uC54C\uB9BC",
  "perm.resource.nurse-scheduler": "\uC2A4\uCF00\uC904\uB7EC \uAD00\uB9AC",
  "perm.resource.offsiteWork": "\uC678\uADFC",
  "perm.resource.organization": "\uC870\uC9C1",
  "perm.resource.overtime": "\uCD08\uACFC\uADFC\uBB34",
  "perm.resource.payroll": "\uAE09\uC5EC",
  "perm.resource.resignation": "\uD1F4\uC9C1",
  "perm.resource.role": "{@role}",
  "perm.resource.salaryGrade": "\uD638\uBD09",
  "perm.resource.schedule": "\uADFC\uBB34\uD45C",
  "perm.resource.setting": "\uC124\uC815",
  "perm.resource.storage": "\uD30C\uC77C",
  "perm.resource.system": "\uC2DC\uC2A4\uD15C",
  "perm.resource.team": "\uD300",
  "perm.resource.teamDrive": "\uB4DC\uB77C\uC774\uBE0C",
  "perm.resource.impersonation": "\uAD8C\uD55C \uBBF8\uB9AC\uBCF4\uAE30",
  "perm.resource.chatRecovery": "\uB300\uD654 \uBCF5\uAD6C",
  "perm.resource.sheet": "\uC2DC\uD2B8 \uAD00\uB9AC",
  "perm.resource.ward": "\uBCD1\uB3D9",
  "perm.resource.yearEndSettlement": "\uC5F0\uB9D0\uC815\uC0B0",
  "perm.scope.all": "\uC804\uCCB4",
  "perm.scope.department": "\uBD80\uC11C",
  "perm.scope.self": "\uBCF8\uC778",
  "perm.scope.team": "\uD300"
};

// src/locales/index.ts
var TERM_TOKEN = /\{@([A-Za-z_]\w*)(?:\|([^}]+))?\}/g;
function createI18n(locale) {
  let currentLocale = locale;
  let translations = {};
  let terms = {};
  function term(key) {
    return terms[key] ?? translations[`term.${key}`] ?? key;
  }
  __name(term, "term");
  function setTerms(next) {
    terms = {
      ...next
    };
  }
  __name(setTerms, "setTerms");
  function t(key, vars) {
    let s = translations[key] ?? key;
    if (vars) {
      s = s.replace(/\{(\w+)\}/g, (_, k) => {
        const v = vars[k];
        return v != null ? String(v) : `{${k}}`;
      });
    }
    if (s.includes("{@")) {
      s = s.replace(TERM_TOKEN, (_, k, pair) => {
        const word = term(k);
        return pair ? `${word}${josa(word, pair)}` : word;
      });
    }
    return s;
  }
  __name(t, "t");
  function tEnum(enumName, value) {
    if (!value) {
      return "";
    }
    const key = `enums.${enumName}.${value}`;
    const translated = translations[key] ?? translations[`enums.${enumName}.${value.toUpperCase()}`];
    return translated ?? value;
  }
  __name(tEnum, "tEnum");
  function tPermission(code) {
    if (!code) {
      return "";
    }
    let resource;
    let action;
    let scope = null;
    const colonIdx = code.indexOf(":");
    if (colonIdx !== -1) {
      resource = code.slice(0, colonIdx);
      const rest = code.slice(colonIdx + 1);
      const dotIdx = rest.indexOf(".");
      if (dotIdx !== -1) {
        action = rest.slice(0, dotIdx);
        scope = rest.slice(dotIdx + 1);
      } else {
        action = rest;
      }
    } else {
      const parts = code.split(".");
      if (parts.length < 2) {
        return code;
      }
      resource = parts[0];
      action = parts[1];
      if (parts.length > 2) {
        scope = parts.slice(2).join(".");
      }
    }
    const rLabel = t(`perm.resource.${resource}`);
    const aLabel = t(`perm.action.${action}`);
    if (rLabel === `perm.resource.${resource}` && aLabel === `perm.action.${action}`) {
      return "";
    }
    if (scope) {
      const sLabel = t(`perm.scope.${scope}`);
      return `${rLabel} ${aLabel} (${sLabel})`;
    }
    return `${rLabel} ${aLabel}`;
  }
  __name(tPermission, "tPermission");
  function load(...maps) {
    for (const map of maps) {
      Object.assign(translations, map);
    }
  }
  __name(load, "load");
  function reset(newLocale, ...maps) {
    currentLocale = newLocale;
    translations = {};
    load(...maps);
  }
  __name(reset, "reset");
  return {
    get locale() {
      return currentLocale;
    },
    load,
    t,
    setTerms,
    term,
    tEnum,
    tPermission,
    reset
  };
}
__name(createI18n, "createI18n");
var BUNDLES = {
  ko: [
    common_default2,
    domain_default2,
    enums_default2,
    errors_default2,
    permissions_default2
  ],
  en: [
    common_default,
    domain_default,
    enums_default,
    errors_default,
    permissions_default
  ]
};
function getLocaleBundle(locale) {
  const lang = locale.slice(0, 2);
  const maps = BUNDLES[lang] ?? BUNDLES.ko;
  return Object.assign({}, ...maps);
}
__name(getLocaleBundle, "getLocaleBundle");
var SUPPORTED_LOCALES = Object.keys(BUNDLES);
export {
  SUPPORTED_LOCALES,
  createI18n,
  common_default as enCommon,
  domain_default as enDomain,
  enums_default as enEnums,
  errors_default as enErrors,
  permissions_default as enPermissions,
  getLocaleBundle,
  common_default2 as koCommon,
  domain_default2 as koDomain,
  enums_default2 as koEnums,
  errors_default2 as koErrors,
  permissions_default2 as koPermissions
};
//# sourceMappingURL=locales.mjs.map